import * as E from "react";
import v, { forwardRef as qt, createContext as X3, useContext as gl, useState as he, useEffect as nt, useMemo as Ct, useCallback as Ue, isValidElement as Ao, PureComponent as Io, Component as Wo, useRef as jt, useLayoutEffect as vl, Children as Mo, createElement as _s, cloneElement as Td, Fragment as Z3, useDebugValue as K3, useImperativeHandle as Ad } from "react";
import * as $d from "react-dom";
import Q3 from "react-dom";
import { presetIcons as J3 } from "unocss";
function Rd(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Rd(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Dd() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Rd(e)) && (r && (r += " "), r += t);
  return r;
}
const iu = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, su = Dd, bl = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return su(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = a == null ? void 0 : a[c];
    if (u === null)
      return null;
    const f = iu(u) || iu(d);
    return o[c][f];
  }), s = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((p) => {
      let [m, g] = p;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...s
      }[m]) : {
        ...a,
        ...s
      }[m] === g;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return su(e, i, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
var sa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ps = { exports: {} }, oo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lu;
function e6() {
  if (lu)
    return oo;
  lu = 1;
  var e = v, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !a.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: f, ref: h, props: d, _owner: o.current };
  }
  return oo.Fragment = n, oo.jsx = i, oo.jsxs = i, oo;
}
var ao = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cu;
function t6() {
  return cu || (cu = 1, process.env.NODE_ENV !== "production" && function() {
    var e = v, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, m = "@@iterator";
    function g(k) {
      if (k === null || typeof k != "object")
        return null;
      var V = p && k[p] || k[m];
      return typeof V == "function" ? V : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(k) {
      {
        for (var V = arguments.length, K = new Array(V > 1 ? V - 1 : 0), se = 1; se < V; se++)
          K[se - 1] = arguments[se];
        w("error", k, K);
      }
    }
    function w(k, V, K) {
      {
        var se = y.ReactDebugCurrentFrame, Me = se.getStackAddendum();
        Me !== "" && (V += "%s", K = K.concat([Me]));
        var Te = K.map(function(Ce) {
          return String(Ce);
        });
        Te.unshift("Warning: " + V), Function.prototype.apply.call(console[k], console, Te);
      }
    }
    var S = !1, x = !1, M = !1, _ = !1, R = !1, B;
    B = Symbol.for("react.module.reference");
    function U(k) {
      return !!(typeof k == "string" || typeof k == "function" || k === r || k === a || R || k === o || k === c || k === u || _ || k === h || S || x || M || typeof k == "object" && k !== null && (k.$$typeof === f || k.$$typeof === d || k.$$typeof === i || k.$$typeof === s || k.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      k.$$typeof === B || k.getModuleId !== void 0));
    }
    function F(k, V, K) {
      var se = k.displayName;
      if (se)
        return se;
      var Me = V.displayName || V.name || "";
      return Me !== "" ? K + "(" + Me + ")" : K;
    }
    function T(k) {
      return k.displayName || "Context";
    }
    function j(k) {
      if (k == null)
        return null;
      if (typeof k.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof k == "function")
        return k.displayName || k.name || null;
      if (typeof k == "string")
        return k;
      switch (k) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof k == "object")
        switch (k.$$typeof) {
          case s:
            var V = k;
            return T(V) + ".Consumer";
          case i:
            var K = k;
            return T(K._context) + ".Provider";
          case l:
            return F(k, k.render, "ForwardRef");
          case d:
            var se = k.displayName || null;
            return se !== null ? se : j(k.type) || "Memo";
          case f: {
            var Me = k, Te = Me._payload, Ce = Me._init;
            try {
              return j(Ce(Te));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, G = 0, N, te, oe, Q, P, L, $;
    function I() {
    }
    I.__reactDisabledLog = !0;
    function H() {
      {
        if (G === 0) {
          N = console.log, te = console.info, oe = console.warn, Q = console.error, P = console.group, L = console.groupCollapsed, $ = console.groupEnd;
          var k = {
            configurable: !0,
            enumerable: !0,
            value: I,
            writable: !0
          };
          Object.defineProperties(console, {
            info: k,
            log: k,
            warn: k,
            error: k,
            group: k,
            groupCollapsed: k,
            groupEnd: k
          });
        }
        G++;
      }
    }
    function Y() {
      {
        if (G--, G === 0) {
          var k = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, k, {
              value: N
            }),
            info: A({}, k, {
              value: te
            }),
            warn: A({}, k, {
              value: oe
            }),
            error: A({}, k, {
              value: Q
            }),
            group: A({}, k, {
              value: P
            }),
            groupCollapsed: A({}, k, {
              value: L
            }),
            groupEnd: A({}, k, {
              value: $
            })
          });
        }
        G < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var W = y.ReactCurrentDispatcher, q;
    function Z(k, V, K) {
      {
        if (q === void 0)
          try {
            throw Error();
          } catch (Me) {
            var se = Me.stack.trim().match(/\n( *(at )?)/);
            q = se && se[1] || "";
          }
        return `
` + q + k;
      }
    }
    var ee = !1, J;
    {
      var ie = typeof WeakMap == "function" ? WeakMap : Map;
      J = new ie();
    }
    function D(k, V) {
      if (!k || ee)
        return "";
      {
        var K = J.get(k);
        if (K !== void 0)
          return K;
      }
      var se;
      ee = !0;
      var Me = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Te;
      Te = W.current, W.current = null, H();
      try {
        if (V) {
          var Ce = function() {
            throw Error();
          };
          if (Object.defineProperty(Ce.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ce, []);
            } catch (Gt) {
              se = Gt;
            }
            Reflect.construct(k, [], Ce);
          } else {
            try {
              Ce.call();
            } catch (Gt) {
              se = Gt;
            }
            k.call(Ce.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Gt) {
            se = Gt;
          }
          k();
        }
      } catch (Gt) {
        if (Gt && se && typeof Gt.stack == "string") {
          for (var ge = Gt.stack.split(`
`), ft = se.stack.split(`
`), qe = ge.length - 1, Qe = ft.length - 1; qe >= 1 && Qe >= 0 && ge[qe] !== ft[Qe]; )
            Qe--;
          for (; qe >= 1 && Qe >= 0; qe--, Qe--)
            if (ge[qe] !== ft[Qe]) {
              if (qe !== 1 || Qe !== 1)
                do
                  if (qe--, Qe--, Qe < 0 || ge[qe] !== ft[Qe]) {
                    var Mt = `
` + ge[qe].replace(" at new ", " at ");
                    return k.displayName && Mt.includes("<anonymous>") && (Mt = Mt.replace("<anonymous>", k.displayName)), typeof k == "function" && J.set(k, Mt), Mt;
                  }
                while (qe >= 1 && Qe >= 0);
              break;
            }
        }
      } finally {
        ee = !1, W.current = Te, Y(), Error.prepareStackTrace = Me;
      }
      var nr = k ? k.displayName || k.name : "", au = nr ? Z(nr) : "";
      return typeof k == "function" && J.set(k, au), au;
    }
    function ye(k, V, K) {
      return D(k, !1);
    }
    function We(k) {
      var V = k.prototype;
      return !!(V && V.isReactComponent);
    }
    function we(k, V, K) {
      if (k == null)
        return "";
      if (typeof k == "function")
        return D(k, We(k));
      if (typeof k == "string")
        return Z(k);
      switch (k) {
        case c:
          return Z("Suspense");
        case u:
          return Z("SuspenseList");
      }
      if (typeof k == "object")
        switch (k.$$typeof) {
          case l:
            return ye(k.render);
          case d:
            return we(k.type, V, K);
          case f: {
            var se = k, Me = se._payload, Te = se._init;
            try {
              return we(Te(Me), V, K);
            } catch {
            }
          }
        }
      return "";
    }
    var lt = Object.prototype.hasOwnProperty, xe = {}, ce = y.ReactDebugCurrentFrame;
    function ue(k) {
      if (k) {
        var V = k._owner, K = we(k.type, k._source, V ? V.type : null);
        ce.setExtraStackFrame(K);
      } else
        ce.setExtraStackFrame(null);
    }
    function Ve(k, V, K, se, Me) {
      {
        var Te = Function.call.bind(lt);
        for (var Ce in k)
          if (Te(k, Ce)) {
            var ge = void 0;
            try {
              if (typeof k[Ce] != "function") {
                var ft = Error((se || "React class") + ": " + K + " type `" + Ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof k[Ce] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ft.name = "Invariant Violation", ft;
              }
              ge = k[Ce](V, Ce, se, K, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (qe) {
              ge = qe;
            }
            ge && !(ge instanceof Error) && (ue(Me), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", se || "React class", K, Ce, typeof ge), ue(null)), ge instanceof Error && !(ge.message in xe) && (xe[ge.message] = !0, ue(Me), b("Failed %s type: %s", K, ge.message), ue(null));
          }
      }
    }
    var ne = Array.isArray;
    function Se(k) {
      return ne(k);
    }
    function rt(k) {
      {
        var V = typeof Symbol == "function" && Symbol.toStringTag, K = V && k[Symbol.toStringTag] || k.constructor.name || "Object";
        return K;
      }
    }
    function Ee(k) {
      try {
        return Fe(k), !1;
      } catch {
        return !0;
      }
    }
    function Fe(k) {
      return "" + k;
    }
    function Ze(k) {
      if (Ee(k))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", rt(k)), Fe(k);
    }
    var et = y.ReactCurrentOwner, ct = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, cn, ve, Ye;
    Ye = {};
    function Be(k) {
      if (lt.call(k, "ref")) {
        var V = Object.getOwnPropertyDescriptor(k, "ref").get;
        if (V && V.isReactWarning)
          return !1;
      }
      return k.ref !== void 0;
    }
    function er(k) {
      if (lt.call(k, "key")) {
        var V = Object.getOwnPropertyDescriptor(k, "key").get;
        if (V && V.isReactWarning)
          return !1;
      }
      return k.key !== void 0;
    }
    function Jr(k, V) {
      if (typeof k.ref == "string" && et.current && V && et.current.stateNode !== V) {
        var K = j(et.current.type);
        Ye[K] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(et.current.type), k.ref), Ye[K] = !0);
      }
    }
    function eo(k, V) {
      {
        var K = function() {
          cn || (cn = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
        };
        K.isReactWarning = !0, Object.defineProperty(k, "key", {
          get: K,
          configurable: !0
        });
      }
    }
    function dt(k, V) {
      {
        var K = function() {
          ve || (ve = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
        };
        K.isReactWarning = !0, Object.defineProperty(k, "ref", {
          get: K,
          configurable: !0
        });
      }
    }
    var un = function(k, V, K, se, Me, Te, Ce) {
      var ge = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: k,
        key: V,
        ref: K,
        props: Ce,
        // Record the component responsible for creating this element.
        _owner: Te
      };
      return ge._store = {}, Object.defineProperty(ge._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ge, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: se
      }), Object.defineProperty(ge, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Me
      }), Object.freeze && (Object.freeze(ge.props), Object.freeze(ge)), ge;
    };
    function Ke(k, V, K, se, Me) {
      {
        var Te, Ce = {}, ge = null, ft = null;
        K !== void 0 && (Ze(K), ge = "" + K), er(V) && (Ze(V.key), ge = "" + V.key), Be(V) && (ft = V.ref, Jr(V, Me));
        for (Te in V)
          lt.call(V, Te) && !ct.hasOwnProperty(Te) && (Ce[Te] = V[Te]);
        if (k && k.defaultProps) {
          var qe = k.defaultProps;
          for (Te in qe)
            Ce[Te] === void 0 && (Ce[Te] = qe[Te]);
        }
        if (ge || ft) {
          var Qe = typeof k == "function" ? k.displayName || k.name || "Unknown" : k;
          ge && eo(Ce, Qe), ft && dt(Ce, Qe);
        }
        return un(k, ge, ft, Me, se, et.current, Ce);
      }
    }
    var ht = y.ReactCurrentOwner, ke = y.ReactDebugCurrentFrame;
    function dn(k) {
      if (k) {
        var V = k._owner, K = we(k.type, k._source, V ? V.type : null);
        ke.setExtraStackFrame(K);
      } else
        ke.setExtraStackFrame(null);
    }
    var to;
    to = !1;
    function no(k) {
      return typeof k == "object" && k !== null && k.$$typeof === t;
    }
    function tr() {
      {
        if (ht.current) {
          var k = j(ht.current.type);
          if (k)
            return `

Check the render method of \`` + k + "`.";
        }
        return "";
      }
    }
    function ro(k) {
      {
        if (k !== void 0) {
          var V = k.fileName.replace(/^.*[\\\/]/, ""), K = k.lineNumber;
          return `

Check your code at ` + V + ":" + K + ".";
        }
        return "";
      }
    }
    var tu = {};
    function I3(k) {
      {
        var V = tr();
        if (!V) {
          var K = typeof k == "string" ? k : k.displayName || k.name;
          K && (V = `

Check the top-level render call using <` + K + ">.");
        }
        return V;
      }
    }
    function nu(k, V) {
      {
        if (!k._store || k._store.validated || k.key != null)
          return;
        k._store.validated = !0;
        var K = I3(V);
        if (tu[K])
          return;
        tu[K] = !0;
        var se = "";
        k && k._owner && k._owner !== ht.current && (se = " It was passed a child from " + j(k._owner.type) + "."), dn(k), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', K, se), dn(null);
      }
    }
    function ru(k, V) {
      {
        if (typeof k != "object")
          return;
        if (Se(k))
          for (var K = 0; K < k.length; K++) {
            var se = k[K];
            no(se) && nu(se, V);
          }
        else if (no(k))
          k._store && (k._store.validated = !0);
        else if (k) {
          var Me = g(k);
          if (typeof Me == "function" && Me !== k.entries)
            for (var Te = Me.call(k), Ce; !(Ce = Te.next()).done; )
              no(Ce.value) && nu(Ce.value, V);
        }
      }
    }
    function W3(k) {
      {
        var V = k.type;
        if (V == null || typeof V == "string")
          return;
        var K;
        if (typeof V == "function")
          K = V.propTypes;
        else if (typeof V == "object" && (V.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        V.$$typeof === d))
          K = V.propTypes;
        else
          return;
        if (K) {
          var se = j(V);
          Ve(K, k.props, "prop", se, k);
        } else if (V.PropTypes !== void 0 && !to) {
          to = !0;
          var Me = j(V);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Me || "Unknown");
        }
        typeof V.getDefaultProps == "function" && !V.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function V3(k) {
      {
        for (var V = Object.keys(k.props), K = 0; K < V.length; K++) {
          var se = V[K];
          if (se !== "children" && se !== "key") {
            dn(k), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", se), dn(null);
            break;
          }
        }
        k.ref !== null && (dn(k), b("Invalid attribute `ref` supplied to `React.Fragment`."), dn(null));
      }
    }
    function ou(k, V, K, se, Me, Te) {
      {
        var Ce = U(k);
        if (!Ce) {
          var ge = "";
          (k === void 0 || typeof k == "object" && k !== null && Object.keys(k).length === 0) && (ge += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ft = ro(Me);
          ft ? ge += ft : ge += tr();
          var qe;
          k === null ? qe = "null" : Se(k) ? qe = "array" : k !== void 0 && k.$$typeof === t ? (qe = "<" + (j(k.type) || "Unknown") + " />", ge = " Did you accidentally export a JSX literal instead of a component?") : qe = typeof k, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", qe, ge);
        }
        var Qe = Ke(k, V, K, Me, Te);
        if (Qe == null)
          return Qe;
        if (Ce) {
          var Mt = V.children;
          if (Mt !== void 0)
            if (se)
              if (Se(Mt)) {
                for (var nr = 0; nr < Mt.length; nr++)
                  ru(Mt[nr], k);
                Object.freeze && Object.freeze(Mt);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ru(Mt, k);
        }
        return k === r ? V3(Qe) : W3(Qe), Qe;
      }
    }
    function Y3(k, V, K) {
      return ou(k, V, K, !0);
    }
    function q3(k, V, K) {
      return ou(k, V, K, !1);
    }
    var U3 = q3, G3 = Y3;
    ao.Fragment = r, ao.jsx = U3, ao.jsxs = G3;
  }()), ao;
}
process.env.NODE_ENV === "production" ? Ps.exports = e6() : Ps.exports = t6();
var C = Ps.exports;
const wl = "-";
function n6(e) {
  const t = o6(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  function o(i) {
    const s = i.split(wl);
    return s[0] === "" && s.length !== 1 && s.shift(), Nd(s, t) || r6(i);
  }
  function a(i, s) {
    const l = n[i] || [];
    return s && r[i] ? [...l, ...r[i]] : l;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function Nd(e, t) {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Nd(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(wl);
  return (i = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : i.classGroupId;
}
const uu = /^\[(.+)\]$/;
function r6(e) {
  if (uu.test(e)) {
    const t = uu.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function o6(e) {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return i6(Object.entries(e.classGroups), n).forEach(([a, i]) => {
    Os(i, r, a, t);
  }), r;
}
function Os(e, t, n, r) {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : du(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (a6(o)) {
        Os(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      Os(i, du(t, a), n, r);
    });
  });
}
function du(e, t) {
  let n = e;
  return t.split(wl).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function a6(e) {
  return e.isThemeGetter;
}
function i6(e, t) {
  return t ? e.map(([n, r]) => {
    const o = r.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([i, s]) => [t + i, s])) : a);
    return [n, o];
  }) : e;
}
function s6(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(a, i) {
    n.set(a, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(a) {
      let i = n.get(a);
      if (i !== void 0)
        return i;
      if ((i = r.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      n.has(a) ? n.set(a, i) : o(a, i);
    }
  };
}
const Ld = "!";
function l6(e) {
  const t = e.separator, n = t.length === 1, r = t[0], o = t.length;
  return function(i) {
    const s = [];
    let l = 0, c = 0, u;
    for (let m = 0; m < i.length; m++) {
      let g = i[m];
      if (l === 0) {
        if (g === r && (n || i.slice(m, m + o) === t)) {
          s.push(i.slice(c, m)), c = m + o;
          continue;
        }
        if (g === "/") {
          u = m;
          continue;
        }
      }
      g === "[" ? l++ : g === "]" && l--;
    }
    const d = s.length === 0 ? i : i.substring(c), f = d.startsWith(Ld), h = f ? d.substring(1) : d, p = u && u > c ? u - c : void 0;
    return {
      modifiers: s,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: p
    };
  };
}
function c6(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}
function u6(e) {
  return {
    cache: s6(e.cacheSize),
    splitModifiers: l6(e),
    ...n6(e)
  };
}
const d6 = /\s+/;
function f6(e, t) {
  const {
    splitModifiers: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, a = /* @__PURE__ */ new Set();
  return e.trim().split(d6).map((i) => {
    const {
      modifiers: s,
      hasImportantModifier: l,
      baseClassName: c,
      maybePostfixModifierPosition: u
    } = n(i);
    let d = r(u ? c.substring(0, u) : c), f = !!u;
    if (!d) {
      if (!u)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (d = r(c), !d)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      f = !1;
    }
    const h = c6(s).join(":");
    return {
      isTailwindClass: !0,
      modifierId: l ? h + Ld : h,
      classGroupId: d,
      originalClassName: i,
      hasPostfixModifier: f
    };
  }).reverse().filter((i) => {
    if (!i.isTailwindClass)
      return !0;
    const {
      modifierId: s,
      classGroupId: l,
      hasPostfixModifier: c
    } = i, u = s + l;
    return a.has(u) ? !1 : (a.add(u), o(l, c).forEach((d) => a.add(s + d)), !0);
  }).reverse().map((i) => i.originalClassName).join(" ");
}
function h6() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = jd(t)) && (r && (r += " "), r += n);
  return r;
}
function jd(e) {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = jd(e[r])) && (n && (n += " "), n += t);
  return n;
}
function fu(e, ...t) {
  let n, r, o, a = i;
  function i(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = u6(c), r = n.cache.get, o = n.cache.set, a = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = f6(l, n);
    return o(l, u), u;
  }
  return function() {
    return a(h6.apply(null, arguments));
  };
}
function Ne(e) {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}
const Hd = /^\[(?:([a-z-]+):)?(.+)\]$/i, p6 = /^\d+\/\d+$/, m6 = /* @__PURE__ */ new Set(["px", "full", "screen"]), g6 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, v6 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, b6 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, y6 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function zt(e) {
  return xn(e) || m6.has(e) || p6.test(e);
}
function Zt(e) {
  return Lr(e, "length", C6);
}
function xn(e) {
  return !!e && !Number.isNaN(Number(e));
}
function yo(e) {
  return Lr(e, "number", xn);
}
function sr(e) {
  return !!e && Number.isInteger(Number(e));
}
function Fd(e) {
  return e.endsWith("%") && xn(e.slice(0, -1));
}
function de(e) {
  return Hd.test(e);
}
function Kt(e) {
  return g6.test(e);
}
const w6 = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function Bd(e) {
  return Lr(e, w6, Vd);
}
function zd(e) {
  return Lr(e, "position", Vd);
}
const x6 = /* @__PURE__ */ new Set(["image", "url"]);
function Id(e) {
  return Lr(e, x6, E6);
}
function Wd(e) {
  return Lr(e, "", S6);
}
function lr() {
  return !0;
}
function Lr(e, t, n) {
  const r = Hd.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function C6(e) {
  return v6.test(e);
}
function Vd() {
  return !1;
}
function S6(e) {
  return b6.test(e);
}
function E6(e) {
  return y6.test(e);
}
const at = /* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isAny: lr,
  isArbitraryImage: Id,
  isArbitraryLength: Zt,
  isArbitraryNumber: yo,
  isArbitraryPosition: zd,
  isArbitraryShadow: Wd,
  isArbitrarySize: Bd,
  isArbitraryValue: de,
  isInteger: sr,
  isLength: zt,
  isNumber: xn,
  isPercent: Fd,
  isTshirtSize: Kt
}, Symbol.toStringTag, {
  value: "Module"
});
function hu() {
  const e = Ne("colors"), t = Ne("spacing"), n = Ne("blur"), r = Ne("brightness"), o = Ne("borderColor"), a = Ne("borderRadius"), i = Ne("borderSpacing"), s = Ne("borderWidth"), l = Ne("contrast"), c = Ne("grayscale"), u = Ne("hueRotate"), d = Ne("invert"), f = Ne("gap"), h = Ne("gradientColorStops"), p = Ne("gradientColorStopPositions"), m = Ne("inset"), g = Ne("margin"), y = Ne("opacity"), b = Ne("padding"), w = Ne("saturate"), S = Ne("scale"), x = Ne("sepia"), M = Ne("skew"), _ = Ne("space"), R = Ne("translate"), B = () => ["auto", "contain", "none"], U = () => ["auto", "hidden", "clip", "visible", "scroll"], F = () => ["auto", de, t], T = () => [de, t], j = () => ["", zt, Zt], A = () => ["auto", xn, de], G = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], N = () => ["solid", "dashed", "dotted", "double", "none"], te = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], oe = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Q = () => ["", "0", de], P = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], L = () => [xn, yo], $ = () => [xn, de];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [lr],
      spacing: [zt, Zt],
      blur: ["none", "", Kt, de],
      brightness: L(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Kt, de],
      borderSpacing: T(),
      borderWidth: j(),
      contrast: L(),
      grayscale: Q(),
      hueRotate: $(),
      invert: Q(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Fd, Zt],
      inset: F(),
      margin: F(),
      opacity: L(),
      padding: T(),
      saturate: L(),
      scale: L(),
      sepia: Q(),
      skew: $(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", de]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Kt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": P()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": P()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...G(), de]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: U()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": U()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": U()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", sr, de]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: F()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", de]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Q()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Q()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", sr, de]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [lr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", sr, de]
        }, de]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": A()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": A()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [lr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [sr, de]
        }, de]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": A()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": A()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", de]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", de]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...oe()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...oe(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...oe(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [_]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [_]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", de, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [de, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [de, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Kt]
        }, Kt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [de, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [de, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [de, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [de, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Kt, Zt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", yo]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [lr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", de]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", xn, yo]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", zt, de]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", de]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", de]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...N(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", zt, Zt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", zt, de]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", de]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", de]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...G(), zd]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Bd]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Id]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...N(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: N()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...N()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [zt, de]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [zt, Zt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: j()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [zt, Zt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Kt, Wd]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [lr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": te()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": te()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Kt, de]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", de]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: $()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", de]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: $()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", de]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [sr, de]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", de]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", de]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", de]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [zt, Zt, yo]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function k6(e, {
  cacheSize: t,
  prefix: n,
  separator: r,
  extend: o = {},
  override: a = {}
}) {
  Sa(e, "cacheSize", t), Sa(e, "prefix", n), Sa(e, "separator", r);
  for (const i in a)
    M6(e[i], a[i]);
  for (const i in o)
    _6(e[i], o[i]);
  return e;
}
function Sa(e, t, n) {
  n !== void 0 && (e[t] = n);
}
function M6(e, t) {
  if (t)
    for (const n in t)
      Sa(e, n, t[n]);
}
function _6(e, t) {
  if (t)
    for (const n in t) {
      const r = t[n];
      r !== void 0 && (e[n] = (e[n] || []).concat(r));
    }
}
function P6(e, ...t) {
  return typeof e == "function" ? fu(hu, e, ...t) : fu(() => k6(hu(), e), ...t);
}
const fn = (e) => /^(alert|info|neutral|primary|skandI|success|warning)-\d{3}$/.test(e), hn = (e) => /^\d+(\.\d+)?(r?(cap|ch|em|ex|ic|lh)|(s|l|d)?(vh|vw|vmin|vmax|vb|vi)|cqw|cqh|cqi|cqb|cmin|cmax|px|cm|mm|Q|in|pc|pt|%)$/i.test(
  e
), O6 = P6({
  extend: {
    classGroups: {
      /**
       * match text-* as font sizes, includes
       *   - text-xs T-shirt size
       *   - text-[20px] arbitrary length
       *   - text-40 number
       *   - text-20px CSS length
       */
      "font-size": [
        {
          text: [
            at.isTshirtSize,
            at.isArbitraryLength,
            at.isNumber,
            hn
          ]
        }
      ],
      // match color-neutral-* as text colors
      "text-color": [{ color: [fn] }],
      // match b-neutral-* as border colors
      "border-color": [{ b: [fn] }],
      // match b-*-neutral-* as border-* colors
      "border-color-x": [{ "b-x": [fn] }],
      "border-color-y": [{ "b-y": [fn] }],
      "border-color-t": [{ "b-t": [fn] }],
      "border-color-l": [{ "b-l": [fn] }],
      "border-color-b": [{ "b-b": [fn] }],
      "border-color-r": [{ "b-r": [fn] }],
      // match b-* as border width
      "border-w": [{ b: [at.isLength, at.isArbitraryLength, hn] }],
      "border-w-x": [{ "b-x": [at.isLength, at.isArbitraryLength, hn] }],
      "border-w-y": [{ "b-y": [at.isLength, at.isArbitraryLength, hn] }],
      "border-w-t": [{ "b-t": [at.isLength, at.isArbitraryLength, hn] }],
      "border-w-l": [{ "b-l": [at.isLength, at.isArbitraryLength, hn] }],
      "border-w-b": [{ "b-b": [at.isLength, at.isArbitraryLength, hn] }],
      "border-w-r": [{ "b-r": [at.isLength, at.isArbitraryLength, hn] }]
    }
  }
}), z = (...e) => O6(Dd(e)), pu = `
bg-neutral-300 color-neutral-800
active:bg-neutral-400 active:inborder-neutral-300
disabled:bg-neutral-300 disabled:color-neutral-400
focus:outborder-neutral-600 
hover:bg-neutral-400
hover:disabled:bg-neutral-300 hover:disabled:color-neutral-400
[&.active]:bg-neutral-400 [&.active]:inborder-neutral-300
`, mu = `
bg-neutral-100 color-neutral-800 inborder-neutral-500
active:bg-neutral-400 active:inborder-neutral-500
disabled:inborder-neutral-300 disabled:color-neutral-400 disabled:bg-neutral-100
focus:inborder-neutral-500 focus:outborder-neutral-300
hover:bg-neutral-300
hover:disabled:inborder-neutral-300 hover:disabled:color-neutral-400 hover:disabled:bg-neutral-100
[&.active]:bg-neutral-400 [&.active]:inborder-neutral-500
`, T6 = `
bg-primary-400 color-neutral-100
active:enabled:bg-primary-500 active:enabled:inborder-primary-400
disabled:bg-neutral-300 disabled:color-neutral-400 disabled:inborder-transparent
focus:outborder-primary-300
hover:bg-primary-500
hover:disabled:bg-neutral-300 hover:disabled:color-neutral-400 hover:disabled:inborder-transparent
[&.active]:enabled:bg-primary-500 [&.active]:enabled:inborder-primary-400
`, A6 = `
bg-neutral-100 inborder-primary-400 color-neutral-800
active:bg-primary-300
disabled:inborder-neutral-300 disabled:color-neutral-400 disabled:bg-neutral-100
focus:outborder-primary-300
hover:bg-primary-200
hover:disabled:inborder-neutral-300 hover:disabled:color-neutral-400 hover:disabled:bg-neutral-100
[&.active]:bg-primary-300
`, $6 = `
bg-skandI-400 color-neutral-100
active:enabled:bg-skandI-500 active:enabled:inborder-skandI-400
disabled:bg-neutral-300 disabled:color-neutral-400
focus:outborder-skandI-200
hover:bg-skandI-500
hover:disabled:bg-neutral-300 hover:disabled:color-neutral-400
[&.active]:enabled:bg-skandI-500 [&.active]:enabled:inborder-skandI-400
`, R6 = `
bg-neutral-100 inborder-skandI-400 color-neutral-800
active:bg-skandI-300
disabled:inborder-neutral-300 disabled:color-neutral-400 disabled:bg-neutral-100
focus:outborder-skandI-200
hover:bg-skandI-200
hover:disabled:inborder-neutral-300 hover:disabled:color-neutral-400 hover:disabled:bg-neutral-100
[&.active]:bg-skandI-300
`, D6 = {
  v2: {
    filled: {
      primary: T6,
      secondary: pu
    },
    outlined: {
      primary: A6,
      secondary: mu
    }
  },
  v1: {
    filled: {
      primary: $6,
      secondary: pu
    },
    outlined: {
      primary: R6,
      secondary: mu
    }
  }
}, N6 = {
  m: "m",
  medium: "m",
  s: "s",
  small: "s",
  xs: "xs",
  extraSmall: "xs"
}, L6 = (e) => N6[e], xl = qt(
  ({ active: e, children: t, size: n = "m", filled: r, primary: o, v1: a, className: i, ...s }, l) => {
    const c = L6(n), u = a ? "v1" : "v2", d = r ? "filled" : "outlined", f = o ? "primary" : "secondary";
    return /* @__PURE__ */ C.jsx(
      "button",
      {
        className: z(
          e && "active",
          "border-0",
          "dual-border",
          "duration-300",
          "ease-out",
          "inborder-transparent",
          "outborder-2",
          "outborder-transparent",
          "outline-none",
          "transition",
          c === "m" && ["p-x-4", "p-y-2", "rounded-2", "typo-text-m", "inborder-2"],
          c === "s" && ["p-x-2", "p-y-1", "rounded-1", "typo-text-s", "inborder-1"],
          c === "xs" && [
            "inborder-1",
            "p-x-1",
            "p-y-2px",
            "rounded-1",
            "typo-button-xs",
            "uppercase"
          ],
          D6[u][d][f],
          i
        ),
        ref: l,
        ...s,
        children: t
      }
    );
  }
);
xl.displayName = "Button";
xl.defaultProps = {
  active: !1,
  filled: !1,
  primary: !1,
  size: "m",
  v1: !1
};
var ae;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(ae || (ae = {}));
var Re;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Re || (Re = {}));
var tt;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(tt || (tt = {}));
const Yd = 6048e5, j6 = 864e5, gu = Symbol.for("constructDateFrom");
function ot(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && gu in e ? e[gu](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function De(e, t) {
  return ot(t || e, e);
}
function qd(e, t, n) {
  const r = De(e, n == null ? void 0 : n.in);
  return isNaN(t) ? ot((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Ud(e, t, n) {
  const r = De(e, n == null ? void 0 : n.in);
  if (isNaN(t))
    return ot((n == null ? void 0 : n.in) || e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), a = ot((n == null ? void 0 : n.in) || e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const i = a.getDate();
  return o >= i ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    o
  ), r);
}
let H6 = {};
function Vo() {
  return H6;
}
function Tr(e, t) {
  var s, l, c, u;
  const n = Vo(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = De(e, t == null ? void 0 : t.in), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function $o(e, t) {
  return Tr(e, { ...t, weekStartsOn: 1 });
}
function Gd(e, t) {
  const n = De(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = ot(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = $o(o), i = ot(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const s = $o(i);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function vu(e) {
  const t = De(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Yo(e, ...t) {
  const n = ot.bind(
    null,
    e || t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ro(e, t) {
  const n = De(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Xd(e, t, n) {
  const [r, o] = Yo(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = Ro(r), i = Ro(o), s = +a - vu(a), l = +i - vu(i);
  return Math.round((s - l) / j6);
}
function F6(e, t) {
  const n = Gd(e, t), r = ot((t == null ? void 0 : t.in) || e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), $o(r);
}
function B6(e, t, n) {
  return qd(e, t * 7, n);
}
function z6(e, t, n) {
  return Ud(e, t * 12, n);
}
function I6(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = ot.bind(null, o));
    const a = De(o, r);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), ot(r, n || NaN);
}
function W6(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = ot.bind(null, o));
    const a = De(o, r);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), ot(r, n || NaN);
}
function V6(e, t, n) {
  const [r, o] = Yo(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Ro(r) == +Ro(o);
}
function Zd(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Y6(e) {
  return !(!Zd(e) && typeof e != "number" || isNaN(+De(e)));
}
function q6(e, t, n) {
  const [r, o] = Yo(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = r.getFullYear() - o.getFullYear(), i = r.getMonth() - o.getMonth();
  return a * 12 + i;
}
function U6(e, t) {
  const n = De(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function G6(e, t) {
  const n = De(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function X6(e, t) {
  const n = De(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Kd(e, t) {
  const n = De(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Qd(e, t) {
  var s, l, c, u;
  const n = Vo(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = De(e, t == null ? void 0 : t.in), a = o.getDay(), i = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function Z6(e, t) {
  return Qd(e, { ...t, weekStartsOn: 1 });
}
const K6 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Q6 = (e, t, n) => {
  let r;
  const o = K6[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function zi(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const J6 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, e4 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, t4 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, n4 = {
  date: zi({
    formats: J6,
    defaultWidth: "full"
  }),
  time: zi({
    formats: e4,
    defaultWidth: "full"
  }),
  dateTime: zi({
    formats: t4,
    defaultWidth: "full"
  })
}, r4 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, o4 = (e, t, n, r) => r4[e];
function io(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const a4 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, i4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, s4 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, l4 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, c4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, u4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, d4 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, f4 = {
  ordinalNumber: d4,
  era: io({
    values: a4,
    defaultWidth: "wide"
  }),
  quarter: io({
    values: i4,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: io({
    values: s4,
    defaultWidth: "wide"
  }),
  day: io({
    values: l4,
    defaultWidth: "wide"
  }),
  dayPeriod: io({
    values: c4,
    defaultWidth: "wide",
    formattingValues: u4,
    defaultFormattingWidth: "wide"
  })
};
function so(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? p4(s, (d) => d.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      h4(s, (d) => d.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(i.length);
    return { value: c, rest: u };
  };
}
function h4(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function p4(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function m4(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const g4 = /^(\d+)(th|st|nd|rd)?/i, v4 = /\d+/i, b4 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, y4 = {
  any: [/^b/i, /^(a|c)/i]
}, w4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, x4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, C4 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, S4 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, E4 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, k4 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, M4 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, _4 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, P4 = {
  ordinalNumber: m4({
    matchPattern: g4,
    parsePattern: v4,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: so({
    matchPatterns: b4,
    defaultMatchWidth: "wide",
    parsePatterns: y4,
    defaultParseWidth: "any"
  }),
  quarter: so({
    matchPatterns: w4,
    defaultMatchWidth: "wide",
    parsePatterns: x4,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: so({
    matchPatterns: C4,
    defaultMatchWidth: "wide",
    parsePatterns: S4,
    defaultParseWidth: "any"
  }),
  day: so({
    matchPatterns: E4,
    defaultMatchWidth: "wide",
    parsePatterns: k4,
    defaultParseWidth: "any"
  }),
  dayPeriod: so({
    matchPatterns: M4,
    defaultMatchWidth: "any",
    parsePatterns: _4,
    defaultParseWidth: "any"
  })
}, ei = {
  code: "en-US",
  formatDistance: Q6,
  formatLong: n4,
  formatRelative: o4,
  localize: f4,
  match: P4,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function O4(e, t) {
  const n = De(e, t == null ? void 0 : t.in);
  return Xd(n, Kd(n)) + 1;
}
function Jd(e, t) {
  const n = De(e, t == null ? void 0 : t.in), r = +$o(n) - +F6(n);
  return Math.round(r / Yd) + 1;
}
function ef(e, t) {
  var u, d, f, h;
  const n = De(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = Vo(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = ot((t == null ? void 0 : t.in) || e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = Tr(i, t), l = ot((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const c = Tr(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function T4(e, t) {
  var s, l, c, u;
  const n = Vo(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = ef(e, t), a = ot((t == null ? void 0 : t.in) || e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), Tr(a, t);
}
function tf(e, t) {
  const n = De(e, t == null ? void 0 : t.in), r = +Tr(n, t) - +T4(n, t);
  return Math.round(r / Yd) + 1;
}
function Oe(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const pn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Oe(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Oe(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Oe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Oe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Oe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Oe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Oe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Oe(o, t.length);
  }
}, rr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, bu = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return pn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = ef(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return Oe(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Oe(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Gd(e);
    return Oe(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Oe(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Oe(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Oe(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return pn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Oe(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = tf(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Oe(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Jd(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Oe(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : pn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = O4(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Oe(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return Oe(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return Oe(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Oe(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = rr.noon : r === 0 ? o = rr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = rr.evening : r >= 12 ? o = rr.afternoon : r >= 4 ? o = rr.morning : o = rr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return pn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : pn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Oe(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Oe(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : pn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : pn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return pn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return wu(r);
      case "XXXX":
      case "XX":
        return $n(r);
      case "XXXXX":
      case "XXX":
      default:
        return $n(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return wu(r);
      case "xxxx":
      case "xx":
        return $n(r);
      case "xxxxx":
      case "xxx":
      default:
        return $n(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + yu(r, ":");
      case "OOOO":
      default:
        return "GMT" + $n(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + yu(r, ":");
      case "zzzz":
      default:
        return "GMT" + $n(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Oe(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Oe(+e, t.length);
  }
};
function yu(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + Oe(a, 2);
}
function wu(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Oe(Math.abs(e) / 60, 2) : $n(e, t);
}
function $n(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Oe(Math.trunc(r / 60), 2), a = Oe(r % 60, 2);
  return n + o + t + a;
}
const xu = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, nf = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, A4 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return xu(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", xu(r, t)).replace("{{time}}", nf(o, t));
}, $4 = {
  p: nf,
  P: A4
}, R4 = /^D+$/, D4 = /^Y+$/, N4 = ["D", "DD", "YY", "YYYY"];
function L4(e) {
  return R4.test(e);
}
function j4(e) {
  return D4.test(e);
}
function H4(e, t, n) {
  const r = F4(e, t, n);
  if (console.warn(r), N4.includes(e))
    throw new RangeError(r);
}
function F4(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const B4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, z4 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, I4 = /^'([^]*?)'?$/, W4 = /''/g, V4 = /[a-zA-Z]/;
function Y4(e, t, n) {
  var u, d, f, h, p, m, g, y;
  const r = Vo(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? ei, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((y = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = De(e, n == null ? void 0 : n.in);
  if (!Y6(s))
    throw new RangeError("Invalid time value");
  let l = t.match(z4).map((b) => {
    const w = b[0];
    if (w === "p" || w === "P") {
      const S = $4[w];
      return S(b, o.formatLong);
    }
    return b;
  }).join("").match(B4).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const w = b[0];
    if (w === "'")
      return { isToken: !1, value: q4(b) };
    if (bu[w])
      return { isToken: !0, value: b };
    if (w.match(V4))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: b };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((b) => {
    if (!b.isToken)
      return b.value;
    const w = b.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && j4(w) || !(n != null && n.useAdditionalDayOfYearTokens) && L4(w)) && H4(w, t, String(e));
    const S = bu[w[0]];
    return S(s, w, o.localize, c);
  }).join("");
}
function q4(e) {
  const t = e.match(I4);
  return t ? t[1].replace(W4, "'") : e;
}
function U4(e, t) {
  const n = De(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), a = ot(n, 0);
  return a.setFullYear(r, o + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function G4(e, t) {
  return +De(e) > +De(t);
}
function X4(e, t) {
  return +De(e) < +De(t);
}
function Z4(e, t, n) {
  const [r, o] = Yo(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function K4(e, t, n) {
  const [r, o] = Yo(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function Q4(e, t, n) {
  const r = De(e, n == null ? void 0 : n.in), o = r.getFullYear(), a = r.getDate(), i = ot((n == null ? void 0 : n.in) || e, 0);
  i.setFullYear(o, t, 15), i.setHours(0, 0, 0, 0);
  const s = U4(i);
  return r.setMonth(t, Math.min(a, s)), r;
}
function J4(e, t, n) {
  const r = De(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? ot((n == null ? void 0 : n.in) || e, NaN) : (r.setFullYear(t), r);
}
class rn {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.addDays = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addDays ? this.overrides.addDays(r, o) : qd(r, o);
    }, this.addMonths = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addMonths ? this.overrides.addMonths(r, o) : Ud(r, o);
    }, this.addWeeks = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addWeeks ? this.overrides.addWeeks(r, o) : B6(r, o);
    }, this.addYears = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addYears ? this.overrides.addYears(r, o) : z6(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Xd(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : q6(r, o);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : Z6(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : U6(r);
    }, this.endOfWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfWeek ? this.overrides.endOfWeek(r, this.options) : Qd(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : X6(r);
    }, this.format = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.format ? this.overrides.format(r, o, this.options) : Y4(r, o, this.options);
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : Jd(r);
    }, this.getWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getWeek ? this.overrides.getWeek(r, this.options) : tf(r, this.options);
    }, this.isAfter = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isAfter ? this.overrides.isAfter(r, o) : G4(r, o);
    }, this.isBefore = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isBefore ? this.overrides.isBefore(r, o) : X4(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : Zd(r);
    }, this.isSameDay = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isSameDay ? this.overrides.isSameDay(r, o) : V6(r, o);
    }, this.isSameMonth = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isSameMonth ? this.overrides.isSameMonth(r, o) : Z4(r, o);
    }, this.isSameYear = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isSameYear ? this.overrides.isSameYear(r, o) : K4(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : I6(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : W6(r);
    }, this.setMonth = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.setMonth ? this.overrides.setMonth(r, o) : Q4(r, o);
    }, this.setYear = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.setYear ? this.overrides.setYear(r, o) : J4(r, o);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : Ro(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : $o(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : G6(r);
    }, this.startOfWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Tr(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : Kd(r);
    }, this.options = { locale: ei, ...t }, this.overrides = n;
  }
}
const Yn = new rn();
function e5(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [a]) => (n[a] ? o.push(n[a]) : t[Re[a]] ? o.push(t[Re[a]]) : t[tt[a]] && o.push(t[tt[a]]), o), [t[ae.Day]]);
}
function t5(e) {
  return v.createElement("button", { ...e });
}
function n5(e) {
  return v.createElement("span", { ...e });
}
function r5(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return v.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && v.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && v.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && v.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && v.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" })
  );
}
function o5(e) {
  const { day: t, modifiers: n, ...r } = e;
  return v.createElement("td", { ...r });
}
function a5(e) {
  const { day: t, modifiers: n, ...r } = e, o = v.useRef(null);
  return v.useEffect(() => {
    var a;
    n.focused && ((a = o.current) == null || a.focus());
  }, [n.focused]), v.createElement("button", { ref: o, ...r });
}
function i5(e) {
  const { options: t, className: n, components: r, classNames: o, ...a } = e, i = [o[ae.Dropdown], n].join(" "), s = t == null ? void 0 : t.find(({ value: l }) => l === a.value);
  return v.createElement(
    "span",
    { "data-disabled": a.disabled, className: o[ae.DropdownRoot] },
    v.createElement(r.Select, { className: i, ...a }, t == null ? void 0 : t.map(({ value: l, label: c, disabled: u }) => v.createElement(r.Option, { key: l, value: l, disabled: u }, c))),
    v.createElement(
      "span",
      { className: o[ae.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      v.createElement(r.Chevron, { orientation: "down", size: 18, className: o[ae.Chevron] })
    )
  );
}
function s5(e) {
  return v.createElement("div", { ...e });
}
function l5(e) {
  return v.createElement("div", { ...e });
}
function c5(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return v.createElement("div", { ...r }, e.children);
}
function u5(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return v.createElement("div", { ...r });
}
function d5(e) {
  return v.createElement("table", { ...e });
}
function f5(e) {
  return v.createElement("div", { ...e });
}
const rf = X3(void 0);
function qo() {
  const e = gl(rf);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function h5(e) {
  const { components: t } = qo();
  return v.createElement(t.Dropdown, { ...e });
}
function p5(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...a } = e, { components: i, classNames: s, labels: { labelPrevious: l, labelNext: c } } = qo();
  return v.createElement(
    "nav",
    { ...a },
    v.createElement(
      i.PreviousMonthButton,
      { type: "button", className: s[ae.PreviousMonthButton], tabIndex: r ? void 0 : -1, disabled: r ? void 0 : !0, "aria-label": l(r), onClick: e.onPreviousClick },
      v.createElement(i.Chevron, { disabled: r ? void 0 : !0, className: s[ae.Chevron], orientation: "left" })
    ),
    v.createElement(
      i.NextMonthButton,
      { type: "button", className: s[ae.NextMonthButton], tabIndex: o ? void 0 : -1, disabled: o ? void 0 : !0, "aria-label": c(o), onClick: e.onNextClick },
      v.createElement(i.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: s[ae.Chevron] })
    )
  );
}
function m5(e) {
  const { components: t } = qo();
  return v.createElement(t.Button, { ...e });
}
function g5(e) {
  return v.createElement("option", { ...e });
}
function v5(e) {
  const { components: t } = qo();
  return v.createElement(t.Button, { ...e });
}
function b5(e) {
  return v.createElement("div", { ...e });
}
function y5(e) {
  return v.createElement("select", { ...e });
}
function w5(e) {
  const { week: t, ...n } = e;
  return v.createElement("tr", { ...n });
}
function x5(e) {
  return v.createElement("th", { ...e });
}
function C5(e) {
  return v.createElement(
    "thead",
    null,
    v.createElement("tr", { ...e })
  );
}
function S5(e) {
  const { week: t, ...n } = e;
  return v.createElement("th", { ...n });
}
function E5(e) {
  return v.createElement("th", { ...e });
}
function k5(e) {
  return v.createElement("tbody", { ...e });
}
function M5(e) {
  const { components: t } = qo();
  return v.createElement(t.Dropdown, { ...e });
}
const _5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: t5,
  CaptionLabel: n5,
  Chevron: r5,
  Day: o5,
  DayButton: a5,
  Dropdown: i5,
  DropdownNav: s5,
  Footer: l5,
  Month: c5,
  MonthCaption: u5,
  MonthGrid: d5,
  Months: f5,
  MonthsDropdown: h5,
  Nav: p5,
  NextMonthButton: m5,
  Option: g5,
  PreviousMonthButton: v5,
  Root: b5,
  Select: y5,
  Week: w5,
  WeekNumber: S5,
  WeekNumberHeader: E5,
  Weekday: x5,
  Weekdays: C5,
  Weeks: k5,
  YearsDropdown: M5
}, Symbol.toStringTag, { value: "Module" }));
function P5(e) {
  return {
    ..._5,
    ...e
  };
}
function O5(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function T5() {
  const e = {};
  for (const t in ae)
    e[ae[t]] = `rdp-${ae[t]}`;
  for (const t in Re)
    e[Re[t]] = `rdp-${Re[t]}`;
  for (const t in tt)
    e[tt[t]] = `rdp-${tt[t]}`;
  return e;
}
function of(e, t, n) {
  return (n ?? new rn(t)).format(e, "LLLL y");
}
const A5 = of;
function $5(e, t, n) {
  return (n ?? new rn(t)).format(e, "d");
}
function R5(e, t = ei) {
  var n;
  return (n = t.localize) == null ? void 0 : n.month(e);
}
function D5(e) {
  return e < 10 ? `0${e.toLocaleString()}` : `${e.toLocaleString()}`;
}
function N5() {
  return "";
}
function L5(e, t, n) {
  return (n ?? new rn(t)).format(e, "cccccc");
}
function af(e) {
  return e.toString();
}
const j5 = af, H5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: of,
  formatDay: $5,
  formatMonthCaption: A5,
  formatMonthDropdown: R5,
  formatWeekNumber: D5,
  formatWeekNumberHeader: N5,
  formatWeekdayName: L5,
  formatYearCaption: j5,
  formatYearDropdown: af
}, Symbol.toStringTag, { value: "Module" }));
function F5(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...H5,
    ...e
  };
}
function B5(e, t, n, r, o) {
  if (!t || !n)
    return;
  const { addMonths: a, startOfMonth: i, isBefore: s } = o, l = e.getFullYear(), c = [];
  let u = t;
  for (; c.length < 12 && s(u, a(n, 1)); )
    c.push(u.getMonth()), u = a(u, 1);
  return c.sort((h, p) => h - p).map((h) => {
    const p = r.formatMonthDropdown(h, o.options.locale), m = o.Date ? new o.Date(l, h) : new Date(l, h), g = t && m < i(t) || n && m > i(n) || !1;
    return { value: h, label: p, disabled: g };
  });
}
function z5(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[ae.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
const Ii = {}, wo = {};
function _o(e, t) {
  try {
    const r = (Ii[e] || (Ii[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in wo ? wo[r] : Cu(r, r.split(":"));
  } catch {
    if (e in wo)
      return wo[e];
    const n = e == null ? void 0 : e.match(I5);
    return n ? Cu(e, n.slice(1)) : NaN;
  }
}
const I5 = /([+-]\d\d):?(\d\d)?/;
function Cu(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return wo[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Wt extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(_o(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), sf(this), Ts(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Wt(...n, t) : new Wt(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Wt(+this, t);
  }
  getTimezoneOffset() {
    return -_o(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), Ts(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Wt(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Su = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Su.test(e))
    return;
  const t = e.replace(Su, "$1UTC");
  Wt.prototype[t] && (e.startsWith("get") ? Wt.prototype[e] = function() {
    return this.internal[t]();
  } : (Wt.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), W5(this), +this;
  }, Wt.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), Ts(this), +this;
  }));
});
function Ts(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function W5(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), sf(e);
}
function sf(e) {
  const t = _o(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), o = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), a = r - o, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  a && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + a);
  const s = r - t;
  s && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + s);
  const l = _o(e.timeZone, e), u = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - l, d = l !== t, f = u - s;
  if (d && f) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + f);
    const h = _o(e.timeZone, e), p = l - h;
    p && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + p), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + p));
  }
}
class Vt extends Wt {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Vt(...n, t) : new Vt(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${V5(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Vt(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Vt(+new Date(t), this.timeZone);
  }
  //#endregion
}
function V5(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
function Y5(e, t, n) {
  const r = n ? Vt.tz(n) : e.Date ? new e.Date() : /* @__PURE__ */ new Date(), o = t ? e.startOfISOWeek(r) : e.startOfWeek(r), a = [];
  for (let i = 0; i < 7; i++) {
    const s = e.addDays(o, i);
    a.push(s);
  }
  return a;
}
function q5(e, t, n, r, o) {
  if (!t || !n)
    return;
  const { startOfMonth: a, startOfYear: i, endOfYear: s, addYears: l, isBefore: c, isSameYear: u } = o, d = e.getMonth(), f = i(t), h = s(n), p = [];
  let m = f;
  for (; c(m, h) || u(m, h); )
    p.push(m.getFullYear()), m = l(m, 1);
  return p.map((g) => {
    const y = o.Date ? new o.Date(g, d) : new Date(g, d), b = t && y < a(t) || d && n && y > a(n) || !1, w = r.formatYearDropdown(g);
    return {
      value: g,
      label: w,
      disabled: b
    };
  });
}
function lf(e, t, n) {
  return (n ?? new rn(t)).format(e, "LLLL y");
}
const U5 = lf;
function G5(e, t, n, r) {
  let o = (r ?? new rn(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function cf(e, t, n, r) {
  let o = (r ?? new rn(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const X5 = cf;
function Z5() {
  return "";
}
function K5(e) {
  return "Choose the Month";
}
function Q5(e) {
  return "Go to the Next Month";
}
function J5(e) {
  return "Go to the Previous Month";
}
function e8(e, t, n) {
  return (n ?? new rn(t)).format(e, "cccc");
}
function t8(e, t) {
  return `Week ${e}`;
}
function n8(e) {
  return "Week Number";
}
function r8(e) {
  return "Choose the Year";
}
const o8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: U5,
  labelDay: X5,
  labelDayButton: cf,
  labelGrid: lf,
  labelGridcell: G5,
  labelMonthDropdown: K5,
  labelNav: Z5,
  labelNext: Q5,
  labelPrevious: J5,
  labelWeekNumber: t8,
  labelWeekNumberHeader: n8,
  labelWeekday: e8,
  labelYearDropdown: r8
}, Symbol.toStringTag, { value: "Module" })), a8 = 42;
function i8(e, t, n, r) {
  const o = e[0], a = e[e.length - 1], { ISOWeek: i, fixedWeeks: s } = n ?? {}, { startOfWeek: l, endOfWeek: c, startOfISOWeek: u, endOfISOWeek: d, addDays: f, differenceInCalendarDays: h, differenceInCalendarMonths: p, isAfter: m, endOfMonth: g } = r, y = i ? u(o) : l(o), b = i ? d(g(a)) : c(g(a)), w = h(b, y), S = p(a, o) + 1, x = [];
  for (let _ = 0; _ <= w; _++) {
    const R = f(y, _);
    if (t && m(R, t))
      break;
    x.push(R);
  }
  const M = a8 * S;
  if (s && x.length < M)
    for (let _ = 0; _ < 7; _++) {
      const R = f(x[x.length - 1], 1);
      x.push(R);
    }
  return x;
}
function s8(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = [], a = r.weeks.reduce((i, s) => [...i, ...s.days], o);
    return [...n, ...a];
  }, t);
}
function l8(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, a = [];
  for (let i = 0; i < o; i++) {
    const s = r.addMonths(e, i);
    if (t && s > t)
      break;
    a.push(s);
  }
  return a;
}
function Eu(e, t) {
  const { month: n, defaultMonth: r, today: o = e.timeZone ? Vt.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date(), numberOfMonths: a = 1, endMonth: i, startMonth: s } = e;
  let l = n || r || o;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = t;
  if (i && c(i, l) < 0) {
    const f = -1 * (a - 1);
    l = u(i, f);
  }
  return s && c(l, s) < 0 && (l = s), d(l);
}
class uf {
  constructor(t, n, r = Yn) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class c8 {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class u8 {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function d8(e, t, n, r) {
  const { startOfWeek: o, endOfWeek: a, startOfISOWeek: i, endOfISOWeek: s, endOfMonth: l, addDays: c, getWeek: u, getISOWeek: d } = r, f = e.reduce((h, p) => {
    const m = n.ISOWeek ? i(p) : o(p), g = n.ISOWeek ? s(l(p)) : a(l(p)), y = t.filter((S) => S >= m && S <= g);
    if (n.fixedWeeks && y.length < 42) {
      const S = t.filter((x) => x > g && x <= c(g, 7));
      y.push(...S);
    }
    const b = y.reduce((S, x) => {
      const M = n.ISOWeek ? d(x) : u(x), _ = S.find((B) => B.weekNumber === M), R = new uf(x, p, r);
      return _ ? _.days.push(R) : S.push(new u8(M, [R])), S;
    }, []), w = new c8(p, b);
    return h.push(w), h;
  }, []);
  return n.reverseMonths ? f.reverse() : f;
}
function f8(e, t) {
  var m;
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: a, startOfMonth: i, endOfMonth: s, addYears: l, endOfYear: c } = t, { fromYear: u, toYear: d, fromMonth: f, toMonth: h } = e;
  !n && f && (n = f), !n && u && (n = new Date(u, 0, 1)), !r && h && (r = h), !r && d && (r = new Date(d, 11, 31));
  const p = (m = e.captionLayout) == null ? void 0 : m.startsWith("dropdown");
  if (n)
    n = i(n);
  else if (u)
    n = new Date(u, 0, 1);
  else if (!n && p) {
    const g = e.today ?? (e.timeZone ? Vt.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    n = o(l(g, -100));
  }
  if (r)
    r = s(r);
  else if (d)
    r = new Date(d, 11, 31);
  else if (!r && p) {
    const g = e.today ?? (e.timeZone ? Vt.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    r = c(g);
  }
  return [
    n && a(n),
    r && a(r)
  ];
}
function h8(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a = 1 } = n, { startOfMonth: i, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? a : 1, u = i(e);
  if (!t)
    return s(u, c);
  if (!(l(t, e) < a))
    return s(u, c);
}
function p8(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a } = n, { startOfMonth: i, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? a ?? 1 : 1, u = i(e);
  if (!t)
    return s(u, -c);
  if (!(l(u, t) <= 0))
    return s(u, -c);
}
function m8(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function ti(e, t) {
  const [n, r] = he(e);
  return [t === void 0 ? n : t, r];
}
function g8(e, t) {
  const [n, r] = f8(e, t), { startOfMonth: o, endOfMonth: a } = t, i = Eu(e, t), [s, l] = ti(i, e.month ? o(e.month) : void 0);
  nt(() => {
    const M = Eu(e, t);
    l(M);
  }, [e.timeZone]);
  const c = l8(s, r, e, t), u = i8(c, e.endMonth ? a(e.endMonth) : void 0, e, t), d = d8(c, u, e, t), f = m8(d), h = s8(d), p = p8(s, n, e, t), m = h8(s, r, e, t), { disableNavigation: g, onMonthChange: y } = e, b = (M) => f.some((_) => _.days.some((R) => R.isEqualTo(M))), w = (M) => {
    if (g)
      return;
    let _ = o(M);
    n && _ < o(n) && (_ = o(n)), r && _ > o(r) && (_ = o(r)), l(_), y == null || y(_);
  };
  return {
    months: d,
    weeks: f,
    days: h,
    navStart: n,
    navEnd: r,
    previousMonth: p,
    nextMonth: m,
    goToMonth: w,
    goToDay: (M) => {
      b(M) || w(M.date);
    }
  };
}
function v8(e, t, n, r) {
  let o, a = 0, i = !1;
  for (; a < e.length && !i; ) {
    const s = e[a], l = t(s);
    !l[Re.disabled] && !l[Re.hidden] && !l[Re.outside] && (l[Re.focused] || r != null && r.isEqualTo(s) || n(s.date) || l[Re.today]) && (o = s, i = !0), a++;
  }
  return o || (o = e.find((s) => {
    const l = t(s);
    return !l[Re.disabled] && !l[Re.hidden] && !l[Re.outside];
  })), o;
}
function Qt(e, t, n = !1, r = Yn) {
  let { from: o, to: a } = e;
  const { differenceInCalendarDays: i, isSameDay: s } = r;
  return o && a ? (i(a, o) < 0 && ([o, a] = [a, o]), i(t, o) >= (n ? 1 : 0) && i(a, t) >= (n ? 1 : 0)) : !n && a ? s(a, t) : !n && o ? s(o, t) : !1;
}
function df(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Cl(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function ff(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function hf(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function pf(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function mf(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Jt(e, t, n = Yn) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: a, isAfter: i } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return o(e, s);
    if (mf(s, n))
      return s.includes(e);
    if (Cl(s))
      return Qt(s, e, !1, n);
    if (pf(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (df(s)) {
      const l = a(s.before, e), c = a(s.after, e), u = l > 0, d = c < 0;
      return i(s.before, s.after) ? d && u : u || d;
    }
    return ff(s) ? a(e, s.after) > 0 : hf(s) ? a(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function b8(e, t, n, r, o, a, i) {
  const { ISOWeek: s } = a, { addDays: l, addMonths: c, addYears: u, addWeeks: d, startOfISOWeek: f, endOfISOWeek: h, startOfWeek: p, endOfWeek: m, max: g, min: y } = i;
  let w = {
    day: l,
    week: d,
    month: c,
    year: u,
    startOfWeek: (S) => s ? f(S) : p(S),
    endOfWeek: (S) => s ? h(S) : m(S)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? w = g([r, w]) : t === "after" && o && (w = y([o, w])), w;
}
function gf(e, t, n, r, o, a, i, s = 0) {
  if (s > 365)
    return;
  const l = b8(
    e,
    t,
    n.date,
    // should be refDay? or refDay.date?
    r,
    o,
    a,
    i
  ), c = !!(a.disabled && Jt(l, a.disabled, i)), u = !!(a.hidden && Jt(l, a.hidden, i)), d = l, f = new uf(l, d, i);
  return !c && !u ? f : gf(e, t, f, r, o, a, i, s + 1);
}
function y8(e, t, n, r, o) {
  const { autoFocus: a } = e, [i, s] = he(), l = v8(t.days, n, r || (() => !1), i), [c, u] = he(a ? l : void 0);
  return {
    isFocusTarget: (m) => !!(l != null && l.isEqualTo(m)),
    setFocused: u,
    focused: c,
    blur: () => {
      s(c), u(void 0);
    },
    moveFocus: (m, g) => {
      if (!c)
        return;
      const y = gf(m, g, c, t.navStart, t.navEnd, e, o);
      y && (t.goToDay(y), u(y));
    }
  };
}
function w8(e, t, n) {
  const { disabled: r, hidden: o, modifiers: a, showOutsideDays: i, today: s } = t, { isSameDay: l, isSameMonth: c } = n, u = {
    [Re.focused]: [],
    [Re.outside]: [],
    [Re.disabled]: [],
    [Re.hidden]: [],
    [Re.today]: []
  }, d = {}, f = {
    [tt.range_end]: [],
    [tt.range_middle]: [],
    [tt.range_start]: [],
    [tt.selected]: []
  };
  for (const h of e) {
    const { date: p, displayMonth: m } = h, g = !!(m && !c(p, m)), y = !!(r && Jt(p, r, n)), b = !!(o && Jt(p, o, n)) || !i && g, w = l(p, s ?? (t.timeZone ? Vt.tz(t.timeZone) : n.Date ? new n.Date() : /* @__PURE__ */ new Date()));
    g && u.outside.push(h), y && u.disabled.push(h), b && u.hidden.push(h), w && u.today.push(h), a && Object.keys(a).forEach((S) => {
      const x = a == null ? void 0 : a[S];
      x && Jt(p, x, n) && (d[S] ? d[S].push(h) : d[S] = [h]);
    });
  }
  return (h) => {
    const p = {
      [Re.focused]: !1,
      [Re.disabled]: !1,
      [Re.hidden]: !1,
      [Re.outside]: !1,
      [Re.today]: !1
    }, m = {
      [tt.range_end]: !1,
      [tt.range_middle]: !1,
      [tt.range_start]: !1,
      [tt.selected]: !1
    }, g = {};
    for (const y in u) {
      const b = u[y];
      p[y] = b.some((w) => w === h);
    }
    for (const y in f) {
      const b = f[y];
      m[y] = b.some((w) => w === h);
    }
    for (const y in d)
      g[y] = d[y].some((b) => b === h);
    return {
      ...m,
      ...p,
      // custom modifiers should override all the previous ones
      ...g
    };
  };
}
function x8(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, i] = ti(n, o ? n : void 0), s = o ? n : a, { isSameDay: l } = t, c = (h) => (s == null ? void 0 : s.some((p) => l(p, h))) ?? !1, { min: u, max: d } = e;
  return {
    selected: s,
    select: (h, p, m) => {
      let g = [...s ?? []];
      if (c(h)) {
        if ((s == null ? void 0 : s.length) === u || r && (s == null ? void 0 : s.length) === 1)
          return;
        g = s == null ? void 0 : s.filter((y) => !l(y, h));
      } else
        (s == null ? void 0 : s.length) === d ? g = [h] : g = [...g, h];
      return o || i(g), o == null || o(g, h, p, m), g;
    },
    isSelected: c
  };
}
function C8(e, t, n = 0, r = 0, o = !1, a = Yn) {
  const { from: i, to: s } = t || {}, { isSameDay: l, isAfter: c, isBefore: u } = a;
  let d;
  if (!i && !s)
    d = { from: e, to: n > 0 ? void 0 : e };
  else if (i && !s)
    l(i, e) ? o ? d = { from: i, to: void 0 } : d = void 0 : u(e, i) ? d = { from: e, to: i } : d = { from: i, to: e };
  else if (i && s)
    if (l(i, e) && l(s, e))
      o ? d = { from: i, to: s } : d = void 0;
    else if (l(i, e))
      d = { from: i, to: n > 0 ? void 0 : e };
    else if (l(s, e))
      d = { from: e, to: n > 0 ? void 0 : e };
    else if (u(e, i))
      d = { from: e, to: s };
    else if (c(e, i))
      d = { from: i, to: e };
    else if (c(e, s))
      d = { from: i, to: e };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const f = a.differenceInCalendarDays(d.to, d.from);
    r > 0 && f > r ? d = { from: e, to: void 0 } : n > 1 && f < n && (d = { from: e, to: void 0 });
  }
  return d;
}
function S8(e, t, n = Yn) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), i = Math.min(a, 6);
  for (let s = 0; s <= i; s++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function ku(e, t, n = Yn) {
  return Qt(e, t.from, !1, n) || Qt(e, t.to, !1, n) || Qt(t, e.from, !1, n) || Qt(t, e.to, !1, n);
}
function E8(e, t, n = Yn) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Qt(e, s, !1, n) : mf(s, n) ? s.some((l) => Qt(e, l, !1, n)) : Cl(s) ? s.from && s.to ? ku(e, { from: s.from, to: s.to }, n) : !1 : pf(s) ? S8(e, s.dayOfWeek, n) : df(s) ? n.isAfter(s.before, s.after) ? ku(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Jt(e.from, s, n) || Jt(e.to, s, n) : ff(s) || hf(s) ? Jt(e.from, s, n) || Jt(e.to, s, n) : !1))
    return !0;
  const i = r.filter((s) => typeof s == "function");
  if (i.length) {
    let s = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (i.some((u) => u(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function k8(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: a, onSelect: i } = e, [s, l] = ti(o, i ? o : void 0), c = i ? o : s;
  return {
    selected: c,
    select: (f, h, p) => {
      const { min: m, max: g } = e, y = f ? C8(f, c, m, g, a, t) : void 0;
      return r && n && (y != null && y.from) && y.to && E8({ from: y.from, to: y.to }, n, t) && (y.from = f, y.to = void 0), i || l(y), i == null || i(y, f, h, p), y;
    },
    isSelected: (f) => c && Qt(c, f, !1, t)
  };
}
function M8(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, i] = ti(n, o ? n : void 0), s = o ? n : a, { isSameDay: l } = t;
  return {
    selected: s,
    select: (d, f, h) => {
      let p = d;
      return !r && s && s && l(d, s) && (p = void 0), o || i(p), o == null || o(p, d, f, h), p;
    },
    isSelected: (d) => s ? l(s, d) : !1
  };
}
function _8(e, t) {
  const n = M8(e, t), r = x8(e, t), o = k8(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function P8(e) {
  const { components: t, formatters: n, labels: r, dateLib: o, locale: a, classNames: i } = Ct(() => {
    const ve = { ...ei, ...e.locale };
    return {
      dateLib: new rn({
        locale: ve,
        weekStartsOn: e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens
      }, e.dateLib),
      components: P5(e.components),
      formatters: F5(e.formatters),
      labels: { ...o8, ...e.labels },
      locale: ve,
      classNames: { ...T5(), ...e.classNames }
    };
  }, [
    e.classNames,
    e.components,
    e.dateLib,
    e.firstWeekContainsDate,
    e.formatters,
    e.labels,
    e.locale,
    e.useAdditionalDayOfYearTokens,
    e.useAdditionalWeekYearTokens,
    e.weekStartsOn
  ]), { captionLayout: s, mode: l, onDayBlur: c, onDayClick: u, onDayFocus: d, onDayKeyDown: f, onDayMouseEnter: h, onDayMouseLeave: p, onNextClick: m, onPrevClick: g, showWeekNumber: y, styles: b } = e, { formatCaption: w, formatDay: S, formatMonthDropdown: x, formatWeekNumber: M, formatWeekNumberHeader: _, formatWeekdayName: R, formatYearDropdown: B } = n, U = g8(e, o), { days: F, months: T, navStart: j, navEnd: A, previousMonth: G, nextMonth: N, goToMonth: te } = U, oe = w8(F, e, o), { isSelected: Q, select: P, selected: L } = _8(e, o) ?? {}, { blur: $, focused: I, isFocusTarget: H, moveFocus: Y, setFocused: W } = y8(e, U, oe, Q ?? (() => !1), o), { labelDayButton: q, labelGridcell: Z, labelGrid: ee, labelMonthDropdown: J, labelNav: ie, labelWeekday: D, labelWeekNumber: ye, labelWeekNumberHeader: We, labelYearDropdown: we } = r, lt = Ct(() => Y5(o, e.ISOWeek, e.timeZone), [o, e.ISOWeek, e.timeZone]), xe = l !== void 0 || u !== void 0, ce = Ue(() => {
    G && (te(G), g == null || g(G));
  }, [G, te, g]), ue = Ue(() => {
    N && (te(N), m == null || m(N));
  }, [te, N, m]), Ve = Ue((ve, Ye) => (Be) => {
    Be.preventDefault(), Be.stopPropagation(), W(ve), P == null || P(ve.date, Ye, Be), u == null || u(ve.date, Ye, Be);
  }, [P, u, W]), ne = Ue((ve, Ye) => (Be) => {
    W(ve), d == null || d(ve.date, Ye, Be);
  }, [d, W]), Se = Ue((ve, Ye) => (Be) => {
    $(), c == null || c(ve.date, Ye, Be);
  }, [$, c]), rt = Ue((ve, Ye) => (Be) => {
    const er = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [Be.shiftKey ? "year" : "month", "before"],
      PageDown: [Be.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (er[Be.key]) {
      Be.preventDefault(), Be.stopPropagation();
      const [Jr, eo] = er[Be.key];
      Y(Jr, eo);
    }
    f == null || f(ve.date, Ye, Be);
  }, [Y, f, e.dir]), Ee = Ue((ve, Ye) => (Be) => {
    h == null || h(ve.date, Ye, Be);
  }, [h]), Fe = Ue((ve, Ye) => (Be) => {
    p == null || p(ve.date, Ye, Be);
  }, [p]), { className: Ze, style: et } = Ct(() => ({
    className: [i[ae.Root], e.className].filter(Boolean).join(" "),
    style: { ...b == null ? void 0 : b[ae.Root], ...e.style }
  }), [i, e.className, e.style, b]), ct = O5(e), cn = {
    dayPickerProps: e,
    selected: L,
    select: P,
    isSelected: Q,
    months: T,
    nextMonth: N,
    previousMonth: G,
    goToMonth: te,
    getModifiers: oe,
    components: t,
    classNames: i,
    styles: b,
    labels: r,
    formatters: n
  };
  return v.createElement(
    rf.Provider,
    { value: cn },
    v.createElement(
      t.Root,
      { className: Ze, style: et, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, ...ct },
      v.createElement(
        t.Months,
        { className: i[ae.Months], style: b == null ? void 0 : b[ae.Months] },
        !e.hideNavigation && v.createElement(t.Nav, { className: i[ae.Nav], style: b == null ? void 0 : b[ae.Nav], "aria-label": ie(), onPreviousClick: ce, onNextClick: ue, previousMonth: G, nextMonth: N }),
        T.map((ve, Ye) => {
          const Be = (dt) => {
            const un = Number(dt.target.value), Ke = o.setMonth(o.startOfMonth(ve.date), un);
            te(Ke);
          }, er = (dt) => {
            const un = o.setYear(o.startOfMonth(ve.date), Number(dt.target.value));
            te(un);
          }, Jr = B5(ve.date, j, A, n, o), eo = q5(T[0].date, j, A, n, o);
          return v.createElement(
            t.Month,
            { className: i[ae.Month], style: b == null ? void 0 : b[ae.Month], key: Ye, displayIndex: Ye, calendarMonth: ve },
            v.createElement(t.MonthCaption, { className: i[ae.MonthCaption], style: b == null ? void 0 : b[ae.MonthCaption], calendarMonth: ve, displayIndex: Ye }, s != null && s.startsWith("dropdown") ? v.createElement(
              t.DropdownNav,
              { className: i[ae.Dropdowns], style: b == null ? void 0 : b[ae.Dropdowns] },
              s === "dropdown" || s === "dropdown-months" ? v.createElement(t.MonthsDropdown, { className: i[ae.MonthsDropdown], "aria-label": J(), classNames: i, components: t, disabled: !!e.disableNavigation, onChange: Be, options: Jr, style: b == null ? void 0 : b[ae.Dropdown], value: ve.date.getMonth() }) : v.createElement("span", { role: "status", "aria-live": "polite" }, x(ve.date.getMonth(), a)),
              s === "dropdown" || s === "dropdown-years" ? v.createElement(t.YearsDropdown, { className: i[ae.YearsDropdown], "aria-label": we(o.options), classNames: i, components: t, disabled: !!e.disableNavigation, onChange: er, options: eo, style: b == null ? void 0 : b[ae.Dropdown], value: ve.date.getFullYear() }) : v.createElement("span", { role: "status", "aria-live": "polite" }, B(ve.date.getFullYear()))
            ) : v.createElement(t.CaptionLabel, { className: i[ae.CaptionLabel], role: "status", "aria-live": "polite" }, w(ve.date, o.options, o))),
            v.createElement(
              t.MonthGrid,
              { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": ee(ve.date, o.options, o) || void 0, className: i[ae.MonthGrid], style: b == null ? void 0 : b[ae.MonthGrid] },
              !e.hideWeekdays && v.createElement(
                t.Weekdays,
                { className: i[ae.Weekdays], style: b == null ? void 0 : b[ae.Weekdays] },
                y && v.createElement(t.WeekNumberHeader, { "aria-label": We(o.options), className: i[ae.WeekNumberHeader], style: b == null ? void 0 : b[ae.WeekNumberHeader], scope: "col" }, _()),
                lt.map((dt, un) => v.createElement(t.Weekday, { "aria-label": D(dt, o.options, o), className: i[ae.Weekday], key: un, style: b == null ? void 0 : b[ae.Weekday], scope: "col" }, R(dt, o.options, o)))
              ),
              v.createElement(t.Weeks, { className: i[ae.Weeks], style: b == null ? void 0 : b[ae.Weeks] }, ve.weeks.map((dt, un) => v.createElement(
                t.Week,
                { className: i[ae.Week], key: dt.weekNumber, style: b == null ? void 0 : b[ae.Week], week: dt },
                y && v.createElement(t.WeekNumber, { week: dt, style: b == null ? void 0 : b[ae.WeekNumber], "aria-label": ye(dt.weekNumber, {
                  locale: a
                }), className: i[ae.WeekNumber], scope: "row" }, M(dt.weekNumber)),
                dt.days.map((Ke) => {
                  const { date: ht } = Ke, ke = oe(Ke);
                  if (ke[Re.focused] = !ke.hidden && !!(I != null && I.isEqualTo(Ke)), ke[tt.selected] = !ke.disabled && ((Q == null ? void 0 : Q(ht)) || ke.selected), Cl(L)) {
                    const { from: tr, to: ro } = L;
                    ke[tt.range_start] = !!(tr && ro && o.isSameDay(ht, tr)), ke[tt.range_end] = !!(tr && ro && o.isSameDay(ht, ro)), ke[tt.range_middle] = Qt(L, ht, !0, o);
                  }
                  const dn = z5(ke, b, e.modifiersStyles), to = e5(ke, i, e.modifiersClassNames), no = xe ? void 0 : Z(ht, ke, o.options, o);
                  return v.createElement(t.Day, { key: `${o.format(ht, "yyyy-MM-dd")}_${o.format(Ke.displayMonth, "yyyy-MM")}`, day: Ke, modifiers: ke, className: to.join(" "), style: dn, "aria-hidden": ke.hidden || void 0, "aria-selected": ke.selected || void 0, "aria-label": no, "data-day": o.format(ht, "yyyy-MM-dd"), "data-month": Ke.outside ? o.format(ht, "yyyy-MM") : void 0, "data-selected": ke.selected || void 0, "data-disabled": ke.disabled || void 0, "data-hidden": ke.hidden || void 0, "data-outside": Ke.outside || void 0, "data-focused": ke.focused || void 0, "data-today": ke.today || void 0 }, xe ? v.createElement(t.DayButton, { className: i[ae.DayButton], style: b == null ? void 0 : b[ae.DayButton], type: "button", day: Ke, modifiers: ke, disabled: ke.disabled || void 0, tabIndex: H(Ke) ? 0 : -1, "aria-label": q(ht, ke, o.options, o), onClick: Ve(Ke, ke), onBlur: Se(Ke, ke), onFocus: ne(Ke, ke), onKeyDown: rt(Ke, ke), onMouseEnter: Ee(Ke, ke), onMouseLeave: Fe(Ke, ke) }, S(ht, o.options, o)) : S(Ke.date, o.options, o));
                })
              )))
            )
          );
        })
      ),
      e.footer && v.createElement(t.Footer, { className: i[ae.Footer], style: b == null ? void 0 : b[ae.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
const vf = ({ className: e, classNames: t, styles: n, ...r }) => /* @__PURE__ */ C.jsx(
  P8,
  {
    captionLayout: "dropdown",
    className: z(
      "w-[fit-content] b-1 b-neutral-400 rounded-2 b-solid px-3 pt-3 pb-2 bg-neutral-100 relative",
      e
    ),
    classNames: {
      months: "relative",
      nav: "absolute w-full h-20px",
      button_previous: "z-1 h-20px w-20px color-neutral-400 hover:color-neutral-600 cursor-pointer b-0 b-none bg-transparent absolute left-2",
      button_next: "z-1 h-20px w-20px  color-neutral-400 hover:color-neutral-600 cursor-pointer b-0 b-none bg-transparent absolute right-2",
      month: "",
      month_caption: "flex justify-center items-center pt-1px",
      dropdowns: "flex items-center gap-3",
      dropdown_root: "relative",
      dropdown: "appearance-none opacity-0 cursor-pointer absolute z-1 w-full",
      caption_label: z("flex items-center gap-1 color-neutral-600 typo-text-s"),
      month_grid: "mt-3 border-spacing-x-1 border-spacing-y-2px",
      weekday: "h-24px w-24px color-neutral-800 typo-text-s",
      day: z(
        "h-24px w-24px text-center rounded-3 cursor-pointer",
        "color-neutral-600 typo-text-s hover:bg-neutral-200",
        "[&.today]:color-neutral-800 [&.today]:typo-text-s-em",
        "[&.selected]:color-neutral-800 [&.selected]:typo-text-s-em [&.selected]:bg-neutral-200",
        "[&.outside]:color-neutral-400",
        "[&.disabled]:color-neutral-400 [&.disabled]:pointer-events-none"
      ),
      day_button: z(
        "h-24px w-24px outline-none bg-transparent b-0 b-none cursor-pointer",
        "flex items-center justify-center"
      ),
      selected: "selected",
      today: "today",
      outside: "outside",
      disabled: "disabled",
      hidden: "hidden invisible",
      ...t
    },
    components: {
      Chevron: ({ className: o, orientation: a, ...i }) => /* @__PURE__ */ C.jsx(
        "div",
        {
          className: z(
            "i-skand-dropdown",
            a === "up" && "rotate-180 text-3",
            a === "left" && "rotate-90 text-4",
            a === "right" && "rotate-270 text-4",
            a === "down" && "text-2 color-neutral-400",
            o
          ),
          ...i
        }
      )
    },
    showOutsideDays: !0,
    styles: {
      day_button: {
        color: "inherit",
        cursor: "inherit",
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit"
      },
      ...n
    },
    ...r
  }
);
vf.displayName = "Calendar";
const O8 = qt(
  ({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx(
    "input",
    {
      className: z(
        "appearance-none",
        "checked:color-neutral-600",
        "checked:i-skand-boxchecked",
        "color-neutral-600",
        "i-skand-boxunchecked",
        "text-3",
        e
      ),
      ref: n,
      type: "checkbox",
      ...t
    }
  )
);
O8.displayName = "CheckBox";
const T8 = bl(["rounded-1", "inline-flex items-center"], {
  variants: {
    border: {
      false: ["b-none"],
      true: ["b-1 b-solid"]
    },
    intent: {
      alert: ["bg-alert-100 b-alert-400 color-neutral-800"],
      info: ["bg-info-100 b-info-400 color-neutral-800"],
      neutral: ["bg-neutral-100 b-neutral-400 color-neutral-800"],
      success: ["bg-success-100 b-success-400 color-neutral-800"],
      warning: ["bg-warning-100 b-warning-400 color-neutral-800"],
      annotation: ["bg-[hsla(225,100%,30%,0.5)] color-neutral-100"],
      deactivated: ["bg-neutral-100 b-neutral-400 color-neutral-500"],
      pending: ["bg-neutral-200 b-neutral-500 color-neutral-800"],
      purple: ["bg-[hsla(266,100%,95%,1)] b-[hsla(266,100%,64%,1)] color-[hsla(266,100%,64%,1)]"]
    },
    size: {
      xs: ["typo-text-s", "px-1 py-0"],
      small: ["typo-text-s", "px-2 py-2px"],
      middle: ["typo-text-s", "px-2 py-1"],
      large: ["typo-text-s", "px-3 py-2"]
    },
    shadow: {
      false: ["shadow-none"],
      true: "shadow-[0px_2px_2px_0px_rgba(0,0,0,0.15)]"
    }
  },
  defaultVariants: {
    border: !0,
    intent: "neutral",
    size: "middle",
    shadow: !1
  }
}), XW = (e) => z(T8(e)), A8 = bl(["mr-2 text-3"], {
  variants: {
    intent: {
      alert: ["i-skand-warn color-alert-400"],
      info: ["i-skand-info color-info-400"],
      neutral: ["i-skand-warn color-neutral-400"],
      success: ["i-skand-done color-success-400"],
      warning: ["i-skand-warn color-warning-400"]
    }
  },
  defaultVariants: {
    intent: "neutral"
  }
}), ZW = (e) => z(A8(e)), $8 = bl(["mr-1 h-6px w-6px rounded-full"], {
  variants: {
    intent: {
      alert: ["bg-alert-400"],
      info: ["bg-info-400"],
      neutral: ["bg-neutral-400"],
      success: ["bg-success-400"],
      warning: ["bg-warning-400"]
    }
  },
  defaultVariants: {
    intent: "neutral"
  }
}), KW = (e) => z($8(e)), QW = () => z("ml-2 i-skand-close text-3 color-neutral-500");
var _t = {}, Uo = {}, R8 = typeof sa == "object" && sa && sa.Object === Object && sa, bf = R8, D8 = bf, N8 = typeof self == "object" && self && self.Object === Object && self, L8 = D8 || N8 || Function("return this")(), Ut = L8, j8 = Ut, H8 = j8.Symbol, Go = H8, Mu = Go, yf = Object.prototype, F8 = yf.hasOwnProperty, B8 = yf.toString, lo = Mu ? Mu.toStringTag : void 0;
function z8(e) {
  var t = F8.call(e, lo), n = e[lo];
  try {
    e[lo] = void 0;
    var r = !0;
  } catch {
  }
  var o = B8.call(e);
  return r && (t ? e[lo] = n : delete e[lo]), o;
}
var I8 = z8, W8 = Object.prototype, V8 = W8.toString;
function Y8(e) {
  return V8.call(e);
}
var q8 = Y8, _u = Go, U8 = I8, G8 = q8, X8 = "[object Null]", Z8 = "[object Undefined]", Pu = _u ? _u.toStringTag : void 0;
function K8(e) {
  return e == null ? e === void 0 ? Z8 : X8 : Pu && Pu in Object(e) ? U8(e) : G8(e);
}
var qn = K8, Q8 = Array.isArray, Ht = Q8;
function J8(e) {
  return e != null && typeof e == "object";
}
var on = J8, em = qn, tm = Ht, nm = on, rm = "[object String]";
function om(e) {
  return typeof e == "string" || !tm(e) && nm(e) && em(e) == rm;
}
var am = om;
function im(e) {
  return function(t, n, r) {
    for (var o = -1, a = Object(t), i = r(t), s = i.length; s--; ) {
      var l = i[e ? s : ++o];
      if (n(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var sm = im, lm = sm, cm = lm(), um = cm;
function dm(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var fm = dm, hm = qn, pm = on, mm = "[object Arguments]";
function gm(e) {
  return pm(e) && hm(e) == mm;
}
var vm = gm, Ou = vm, bm = on, wf = Object.prototype, ym = wf.hasOwnProperty, wm = wf.propertyIsEnumerable, xm = Ou(function() {
  return arguments;
}()) ? Ou : function(e) {
  return bm(e) && ym.call(e, "callee") && !wm.call(e, "callee");
}, xf = xm, Aa = { exports: {} };
function Cm() {
  return !1;
}
var Sm = Cm;
Aa.exports;
(function(e, t) {
  var n = Ut, r = Sm, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, i = a && a.exports === o, s = i ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  e.exports = c;
})(Aa, Aa.exports);
var Sl = Aa.exports, Em = 9007199254740991, km = /^(?:0|[1-9]\d*)$/;
function Mm(e, t) {
  var n = typeof e;
  return t = t ?? Em, !!t && (n == "number" || n != "symbol" && km.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Cf = Mm, _m = 9007199254740991;
function Pm(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= _m;
}
var El = Pm, Om = qn, Tm = El, Am = on, $m = "[object Arguments]", Rm = "[object Array]", Dm = "[object Boolean]", Nm = "[object Date]", Lm = "[object Error]", jm = "[object Function]", Hm = "[object Map]", Fm = "[object Number]", Bm = "[object Object]", zm = "[object RegExp]", Im = "[object Set]", Wm = "[object String]", Vm = "[object WeakMap]", Ym = "[object ArrayBuffer]", qm = "[object DataView]", Um = "[object Float32Array]", Gm = "[object Float64Array]", Xm = "[object Int8Array]", Zm = "[object Int16Array]", Km = "[object Int32Array]", Qm = "[object Uint8Array]", Jm = "[object Uint8ClampedArray]", eg = "[object Uint16Array]", tg = "[object Uint32Array]", Le = {};
Le[Um] = Le[Gm] = Le[Xm] = Le[Zm] = Le[Km] = Le[Qm] = Le[Jm] = Le[eg] = Le[tg] = !0;
Le[$m] = Le[Rm] = Le[Ym] = Le[Dm] = Le[qm] = Le[Nm] = Le[Lm] = Le[jm] = Le[Hm] = Le[Fm] = Le[Bm] = Le[zm] = Le[Im] = Le[Wm] = Le[Vm] = !1;
function ng(e) {
  return Am(e) && Tm(e.length) && !!Le[Om(e)];
}
var rg = ng;
function og(e) {
  return function(t) {
    return e(t);
  };
}
var kl = og, $a = { exports: {} };
$a.exports;
(function(e, t) {
  var n = bf, r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, a = o && o.exports === r, i = a && n.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})($a, $a.exports);
var Ml = $a.exports, ag = rg, ig = kl, Tu = Ml, Au = Tu && Tu.isTypedArray, sg = Au ? ig(Au) : ag, Sf = sg, lg = fm, cg = xf, ug = Ht, dg = Sl, fg = Cf, hg = Sf, pg = Object.prototype, mg = pg.hasOwnProperty;
function gg(e, t) {
  var n = ug(e), r = !n && cg(e), o = !n && !r && dg(e), a = !n && !r && !o && hg(e), i = n || r || o || a, s = i ? lg(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || mg.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    fg(c, l))) && s.push(c);
  return s;
}
var Ef = gg, vg = Object.prototype;
function bg(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || vg;
  return e === n;
}
var _l = bg;
function yg(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var kf = yg, wg = kf, xg = wg(Object.keys, Object), Cg = xg, Sg = _l, Eg = Cg, kg = Object.prototype, Mg = kg.hasOwnProperty;
function _g(e) {
  if (!Sg(e))
    return Eg(e);
  var t = [];
  for (var n in Object(e))
    Mg.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var Pg = _g;
function Og(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var jr = Og, Tg = qn, Ag = jr, $g = "[object AsyncFunction]", Rg = "[object Function]", Dg = "[object GeneratorFunction]", Ng = "[object Proxy]";
function Lg(e) {
  if (!Ag(e))
    return !1;
  var t = Tg(e);
  return t == Rg || t == Dg || t == $g || t == Ng;
}
var Mf = Lg, jg = Mf, Hg = El;
function Fg(e) {
  return e != null && Hg(e.length) && !jg(e);
}
var ni = Fg, Bg = Ef, zg = Pg, Ig = ni;
function Wg(e) {
  return Ig(e) ? Bg(e) : zg(e);
}
var Xo = Wg, Vg = um, Yg = Xo;
function qg(e, t) {
  return e && Vg(e, t, Yg);
}
var _f = qg;
function Ug(e) {
  return e;
}
var Pf = Ug, Gg = Pf;
function Xg(e) {
  return typeof e == "function" ? e : Gg;
}
var Zg = Xg, Kg = _f, Qg = Zg;
function Jg(e, t) {
  return e && Kg(e, Qg(t));
}
var Pl = Jg, ev = kf, tv = ev(Object.getPrototypeOf, Object), Ol = tv, nv = qn, rv = Ol, ov = on, av = "[object Object]", iv = Function.prototype, sv = Object.prototype, Of = iv.toString, lv = sv.hasOwnProperty, cv = Of.call(Object);
function uv(e) {
  if (!ov(e) || nv(e) != av)
    return !1;
  var t = rv(e);
  if (t === null)
    return !0;
  var n = lv.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Of.call(n) == cv;
}
var dv = uv;
function fv(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r; )
    o[n] = t(e[n], n, e);
  return o;
}
var Tf = fv;
function hv() {
  this.__data__ = [], this.size = 0;
}
var pv = hv;
function mv(e, t) {
  return e === t || e !== e && t !== t;
}
var Tl = mv, gv = Tl;
function vv(e, t) {
  for (var n = e.length; n--; )
    if (gv(e[n][0], t))
      return n;
  return -1;
}
var ri = vv, bv = ri, yv = Array.prototype, wv = yv.splice;
function xv(e) {
  var t = this.__data__, n = bv(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : wv.call(t, n, 1), --this.size, !0;
}
var Cv = xv, Sv = ri;
function Ev(e) {
  var t = this.__data__, n = Sv(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var kv = Ev, Mv = ri;
function _v(e) {
  return Mv(this.__data__, e) > -1;
}
var Pv = _v, Ov = ri;
function Tv(e, t) {
  var n = this.__data__, r = Ov(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var Av = Tv, $v = pv, Rv = Cv, Dv = kv, Nv = Pv, Lv = Av;
function Hr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Hr.prototype.clear = $v;
Hr.prototype.delete = Rv;
Hr.prototype.get = Dv;
Hr.prototype.has = Nv;
Hr.prototype.set = Lv;
var oi = Hr, jv = oi;
function Hv() {
  this.__data__ = new jv(), this.size = 0;
}
var Fv = Hv;
function Bv(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var zv = Bv;
function Iv(e) {
  return this.__data__.get(e);
}
var Wv = Iv;
function Vv(e) {
  return this.__data__.has(e);
}
var Yv = Vv, qv = Ut, Uv = qv["__core-js_shared__"], Gv = Uv, Wi = Gv, $u = function() {
  var e = /[^.]+$/.exec(Wi && Wi.keys && Wi.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Xv(e) {
  return !!$u && $u in e;
}
var Zv = Xv, Kv = Function.prototype, Qv = Kv.toString;
function Jv(e) {
  if (e != null) {
    try {
      return Qv.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Af = Jv, e7 = Mf, t7 = Zv, n7 = jr, r7 = Af, o7 = /[\\^$.*+?()[\]{}|]/g, a7 = /^\[object .+?Constructor\]$/, i7 = Function.prototype, s7 = Object.prototype, l7 = i7.toString, c7 = s7.hasOwnProperty, u7 = RegExp(
  "^" + l7.call(c7).replace(o7, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function d7(e) {
  if (!n7(e) || t7(e))
    return !1;
  var t = e7(e) ? u7 : a7;
  return t.test(r7(e));
}
var f7 = d7;
function h7(e, t) {
  return e == null ? void 0 : e[t];
}
var p7 = h7, m7 = f7, g7 = p7;
function v7(e, t) {
  var n = g7(e, t);
  return m7(n) ? n : void 0;
}
var Un = v7, b7 = Un, y7 = Ut, w7 = b7(y7, "Map"), Al = w7, x7 = Un, C7 = x7(Object, "create"), ai = C7, Ru = ai;
function S7() {
  this.__data__ = Ru ? Ru(null) : {}, this.size = 0;
}
var E7 = S7;
function k7(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var M7 = k7, _7 = ai, P7 = "__lodash_hash_undefined__", O7 = Object.prototype, T7 = O7.hasOwnProperty;
function A7(e) {
  var t = this.__data__;
  if (_7) {
    var n = t[e];
    return n === P7 ? void 0 : n;
  }
  return T7.call(t, e) ? t[e] : void 0;
}
var $7 = A7, R7 = ai, D7 = Object.prototype, N7 = D7.hasOwnProperty;
function L7(e) {
  var t = this.__data__;
  return R7 ? t[e] !== void 0 : N7.call(t, e);
}
var j7 = L7, H7 = ai, F7 = "__lodash_hash_undefined__";
function B7(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = H7 && t === void 0 ? F7 : t, this;
}
var z7 = B7, I7 = E7, W7 = M7, V7 = $7, Y7 = j7, q7 = z7;
function Fr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Fr.prototype.clear = I7;
Fr.prototype.delete = W7;
Fr.prototype.get = V7;
Fr.prototype.has = Y7;
Fr.prototype.set = q7;
var U7 = Fr, Du = U7, G7 = oi, X7 = Al;
function Z7() {
  this.size = 0, this.__data__ = {
    hash: new Du(),
    map: new (X7 || G7)(),
    string: new Du()
  };
}
var K7 = Z7;
function Q7(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var J7 = Q7, e9 = J7;
function t9(e, t) {
  var n = e.__data__;
  return e9(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var ii = t9, n9 = ii;
function r9(e) {
  var t = n9(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var o9 = r9, a9 = ii;
function i9(e) {
  return a9(this, e).get(e);
}
var s9 = i9, l9 = ii;
function c9(e) {
  return l9(this, e).has(e);
}
var u9 = c9, d9 = ii;
function f9(e, t) {
  var n = d9(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var h9 = f9, p9 = K7, m9 = o9, g9 = s9, v9 = u9, b9 = h9;
function Br(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Br.prototype.clear = p9;
Br.prototype.delete = m9;
Br.prototype.get = g9;
Br.prototype.has = v9;
Br.prototype.set = b9;
var $l = Br, y9 = oi, w9 = Al, x9 = $l, C9 = 200;
function S9(e, t) {
  var n = this.__data__;
  if (n instanceof y9) {
    var r = n.__data__;
    if (!w9 || r.length < C9 - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new x9(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var E9 = S9, k9 = oi, M9 = Fv, _9 = zv, P9 = Wv, O9 = Yv, T9 = E9;
function zr(e) {
  var t = this.__data__ = new k9(e);
  this.size = t.size;
}
zr.prototype.clear = M9;
zr.prototype.delete = _9;
zr.prototype.get = P9;
zr.prototype.has = O9;
zr.prototype.set = T9;
var Rl = zr, A9 = "__lodash_hash_undefined__";
function $9(e) {
  return this.__data__.set(e, A9), this;
}
var R9 = $9;
function D9(e) {
  return this.__data__.has(e);
}
var N9 = D9, L9 = $l, j9 = R9, H9 = N9;
function Ra(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new L9(); ++t < n; )
    this.add(e[t]);
}
Ra.prototype.add = Ra.prototype.push = j9;
Ra.prototype.has = H9;
var F9 = Ra;
function B9(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var z9 = B9;
function I9(e, t) {
  return e.has(t);
}
var W9 = I9, V9 = F9, Y9 = z9, q9 = W9, U9 = 1, G9 = 2;
function X9(e, t, n, r, o, a) {
  var i = n & U9, s = e.length, l = t.length;
  if (s != l && !(i && l > s))
    return !1;
  var c = a.get(e), u = a.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, h = n & G9 ? new V9() : void 0;
  for (a.set(e, t), a.set(t, e); ++d < s; ) {
    var p = e[d], m = t[d];
    if (r)
      var g = i ? r(m, p, d, t, e, a) : r(p, m, d, e, t, a);
    if (g !== void 0) {
      if (g)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!Y9(t, function(y, b) {
        if (!q9(h, b) && (p === y || o(p, y, n, r, a)))
          return h.push(b);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === m || o(p, m, n, r, a))) {
      f = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), f;
}
var $f = X9, Z9 = Ut, K9 = Z9.Uint8Array, Rf = K9;
function Q9(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
var J9 = Q9;
function eb(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var tb = eb, Nu = Go, Lu = Rf, nb = Tl, rb = $f, ob = J9, ab = tb, ib = 1, sb = 2, lb = "[object Boolean]", cb = "[object Date]", ub = "[object Error]", db = "[object Map]", fb = "[object Number]", hb = "[object RegExp]", pb = "[object Set]", mb = "[object String]", gb = "[object Symbol]", vb = "[object ArrayBuffer]", bb = "[object DataView]", ju = Nu ? Nu.prototype : void 0, Vi = ju ? ju.valueOf : void 0;
function yb(e, t, n, r, o, a, i) {
  switch (n) {
    case bb:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case vb:
      return !(e.byteLength != t.byteLength || !a(new Lu(e), new Lu(t)));
    case lb:
    case cb:
    case fb:
      return nb(+e, +t);
    case ub:
      return e.name == t.name && e.message == t.message;
    case hb:
    case mb:
      return e == t + "";
    case db:
      var s = ob;
    case pb:
      var l = r & ib;
      if (s || (s = ab), e.size != t.size && !l)
        return !1;
      var c = i.get(e);
      if (c)
        return c == t;
      r |= sb, i.set(e, t);
      var u = rb(s(e), s(t), r, o, a, i);
      return i.delete(e), u;
    case gb:
      if (Vi)
        return Vi.call(e) == Vi.call(t);
  }
  return !1;
}
var wb = yb;
function xb(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var Df = xb, Cb = Df, Sb = Ht;
function Eb(e, t, n) {
  var r = t(e);
  return Sb(e) ? r : Cb(r, n(e));
}
var Nf = Eb;
function kb(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, a = []; ++n < r; ) {
    var i = e[n];
    t(i, n, e) && (a[o++] = i);
  }
  return a;
}
var Mb = kb;
function _b() {
  return [];
}
var Lf = _b, Pb = Mb, Ob = Lf, Tb = Object.prototype, Ab = Tb.propertyIsEnumerable, Hu = Object.getOwnPropertySymbols, $b = Hu ? function(e) {
  return e == null ? [] : (e = Object(e), Pb(Hu(e), function(t) {
    return Ab.call(e, t);
  }));
} : Ob, Dl = $b, Rb = Nf, Db = Dl, Nb = Xo;
function Lb(e) {
  return Rb(e, Nb, Db);
}
var jf = Lb, Fu = jf, jb = 1, Hb = Object.prototype, Fb = Hb.hasOwnProperty;
function Bb(e, t, n, r, o, a) {
  var i = n & jb, s = Fu(e), l = s.length, c = Fu(t), u = c.length;
  if (l != u && !i)
    return !1;
  for (var d = l; d--; ) {
    var f = s[d];
    if (!(i ? f in t : Fb.call(t, f)))
      return !1;
  }
  var h = a.get(e), p = a.get(t);
  if (h && p)
    return h == t && p == e;
  var m = !0;
  a.set(e, t), a.set(t, e);
  for (var g = i; ++d < l; ) {
    f = s[d];
    var y = e[f], b = t[f];
    if (r)
      var w = i ? r(b, y, f, t, e, a) : r(y, b, f, e, t, a);
    if (!(w === void 0 ? y === b || o(y, b, n, r, a) : w)) {
      m = !1;
      break;
    }
    g || (g = f == "constructor");
  }
  if (m && !g) {
    var S = e.constructor, x = t.constructor;
    S != x && "constructor" in e && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof x == "function" && x instanceof x) && (m = !1);
  }
  return a.delete(e), a.delete(t), m;
}
var zb = Bb, Ib = Un, Wb = Ut, Vb = Ib(Wb, "DataView"), Yb = Vb, qb = Un, Ub = Ut, Gb = qb(Ub, "Promise"), Xb = Gb, Zb = Un, Kb = Ut, Qb = Zb(Kb, "Set"), Jb = Qb, ey = Un, ty = Ut, ny = ey(ty, "WeakMap"), ry = ny, As = Yb, $s = Al, Rs = Xb, Ds = Jb, Ns = ry, Hf = qn, Ir = Af, Bu = "[object Map]", oy = "[object Object]", zu = "[object Promise]", Iu = "[object Set]", Wu = "[object WeakMap]", Vu = "[object DataView]", ay = Ir(As), iy = Ir($s), sy = Ir(Rs), ly = Ir(Ds), cy = Ir(Ns), Rn = Hf;
(As && Rn(new As(new ArrayBuffer(1))) != Vu || $s && Rn(new $s()) != Bu || Rs && Rn(Rs.resolve()) != zu || Ds && Rn(new Ds()) != Iu || Ns && Rn(new Ns()) != Wu) && (Rn = function(e) {
  var t = Hf(e), n = t == oy ? e.constructor : void 0, r = n ? Ir(n) : "";
  if (r)
    switch (r) {
      case ay:
        return Vu;
      case iy:
        return Bu;
      case sy:
        return zu;
      case ly:
        return Iu;
      case cy:
        return Wu;
    }
  return t;
});
var si = Rn, Yi = Rl, uy = $f, dy = wb, fy = zb, Yu = si, qu = Ht, Uu = Sl, hy = Sf, py = 1, Gu = "[object Arguments]", Xu = "[object Array]", la = "[object Object]", my = Object.prototype, Zu = my.hasOwnProperty;
function gy(e, t, n, r, o, a) {
  var i = qu(e), s = qu(t), l = i ? Xu : Yu(e), c = s ? Xu : Yu(t);
  l = l == Gu ? la : l, c = c == Gu ? la : c;
  var u = l == la, d = c == la, f = l == c;
  if (f && Uu(e)) {
    if (!Uu(t))
      return !1;
    i = !0, u = !1;
  }
  if (f && !u)
    return a || (a = new Yi()), i || hy(e) ? uy(e, t, n, r, o, a) : dy(e, t, l, n, r, o, a);
  if (!(n & py)) {
    var h = u && Zu.call(e, "__wrapped__"), p = d && Zu.call(t, "__wrapped__");
    if (h || p) {
      var m = h ? e.value() : e, g = p ? t.value() : t;
      return a || (a = new Yi()), o(m, g, n, r, a);
    }
  }
  return f ? (a || (a = new Yi()), fy(e, t, n, r, o, a)) : !1;
}
var vy = gy, by = vy, Ku = on;
function Ff(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !Ku(e) && !Ku(t) ? e !== e && t !== t : by(e, t, n, r, Ff, o);
}
var Bf = Ff, yy = Rl, wy = Bf, xy = 1, Cy = 2;
function Sy(e, t, n, r) {
  var o = n.length, a = o, i = !r;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = n[o];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = n[o];
    var l = s[0], c = e[l], u = s[1];
    if (i && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var d = new yy();
      if (r)
        var f = r(c, u, l, e, t, d);
      if (!(f === void 0 ? wy(u, c, xy | Cy, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var Ey = Sy, ky = jr;
function My(e) {
  return e === e && !ky(e);
}
var zf = My, _y = zf, Py = Xo;
function Oy(e) {
  for (var t = Py(e), n = t.length; n--; ) {
    var r = t[n], o = e[r];
    t[n] = [r, o, _y(o)];
  }
  return t;
}
var Ty = Oy;
function Ay(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var If = Ay, $y = Ey, Ry = Ty, Dy = If;
function Ny(e) {
  var t = Ry(e);
  return t.length == 1 && t[0][2] ? Dy(t[0][0], t[0][1]) : function(n) {
    return n === e || $y(n, e, t);
  };
}
var Ly = Ny, jy = qn, Hy = on, Fy = "[object Symbol]";
function By(e) {
  return typeof e == "symbol" || Hy(e) && jy(e) == Fy;
}
var Nl = By, zy = Ht, Iy = Nl, Wy = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Vy = /^\w*$/;
function Yy(e, t) {
  if (zy(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Iy(e) ? !0 : Vy.test(e) || !Wy.test(e) || t != null && e in Object(t);
}
var Ll = Yy, Wf = $l, qy = "Expected a function";
function jl(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(qy);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(o))
      return a.get(o);
    var i = e.apply(this, r);
    return n.cache = a.set(o, i) || a, i;
  };
  return n.cache = new (jl.Cache || Wf)(), n;
}
jl.Cache = Wf;
var Uy = jl, Gy = Uy, Xy = 500;
function Zy(e) {
  var t = Gy(e, function(r) {
    return n.size === Xy && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Ky = Zy, Qy = Ky, Jy = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ew = /\\(\\)?/g, tw = Qy(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Jy, function(n, r, o, a) {
    t.push(o ? a.replace(ew, "$1") : r || n);
  }), t;
}), nw = tw, Qu = Go, rw = Tf, ow = Ht, aw = Nl, iw = 1 / 0, Ju = Qu ? Qu.prototype : void 0, e0 = Ju ? Ju.toString : void 0;
function Vf(e) {
  if (typeof e == "string")
    return e;
  if (ow(e))
    return rw(e, Vf) + "";
  if (aw(e))
    return e0 ? e0.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -iw ? "-0" : t;
}
var sw = Vf, lw = sw;
function cw(e) {
  return e == null ? "" : lw(e);
}
var uw = cw, dw = Ht, fw = Ll, hw = nw, pw = uw;
function mw(e, t) {
  return dw(e) ? e : fw(e, t) ? [e] : hw(pw(e));
}
var Yf = mw, gw = Nl, vw = 1 / 0;
function bw(e) {
  if (typeof e == "string" || gw(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -vw ? "-0" : t;
}
var li = bw, yw = Yf, ww = li;
function xw(e, t) {
  t = yw(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[ww(t[n++])];
  return n && n == r ? e : void 0;
}
var qf = xw, Cw = qf;
function Sw(e, t, n) {
  var r = e == null ? void 0 : Cw(e, t);
  return r === void 0 ? n : r;
}
var Ew = Sw;
function kw(e, t) {
  return e != null && t in Object(e);
}
var Mw = kw, _w = Yf, Pw = xf, Ow = Ht, Tw = Cf, Aw = El, $w = li;
function Rw(e, t, n) {
  t = _w(t, e);
  for (var r = -1, o = t.length, a = !1; ++r < o; ) {
    var i = $w(t[r]);
    if (!(a = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return a || ++r != o ? a : (o = e == null ? 0 : e.length, !!o && Aw(o) && Tw(i, o) && (Ow(e) || Pw(e)));
}
var Dw = Rw, Nw = Mw, Lw = Dw;
function jw(e, t) {
  return e != null && Lw(e, t, Nw);
}
var Hw = jw, Fw = Bf, Bw = Ew, zw = Hw, Iw = Ll, Ww = zf, Vw = If, Yw = li, qw = 1, Uw = 2;
function Gw(e, t) {
  return Iw(e) && Ww(t) ? Vw(Yw(e), t) : function(n) {
    var r = Bw(n, e);
    return r === void 0 && r === t ? zw(n, e) : Fw(t, r, qw | Uw);
  };
}
var Xw = Gw;
function Zw(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Kw = Zw, Qw = qf;
function Jw(e) {
  return function(t) {
    return Qw(t, e);
  };
}
var ex = Jw, tx = Kw, nx = ex, rx = Ll, ox = li;
function ax(e) {
  return rx(e) ? tx(ox(e)) : nx(e);
}
var ix = ax, sx = Ly, lx = Xw, cx = Pf, ux = Ht, dx = ix;
function fx(e) {
  return typeof e == "function" ? e : e == null ? cx : typeof e == "object" ? ux(e) ? lx(e[0], e[1]) : sx(e) : dx(e);
}
var hx = fx, px = ni;
function mx(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!px(n))
      return e(n, r);
    for (var o = n.length, a = t ? o : -1, i = Object(n); (t ? a-- : ++a < o) && r(i[a], a, i) !== !1; )
      ;
    return n;
  };
}
var gx = mx, vx = _f, bx = gx, yx = bx(vx), wx = yx, xx = wx, Cx = ni;
function Sx(e, t) {
  var n = -1, r = Cx(e) ? Array(e.length) : [];
  return xx(e, function(o, a, i) {
    r[++n] = t(o, a, i);
  }), r;
}
var Ex = Sx, kx = Tf, Mx = hx, _x = Ex, Px = Ht;
function Ox(e, t) {
  var n = Px(e) ? kx : _x;
  return n(e, Mx(t));
}
var Tx = Ox;
Object.defineProperty(Uo, "__esModule", {
  value: !0
});
Uo.flattenNames = void 0;
var Ax = am, $x = ci(Ax), Rx = Pl, Dx = ci(Rx), Nx = dv, Lx = ci(Nx), jx = Tx, Hx = ci(jx);
function ci(e) {
  return e && e.__esModule ? e : { default: e };
}
var Fx = Uo.flattenNames = function e() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [];
  return (0, Hx.default)(t, function(r) {
    Array.isArray(r) ? e(r).map(function(o) {
      return n.push(o);
    }) : (0, Lx.default)(r) ? (0, Dx.default)(r, function(o, a) {
      o === !0 && n.push(a), n.push(a + "-" + o);
    }) : (0, $x.default)(r) && n.push(r);
  }), n;
};
Uo.default = Fx;
var Zo = {};
function Bx(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var zx = Bx, Ix = Un, Wx = function() {
  try {
    var e = Ix(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Vx = Wx, t0 = Vx;
function Yx(e, t, n) {
  t == "__proto__" && t0 ? t0(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Uf = Yx, qx = Uf, Ux = Tl, Gx = Object.prototype, Xx = Gx.hasOwnProperty;
function Zx(e, t, n) {
  var r = e[t];
  (!(Xx.call(e, t) && Ux(r, n)) || n === void 0 && !(t in e)) && qx(e, t, n);
}
var Gf = Zx, Kx = Gf, Qx = Uf;
function Jx(e, t, n, r) {
  var o = !n;
  n || (n = {});
  for (var a = -1, i = t.length; ++a < i; ) {
    var s = t[a], l = r ? r(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), o ? Qx(n, s, l) : Kx(n, s, l);
  }
  return n;
}
var ui = Jx, eC = ui, tC = Xo;
function nC(e, t) {
  return e && eC(t, tC(t), e);
}
var rC = nC;
function oC(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var aC = oC, iC = jr, sC = _l, lC = aC, cC = Object.prototype, uC = cC.hasOwnProperty;
function dC(e) {
  if (!iC(e))
    return lC(e);
  var t = sC(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !uC.call(e, r)) || n.push(r);
  return n;
}
var fC = dC, hC = Ef, pC = fC, mC = ni;
function gC(e) {
  return mC(e) ? hC(e, !0) : pC(e);
}
var Hl = gC, vC = ui, bC = Hl;
function yC(e, t) {
  return e && vC(t, bC(t), e);
}
var wC = yC, Da = { exports: {} };
Da.exports;
(function(e, t) {
  var n = Ut, r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, a = o && o.exports === r, i = a ? n.Buffer : void 0, s = i ? i.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, f = s ? s(d) : new c.constructor(d);
    return c.copy(f), f;
  }
  e.exports = l;
})(Da, Da.exports);
var xC = Da.exports;
function CC(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var SC = CC, EC = ui, kC = Dl;
function MC(e, t) {
  return EC(e, kC(e), t);
}
var _C = MC, PC = Df, OC = Ol, TC = Dl, AC = Lf, $C = Object.getOwnPropertySymbols, RC = $C ? function(e) {
  for (var t = []; e; )
    PC(t, TC(e)), e = OC(e);
  return t;
} : AC, Xf = RC, DC = ui, NC = Xf;
function LC(e, t) {
  return DC(e, NC(e), t);
}
var jC = LC, HC = Nf, FC = Xf, BC = Hl;
function zC(e) {
  return HC(e, BC, FC);
}
var IC = zC, WC = Object.prototype, VC = WC.hasOwnProperty;
function YC(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && VC.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var qC = YC, n0 = Rf;
function UC(e) {
  var t = new e.constructor(e.byteLength);
  return new n0(t).set(new n0(e)), t;
}
var Fl = UC, GC = Fl;
function XC(e, t) {
  var n = t ? GC(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var ZC = XC, KC = /\w*$/;
function QC(e) {
  var t = new e.constructor(e.source, KC.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var JC = QC, r0 = Go, o0 = r0 ? r0.prototype : void 0, a0 = o0 ? o0.valueOf : void 0;
function eS(e) {
  return a0 ? Object(a0.call(e)) : {};
}
var tS = eS, nS = Fl;
function rS(e, t) {
  var n = t ? nS(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var oS = rS, aS = Fl, iS = ZC, sS = JC, lS = tS, cS = oS, uS = "[object Boolean]", dS = "[object Date]", fS = "[object Map]", hS = "[object Number]", pS = "[object RegExp]", mS = "[object Set]", gS = "[object String]", vS = "[object Symbol]", bS = "[object ArrayBuffer]", yS = "[object DataView]", wS = "[object Float32Array]", xS = "[object Float64Array]", CS = "[object Int8Array]", SS = "[object Int16Array]", ES = "[object Int32Array]", kS = "[object Uint8Array]", MS = "[object Uint8ClampedArray]", _S = "[object Uint16Array]", PS = "[object Uint32Array]";
function OS(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case bS:
      return aS(e);
    case uS:
    case dS:
      return new r(+e);
    case yS:
      return iS(e, n);
    case wS:
    case xS:
    case CS:
    case SS:
    case ES:
    case kS:
    case MS:
    case _S:
    case PS:
      return cS(e, n);
    case fS:
      return new r();
    case hS:
    case gS:
      return new r(e);
    case pS:
      return sS(e);
    case mS:
      return new r();
    case vS:
      return lS(e);
  }
}
var TS = OS, AS = jr, i0 = Object.create, $S = function() {
  function e() {
  }
  return function(t) {
    if (!AS(t))
      return {};
    if (i0)
      return i0(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), RS = $S, DS = RS, NS = Ol, LS = _l;
function jS(e) {
  return typeof e.constructor == "function" && !LS(e) ? DS(NS(e)) : {};
}
var HS = jS, FS = si, BS = on, zS = "[object Map]";
function IS(e) {
  return BS(e) && FS(e) == zS;
}
var WS = IS, VS = WS, YS = kl, s0 = Ml, l0 = s0 && s0.isMap, qS = l0 ? YS(l0) : VS, US = qS, GS = si, XS = on, ZS = "[object Set]";
function KS(e) {
  return XS(e) && GS(e) == ZS;
}
var QS = KS, JS = QS, eE = kl, c0 = Ml, u0 = c0 && c0.isSet, tE = u0 ? eE(u0) : JS, nE = tE, rE = Rl, oE = zx, aE = Gf, iE = rC, sE = wC, lE = xC, cE = SC, uE = _C, dE = jC, fE = jf, hE = IC, pE = si, mE = qC, gE = TS, vE = HS, bE = Ht, yE = Sl, wE = US, xE = jr, CE = nE, SE = Xo, EE = Hl, kE = 1, ME = 2, _E = 4, Zf = "[object Arguments]", PE = "[object Array]", OE = "[object Boolean]", TE = "[object Date]", AE = "[object Error]", Kf = "[object Function]", $E = "[object GeneratorFunction]", RE = "[object Map]", DE = "[object Number]", Qf = "[object Object]", NE = "[object RegExp]", LE = "[object Set]", jE = "[object String]", HE = "[object Symbol]", FE = "[object WeakMap]", BE = "[object ArrayBuffer]", zE = "[object DataView]", IE = "[object Float32Array]", WE = "[object Float64Array]", VE = "[object Int8Array]", YE = "[object Int16Array]", qE = "[object Int32Array]", UE = "[object Uint8Array]", GE = "[object Uint8ClampedArray]", XE = "[object Uint16Array]", ZE = "[object Uint32Array]", $e = {};
$e[Zf] = $e[PE] = $e[BE] = $e[zE] = $e[OE] = $e[TE] = $e[IE] = $e[WE] = $e[VE] = $e[YE] = $e[qE] = $e[RE] = $e[DE] = $e[Qf] = $e[NE] = $e[LE] = $e[jE] = $e[HE] = $e[UE] = $e[GE] = $e[XE] = $e[ZE] = !0;
$e[AE] = $e[Kf] = $e[FE] = !1;
function Ea(e, t, n, r, o, a) {
  var i, s = t & kE, l = t & ME, c = t & _E;
  if (n && (i = o ? n(e, r, o, a) : n(e)), i !== void 0)
    return i;
  if (!xE(e))
    return e;
  var u = bE(e);
  if (u) {
    if (i = mE(e), !s)
      return cE(e, i);
  } else {
    var d = pE(e), f = d == Kf || d == $E;
    if (yE(e))
      return lE(e, s);
    if (d == Qf || d == Zf || f && !o) {
      if (i = l || f ? {} : vE(e), !s)
        return l ? dE(e, sE(i, e)) : uE(e, iE(i, e));
    } else {
      if (!$e[d])
        return o ? e : {};
      i = gE(e, d, s);
    }
  }
  a || (a = new rE());
  var h = a.get(e);
  if (h)
    return h;
  a.set(e, i), CE(e) ? e.forEach(function(g) {
    i.add(Ea(g, t, n, g, e, a));
  }) : wE(e) && e.forEach(function(g, y) {
    i.set(y, Ea(g, t, n, y, e, a));
  });
  var p = c ? l ? hE : fE : l ? EE : SE, m = u ? void 0 : p(e);
  return oE(m || e, function(g, y) {
    m && (y = g, g = e[y]), aE(i, y, Ea(g, t, n, y, e, a));
  }), i;
}
var KE = Ea, QE = KE, JE = 1, ek = 4;
function tk(e) {
  return QE(e, JE | ek);
}
var nk = tk;
Object.defineProperty(Zo, "__esModule", {
  value: !0
});
Zo.mergeClasses = void 0;
var rk = Pl, ok = Jf(rk), ak = nk, ik = Jf(ak), sk = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
};
function Jf(e) {
  return e && e.__esModule ? e : { default: e };
}
var lk = Zo.mergeClasses = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = t.default && (0, ik.default)(t.default) || {};
  return n.map(function(o) {
    var a = t[o];
    return a && (0, ok.default)(a, function(i, s) {
      r[s] || (r[s] = {}), r[s] = sk({}, r[s], a[s]);
    }), o;
  }), r;
};
Zo.default = lk;
var Ko = {};
Object.defineProperty(Ko, "__esModule", {
  value: !0
});
Ko.autoprefix = void 0;
var ck = Pl, d0 = dk(ck), uk = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
};
function dk(e) {
  return e && e.__esModule ? e : { default: e };
}
var fk = {
  borderRadius: function(t) {
    return {
      msBorderRadius: t,
      MozBorderRadius: t,
      OBorderRadius: t,
      WebkitBorderRadius: t,
      borderRadius: t
    };
  },
  boxShadow: function(t) {
    return {
      msBoxShadow: t,
      MozBoxShadow: t,
      OBoxShadow: t,
      WebkitBoxShadow: t,
      boxShadow: t
    };
  },
  userSelect: function(t) {
    return {
      WebkitTouchCallout: t,
      KhtmlUserSelect: t,
      MozUserSelect: t,
      msUserSelect: t,
      WebkitUserSelect: t,
      userSelect: t
    };
  },
  flex: function(t) {
    return {
      WebkitBoxFlex: t,
      MozBoxFlex: t,
      WebkitFlex: t,
      msFlex: t,
      flex: t
    };
  },
  flexBasis: function(t) {
    return {
      WebkitFlexBasis: t,
      flexBasis: t
    };
  },
  justifyContent: function(t) {
    return {
      WebkitJustifyContent: t,
      justifyContent: t
    };
  },
  transition: function(t) {
    return {
      msTransition: t,
      MozTransition: t,
      OTransition: t,
      WebkitTransition: t,
      transition: t
    };
  },
  transform: function(t) {
    return {
      msTransform: t,
      MozTransform: t,
      OTransform: t,
      WebkitTransform: t,
      transform: t
    };
  },
  absolute: function(t) {
    var n = t && t.split(" ");
    return {
      position: "absolute",
      top: n && n[0],
      right: n && n[1],
      bottom: n && n[2],
      left: n && n[3]
    };
  },
  extend: function(t, n) {
    var r = n[t];
    return r || {
      extend: t
    };
  }
}, hk = Ko.autoprefix = function(t) {
  var n = {};
  return (0, d0.default)(t, function(r, o) {
    var a = {};
    (0, d0.default)(r, function(i, s) {
      var l = fk[s];
      l ? a = uk({}, a, l(i)) : a[s] = i;
    }), n[o] = a;
  }), n;
};
Ko.default = hk;
var Qo = {};
Object.defineProperty(Qo, "__esModule", {
  value: !0
});
Qo.hover = void 0;
var pk = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, mk = v, qi = gk(mk);
function gk(e) {
  return e && e.__esModule ? e : { default: e };
}
function vk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f0(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function bk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var yk = Qo.hover = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    bk(o, r);
    function o() {
      var a, i, s, l;
      vk(this, o);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (i = (s = f0(this, (a = o.__proto__ || Object.getPrototypeOf(o)).call.apply(a, [this].concat(u))), s), s.state = { hover: !1 }, s.handleMouseOver = function() {
        return s.setState({ hover: !0 });
      }, s.handleMouseOut = function() {
        return s.setState({ hover: !1 });
      }, s.render = function() {
        return qi.default.createElement(
          n,
          { onMouseOver: s.handleMouseOver, onMouseOut: s.handleMouseOut },
          qi.default.createElement(t, pk({}, s.props, s.state))
        );
      }, i), f0(s, l);
    }
    return o;
  }(qi.default.Component);
};
Qo.default = yk;
var Jo = {};
Object.defineProperty(Jo, "__esModule", {
  value: !0
});
Jo.active = void 0;
var wk = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, xk = v, Ui = Ck(xk);
function Ck(e) {
  return e && e.__esModule ? e : { default: e };
}
function Sk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function h0(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Ek(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var kk = Jo.active = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    Ek(o, r);
    function o() {
      var a, i, s, l;
      Sk(this, o);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (i = (s = h0(this, (a = o.__proto__ || Object.getPrototypeOf(o)).call.apply(a, [this].concat(u))), s), s.state = { active: !1 }, s.handleMouseDown = function() {
        return s.setState({ active: !0 });
      }, s.handleMouseUp = function() {
        return s.setState({ active: !1 });
      }, s.render = function() {
        return Ui.default.createElement(
          n,
          { onMouseDown: s.handleMouseDown, onMouseUp: s.handleMouseUp },
          Ui.default.createElement(t, wk({}, s.props, s.state))
        );
      }, i), h0(s, l);
    }
    return o;
  }(Ui.default.Component);
};
Jo.default = kk;
var Bl = {};
Object.defineProperty(Bl, "__esModule", {
  value: !0
});
var Mk = function(t, n) {
  var r = {}, o = function(i) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    r[i] = s;
  };
  return t === 0 && o("first-child"), t === n - 1 && o("last-child"), (t === 0 || t % 2 === 0) && o("even"), Math.abs(t % 2) === 1 && o("odd"), o("nth-child", t), r;
};
Bl.default = Mk;
Object.defineProperty(_t, "__esModule", {
  value: !0
});
_t.ReactCSS = _t.loop = _t.handleActive = zl = _t.handleHover = _t.hover = void 0;
var _k = Uo, Pk = Wr(_k), Ok = Zo, Tk = Wr(Ok), Ak = Ko, $k = Wr(Ak), Rk = Qo, e2 = Wr(Rk), Dk = Jo, Nk = Wr(Dk), Lk = Bl, jk = Wr(Lk);
function Wr(e) {
  return e && e.__esModule ? e : { default: e };
}
_t.hover = e2.default;
var zl = _t.handleHover = e2.default;
_t.handleActive = Nk.default;
_t.loop = jk.default;
var Hk = _t.ReactCSS = function(t) {
  for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var a = (0, Pk.default)(r), i = (0, Tk.default)(t, a);
  return (0, $k.default)(i);
}, le = _t.default = Hk, Fk = function(t, n, r, o, a) {
  var i = a.clientWidth, s = a.clientHeight, l = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, c = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, u = l - (a.getBoundingClientRect().left + window.pageXOffset), d = c - (a.getBoundingClientRect().top + window.pageYOffset);
  if (r === "vertical") {
    var f = void 0;
    if (d < 0 ? f = 0 : d > s ? f = 1 : f = Math.round(d * 100 / s) / 100, n.a !== f)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: f,
        source: "rgb"
      };
  } else {
    var h = void 0;
    if (u < 0 ? h = 0 : u > i ? h = 1 : h = Math.round(u * 100 / i) / 100, o !== h)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: h,
        source: "rgb"
      };
  }
  return null;
}, Gi = {}, Bk = function(t, n, r, o) {
  if (typeof document > "u" && !o)
    return null;
  var a = o ? new o() : document.createElement("canvas");
  a.width = r * 2, a.height = r * 2;
  var i = a.getContext("2d");
  return i ? (i.fillStyle = t, i.fillRect(0, 0, a.width, a.height), i.fillStyle = n, i.fillRect(0, 0, r, r), i.translate(r, r), i.fillRect(0, 0, r, r), a.toDataURL()) : null;
}, zk = function(t, n, r, o) {
  var a = t + "-" + n + "-" + r + (o ? "-server" : "");
  if (Gi[a])
    return Gi[a];
  var i = Bk(t, n, r, o);
  return Gi[a] = i, i;
}, p0 = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, Vr = function(t) {
  var n = t.white, r = t.grey, o = t.size, a = t.renderers, i = t.borderRadius, s = t.boxShadow, l = t.children, c = le({
    default: {
      grid: {
        borderRadius: i,
        boxShadow: s,
        absolute: "0px 0px 0px 0px",
        background: "url(" + zk(n, r, o, a.canvas) + ") center left"
      }
    }
  });
  return Ao(l) ? v.cloneElement(l, p0({}, l.props, { style: p0({}, l.props.style, c.grid) })) : v.createElement("div", { style: c.grid });
};
Vr.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var Ik = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, Wk = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function Vk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function m0(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Yk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Il = function(e) {
  Yk(t, e);
  function t() {
    var n, r, o, a;
    Vk(this, t);
    for (var i = arguments.length, s = Array(i), l = 0; l < i; l++)
      s[l] = arguments[l];
    return a = (r = (o = m0(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(s))), o), o.handleChange = function(c) {
      var u = Fk(c, o.props.hsl, o.props.direction, o.props.a, o.container);
      u && typeof o.props.onChange == "function" && o.props.onChange(u, c);
    }, o.handleMouseDown = function(c) {
      o.handleChange(c), window.addEventListener("mousemove", o.handleChange), window.addEventListener("mouseup", o.handleMouseUp);
    }, o.handleMouseUp = function() {
      o.unbindEventListeners();
    }, o.unbindEventListeners = function() {
      window.removeEventListener("mousemove", o.handleChange), window.removeEventListener("mouseup", o.handleMouseUp);
    }, r), m0(o, a);
  }
  return Wk(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props.rgb, a = le({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + o.r + "," + o.g + "," + o.b + `, 0) 0%,
           rgba(` + o.r + "," + o.g + "," + o.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: o.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + o.r + "," + o.g + "," + o.b + `, 0) 0%,
           rgba(` + o.r + "," + o.g + "," + o.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: o.a * 100 + "%"
          }
        },
        overwrite: Ik({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return v.createElement(
        "div",
        { style: a.alpha },
        v.createElement(
          "div",
          { style: a.checkboard },
          v.createElement(Vr, { renderers: this.props.renderers })
        ),
        v.createElement("div", { style: a.gradient }),
        v.createElement(
          "div",
          {
            style: a.container,
            ref: function(s) {
              return r.container = s;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          v.createElement(
            "div",
            { style: a.pointer },
            this.props.pointer ? v.createElement(this.props.pointer, this.props) : v.createElement("div", { style: a.slider })
          )
        )
      );
    }
  }]), t;
}(Io || Wo), qk = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function Uk(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Gk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Xk(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Zk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Kk = 1, t2 = 38, Qk = 40, Jk = [t2, Qk], eM = function(t) {
  return Jk.indexOf(t) > -1;
}, tM = function(t) {
  return Number(String(t).replace(/%/g, ""));
}, nM = 1, be = function(e) {
  Zk(t, e);
  function t(n) {
    Gk(this, t);
    var r = Xk(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return r.handleBlur = function() {
      r.state.blurValue && r.setState({ value: r.state.blurValue, blurValue: null });
    }, r.handleChange = function(o) {
      r.setUpdatedValue(o.target.value, o);
    }, r.handleKeyDown = function(o) {
      var a = tM(o.target.value);
      if (!isNaN(a) && eM(o.keyCode)) {
        var i = r.getArrowOffset(), s = o.keyCode === t2 ? a + i : a - i;
        r.setUpdatedValue(s, o);
      }
    }, r.handleDrag = function(o) {
      if (r.props.dragLabel) {
        var a = Math.round(r.props.value + o.movementX);
        a >= 0 && a <= r.props.dragMax && r.props.onChange && r.props.onChange(r.getValueObjectWithLabel(a), o);
      }
    }, r.handleMouseDown = function(o) {
      r.props.dragLabel && (o.preventDefault(), r.handleDrag(o), window.addEventListener("mousemove", r.handleDrag), window.addEventListener("mouseup", r.handleMouseUp));
    }, r.handleMouseUp = function() {
      r.unbindEventListeners();
    }, r.unbindEventListeners = function() {
      window.removeEventListener("mousemove", r.handleDrag), window.removeEventListener("mouseup", r.handleMouseUp);
    }, r.state = {
      value: String(n.value).toUpperCase(),
      blurValue: String(n.value).toUpperCase()
    }, r.inputId = "rc-editable-input-" + nM++, r;
  }
  return qk(t, [{
    key: "componentDidUpdate",
    value: function(r, o) {
      this.props.value !== this.state.value && (r.value !== this.props.value || o.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(r) {
      return Uk({}, this.props.label, r);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || Kk;
    }
  }, {
    key: "setUpdatedValue",
    value: function(r, o) {
      var a = this.props.label ? this.getValueObjectWithLabel(r) : r;
      this.props.onChange && this.props.onChange(a, o), this.setState({ value: r });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = le({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return v.createElement(
        "div",
        { style: o.wrap },
        v.createElement("input", {
          id: this.inputId,
          style: o.input,
          ref: function(i) {
            return r.input = i;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? v.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: o.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), t;
}(Io || Wo), rM = function(t, n, r, o) {
  var a = o.clientWidth, i = o.clientHeight, s = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, l = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, c = s - (o.getBoundingClientRect().left + window.pageXOffset), u = l - (o.getBoundingClientRect().top + window.pageYOffset);
  if (n === "vertical") {
    var d = void 0;
    if (u < 0)
      d = 359;
    else if (u > i)
      d = 0;
    else {
      var f = -(u * 100 / i) + 100;
      d = 360 * f / 100;
    }
    if (r.h !== d)
      return {
        h: d,
        s: r.s,
        l: r.l,
        a: r.a,
        source: "hsl"
      };
  } else {
    var h = void 0;
    if (c < 0)
      h = 0;
    else if (c > a)
      h = 359;
    else {
      var p = c * 100 / a;
      h = 360 * p / 100;
    }
    if (r.h !== h)
      return {
        h,
        s: r.s,
        l: r.l,
        a: r.a,
        source: "hsl"
      };
  }
  return null;
}, oM = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function aM(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function g0(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function iM(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Yr = function(e) {
  iM(t, e);
  function t() {
    var n, r, o, a;
    aM(this, t);
    for (var i = arguments.length, s = Array(i), l = 0; l < i; l++)
      s[l] = arguments[l];
    return a = (r = (o = g0(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(s))), o), o.handleChange = function(c) {
      var u = rM(c, o.props.direction, o.props.hsl, o.container);
      u && typeof o.props.onChange == "function" && o.props.onChange(u, c);
    }, o.handleMouseDown = function(c) {
      o.handleChange(c), window.addEventListener("mousemove", o.handleChange), window.addEventListener("mouseup", o.handleMouseUp);
    }, o.handleMouseUp = function() {
      o.unbindEventListeners();
    }, r), g0(o, a);
  }
  return oM(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props.direction, a = o === void 0 ? "horizontal" : o, i = le({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: a === "vertical" });
      return v.createElement(
        "div",
        { style: i.hue },
        v.createElement(
          "div",
          {
            className: "hue-" + a,
            style: i.container,
            ref: function(l) {
              return r.container = l;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          v.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          v.createElement(
            "div",
            { style: i.pointer },
            this.props.pointer ? v.createElement(this.props.pointer, this.props) : v.createElement("div", { style: i.slider })
          )
        )
      );
    }
  }]), t;
}(Io || Wo), Ls = { exports: {} }, ca = { exports: {} }, _e = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v0;
function sM() {
  if (v0)
    return _e;
  v0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function w(x) {
    if (typeof x == "object" && x !== null) {
      var M = x.$$typeof;
      switch (M) {
        case t:
          switch (x = x.type, x) {
            case l:
            case c:
            case r:
            case a:
            case o:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case u:
                case p:
                case h:
                case i:
                  return x;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function S(x) {
    return w(x) === c;
  }
  return _e.AsyncMode = l, _e.ConcurrentMode = c, _e.ContextConsumer = s, _e.ContextProvider = i, _e.Element = t, _e.ForwardRef = u, _e.Fragment = r, _e.Lazy = p, _e.Memo = h, _e.Portal = n, _e.Profiler = a, _e.StrictMode = o, _e.Suspense = d, _e.isAsyncMode = function(x) {
    return S(x) || w(x) === l;
  }, _e.isConcurrentMode = S, _e.isContextConsumer = function(x) {
    return w(x) === s;
  }, _e.isContextProvider = function(x) {
    return w(x) === i;
  }, _e.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, _e.isForwardRef = function(x) {
    return w(x) === u;
  }, _e.isFragment = function(x) {
    return w(x) === r;
  }, _e.isLazy = function(x) {
    return w(x) === p;
  }, _e.isMemo = function(x) {
    return w(x) === h;
  }, _e.isPortal = function(x) {
    return w(x) === n;
  }, _e.isProfiler = function(x) {
    return w(x) === a;
  }, _e.isStrictMode = function(x) {
    return w(x) === o;
  }, _e.isSuspense = function(x) {
    return w(x) === d;
  }, _e.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === c || x === a || x === o || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === p || x.$$typeof === h || x.$$typeof === i || x.$$typeof === s || x.$$typeof === u || x.$$typeof === g || x.$$typeof === y || x.$$typeof === b || x.$$typeof === m);
  }, _e.typeOf = w, _e;
}
var Pe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b0;
function lM() {
  return b0 || (b0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function w(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === r || D === c || D === a || D === o || D === d || D === f || typeof D == "object" && D !== null && (D.$$typeof === p || D.$$typeof === h || D.$$typeof === i || D.$$typeof === s || D.$$typeof === u || D.$$typeof === g || D.$$typeof === y || D.$$typeof === b || D.$$typeof === m);
    }
    function S(D) {
      if (typeof D == "object" && D !== null) {
        var ye = D.$$typeof;
        switch (ye) {
          case t:
            var We = D.type;
            switch (We) {
              case l:
              case c:
              case r:
              case a:
              case o:
              case d:
                return We;
              default:
                var we = We && We.$$typeof;
                switch (we) {
                  case s:
                  case u:
                  case p:
                  case h:
                  case i:
                    return we;
                  default:
                    return ye;
                }
            }
          case n:
            return ye;
        }
      }
    }
    var x = l, M = c, _ = s, R = i, B = t, U = u, F = r, T = p, j = h, A = n, G = a, N = o, te = d, oe = !1;
    function Q(D) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), P(D) || S(D) === l;
    }
    function P(D) {
      return S(D) === c;
    }
    function L(D) {
      return S(D) === s;
    }
    function $(D) {
      return S(D) === i;
    }
    function I(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function H(D) {
      return S(D) === u;
    }
    function Y(D) {
      return S(D) === r;
    }
    function W(D) {
      return S(D) === p;
    }
    function q(D) {
      return S(D) === h;
    }
    function Z(D) {
      return S(D) === n;
    }
    function ee(D) {
      return S(D) === a;
    }
    function J(D) {
      return S(D) === o;
    }
    function ie(D) {
      return S(D) === d;
    }
    Pe.AsyncMode = x, Pe.ConcurrentMode = M, Pe.ContextConsumer = _, Pe.ContextProvider = R, Pe.Element = B, Pe.ForwardRef = U, Pe.Fragment = F, Pe.Lazy = T, Pe.Memo = j, Pe.Portal = A, Pe.Profiler = G, Pe.StrictMode = N, Pe.Suspense = te, Pe.isAsyncMode = Q, Pe.isConcurrentMode = P, Pe.isContextConsumer = L, Pe.isContextProvider = $, Pe.isElement = I, Pe.isForwardRef = H, Pe.isFragment = Y, Pe.isLazy = W, Pe.isMemo = q, Pe.isPortal = Z, Pe.isProfiler = ee, Pe.isStrictMode = J, Pe.isSuspense = ie, Pe.isValidElementType = w, Pe.typeOf = S;
  }()), Pe;
}
var y0;
function n2() {
  return y0 || (y0 = 1, process.env.NODE_ENV === "production" ? ca.exports = sM() : ca.exports = lM()), ca.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Xi, w0;
function cM() {
  if (w0)
    return Xi;
  w0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Xi = o() ? Object.assign : function(a, i) {
    for (var s, l = r(a), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var f = 0; f < c.length; f++)
          n.call(s, c[f]) && (l[c[f]] = s[c[f]]);
      }
    }
    return l;
  }, Xi;
}
var Zi, x0;
function Wl() {
  if (x0)
    return Zi;
  x0 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Zi = e, Zi;
}
var Ki, C0;
function r2() {
  return C0 || (C0 = 1, Ki = Function.call.bind(Object.prototype.hasOwnProperty)), Ki;
}
var Qi, S0;
function uM() {
  if (S0)
    return Qi;
  S0 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Wl(), n = {}, r = r2();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in a)
        if (r(a, u)) {
          var d;
          try {
            if (typeof a[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = a[u](i, u, l, s, null, t);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Qi = o, Qi;
}
var Ji, E0;
function dM() {
  if (E0)
    return Ji;
  E0 = 1;
  var e = n2(), t = cM(), n = Wl(), r = r2(), o = uM(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Ji = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(P) {
      var L = P && (c && P[c] || P[u]);
      if (typeof L == "function")
        return L;
    }
    var f = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: b(),
      arrayOf: w,
      element: S(),
      elementType: x(),
      instanceOf: M,
      node: U(),
      objectOf: R,
      oneOf: _,
      oneOfType: B,
      shape: T,
      exact: j
    };
    function p(P, L) {
      return P === L ? P !== 0 || 1 / P === 1 / L : P !== P && L !== L;
    }
    function m(P, L) {
      this.message = P, this.data = L && typeof L == "object" ? L : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g(P) {
      if (process.env.NODE_ENV !== "production")
        var L = {}, $ = 0;
      function I(Y, W, q, Z, ee, J, ie) {
        if (Z = Z || f, J = J || q, ie !== n) {
          if (l) {
            var D = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D.name = "Invariant Violation", D;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = Z + ":" + q;
            !L[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            $ < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + J + "` prop on `" + Z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), L[ye] = !0, $++);
          }
        }
        return W[q] == null ? Y ? W[q] === null ? new m("The " + ee + " `" + J + "` is marked as required " + ("in `" + Z + "`, but its value is `null`.")) : new m("The " + ee + " `" + J + "` is marked as required in " + ("`" + Z + "`, but its value is `undefined`.")) : null : P(W, q, Z, ee, J);
      }
      var H = I.bind(null, !1);
      return H.isRequired = I.bind(null, !0), H;
    }
    function y(P) {
      function L($, I, H, Y, W, q) {
        var Z = $[I], ee = N(Z);
        if (ee !== P) {
          var J = te(Z);
          return new m(
            "Invalid " + Y + " `" + W + "` of type " + ("`" + J + "` supplied to `" + H + "`, expected ") + ("`" + P + "`."),
            { expectedType: P }
          );
        }
        return null;
      }
      return g(L);
    }
    function b() {
      return g(i);
    }
    function w(P) {
      function L($, I, H, Y, W) {
        if (typeof P != "function")
          return new m("Property `" + W + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
        var q = $[I];
        if (!Array.isArray(q)) {
          var Z = N(q);
          return new m("Invalid " + Y + " `" + W + "` of type " + ("`" + Z + "` supplied to `" + H + "`, expected an array."));
        }
        for (var ee = 0; ee < q.length; ee++) {
          var J = P(q, ee, H, Y, W + "[" + ee + "]", n);
          if (J instanceof Error)
            return J;
        }
        return null;
      }
      return g(L);
    }
    function S() {
      function P(L, $, I, H, Y) {
        var W = L[$];
        if (!s(W)) {
          var q = N(W);
          return new m("Invalid " + H + " `" + Y + "` of type " + ("`" + q + "` supplied to `" + I + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(P);
    }
    function x() {
      function P(L, $, I, H, Y) {
        var W = L[$];
        if (!e.isValidElementType(W)) {
          var q = N(W);
          return new m("Invalid " + H + " `" + Y + "` of type " + ("`" + q + "` supplied to `" + I + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(P);
    }
    function M(P) {
      function L($, I, H, Y, W) {
        if (!($[I] instanceof P)) {
          var q = P.name || f, Z = Q($[I]);
          return new m("Invalid " + Y + " `" + W + "` of type " + ("`" + Z + "` supplied to `" + H + "`, expected ") + ("instance of `" + q + "`."));
        }
        return null;
      }
      return g(L);
    }
    function _(P) {
      if (!Array.isArray(P))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function L($, I, H, Y, W) {
        for (var q = $[I], Z = 0; Z < P.length; Z++)
          if (p(q, P[Z]))
            return null;
        var ee = JSON.stringify(P, function(ie, D) {
          var ye = te(D);
          return ye === "symbol" ? String(D) : D;
        });
        return new m("Invalid " + Y + " `" + W + "` of value `" + String(q) + "` " + ("supplied to `" + H + "`, expected one of " + ee + "."));
      }
      return g(L);
    }
    function R(P) {
      function L($, I, H, Y, W) {
        if (typeof P != "function")
          return new m("Property `" + W + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
        var q = $[I], Z = N(q);
        if (Z !== "object")
          return new m("Invalid " + Y + " `" + W + "` of type " + ("`" + Z + "` supplied to `" + H + "`, expected an object."));
        for (var ee in q)
          if (r(q, ee)) {
            var J = P(q, ee, H, Y, W + "." + ee, n);
            if (J instanceof Error)
              return J;
          }
        return null;
      }
      return g(L);
    }
    function B(P) {
      if (!Array.isArray(P))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var L = 0; L < P.length; L++) {
        var $ = P[L];
        if (typeof $ != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe($) + " at index " + L + "."
          ), i;
      }
      function I(H, Y, W, q, Z) {
        for (var ee = [], J = 0; J < P.length; J++) {
          var ie = P[J], D = ie(H, Y, W, q, Z, n);
          if (D == null)
            return null;
          D.data && r(D.data, "expectedType") && ee.push(D.data.expectedType);
        }
        var ye = ee.length > 0 ? ", expected one of type [" + ee.join(", ") + "]" : "";
        return new m("Invalid " + q + " `" + Z + "` supplied to " + ("`" + W + "`" + ye + "."));
      }
      return g(I);
    }
    function U() {
      function P(L, $, I, H, Y) {
        return A(L[$]) ? null : new m("Invalid " + H + " `" + Y + "` supplied to " + ("`" + I + "`, expected a ReactNode."));
      }
      return g(P);
    }
    function F(P, L, $, I, H) {
      return new m(
        (P || "React class") + ": " + L + " type `" + $ + "." + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`."
      );
    }
    function T(P) {
      function L($, I, H, Y, W) {
        var q = $[I], Z = N(q);
        if (Z !== "object")
          return new m("Invalid " + Y + " `" + W + "` of type `" + Z + "` " + ("supplied to `" + H + "`, expected `object`."));
        for (var ee in P) {
          var J = P[ee];
          if (typeof J != "function")
            return F(H, Y, W, ee, te(J));
          var ie = J(q, ee, H, Y, W + "." + ee, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return g(L);
    }
    function j(P) {
      function L($, I, H, Y, W) {
        var q = $[I], Z = N(q);
        if (Z !== "object")
          return new m("Invalid " + Y + " `" + W + "` of type `" + Z + "` " + ("supplied to `" + H + "`, expected `object`."));
        var ee = t({}, $[I], P);
        for (var J in ee) {
          var ie = P[J];
          if (r(P, J) && typeof ie != "function")
            return F(H, Y, W, J, te(ie));
          if (!ie)
            return new m(
              "Invalid " + Y + " `" + W + "` key `" + J + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify($[I], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(P), null, "  ")
            );
          var D = ie(q, J, H, Y, W + "." + J, n);
          if (D)
            return D;
        }
        return null;
      }
      return g(L);
    }
    function A(P) {
      switch (typeof P) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !P;
        case "object":
          if (Array.isArray(P))
            return P.every(A);
          if (P === null || s(P))
            return !0;
          var L = d(P);
          if (L) {
            var $ = L.call(P), I;
            if (L !== P.entries) {
              for (; !(I = $.next()).done; )
                if (!A(I.value))
                  return !1;
            } else
              for (; !(I = $.next()).done; ) {
                var H = I.value;
                if (H && !A(H[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function G(P, L) {
      return P === "symbol" ? !0 : L ? L["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && L instanceof Symbol : !1;
    }
    function N(P) {
      var L = typeof P;
      return Array.isArray(P) ? "array" : P instanceof RegExp ? "object" : G(L, P) ? "symbol" : L;
    }
    function te(P) {
      if (typeof P > "u" || P === null)
        return "" + P;
      var L = N(P);
      if (L === "object") {
        if (P instanceof Date)
          return "date";
        if (P instanceof RegExp)
          return "regexp";
      }
      return L;
    }
    function oe(P) {
      var L = te(P);
      switch (L) {
        case "array":
        case "object":
          return "an " + L;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + L;
        default:
          return L;
      }
    }
    function Q(P) {
      return !P.constructor || !P.constructor.name ? f : P.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, Ji;
}
var es, k0;
function fM() {
  if (k0)
    return es;
  k0 = 1;
  var e = Wl();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, es = function() {
    function r(i, s, l, c, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, es;
}
if (process.env.NODE_ENV !== "production") {
  var hM = n2(), pM = !0;
  Ls.exports = dM()(hM.isElement, pM);
} else
  Ls.exports = fM()();
var mM = Ls.exports;
const X = /* @__PURE__ */ yl(mM);
function gM() {
  this.__data__ = [], this.size = 0;
}
function ea(e, t) {
  return e === t || e !== e && t !== t;
}
function di(e, t) {
  for (var n = e.length; n--; )
    if (ea(e[n][0], t))
      return n;
  return -1;
}
var vM = Array.prototype, bM = vM.splice;
function yM(e) {
  var t = this.__data__, n = di(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : bM.call(t, n, 1), --this.size, !0;
}
function wM(e) {
  var t = this.__data__, n = di(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function xM(e) {
  return di(this.__data__, e) > -1;
}
function CM(e, t) {
  var n = this.__data__, r = di(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function an(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
an.prototype.clear = gM;
an.prototype.delete = yM;
an.prototype.get = wM;
an.prototype.has = xM;
an.prototype.set = CM;
function SM() {
  this.__data__ = new an(), this.size = 0;
}
function EM(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function kM(e) {
  return this.__data__.get(e);
}
function MM(e) {
  return this.__data__.has(e);
}
var _M = typeof global == "object" && global && global.Object === Object && global;
const o2 = _M;
var PM = typeof self == "object" && self && self.Object === Object && self, OM = o2 || PM || Function("return this")();
const Ft = OM;
var TM = Ft.Symbol;
const Sn = TM;
var a2 = Object.prototype, AM = a2.hasOwnProperty, $M = a2.toString, co = Sn ? Sn.toStringTag : void 0;
function RM(e) {
  var t = AM.call(e, co), n = e[co];
  try {
    e[co] = void 0;
    var r = !0;
  } catch {
  }
  var o = $M.call(e);
  return r && (t ? e[co] = n : delete e[co]), o;
}
var DM = Object.prototype, NM = DM.toString;
function LM(e) {
  return NM.call(e);
}
var jM = "[object Null]", HM = "[object Undefined]", M0 = Sn ? Sn.toStringTag : void 0;
function Gn(e) {
  return e == null ? e === void 0 ? HM : jM : M0 && M0 in Object(e) ? RM(e) : LM(e);
}
function Tt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var FM = "[object AsyncFunction]", BM = "[object Function]", zM = "[object GeneratorFunction]", IM = "[object Proxy]";
function Vl(e) {
  if (!Tt(e))
    return !1;
  var t = Gn(e);
  return t == BM || t == zM || t == FM || t == IM;
}
var WM = Ft["__core-js_shared__"];
const ts = WM;
var _0 = function() {
  var e = /[^.]+$/.exec(ts && ts.keys && ts.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function VM(e) {
  return !!_0 && _0 in e;
}
var YM = Function.prototype, qM = YM.toString;
function Xn(e) {
  if (e != null) {
    try {
      return qM.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var UM = /[\\^$.*+?()[\]{}|]/g, GM = /^\[object .+?Constructor\]$/, XM = Function.prototype, ZM = Object.prototype, KM = XM.toString, QM = ZM.hasOwnProperty, JM = RegExp(
  "^" + KM.call(QM).replace(UM, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function e_(e) {
  if (!Tt(e) || VM(e))
    return !1;
  var t = Vl(e) ? JM : GM;
  return t.test(Xn(e));
}
function t_(e, t) {
  return e == null ? void 0 : e[t];
}
function Zn(e, t) {
  var n = t_(e, t);
  return e_(n) ? n : void 0;
}
var n_ = Zn(Ft, "Map");
const Do = n_;
var r_ = Zn(Object, "create");
const No = r_;
function o_() {
  this.__data__ = No ? No(null) : {}, this.size = 0;
}
function a_(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var i_ = "__lodash_hash_undefined__", s_ = Object.prototype, l_ = s_.hasOwnProperty;
function c_(e) {
  var t = this.__data__;
  if (No) {
    var n = t[e];
    return n === i_ ? void 0 : n;
  }
  return l_.call(t, e) ? t[e] : void 0;
}
var u_ = Object.prototype, d_ = u_.hasOwnProperty;
function f_(e) {
  var t = this.__data__;
  return No ? t[e] !== void 0 : d_.call(t, e);
}
var h_ = "__lodash_hash_undefined__";
function p_(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = No && t === void 0 ? h_ : t, this;
}
function Bn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Bn.prototype.clear = o_;
Bn.prototype.delete = a_;
Bn.prototype.get = c_;
Bn.prototype.has = f_;
Bn.prototype.set = p_;
function m_() {
  this.size = 0, this.__data__ = {
    hash: new Bn(),
    map: new (Do || an)(),
    string: new Bn()
  };
}
function g_(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function fi(e, t) {
  var n = e.__data__;
  return g_(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function v_(e) {
  var t = fi(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function b_(e) {
  return fi(this, e).get(e);
}
function y_(e) {
  return fi(this, e).has(e);
}
function w_(e, t) {
  var n = fi(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function sn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
sn.prototype.clear = m_;
sn.prototype.delete = v_;
sn.prototype.get = b_;
sn.prototype.has = y_;
sn.prototype.set = w_;
var x_ = 200;
function C_(e, t) {
  var n = this.__data__;
  if (n instanceof an) {
    var r = n.__data__;
    if (!Do || r.length < x_ - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new sn(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Yt(e) {
  var t = this.__data__ = new an(e);
  this.size = t.size;
}
Yt.prototype.clear = SM;
Yt.prototype.delete = EM;
Yt.prototype.get = kM;
Yt.prototype.has = MM;
Yt.prototype.set = C_;
var S_ = function() {
  try {
    var e = Zn(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Na = S_;
function Yl(e, t, n) {
  t == "__proto__" && Na ? Na(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function js(e, t, n) {
  (n !== void 0 && !ea(e[t], n) || n === void 0 && !(t in e)) && Yl(e, t, n);
}
function E_(e) {
  return function(t, n, r) {
    for (var o = -1, a = Object(t), i = r(t), s = i.length; s--; ) {
      var l = i[e ? s : ++o];
      if (n(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var k_ = E_();
const i2 = k_;
var s2 = typeof exports == "object" && exports && !exports.nodeType && exports, P0 = s2 && typeof module == "object" && module && !module.nodeType && module, M_ = P0 && P0.exports === s2, O0 = M_ ? Ft.Buffer : void 0, T0 = O0 ? O0.allocUnsafe : void 0;
function __(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = T0 ? T0(n) : new e.constructor(n);
  return e.copy(r), r;
}
var P_ = Ft.Uint8Array;
const La = P_;
function O_(e) {
  var t = new e.constructor(e.byteLength);
  return new La(t).set(new La(e)), t;
}
function T_(e, t) {
  var n = t ? O_(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
function A_(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var A0 = Object.create, $_ = function() {
  function e() {
  }
  return function(t) {
    if (!Tt(t))
      return {};
    if (A0)
      return A0(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
const R_ = $_;
function l2(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var D_ = l2(Object.getPrototypeOf, Object);
const c2 = D_;
var N_ = Object.prototype;
function ql(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || N_;
  return e === n;
}
function L_(e) {
  return typeof e.constructor == "function" && !ql(e) ? R_(c2(e)) : {};
}
function En(e) {
  return e != null && typeof e == "object";
}
var j_ = "[object Arguments]";
function $0(e) {
  return En(e) && Gn(e) == j_;
}
var u2 = Object.prototype, H_ = u2.hasOwnProperty, F_ = u2.propertyIsEnumerable, B_ = $0(function() {
  return arguments;
}()) ? $0 : function(e) {
  return En(e) && H_.call(e, "callee") && !F_.call(e, "callee");
};
const ja = B_;
var z_ = Array.isArray;
const Et = z_;
var I_ = 9007199254740991;
function Ul(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= I_;
}
function qr(e) {
  return e != null && Ul(e.length) && !Vl(e);
}
function W_(e) {
  return En(e) && qr(e);
}
function V_() {
  return !1;
}
var d2 = typeof exports == "object" && exports && !exports.nodeType && exports, R0 = d2 && typeof module == "object" && module && !module.nodeType && module, Y_ = R0 && R0.exports === d2, D0 = Y_ ? Ft.Buffer : void 0, q_ = D0 ? D0.isBuffer : void 0, U_ = q_ || V_;
const Ha = U_;
var G_ = "[object Object]", X_ = Function.prototype, Z_ = Object.prototype, f2 = X_.toString, K_ = Z_.hasOwnProperty, Q_ = f2.call(Object);
function J_(e) {
  if (!En(e) || Gn(e) != G_)
    return !1;
  var t = c2(e);
  if (t === null)
    return !0;
  var n = K_.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && f2.call(n) == Q_;
}
var eP = "[object Arguments]", tP = "[object Array]", nP = "[object Boolean]", rP = "[object Date]", oP = "[object Error]", aP = "[object Function]", iP = "[object Map]", sP = "[object Number]", lP = "[object Object]", cP = "[object RegExp]", uP = "[object Set]", dP = "[object String]", fP = "[object WeakMap]", hP = "[object ArrayBuffer]", pP = "[object DataView]", mP = "[object Float32Array]", gP = "[object Float64Array]", vP = "[object Int8Array]", bP = "[object Int16Array]", yP = "[object Int32Array]", wP = "[object Uint8Array]", xP = "[object Uint8ClampedArray]", CP = "[object Uint16Array]", SP = "[object Uint32Array]", je = {};
je[mP] = je[gP] = je[vP] = je[bP] = je[yP] = je[wP] = je[xP] = je[CP] = je[SP] = !0;
je[eP] = je[tP] = je[hP] = je[nP] = je[pP] = je[rP] = je[oP] = je[aP] = je[iP] = je[sP] = je[lP] = je[cP] = je[uP] = je[dP] = je[fP] = !1;
function EP(e) {
  return En(e) && Ul(e.length) && !!je[Gn(e)];
}
function kP(e) {
  return function(t) {
    return e(t);
  };
}
var h2 = typeof exports == "object" && exports && !exports.nodeType && exports, Po = h2 && typeof module == "object" && module && !module.nodeType && module, MP = Po && Po.exports === h2, ns = MP && o2.process, _P = function() {
  try {
    var e = Po && Po.require && Po.require("util").types;
    return e || ns && ns.binding && ns.binding("util");
  } catch {
  }
}();
const N0 = _P;
var L0 = N0 && N0.isTypedArray, PP = L0 ? kP(L0) : EP;
const Gl = PP;
function Hs(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var OP = Object.prototype, TP = OP.hasOwnProperty;
function AP(e, t, n) {
  var r = e[t];
  (!(TP.call(e, t) && ea(r, n)) || n === void 0 && !(t in e)) && Yl(e, t, n);
}
function $P(e, t, n, r) {
  var o = !n;
  n || (n = {});
  for (var a = -1, i = t.length; ++a < i; ) {
    var s = t[a], l = r ? r(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), o ? Yl(n, s, l) : AP(n, s, l);
  }
  return n;
}
function RP(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var DP = 9007199254740991, NP = /^(?:0|[1-9]\d*)$/;
function Xl(e, t) {
  var n = typeof e;
  return t = t ?? DP, !!t && (n == "number" || n != "symbol" && NP.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var LP = Object.prototype, jP = LP.hasOwnProperty;
function p2(e, t) {
  var n = Et(e), r = !n && ja(e), o = !n && !r && Ha(e), a = !n && !r && !o && Gl(e), i = n || r || o || a, s = i ? RP(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || jP.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Xl(c, l))) && s.push(c);
  return s;
}
function HP(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var FP = Object.prototype, BP = FP.hasOwnProperty;
function zP(e) {
  if (!Tt(e))
    return HP(e);
  var t = ql(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !BP.call(e, r)) || n.push(r);
  return n;
}
function m2(e) {
  return qr(e) ? p2(e, !0) : zP(e);
}
function IP(e) {
  return $P(e, m2(e));
}
function WP(e, t, n, r, o, a, i) {
  var s = Hs(e, n), l = Hs(t, n), c = i.get(l);
  if (c) {
    js(e, n, c);
    return;
  }
  var u = a ? a(s, l, n + "", e, t, i) : void 0, d = u === void 0;
  if (d) {
    var f = Et(l), h = !f && Ha(l), p = !f && !h && Gl(l);
    u = l, f || h || p ? Et(s) ? u = s : W_(s) ? u = A_(s) : h ? (d = !1, u = __(l, !0)) : p ? (d = !1, u = T_(l, !0)) : u = [] : J_(l) || ja(l) ? (u = s, ja(s) ? u = IP(s) : (!Tt(s) || Vl(s)) && (u = L_(l))) : d = !1;
  }
  d && (i.set(l, u), o(u, l, r, a, i), i.delete(l)), js(e, n, u);
}
function g2(e, t, n, r, o) {
  e !== t && i2(t, function(a, i) {
    if (o || (o = new Yt()), Tt(a))
      WP(e, t, i, n, g2, r, o);
    else {
      var s = r ? r(Hs(e, i), a, i + "", e, t, o) : void 0;
      s === void 0 && (s = a), js(e, i, s);
    }
  }, m2);
}
function hi(e) {
  return e;
}
function VP(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var j0 = Math.max;
function YP(e, t, n) {
  return t = j0(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, o = -1, a = j0(r.length - t, 0), i = Array(a); ++o < a; )
      i[o] = r[t + o];
    o = -1;
    for (var s = Array(t + 1); ++o < t; )
      s[o] = r[o];
    return s[t] = n(i), VP(e, this, s);
  };
}
function qP(e) {
  return function() {
    return e;
  };
}
var UP = Na ? function(e, t) {
  return Na(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: qP(t),
    writable: !0
  });
} : hi;
const GP = UP;
var XP = 800, ZP = 16, KP = Date.now;
function QP(e) {
  var t = 0, n = 0;
  return function() {
    var r = KP(), o = ZP - (r - n);
    if (n = r, o > 0) {
      if (++t >= XP)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var JP = QP(GP);
const eO = JP;
function tO(e, t) {
  return eO(YP(e, t, hi), e + "");
}
function nO(e, t, n) {
  if (!Tt(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? qr(n) && Xl(t, n.length) : r == "string" && t in n) ? ea(n[t], e) : !1;
}
function rO(e) {
  return tO(function(t, n) {
    var r = -1, o = n.length, a = o > 1 ? n[o - 1] : void 0, i = o > 2 ? n[2] : void 0;
    for (a = e.length > 3 && typeof a == "function" ? (o--, a) : void 0, i && nO(n[0], n[1], i) && (a = o < 3 ? void 0 : a, o = 1), t = Object(t); ++r < o; ) {
      var s = n[r];
      s && e(t, s, r, a);
    }
    return t;
  });
}
var oO = rO(function(e, t, n) {
  g2(e, t, n);
});
const gt = oO;
var ta = function(t) {
  var n = t.zDepth, r = t.radius, o = t.background, a = t.children, i = t.styles, s = i === void 0 ? {} : i, l = le(gt({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + n + "px " + n * 4 + "px rgba(0,0,0,.24)",
        borderRadius: r,
        background: o
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, s), { "zDepth-1": n === 1 });
  return v.createElement(
    "div",
    { style: l.wrap },
    v.createElement("div", { style: l.bg }),
    v.createElement(
      "div",
      { style: l.content },
      a
    )
  );
};
ta.propTypes = {
  background: X.string,
  zDepth: X.oneOf([0, 1, 2, 3, 4, 5]),
  radius: X.number,
  styles: X.object
};
ta.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var aO = function() {
  return Ft.Date.now();
};
const rs = aO;
var iO = /\s/;
function sO(e) {
  for (var t = e.length; t-- && iO.test(e.charAt(t)); )
    ;
  return t;
}
var lO = /^\s+/;
function cO(e) {
  return e && e.slice(0, sO(e) + 1).replace(lO, "");
}
var uO = "[object Symbol]";
function pi(e) {
  return typeof e == "symbol" || En(e) && Gn(e) == uO;
}
var H0 = 0 / 0, dO = /^[-+]0x[0-9a-f]+$/i, fO = /^0b[01]+$/i, hO = /^0o[0-7]+$/i, pO = parseInt;
function F0(e) {
  if (typeof e == "number")
    return e;
  if (pi(e))
    return H0;
  if (Tt(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Tt(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = cO(e);
  var n = fO.test(e);
  return n || hO.test(e) ? pO(e.slice(2), n ? 2 : 8) : dO.test(e) ? H0 : +e;
}
var mO = "Expected a function", gO = Math.max, vO = Math.min;
function v2(e, t, n) {
  var r, o, a, i, s, l, c = 0, u = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(mO);
  t = F0(t) || 0, Tt(n) && (u = !!n.leading, d = "maxWait" in n, a = d ? gO(F0(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f);
  function h(M) {
    var _ = r, R = o;
    return r = o = void 0, c = M, i = e.apply(R, _), i;
  }
  function p(M) {
    return c = M, s = setTimeout(y, t), u ? h(M) : i;
  }
  function m(M) {
    var _ = M - l, R = M - c, B = t - _;
    return d ? vO(B, a - R) : B;
  }
  function g(M) {
    var _ = M - l, R = M - c;
    return l === void 0 || _ >= t || _ < 0 || d && R >= a;
  }
  function y() {
    var M = rs();
    if (g(M))
      return b(M);
    s = setTimeout(y, m(M));
  }
  function b(M) {
    return s = void 0, f && r ? h(M) : (r = o = void 0, i);
  }
  function w() {
    s !== void 0 && clearTimeout(s), c = 0, r = l = o = s = void 0;
  }
  function S() {
    return s === void 0 ? i : b(rs());
  }
  function x() {
    var M = rs(), _ = g(M);
    if (r = arguments, o = this, l = M, _) {
      if (s === void 0)
        return p(l);
      if (d)
        return clearTimeout(s), s = setTimeout(y, t), h(l);
    }
    return s === void 0 && (s = setTimeout(y, t)), i;
  }
  return x.cancel = w, x.flush = S, x;
}
var bO = "Expected a function";
function yO(e, t, n) {
  var r = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(bO);
  return Tt(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), v2(e, t, {
    leading: r,
    maxWait: t,
    trailing: o
  });
}
var wO = function(t, n, r) {
  var o = r.getBoundingClientRect(), a = o.width, i = o.height, s = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, l = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, c = s - (r.getBoundingClientRect().left + window.pageXOffset), u = l - (r.getBoundingClientRect().top + window.pageYOffset);
  c < 0 ? c = 0 : c > a && (c = a), u < 0 ? u = 0 : u > i && (u = i);
  var d = c / a, f = 1 - u / i;
  return {
    h: n.h,
    s: d,
    v: f,
    a: n.a,
    source: "hsv"
  };
}, xO = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function CO(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function SO(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function EO(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var mi = function(e) {
  EO(t, e);
  function t(n) {
    CO(this, t);
    var r = SO(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, n));
    return r.handleChange = function(o) {
      typeof r.props.onChange == "function" && r.throttle(r.props.onChange, wO(o, r.props.hsl, r.container), o);
    }, r.handleMouseDown = function(o) {
      r.handleChange(o);
      var a = r.getContainerRenderWindow();
      a.addEventListener("mousemove", r.handleChange), a.addEventListener("mouseup", r.handleMouseUp);
    }, r.handleMouseUp = function() {
      r.unbindEventListeners();
    }, r.throttle = yO(function(o, a, i) {
      o(a, i);
    }, 50), r;
  }
  return xO(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var r = this.container, o = window; !o.document.contains(r) && o.parent !== o; )
        o = o.parent;
      return o;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var r = this.getContainerRenderWindow();
      r.removeEventListener("mousemove", this.handleChange), r.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props.style || {}, a = o.color, i = o.white, s = o.black, l = o.pointer, c = o.circle, u = le({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: a,
          white: i,
          black: s,
          pointer: l,
          circle: c
        }
      }, { custom: !!this.props.style });
      return v.createElement(
        "div",
        {
          style: u.color,
          ref: function(f) {
            return r.container = f;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        v.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        v.createElement(
          "div",
          { style: u.white, className: "saturation-white" },
          v.createElement("div", { style: u.black, className: "saturation-black" }),
          v.createElement(
            "div",
            { style: u.pointer },
            this.props.pointer ? v.createElement(this.props.pointer, this.props) : v.createElement("div", { style: u.circle })
          )
        )
      );
    }
  }]), t;
}(Io || Wo);
function kO(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var MO = l2(Object.keys, Object);
const _O = MO;
var PO = Object.prototype, OO = PO.hasOwnProperty;
function TO(e) {
  if (!ql(e))
    return _O(e);
  var t = [];
  for (var n in Object(e))
    OO.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function Zl(e) {
  return qr(e) ? p2(e) : TO(e);
}
function AO(e, t) {
  return e && i2(e, t, Zl);
}
function $O(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!qr(n))
      return e(n, r);
    for (var o = n.length, a = t ? o : -1, i = Object(n); (t ? a-- : ++a < o) && r(i[a], a, i) !== !1; )
      ;
    return n;
  };
}
var RO = $O(AO);
const b2 = RO;
function DO(e) {
  return typeof e == "function" ? e : hi;
}
function NO(e, t) {
  var n = Et(e) ? kO : b2;
  return n(e, DO(t));
}
function Fa(e) {
  "@babel/helpers - typeof";
  return Fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fa(e);
}
var LO = /^\s+/, jO = /\s+$/;
function re(e, t) {
  if (e = e || "", t = t || {}, e instanceof re)
    return e;
  if (!(this instanceof re))
    return new re(e, t);
  var n = HO(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
re.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, r, o, a, i, s;
    return n = t.r / 255, r = t.g / 255, o = t.b / 255, n <= 0.03928 ? a = n / 12.92 : a = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? i = r / 12.92 : i = Math.pow((r + 0.055) / 1.055, 2.4), o <= 0.03928 ? s = o / 12.92 : s = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * a + 0.7152 * i + 0.0722 * s;
  },
  setAlpha: function(t) {
    return this._a = y2(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = z0(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = z0(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + o + "%)" : "hsva(" + n + ", " + r + "%, " + o + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = B0(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = B0(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + o + "%)" : "hsla(" + n + ", " + r + "%, " + o + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return I0(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return IO(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Ie(this._r, 255) * 100) + "%",
      g: Math.round(Ie(this._g, 255) * 100) + "%",
      b: Math.round(Ie(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Ie(this._r, 255) * 100) + "%, " + Math.round(Ie(this._g, 255) * 100) + "%, " + Math.round(Ie(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Ie(this._r, 255) * 100) + "%, " + Math.round(Ie(this._g, 255) * 100) + "%, " + Math.round(Ie(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : eT[I0(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + W0(this._r, this._g, this._b, this._a), r = n, o = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var a = re(t);
      r = "#" + W0(a._r, a._g, a._b, a._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + o + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var r = !1, o = this._a < 1 && this._a >= 0, a = !n && o && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return a ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return re(this.toString());
  },
  _applyModification: function(t, n) {
    var r = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(qO, arguments);
  },
  brighten: function() {
    return this._applyModification(UO, arguments);
  },
  darken: function() {
    return this._applyModification(GO, arguments);
  },
  desaturate: function() {
    return this._applyModification(WO, arguments);
  },
  saturate: function() {
    return this._applyModification(VO, arguments);
  },
  greyscale: function() {
    return this._applyModification(YO, arguments);
  },
  spin: function() {
    return this._applyModification(XO, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(QO, arguments);
  },
  complement: function() {
    return this._applyCombination(ZO, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(JO, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(KO, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(V0, [3]);
  },
  tetrad: function() {
    return this._applyCombination(V0, [4]);
  }
};
re.fromRatio = function(e, t) {
  if (Fa(e) == "object") {
    var n = {};
    for (var r in e)
      e.hasOwnProperty(r) && (r === "a" ? n[r] = e[r] : n[r] = xo(e[r]));
    e = n;
  }
  return re(e, t);
};
function HO(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, o = null, a = null, i = !1, s = !1;
  return typeof e == "string" && (e = oT(e)), Fa(e) == "object" && (Xt(e.r) && Xt(e.g) && Xt(e.b) ? (t = FO(e.r, e.g, e.b), i = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Xt(e.h) && Xt(e.s) && Xt(e.v) ? (r = xo(e.s), o = xo(e.v), t = zO(e.h, r, o), i = !0, s = "hsv") : Xt(e.h) && Xt(e.s) && Xt(e.l) && (r = xo(e.s), a = xo(e.l), t = BO(e.h, r, a), i = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = y2(n), {
    ok: i,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function FO(e, t, n) {
  return {
    r: Ie(e, 255) * 255,
    g: Ie(t, 255) * 255,
    b: Ie(n, 255) * 255
  };
}
function B0(e, t, n) {
  e = Ie(e, 255), t = Ie(t, 255), n = Ie(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a, i, s = (r + o) / 2;
  if (r == o)
    a = i = 0;
  else {
    var l = r - o;
    switch (i = s > 0.5 ? l / (2 - r - o) : l / (r + o), r) {
      case e:
        a = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / l + 2;
        break;
      case n:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return {
    h: a,
    s: i,
    l: s
  };
}
function BO(e, t, n) {
  var r, o, a;
  e = Ie(e, 360), t = Ie(t, 100), n = Ie(n, 100);
  function i(c, u, d) {
    return d < 0 && (d += 1), d > 1 && (d -= 1), d < 1 / 6 ? c + (u - c) * 6 * d : d < 1 / 2 ? u : d < 2 / 3 ? c + (u - c) * (2 / 3 - d) * 6 : c;
  }
  if (t === 0)
    r = o = a = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    r = i(l, s, e + 1 / 3), o = i(l, s, e), a = i(l, s, e - 1 / 3);
  }
  return {
    r: r * 255,
    g: o * 255,
    b: a * 255
  };
}
function z0(e, t, n) {
  e = Ie(e, 255), t = Ie(t, 255), n = Ie(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a, i, s = r, l = r - o;
  if (i = r === 0 ? 0 : l / r, r == o)
    a = 0;
  else {
    switch (r) {
      case e:
        a = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / l + 2;
        break;
      case n:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return {
    h: a,
    s: i,
    v: s
  };
}
function zO(e, t, n) {
  e = Ie(e, 360) * 6, t = Ie(t, 100), n = Ie(n, 100);
  var r = Math.floor(e), o = e - r, a = n * (1 - t), i = n * (1 - o * t), s = n * (1 - (1 - o) * t), l = r % 6, c = [n, i, a, a, s, n][l], u = [s, n, n, i, a, a][l], d = [a, a, s, n, n, i][l];
  return {
    r: c * 255,
    g: u * 255,
    b: d * 255
  };
}
function I0(e, t, n, r) {
  var o = [Dt(Math.round(e).toString(16)), Dt(Math.round(t).toString(16)), Dt(Math.round(n).toString(16))];
  return r && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function IO(e, t, n, r, o) {
  var a = [Dt(Math.round(e).toString(16)), Dt(Math.round(t).toString(16)), Dt(Math.round(n).toString(16)), Dt(w2(r))];
  return o && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function W0(e, t, n, r) {
  var o = [Dt(w2(r)), Dt(Math.round(e).toString(16)), Dt(Math.round(t).toString(16)), Dt(Math.round(n).toString(16))];
  return o.join("");
}
re.equals = function(e, t) {
  return !e || !t ? !1 : re(e).toRgbString() == re(t).toRgbString();
};
re.random = function() {
  return re.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function WO(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = re(e).toHsl();
  return n.s -= t / 100, n.s = gi(n.s), re(n);
}
function VO(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = re(e).toHsl();
  return n.s += t / 100, n.s = gi(n.s), re(n);
}
function YO(e) {
  return re(e).desaturate(100);
}
function qO(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = re(e).toHsl();
  return n.l += t / 100, n.l = gi(n.l), re(n);
}
function UO(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = re(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), re(n);
}
function GO(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = re(e).toHsl();
  return n.l -= t / 100, n.l = gi(n.l), re(n);
}
function XO(e, t) {
  var n = re(e).toHsl(), r = (n.h + t) % 360;
  return n.h = r < 0 ? 360 + r : r, re(n);
}
function ZO(e) {
  var t = re(e).toHsl();
  return t.h = (t.h + 180) % 360, re(t);
}
function V0(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = re(e).toHsl(), r = [re(e)], o = 360 / t, a = 1; a < t; a++)
    r.push(re({
      h: (n.h + a * o) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function KO(e) {
  var t = re(e).toHsl(), n = t.h;
  return [re(e), re({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), re({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function QO(e, t, n) {
  t = t || 6, n = n || 30;
  var r = re(e).toHsl(), o = 360 / n, a = [re(e)];
  for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
    r.h = (r.h + o) % 360, a.push(re(r));
  return a;
}
function JO(e, t) {
  t = t || 6;
  for (var n = re(e).toHsv(), r = n.h, o = n.s, a = n.v, i = [], s = 1 / t; t--; )
    i.push(re({
      h: r,
      s: o,
      v: a
    })), a = (a + s) % 1;
  return i;
}
re.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var r = re(e).toRgb(), o = re(t).toRgb(), a = n / 100, i = {
    r: (o.r - r.r) * a + r.r,
    g: (o.g - r.g) * a + r.g,
    b: (o.b - r.b) * a + r.b,
    a: (o.a - r.a) * a + r.a
  };
  return re(i);
};
re.readability = function(e, t) {
  var n = re(e), r = re(t);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
re.isReadable = function(e, t, n) {
  var r = re.readability(e, t), o, a;
  switch (a = !1, o = aT(n), o.level + o.size) {
    case "AAsmall":
    case "AAAlarge":
      a = r >= 4.5;
      break;
    case "AAlarge":
      a = r >= 3;
      break;
    case "AAAsmall":
      a = r >= 7;
      break;
  }
  return a;
};
re.mostReadable = function(e, t, n) {
  var r = null, o = 0, a, i, s, l;
  n = n || {}, i = n.includeFallbackColors, s = n.level, l = n.size;
  for (var c = 0; c < t.length; c++)
    a = re.readability(e, t[c]), a > o && (o = a, r = re(t[c]));
  return re.isReadable(e, r, {
    level: s,
    size: l
  }) || !i ? r : (n.includeFallbackColors = !1, re.mostReadable(e, ["#fff", "#000"], n));
};
var Fs = re.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, eT = re.hexNames = tT(Fs);
function tT(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function y2(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ie(e, t) {
  nT(e) && (e = "100%");
  var n = rT(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function gi(e) {
  return Math.min(1, Math.max(0, e));
}
function yt(e) {
  return parseInt(e, 16);
}
function nT(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function rT(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function Dt(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function xo(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function w2(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Y0(e) {
  return yt(e) / 255;
}
var $t = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", o = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + o),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + o),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + o),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function Xt(e) {
  return !!$t.CSS_UNIT.exec(e);
}
function oT(e) {
  e = e.replace(LO, "").replace(jO, "").toLowerCase();
  var t = !1;
  if (Fs[e])
    e = Fs[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = $t.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = $t.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = $t.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = $t.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = $t.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = $t.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = $t.hex8.exec(e)) ? {
    r: yt(n[1]),
    g: yt(n[2]),
    b: yt(n[3]),
    a: Y0(n[4]),
    format: t ? "name" : "hex8"
  } : (n = $t.hex6.exec(e)) ? {
    r: yt(n[1]),
    g: yt(n[2]),
    b: yt(n[3]),
    format: t ? "name" : "hex"
  } : (n = $t.hex4.exec(e)) ? {
    r: yt(n[1] + "" + n[1]),
    g: yt(n[2] + "" + n[2]),
    b: yt(n[3] + "" + n[3]),
    a: Y0(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = $t.hex3.exec(e)) ? {
    r: yt(n[1] + "" + n[1]),
    g: yt(n[2] + "" + n[2]),
    b: yt(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function aT(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
var q0 = function(t) {
  var n = ["r", "g", "b", "a", "h", "s", "l", "v"], r = 0, o = 0;
  return NO(n, function(a) {
    if (t[a] && (r += 1, isNaN(t[a]) || (o += 1), a === "s" || a === "l")) {
      var i = /^\d+%$/;
      i.test(t[a]) && (o += 1);
    }
  }), r === o ? t : !1;
}, Co = function(t, n) {
  var r = t.hex ? re(t.hex) : re(t), o = r.toHsl(), a = r.toHsv(), i = r.toRgb(), s = r.toHex();
  o.s === 0 && (o.h = n || 0, a.h = n || 0);
  var l = s === "000000" && i.a === 0;
  return {
    hsl: o,
    hex: l ? "transparent" : "#" + s,
    rgb: i,
    hsv: a,
    oldHue: t.h || n || o.h,
    source: t.source
  };
}, On = function(t) {
  if (t === "transparent")
    return !0;
  var n = String(t).charAt(0) === "#" ? 1 : 0;
  return t.length !== 4 + n && t.length < 7 + n && re(t).isValid();
}, Kl = function(t) {
  if (!t)
    return "#fff";
  var n = Co(t);
  if (n.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var r = (n.rgb.r * 299 + n.rgb.g * 587 + n.rgb.b * 114) / 1e3;
  return r >= 128 ? "#000" : "#fff";
}, os = function(t, n) {
  var r = t.replace("°", "");
  return re(n + " (" + r + ")")._ok;
}, uo = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, iT = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function sT(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lT(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function cT(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var vt = function(t) {
  var n = function(r) {
    cT(o, r);
    function o(a) {
      sT(this, o);
      var i = lT(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this));
      return i.handleChange = function(s, l) {
        var c = q0(s);
        if (c) {
          var u = Co(s, s.h || i.state.oldHue);
          i.setState(u), i.props.onChangeComplete && i.debounce(i.props.onChangeComplete, u, l), i.props.onChange && i.props.onChange(u, l);
        }
      }, i.handleSwatchHover = function(s, l) {
        var c = q0(s);
        if (c) {
          var u = Co(s, s.h || i.state.oldHue);
          i.props.onSwatchHover && i.props.onSwatchHover(u, l);
        }
      }, i.state = uo({}, Co(a.color, 0)), i.debounce = v2(function(s, l, c) {
        s(l, c);
      }, 100), i;
    }
    return iT(o, [{
      key: "render",
      value: function() {
        var i = {};
        return this.props.onSwatchHover && (i.onSwatchHover = this.handleSwatchHover), v.createElement(t, uo({}, this.props, this.state, {
          onChange: this.handleChange
        }, i));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(i, s) {
        return uo({}, Co(i.color, s.oldHue));
      }
    }]), o;
  }(Io || Wo);
  return n.propTypes = uo({}, t.propTypes), n.defaultProps = uo({}, t.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), n;
}, uT = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, dT = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function fT(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function U0(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function hT(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var pT = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    hT(o, r);
    function o() {
      var a, i, s, l;
      fT(this, o);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (i = (s = U0(this, (a = o.__proto__ || Object.getPrototypeOf(o)).call.apply(a, [this].concat(u))), s), s.state = { focus: !1 }, s.handleFocus = function() {
        return s.setState({ focus: !0 });
      }, s.handleBlur = function() {
        return s.setState({ focus: !1 });
      }, i), U0(s, l);
    }
    return dT(o, [{
      key: "render",
      value: function() {
        return v.createElement(
          n,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          v.createElement(t, uT({}, this.props, this.state))
        );
      }
    }]), o;
  }(v.Component);
}, G0 = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, mT = 13, gT = function(t) {
  var n = t.color, r = t.style, o = t.onClick, a = o === void 0 ? function() {
  } : o, i = t.onHover, s = t.title, l = s === void 0 ? n : s, c = t.children, u = t.focus, d = t.focusStyle, f = d === void 0 ? {} : d, h = n === "transparent", p = le({
    default: {
      swatch: G0({
        background: n,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, r, u ? f : {})
    }
  }), m = function(S) {
    return a(n, S);
  }, g = function(S) {
    return S.keyCode === mT && a(n, S);
  }, y = function(S) {
    return i(n, S);
  }, b = {};
  return i && (b.onMouseOver = y), v.createElement(
    "div",
    G0({
      style: p.swatch,
      onClick: m,
      title: l,
      tabIndex: 0,
      onKeyDown: g
    }, b),
    c,
    h && v.createElement(Vr, {
      borderRadius: p.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const Kn = pT(gT);
var vT = function(t) {
  var n = t.direction, r = le({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return v.createElement("div", { style: r.picker });
}, bT = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, x2 = function(t) {
  var n = t.rgb, r = t.hsl, o = t.width, a = t.height, i = t.onChange, s = t.direction, l = t.style, c = t.renderers, u = t.pointer, d = t.className, f = d === void 0 ? "" : d, h = le({
    default: {
      picker: {
        position: "relative",
        width: o,
        height: a
      },
      alpha: {
        radius: "2px",
        style: l
      }
    }
  });
  return v.createElement(
    "div",
    { style: h.picker, className: "alpha-picker " + f },
    v.createElement(Il, bT({}, h.alpha, {
      rgb: n,
      hsl: r,
      pointer: u,
      renderers: c,
      onChange: i,
      direction: s
    }))
  );
};
x2.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: vT
};
vt(x2);
function C2(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r; )
    o[n] = t(e[n], n, e);
  return o;
}
var yT = "__lodash_hash_undefined__";
function wT(e) {
  return this.__data__.set(e, yT), this;
}
function xT(e) {
  return this.__data__.has(e);
}
function Ba(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new sn(); ++t < n; )
    this.add(e[t]);
}
Ba.prototype.add = Ba.prototype.push = wT;
Ba.prototype.has = xT;
function CT(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function ST(e, t) {
  return e.has(t);
}
var ET = 1, kT = 2;
function S2(e, t, n, r, o, a) {
  var i = n & ET, s = e.length, l = t.length;
  if (s != l && !(i && l > s))
    return !1;
  var c = a.get(e), u = a.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, h = n & kT ? new Ba() : void 0;
  for (a.set(e, t), a.set(t, e); ++d < s; ) {
    var p = e[d], m = t[d];
    if (r)
      var g = i ? r(m, p, d, t, e, a) : r(p, m, d, e, t, a);
    if (g !== void 0) {
      if (g)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!CT(t, function(y, b) {
        if (!ST(h, b) && (p === y || o(p, y, n, r, a)))
          return h.push(b);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === m || o(p, m, n, r, a))) {
      f = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), f;
}
function MT(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
function _T(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var PT = 1, OT = 2, TT = "[object Boolean]", AT = "[object Date]", $T = "[object Error]", RT = "[object Map]", DT = "[object Number]", NT = "[object RegExp]", LT = "[object Set]", jT = "[object String]", HT = "[object Symbol]", FT = "[object ArrayBuffer]", BT = "[object DataView]", X0 = Sn ? Sn.prototype : void 0, as = X0 ? X0.valueOf : void 0;
function zT(e, t, n, r, o, a, i) {
  switch (n) {
    case BT:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case FT:
      return !(e.byteLength != t.byteLength || !a(new La(e), new La(t)));
    case TT:
    case AT:
    case DT:
      return ea(+e, +t);
    case $T:
      return e.name == t.name && e.message == t.message;
    case NT:
    case jT:
      return e == t + "";
    case RT:
      var s = MT;
    case LT:
      var l = r & PT;
      if (s || (s = _T), e.size != t.size && !l)
        return !1;
      var c = i.get(e);
      if (c)
        return c == t;
      r |= OT, i.set(e, t);
      var u = S2(s(e), s(t), r, o, a, i);
      return i.delete(e), u;
    case HT:
      if (as)
        return as.call(e) == as.call(t);
  }
  return !1;
}
function IT(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
function WT(e, t, n) {
  var r = t(e);
  return Et(e) ? r : IT(r, n(e));
}
function VT(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, a = []; ++n < r; ) {
    var i = e[n];
    t(i, n, e) && (a[o++] = i);
  }
  return a;
}
function YT() {
  return [];
}
var qT = Object.prototype, UT = qT.propertyIsEnumerable, Z0 = Object.getOwnPropertySymbols, GT = Z0 ? function(e) {
  return e == null ? [] : (e = Object(e), VT(Z0(e), function(t) {
    return UT.call(e, t);
  }));
} : YT;
const XT = GT;
function K0(e) {
  return WT(e, Zl, XT);
}
var ZT = 1, KT = Object.prototype, QT = KT.hasOwnProperty;
function JT(e, t, n, r, o, a) {
  var i = n & ZT, s = K0(e), l = s.length, c = K0(t), u = c.length;
  if (l != u && !i)
    return !1;
  for (var d = l; d--; ) {
    var f = s[d];
    if (!(i ? f in t : QT.call(t, f)))
      return !1;
  }
  var h = a.get(e), p = a.get(t);
  if (h && p)
    return h == t && p == e;
  var m = !0;
  a.set(e, t), a.set(t, e);
  for (var g = i; ++d < l; ) {
    f = s[d];
    var y = e[f], b = t[f];
    if (r)
      var w = i ? r(b, y, f, t, e, a) : r(y, b, f, e, t, a);
    if (!(w === void 0 ? y === b || o(y, b, n, r, a) : w)) {
      m = !1;
      break;
    }
    g || (g = f == "constructor");
  }
  if (m && !g) {
    var S = e.constructor, x = t.constructor;
    S != x && "constructor" in e && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof x == "function" && x instanceof x) && (m = !1);
  }
  return a.delete(e), a.delete(t), m;
}
var eA = Zn(Ft, "DataView");
const Bs = eA;
var tA = Zn(Ft, "Promise");
const zs = tA;
var nA = Zn(Ft, "Set");
const Is = nA;
var rA = Zn(Ft, "WeakMap");
const Ws = rA;
var Q0 = "[object Map]", oA = "[object Object]", J0 = "[object Promise]", e1 = "[object Set]", t1 = "[object WeakMap]", n1 = "[object DataView]", aA = Xn(Bs), iA = Xn(Do), sA = Xn(zs), lA = Xn(Is), cA = Xn(Ws), Dn = Gn;
(Bs && Dn(new Bs(new ArrayBuffer(1))) != n1 || Do && Dn(new Do()) != Q0 || zs && Dn(zs.resolve()) != J0 || Is && Dn(new Is()) != e1 || Ws && Dn(new Ws()) != t1) && (Dn = function(e) {
  var t = Gn(e), n = t == oA ? e.constructor : void 0, r = n ? Xn(n) : "";
  if (r)
    switch (r) {
      case aA:
        return n1;
      case iA:
        return Q0;
      case sA:
        return J0;
      case lA:
        return e1;
      case cA:
        return t1;
    }
  return t;
});
const r1 = Dn;
var uA = 1, o1 = "[object Arguments]", a1 = "[object Array]", ua = "[object Object]", dA = Object.prototype, i1 = dA.hasOwnProperty;
function fA(e, t, n, r, o, a) {
  var i = Et(e), s = Et(t), l = i ? a1 : r1(e), c = s ? a1 : r1(t);
  l = l == o1 ? ua : l, c = c == o1 ? ua : c;
  var u = l == ua, d = c == ua, f = l == c;
  if (f && Ha(e)) {
    if (!Ha(t))
      return !1;
    i = !0, u = !1;
  }
  if (f && !u)
    return a || (a = new Yt()), i || Gl(e) ? S2(e, t, n, r, o, a) : zT(e, t, l, n, r, o, a);
  if (!(n & uA)) {
    var h = u && i1.call(e, "__wrapped__"), p = d && i1.call(t, "__wrapped__");
    if (h || p) {
      var m = h ? e.value() : e, g = p ? t.value() : t;
      return a || (a = new Yt()), o(m, g, n, r, a);
    }
  }
  return f ? (a || (a = new Yt()), JT(e, t, n, r, o, a)) : !1;
}
function Ql(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !En(e) && !En(t) ? e !== e && t !== t : fA(e, t, n, r, Ql, o);
}
var hA = 1, pA = 2;
function mA(e, t, n, r) {
  var o = n.length, a = o, i = !r;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = n[o];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = n[o];
    var l = s[0], c = e[l], u = s[1];
    if (i && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var d = new Yt();
      if (r)
        var f = r(c, u, l, e, t, d);
      if (!(f === void 0 ? Ql(u, c, hA | pA, r, d) : f))
        return !1;
    }
  }
  return !0;
}
function E2(e) {
  return e === e && !Tt(e);
}
function gA(e) {
  for (var t = Zl(e), n = t.length; n--; ) {
    var r = t[n], o = e[r];
    t[n] = [r, o, E2(o)];
  }
  return t;
}
function k2(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function vA(e) {
  var t = gA(e);
  return t.length == 1 && t[0][2] ? k2(t[0][0], t[0][1]) : function(n) {
    return n === e || mA(n, e, t);
  };
}
var bA = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, yA = /^\w*$/;
function Jl(e, t) {
  if (Et(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || pi(e) ? !0 : yA.test(e) || !bA.test(e) || t != null && e in Object(t);
}
var wA = "Expected a function";
function ec(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(wA);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(o))
      return a.get(o);
    var i = e.apply(this, r);
    return n.cache = a.set(o, i) || a, i;
  };
  return n.cache = new (ec.Cache || sn)(), n;
}
ec.Cache = sn;
var xA = 500;
function CA(e) {
  var t = ec(e, function(r) {
    return n.size === xA && n.clear(), r;
  }), n = t.cache;
  return t;
}
var SA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, EA = /\\(\\)?/g, kA = CA(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(SA, function(n, r, o, a) {
    t.push(o ? a.replace(EA, "$1") : r || n);
  }), t;
});
const MA = kA;
var _A = 1 / 0, s1 = Sn ? Sn.prototype : void 0, l1 = s1 ? s1.toString : void 0;
function M2(e) {
  if (typeof e == "string")
    return e;
  if (Et(e))
    return C2(e, M2) + "";
  if (pi(e))
    return l1 ? l1.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -_A ? "-0" : t;
}
function PA(e) {
  return e == null ? "" : M2(e);
}
function _2(e, t) {
  return Et(e) ? e : Jl(e, t) ? [e] : MA(PA(e));
}
var OA = 1 / 0;
function vi(e) {
  if (typeof e == "string" || pi(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -OA ? "-0" : t;
}
function P2(e, t) {
  t = _2(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[vi(t[n++])];
  return n && n == r ? e : void 0;
}
function TA(e, t, n) {
  var r = e == null ? void 0 : P2(e, t);
  return r === void 0 ? n : r;
}
function AA(e, t) {
  return e != null && t in Object(e);
}
function $A(e, t, n) {
  t = _2(t, e);
  for (var r = -1, o = t.length, a = !1; ++r < o; ) {
    var i = vi(t[r]);
    if (!(a = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return a || ++r != o ? a : (o = e == null ? 0 : e.length, !!o && Ul(o) && Xl(i, o) && (Et(e) || ja(e)));
}
function RA(e, t) {
  return e != null && $A(e, t, AA);
}
var DA = 1, NA = 2;
function LA(e, t) {
  return Jl(e) && E2(t) ? k2(vi(e), t) : function(n) {
    var r = TA(n, e);
    return r === void 0 && r === t ? RA(n, e) : Ql(t, r, DA | NA);
  };
}
function jA(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function HA(e) {
  return function(t) {
    return P2(t, e);
  };
}
function FA(e) {
  return Jl(e) ? jA(vi(e)) : HA(e);
}
function BA(e) {
  return typeof e == "function" ? e : e == null ? hi : typeof e == "object" ? Et(e) ? LA(e[0], e[1]) : vA(e) : FA(e);
}
function zA(e, t) {
  var n = -1, r = qr(e) ? Array(e.length) : [];
  return b2(e, function(o, a, i) {
    r[++n] = t(o, a, i);
  }), r;
}
function Qn(e, t) {
  var n = Et(e) ? C2 : zA;
  return n(e, BA(t));
}
var IA = function(t) {
  var n = t.colors, r = t.onClick, o = t.onSwatchHover, a = le({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return v.createElement(
    "div",
    { style: a.swatches },
    Qn(n, function(i) {
      return v.createElement(Kn, {
        key: i,
        color: i,
        style: a.swatch,
        onClick: r,
        onHover: o,
        focusStyle: {
          boxShadow: "0 0 4px " + i
        }
      });
    }),
    v.createElement("div", { style: a.clear })
  );
}, tc = function(t) {
  var n = t.onChange, r = t.onSwatchHover, o = t.hex, a = t.colors, i = t.width, s = t.triangle, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = o === "transparent", h = function(g, y) {
    On(g) && n({
      hex: g,
      source: "hex"
    }, y);
  }, p = le(gt({
    default: {
      card: {
        width: i,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: o,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: Kl(o),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + o + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, c), { "hide-triangle": s === "hide" });
  return v.createElement(
    "div",
    { style: p.card, className: "block-picker " + d },
    v.createElement("div", { style: p.triangle }),
    v.createElement(
      "div",
      { style: p.head },
      f && v.createElement(Vr, { borderRadius: "6px 6px 0 0" }),
      v.createElement(
        "div",
        { style: p.label },
        o
      )
    ),
    v.createElement(
      "div",
      { style: p.body },
      v.createElement(IA, { colors: a, onClick: h, onSwatchHover: r }),
      v.createElement(be, {
        style: { input: p.input },
        value: o,
        onChange: h
      })
    )
  );
};
tc.propTypes = {
  width: X.oneOfType([X.string, X.number]),
  colors: X.arrayOf(X.string),
  triangle: X.oneOf(["top", "hide"]),
  styles: X.object
};
tc.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
vt(tc);
var cr = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", a100: "#ff8a80", a200: "#ff5252", a400: "#ff1744", a700: "#d50000" }, ur = { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f", a100: "#ff80ab", a200: "#ff4081", a400: "#f50057", a700: "#c51162" }, dr = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", a100: "#ea80fc", a200: "#e040fb", a400: "#d500f9", a700: "#aa00ff" }, fr = { 50: "#ede7f6", 100: "#d1c4e9", 200: "#b39ddb", 300: "#9575cd", 400: "#7e57c2", 500: "#673ab7", 600: "#5e35b1", 700: "#512da8", 800: "#4527a0", 900: "#311b92", a100: "#b388ff", a200: "#7c4dff", a400: "#651fff", a700: "#6200ea" }, hr = { 50: "#e8eaf6", 100: "#c5cae9", 200: "#9fa8da", 300: "#7986cb", 400: "#5c6bc0", 500: "#3f51b5", 600: "#3949ab", 700: "#303f9f", 800: "#283593", 900: "#1a237e", a100: "#8c9eff", a200: "#536dfe", a400: "#3d5afe", a700: "#304ffe" }, pr = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", a100: "#82b1ff", a200: "#448aff", a400: "#2979ff", a700: "#2962ff" }, mr = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", a100: "#80d8ff", a200: "#40c4ff", a400: "#00b0ff", a700: "#0091ea" }, gr = { 50: "#e0f7fa", 100: "#b2ebf2", 200: "#80deea", 300: "#4dd0e1", 400: "#26c6da", 500: "#00bcd4", 600: "#00acc1", 700: "#0097a7", 800: "#00838f", 900: "#006064", a100: "#84ffff", a200: "#18ffff", a400: "#00e5ff", a700: "#00b8d4" }, vr = { 50: "#e0f2f1", 100: "#b2dfdb", 200: "#80cbc4", 300: "#4db6ac", 400: "#26a69a", 500: "#009688", 600: "#00897b", 700: "#00796b", 800: "#00695c", 900: "#004d40", a100: "#a7ffeb", a200: "#64ffda", a400: "#1de9b6", a700: "#00bfa5" }, So = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", a100: "#b9f6ca", a200: "#69f0ae", a400: "#00e676", a700: "#00c853" }, br = { 50: "#f1f8e9", 100: "#dcedc8", 200: "#c5e1a5", 300: "#aed581", 400: "#9ccc65", 500: "#8bc34a", 600: "#7cb342", 700: "#689f38", 800: "#558b2f", 900: "#33691e", a100: "#ccff90", a200: "#b2ff59", a400: "#76ff03", a700: "#64dd17" }, yr = { 50: "#f9fbe7", 100: "#f0f4c3", 200: "#e6ee9c", 300: "#dce775", 400: "#d4e157", 500: "#cddc39", 600: "#c0ca33", 700: "#afb42b", 800: "#9e9d24", 900: "#827717", a100: "#f4ff81", a200: "#eeff41", a400: "#c6ff00", a700: "#aeea00" }, wr = { 50: "#fffde7", 100: "#fff9c4", 200: "#fff59d", 300: "#fff176", 400: "#ffee58", 500: "#ffeb3b", 600: "#fdd835", 700: "#fbc02d", 800: "#f9a825", 900: "#f57f17", a100: "#ffff8d", a200: "#ffff00", a400: "#ffea00", a700: "#ffd600" }, xr = { 50: "#fff8e1", 100: "#ffecb3", 200: "#ffe082", 300: "#ffd54f", 400: "#ffca28", 500: "#ffc107", 600: "#ffb300", 700: "#ffa000", 800: "#ff8f00", 900: "#ff6f00", a100: "#ffe57f", a200: "#ffd740", a400: "#ffc400", a700: "#ffab00" }, Cr = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", a100: "#ffd180", a200: "#ffab40", a400: "#ff9100", a700: "#ff6d00" }, Sr = { 50: "#fbe9e7", 100: "#ffccbc", 200: "#ffab91", 300: "#ff8a65", 400: "#ff7043", 500: "#ff5722", 600: "#f4511e", 700: "#e64a19", 800: "#d84315", 900: "#bf360c", a100: "#ff9e80", a200: "#ff6e40", a400: "#ff3d00", a700: "#dd2c00" }, Er = { 50: "#efebe9", 100: "#d7ccc8", 200: "#bcaaa4", 300: "#a1887f", 400: "#8d6e63", 500: "#795548", 600: "#6d4c41", 700: "#5d4037", 800: "#4e342e", 900: "#3e2723" }, kr = { 50: "#eceff1", 100: "#cfd8dc", 200: "#b0bec5", 300: "#90a4ae", 400: "#78909c", 500: "#607d8b", 600: "#546e7a", 700: "#455a64", 800: "#37474f", 900: "#263238" }, O2 = function(t) {
  var n = t.color, r = t.onClick, o = t.onSwatchHover, a = t.hover, i = t.active, s = t.circleSize, l = t.circleSpacing, c = le({
    default: {
      swatch: {
        width: s,
        height: s,
        marginRight: l,
        marginBottom: l,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (s / 2 + 1) + "px " + n,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + n
      }
    }
  }, { hover: a, active: i });
  return v.createElement(
    "div",
    { style: c.swatch },
    v.createElement(Kn, {
      style: c.Swatch,
      color: n,
      onClick: r,
      onHover: o,
      focusStyle: { boxShadow: c.Swatch.boxShadow + ", 0 0 5px " + n }
    })
  );
};
O2.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const WA = zl(O2);
var nc = function(t) {
  var n = t.width, r = t.onChange, o = t.onSwatchHover, a = t.colors, i = t.hex, s = t.circleSize, l = t.styles, c = l === void 0 ? {} : l, u = t.circleSpacing, d = t.className, f = d === void 0 ? "" : d, h = le(gt({
    default: {
      card: {
        width: n,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -u,
        marginBottom: -u
      }
    }
  }, c)), p = function(g, y) {
    return r({ hex: g, source: "hex" }, y);
  };
  return v.createElement(
    "div",
    { style: h.card, className: "circle-picker " + f },
    Qn(a, function(m) {
      return v.createElement(WA, {
        key: m,
        color: m,
        onClick: p,
        onSwatchHover: o,
        active: i === m.toLowerCase(),
        circleSize: s,
        circleSpacing: u
      });
    })
  );
};
nc.propTypes = {
  width: X.oneOfType([X.string, X.number]),
  circleSize: X.number,
  circleSpacing: X.number,
  styles: X.object
};
nc.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [cr[500], ur[500], dr[500], fr[500], hr[500], pr[500], mr[500], gr[500], vr[500], So[500], br[500], yr[500], wr[500], xr[500], Cr[500], Sr[500], Er[500], kr[500]],
  styles: {}
};
vt(nc);
function c1(e) {
  return e === void 0;
}
var T2 = {};
Object.defineProperty(T2, "__esModule", {
  value: !0
});
var u1 = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, VA = v, d1 = YA(VA);
function YA(e) {
  return e && e.__esModule ? e : { default: e };
}
function qA(e, t) {
  var n = {};
  for (var r in e)
    t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  return n;
}
var da = 24, UA = T2.default = function(e) {
  var t = e.fill, n = t === void 0 ? "currentColor" : t, r = e.width, o = r === void 0 ? da : r, a = e.height, i = a === void 0 ? da : a, s = e.style, l = s === void 0 ? {} : s, c = qA(e, ["fill", "width", "height", "style"]);
  return d1.default.createElement(
    "svg",
    u1({
      viewBox: "0 0 " + da + " " + da,
      style: u1({ fill: n, width: o, height: i }, l)
    }, c),
    d1.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, GA = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function XA(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ZA(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function KA(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var A2 = function(e) {
  KA(t, e);
  function t(n) {
    XA(this, t);
    var r = ZA(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return r.toggleViews = function() {
      r.state.view === "hex" ? r.setState({ view: "rgb" }) : r.state.view === "rgb" ? r.setState({ view: "hsl" }) : r.state.view === "hsl" && (r.props.hsl.a === 1 ? r.setState({ view: "hex" }) : r.setState({ view: "rgb" }));
    }, r.handleChange = function(o, a) {
      o.hex ? On(o.hex) && r.props.onChange({
        hex: o.hex,
        source: "hex"
      }, a) : o.r || o.g || o.b ? r.props.onChange({
        r: o.r || r.props.rgb.r,
        g: o.g || r.props.rgb.g,
        b: o.b || r.props.rgb.b,
        source: "rgb"
      }, a) : o.a ? (o.a < 0 ? o.a = 0 : o.a > 1 && (o.a = 1), r.props.onChange({
        h: r.props.hsl.h,
        s: r.props.hsl.s,
        l: r.props.hsl.l,
        a: Math.round(o.a * 100) / 100,
        source: "rgb"
      }, a)) : (o.h || o.s || o.l) && (typeof o.s == "string" && o.s.includes("%") && (o.s = o.s.replace("%", "")), typeof o.l == "string" && o.l.includes("%") && (o.l = o.l.replace("%", "")), o.s == 1 ? o.s = 0.01 : o.l == 1 && (o.l = 0.01), r.props.onChange({
        h: o.h || r.props.hsl.h,
        s: Number(c1(o.s) ? r.props.hsl.s : o.s),
        l: Number(c1(o.l) ? r.props.hsl.l : o.l),
        source: "hsl"
      }, a));
    }, r.showHighlight = function(o) {
      o.currentTarget.style.background = "#eee";
    }, r.hideHighlight = function(o) {
      o.currentTarget.style.background = "transparent";
    }, n.hsl.a !== 1 && n.view === "hex" ? r.state = {
      view: "rgb"
    } : r.state = {
      view: n.view
    }, r;
  }
  return GA(t, [{
    key: "render",
    value: function() {
      var r = this, o = le({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), a = void 0;
      return this.state.view === "hex" ? a = v.createElement(
        "div",
        { style: o.fields, className: "flexbox-fix" },
        v.createElement(
          "div",
          { style: o.field },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? a = v.createElement(
        "div",
        { style: o.fields, className: "flexbox-fix" },
        v.createElement(
          "div",
          { style: o.field },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        v.createElement(
          "div",
          { style: o.field },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        v.createElement(
          "div",
          { style: o.field },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        v.createElement(
          "div",
          { style: o.alpha },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (a = v.createElement(
        "div",
        { style: o.fields, className: "flexbox-fix" },
        v.createElement(
          "div",
          { style: o.field },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        v.createElement(
          "div",
          { style: o.field },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        v.createElement(
          "div",
          { style: o.field },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        v.createElement(
          "div",
          { style: o.alpha },
          v.createElement(be, {
            style: { input: o.input, label: o.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), v.createElement(
        "div",
        { style: o.wrap, className: "flexbox-fix" },
        a,
        v.createElement(
          "div",
          { style: o.toggle },
          v.createElement(
            "div",
            { style: o.icon, onClick: this.toggleViews, ref: function(s) {
              return r.icon = s;
            } },
            v.createElement(UA, {
              style: o.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      return r.hsl.a !== 1 && o.view === "hex" ? { view: "rgb" } : null;
    }
  }]), t;
}(v.Component);
A2.defaultProps = {
  view: "hex"
};
var f1 = function() {
  var t = le({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return v.createElement("div", { style: t.picker });
}, QA = function() {
  var t = le({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return v.createElement("div", { style: t.picker });
}, rc = function(t) {
  var n = t.width, r = t.onChange, o = t.disableAlpha, a = t.rgb, i = t.hsl, s = t.hsv, l = t.hex, c = t.renderers, u = t.styles, d = u === void 0 ? {} : u, f = t.className, h = f === void 0 ? "" : f, p = t.defaultView, m = le(gt({
    default: {
      picker: {
        width: n,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + a.r + ", " + a.g + ", " + a.b + ", " + a.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, d), { disableAlpha: o });
  return v.createElement(
    "div",
    { style: m.picker, className: "chrome-picker " + h },
    v.createElement(
      "div",
      { style: m.saturation },
      v.createElement(mi, {
        style: m.Saturation,
        hsl: i,
        hsv: s,
        pointer: QA,
        onChange: r
      })
    ),
    v.createElement(
      "div",
      { style: m.body },
      v.createElement(
        "div",
        { style: m.controls, className: "flexbox-fix" },
        v.createElement(
          "div",
          { style: m.color },
          v.createElement(
            "div",
            { style: m.swatch },
            v.createElement("div", { style: m.active }),
            v.createElement(Vr, { renderers: c })
          )
        ),
        v.createElement(
          "div",
          { style: m.toggles },
          v.createElement(
            "div",
            { style: m.hue },
            v.createElement(Yr, {
              style: m.Hue,
              hsl: i,
              pointer: f1,
              onChange: r
            })
          ),
          v.createElement(
            "div",
            { style: m.alpha },
            v.createElement(Il, {
              style: m.Alpha,
              rgb: a,
              hsl: i,
              pointer: f1,
              renderers: c,
              onChange: r
            })
          )
        )
      ),
      v.createElement(A2, {
        rgb: a,
        hsl: i,
        hex: l,
        view: p,
        onChange: r,
        disableAlpha: o
      })
    )
  );
};
rc.propTypes = {
  width: X.oneOfType([X.string, X.number]),
  disableAlpha: X.bool,
  styles: X.object,
  defaultView: X.oneOf(["hex", "rgb", "hsl"])
};
rc.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
vt(rc);
var JA = function(t) {
  var n = t.color, r = t.onClick, o = r === void 0 ? function() {
  } : r, a = t.onSwatchHover, i = t.active, s = le({
    default: {
      color: {
        background: n,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: Kl(n),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: i, "color-#FFFFFF": n === "#FFFFFF", transparent: n === "transparent" });
  return v.createElement(
    Kn,
    {
      style: s.color,
      color: n,
      onClick: o,
      onHover: a,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    v.createElement("div", { style: s.dot })
  );
}, e$ = function(t) {
  var n = t.hex, r = t.rgb, o = t.onChange, a = le({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: n
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), i = function(l, c) {
    l.r || l.g || l.b ? o({
      r: l.r || r.r,
      g: l.g || r.g,
      b: l.b || r.b,
      source: "rgb"
    }, c) : o({
      hex: l.hex,
      source: "hex"
    }, c);
  };
  return v.createElement(
    "div",
    { style: a.fields, className: "flexbox-fix" },
    v.createElement("div", { style: a.active }),
    v.createElement(be, {
      style: { wrap: a.HEXwrap, input: a.HEXinput, label: a.HEXlabel },
      label: "hex",
      value: n,
      onChange: i
    }),
    v.createElement(be, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "r",
      value: r.r,
      onChange: i
    }),
    v.createElement(be, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "g",
      value: r.g,
      onChange: i
    }),
    v.createElement(be, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "b",
      value: r.b,
      onChange: i
    })
  );
}, oc = function(t) {
  var n = t.onChange, r = t.onSwatchHover, o = t.colors, a = t.hex, i = t.rgb, s = t.styles, l = s === void 0 ? {} : s, c = t.className, u = c === void 0 ? "" : c, d = le(gt({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, l)), f = function(p, m) {
    p.hex ? On(p.hex) && n({
      hex: p.hex,
      source: "hex"
    }, m) : n(p, m);
  };
  return v.createElement(
    ta,
    { style: d.Compact, styles: l },
    v.createElement(
      "div",
      { style: d.compact, className: "compact-picker " + u },
      v.createElement(
        "div",
        null,
        Qn(o, function(h) {
          return v.createElement(JA, {
            key: h,
            color: h,
            active: h.toLowerCase() === a,
            onClick: f,
            onSwatchHover: r
          });
        }),
        v.createElement("div", { style: d.clear })
      ),
      v.createElement(e$, { hex: a, rgb: i, onChange: f })
    )
  );
};
oc.propTypes = {
  colors: X.arrayOf(X.string),
  styles: X.object
};
oc.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
vt(oc);
var t$ = function(t) {
  var n = t.hover, r = t.color, o = t.onClick, a = t.onSwatchHover, i = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, s = le({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: i
    }
  }, { hover: n });
  return v.createElement(
    "div",
    { style: s.swatch },
    v.createElement(Kn, {
      color: r,
      onClick: o,
      onHover: a,
      focusStyle: i
    })
  );
};
const n$ = zl(t$);
var ac = function(t) {
  var n = t.width, r = t.colors, o = t.onChange, a = t.onSwatchHover, i = t.triangle, s = t.styles, l = s === void 0 ? {} : s, c = t.className, u = c === void 0 ? "" : c, d = le(gt({
    default: {
      card: {
        width: n,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, l), {
    "hide-triangle": i === "hide",
    "top-left-triangle": i === "top-left",
    "top-right-triangle": i === "top-right",
    "bottom-left-triangle": i === "bottom-left",
    "bottom-right-triangle": i === "bottom-right"
  }), f = function(p, m) {
    return o({ hex: p, source: "hex" }, m);
  };
  return v.createElement(
    "div",
    { style: d.card, className: "github-picker " + u },
    v.createElement("div", { style: d.triangleShadow }),
    v.createElement("div", { style: d.triangle }),
    Qn(r, function(h) {
      return v.createElement(n$, {
        color: h,
        key: h,
        onClick: f,
        onSwatchHover: a
      });
    })
  );
};
ac.propTypes = {
  width: X.oneOfType([X.string, X.number]),
  colors: X.arrayOf(X.string),
  triangle: X.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: X.object
};
ac.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
vt(ac);
var r$ = function(t) {
  var n = t.direction, r = le({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return v.createElement("div", { style: r.picker });
}, o$ = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, ic = function(t) {
  var n = t.width, r = t.height, o = t.onChange, a = t.hsl, i = t.direction, s = t.pointer, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = le(gt({
    default: {
      picker: {
        position: "relative",
        width: n,
        height: r
      },
      hue: {
        radius: "2px"
      }
    }
  }, c)), h = function(m) {
    return o({ a: 1, h: m.h, l: 0.5, s: 1 });
  };
  return v.createElement(
    "div",
    { style: f.picker, className: "hue-picker " + d },
    v.createElement(Yr, o$({}, f.hue, {
      hsl: a,
      pointer: s,
      onChange: h,
      direction: i
    }))
  );
};
ic.propTypes = {
  styles: X.object
};
ic.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: r$,
  styles: {}
};
vt(ic);
var a$ = function(t) {
  var n = t.onChange, r = t.hex, o = t.rgb, a = t.styles, i = a === void 0 ? {} : a, s = t.className, l = s === void 0 ? "" : s, c = le(gt({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + r,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, i)), u = function(f, h) {
    f.hex ? On(f.hex) && n({
      hex: f.hex,
      source: "hex"
    }, h) : (f.r || f.g || f.b) && n({
      r: f.r || o.r,
      g: f.g || o.g,
      b: f.b || o.b,
      source: "rgb"
    }, h);
  };
  return v.createElement(
    ta,
    { styles: i },
    v.createElement(
      "div",
      { style: c.material, className: "material-picker " + l },
      v.createElement(be, {
        style: { wrap: c.HEXwrap, input: c.HEXinput, label: c.HEXlabel },
        label: "hex",
        value: r,
        onChange: u
      }),
      v.createElement(
        "div",
        { style: c.split, className: "flexbox-fix" },
        v.createElement(
          "div",
          { style: c.third },
          v.createElement(be, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "r",
            value: o.r,
            onChange: u
          })
        ),
        v.createElement(
          "div",
          { style: c.third },
          v.createElement(be, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "g",
            value: o.g,
            onChange: u
          })
        ),
        v.createElement(
          "div",
          { style: c.third },
          v.createElement(be, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "b",
            value: o.b,
            onChange: u
          })
        )
      )
    )
  );
};
vt(a$);
var i$ = function(t) {
  var n = t.onChange, r = t.rgb, o = t.hsv, a = t.hex, i = le({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), s = function(c, u) {
    c["#"] ? On(c["#"]) && n({
      hex: c["#"],
      source: "hex"
    }, u) : c.r || c.g || c.b ? n({
      r: c.r || r.r,
      g: c.g || r.g,
      b: c.b || r.b,
      source: "rgb"
    }, u) : (c.h || c.s || c.v) && n({
      h: c.h || o.h,
      s: c.s || o.s,
      v: c.v || o.v,
      source: "hsv"
    }, u);
  };
  return v.createElement(
    "div",
    { style: i.fields },
    v.createElement(be, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "h",
      value: Math.round(o.h),
      onChange: s
    }),
    v.createElement(be, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "s",
      value: Math.round(o.s * 100),
      onChange: s
    }),
    v.createElement(be, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "v",
      value: Math.round(o.v * 100),
      onChange: s
    }),
    v.createElement("div", { style: i.divider }),
    v.createElement(be, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "r",
      value: r.r,
      onChange: s
    }),
    v.createElement(be, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "g",
      value: r.g,
      onChange: s
    }),
    v.createElement(be, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "b",
      value: r.b,
      onChange: s
    }),
    v.createElement("div", { style: i.divider }),
    v.createElement(be, {
      style: { wrap: i.HEXwrap, input: i.HEXinput, label: i.HEXlabel },
      label: "#",
      value: a.replace("#", ""),
      onChange: s
    }),
    v.createElement(
      "div",
      { style: i.fieldSymbols },
      v.createElement(
        "div",
        { style: i.symbol },
        "°"
      ),
      v.createElement(
        "div",
        { style: i.symbol },
        "%"
      ),
      v.createElement(
        "div",
        { style: i.symbol },
        "%"
      )
    )
  );
}, s$ = function(t) {
  var n = t.hsl, r = le({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": n.l > 0.5 });
  return v.createElement("div", { style: r.picker });
}, l$ = function() {
  var t = le({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return v.createElement(
    "div",
    { style: t.pointer },
    v.createElement(
      "div",
      { style: t.left },
      v.createElement("div", { style: t.leftInside })
    ),
    v.createElement(
      "div",
      { style: t.right },
      v.createElement("div", { style: t.rightInside })
    )
  );
}, h1 = function(t) {
  var n = t.onClick, r = t.label, o = t.children, a = t.active, i = le({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: a });
  return v.createElement(
    "div",
    { style: i.button, onClick: n },
    r || o
  );
}, c$ = function(t) {
  var n = t.rgb, r = t.currentColor, o = le({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + n.r + "," + n.g + ", " + n.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: r,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return v.createElement(
    "div",
    null,
    v.createElement(
      "div",
      { style: o.label },
      "new"
    ),
    v.createElement(
      "div",
      { style: o.swatches },
      v.createElement("div", { style: o.new }),
      v.createElement("div", { style: o.current })
    ),
    v.createElement(
      "div",
      { style: o.label },
      "current"
    )
  );
}, u$ = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function d$(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f$(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function h$(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var sc = function(e) {
  h$(t, e);
  function t(n) {
    d$(this, t);
    var r = f$(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return r.state = {
      currentColor: n.hex
    }, r;
  }
  return u$(t, [{
    key: "render",
    value: function() {
      var r = this.props, o = r.styles, a = o === void 0 ? {} : o, i = r.className, s = i === void 0 ? "" : i, l = le(gt({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, a));
      return v.createElement(
        "div",
        { style: l.picker, className: "photoshop-picker " + s },
        v.createElement(
          "div",
          { style: l.head },
          this.props.header
        ),
        v.createElement(
          "div",
          { style: l.body, className: "flexbox-fix" },
          v.createElement(
            "div",
            { style: l.saturation },
            v.createElement(mi, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: s$,
              onChange: this.props.onChange
            })
          ),
          v.createElement(
            "div",
            { style: l.hue },
            v.createElement(Yr, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: l$,
              onChange: this.props.onChange
            })
          ),
          v.createElement(
            "div",
            { style: l.controls },
            v.createElement(
              "div",
              { style: l.top, className: "flexbox-fix" },
              v.createElement(
                "div",
                { style: l.previews },
                v.createElement(c$, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              v.createElement(
                "div",
                { style: l.actions },
                v.createElement(h1, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                v.createElement(h1, { label: "Cancel", onClick: this.props.onCancel }),
                v.createElement(i$, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), t;
}(v.Component);
sc.propTypes = {
  header: X.string,
  styles: X.object
};
sc.defaultProps = {
  header: "Color Picker",
  styles: {}
};
vt(sc);
var p$ = function(t) {
  var n = t.onChange, r = t.rgb, o = t.hsl, a = t.hex, i = t.disableAlpha, s = le({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: i }), l = function(u, d) {
    u.hex ? On(u.hex) && n({
      hex: u.hex,
      source: "hex"
    }, d) : u.r || u.g || u.b ? n({
      r: u.r || r.r,
      g: u.g || r.g,
      b: u.b || r.b,
      a: r.a,
      source: "rgb"
    }, d) : u.a && (u.a < 0 ? u.a = 0 : u.a > 100 && (u.a = 100), u.a /= 100, n({
      h: o.h,
      s: o.s,
      l: o.l,
      a: u.a,
      source: "rgb"
    }, d));
  };
  return v.createElement(
    "div",
    { style: s.fields, className: "flexbox-fix" },
    v.createElement(
      "div",
      { style: s.double },
      v.createElement(be, {
        style: { input: s.input, label: s.label },
        label: "hex",
        value: a.replace("#", ""),
        onChange: l
      })
    ),
    v.createElement(
      "div",
      { style: s.single },
      v.createElement(be, {
        style: { input: s.input, label: s.label },
        label: "r",
        value: r.r,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    v.createElement(
      "div",
      { style: s.single },
      v.createElement(be, {
        style: { input: s.input, label: s.label },
        label: "g",
        value: r.g,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    v.createElement(
      "div",
      { style: s.single },
      v.createElement(be, {
        style: { input: s.input, label: s.label },
        label: "b",
        value: r.b,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    v.createElement(
      "div",
      { style: s.alpha },
      v.createElement(be, {
        style: { input: s.input, label: s.label },
        label: "a",
        value: Math.round(r.a * 100),
        onChange: l,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, m$ = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, $2 = function(t) {
  var n = t.colors, r = t.onClick, o = r === void 0 ? function() {
  } : r, a = t.onSwatchHover, i = le({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !n || !n.length
  }), s = function(c, u) {
    o({
      hex: c,
      source: "hex"
    }, u);
  };
  return v.createElement(
    "div",
    { style: i.colors, className: "flexbox-fix" },
    n.map(function(l) {
      var c = typeof l == "string" ? { color: l } : l, u = "" + c.color + (c.title || "");
      return v.createElement(
        "div",
        { key: u, style: i.swatchWrap },
        v.createElement(Kn, m$({}, c, {
          style: i.swatch,
          onClick: s,
          onHover: a,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
          }
        }))
      );
    })
  );
};
$2.propTypes = {
  colors: X.arrayOf(X.oneOfType([X.string, X.shape({
    color: X.string,
    title: X.string
  })])).isRequired
};
var g$ = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, lc = function(t) {
  var n = t.width, r = t.rgb, o = t.hex, a = t.hsv, i = t.hsl, s = t.onChange, l = t.onSwatchHover, c = t.disableAlpha, u = t.presetColors, d = t.renderers, f = t.styles, h = f === void 0 ? {} : f, p = t.className, m = p === void 0 ? "" : p, g = le(gt({
    default: g$({
      picker: {
        width: n,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + r.r + "," + r.g + "," + r.b + "," + r.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, h),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, h), { disableAlpha: c });
  return v.createElement(
    "div",
    { style: g.picker, className: "sketch-picker " + m },
    v.createElement(
      "div",
      { style: g.saturation },
      v.createElement(mi, {
        style: g.Saturation,
        hsl: i,
        hsv: a,
        onChange: s
      })
    ),
    v.createElement(
      "div",
      { style: g.controls, className: "flexbox-fix" },
      v.createElement(
        "div",
        { style: g.sliders },
        v.createElement(
          "div",
          { style: g.hue },
          v.createElement(Yr, {
            style: g.Hue,
            hsl: i,
            onChange: s
          })
        ),
        v.createElement(
          "div",
          { style: g.alpha },
          v.createElement(Il, {
            style: g.Alpha,
            rgb: r,
            hsl: i,
            renderers: d,
            onChange: s
          })
        )
      ),
      v.createElement(
        "div",
        { style: g.color },
        v.createElement(Vr, null),
        v.createElement("div", { style: g.activeColor })
      )
    ),
    v.createElement(p$, {
      rgb: r,
      hsl: i,
      hex: o,
      onChange: s,
      disableAlpha: c
    }),
    v.createElement($2, {
      colors: u,
      onClick: s,
      onSwatchHover: l
    })
  );
};
lc.propTypes = {
  disableAlpha: X.bool,
  width: X.oneOfType([X.string, X.number]),
  styles: X.object
};
lc.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
const v$ = vt(lc);
var fo = function(t) {
  var n = t.hsl, r = t.offset, o = t.onClick, a = o === void 0 ? function() {
  } : o, i = t.active, s = t.first, l = t.last, c = le({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + n.h + ", 50%, " + r * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: i, first: s, last: l }), u = function(f) {
    return a({
      h: n.h,
      s: 0.5,
      l: r,
      source: "hsl"
    }, f);
  };
  return v.createElement("div", { style: c.swatch, onClick: u });
}, b$ = function(t) {
  var n = t.onClick, r = t.hsl, o = le({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), a = 0.1;
  return v.createElement(
    "div",
    { style: o.swatches },
    v.createElement(
      "div",
      { style: o.swatch },
      v.createElement(fo, {
        hsl: r,
        offset: ".80",
        active: Math.abs(r.l - 0.8) < a && Math.abs(r.s - 0.5) < a,
        onClick: n,
        first: !0
      })
    ),
    v.createElement(
      "div",
      { style: o.swatch },
      v.createElement(fo, {
        hsl: r,
        offset: ".65",
        active: Math.abs(r.l - 0.65) < a && Math.abs(r.s - 0.5) < a,
        onClick: n
      })
    ),
    v.createElement(
      "div",
      { style: o.swatch },
      v.createElement(fo, {
        hsl: r,
        offset: ".50",
        active: Math.abs(r.l - 0.5) < a && Math.abs(r.s - 0.5) < a,
        onClick: n
      })
    ),
    v.createElement(
      "div",
      { style: o.swatch },
      v.createElement(fo, {
        hsl: r,
        offset: ".35",
        active: Math.abs(r.l - 0.35) < a && Math.abs(r.s - 0.5) < a,
        onClick: n
      })
    ),
    v.createElement(
      "div",
      { style: o.swatch },
      v.createElement(fo, {
        hsl: r,
        offset: ".20",
        active: Math.abs(r.l - 0.2) < a && Math.abs(r.s - 0.5) < a,
        onClick: n,
        last: !0
      })
    ),
    v.createElement("div", { style: o.clear })
  );
}, y$ = function() {
  var t = le({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return v.createElement("div", { style: t.picker });
}, cc = function(t) {
  var n = t.hsl, r = t.onChange, o = t.pointer, a = t.styles, i = a === void 0 ? {} : a, s = t.className, l = s === void 0 ? "" : s, c = le(gt({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, i));
  return v.createElement(
    "div",
    { style: c.wrap || {}, className: "slider-picker " + l },
    v.createElement(
      "div",
      { style: c.hue },
      v.createElement(Yr, {
        style: c.Hue,
        hsl: n,
        pointer: o,
        onChange: r
      })
    ),
    v.createElement(
      "div",
      { style: c.swatches },
      v.createElement(b$, { hsl: n, onClick: r })
    )
  );
};
cc.propTypes = {
  styles: X.object
};
cc.defaultProps = {
  pointer: y$,
  styles: {}
};
vt(cc);
var R2 = {};
Object.defineProperty(R2, "__esModule", {
  value: !0
});
var p1 = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, w$ = v, m1 = x$(w$);
function x$(e) {
  return e && e.__esModule ? e : { default: e };
}
function C$(e, t) {
  var n = {};
  for (var r in e)
    t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  return n;
}
var fa = 24, S$ = R2.default = function(e) {
  var t = e.fill, n = t === void 0 ? "currentColor" : t, r = e.width, o = r === void 0 ? fa : r, a = e.height, i = a === void 0 ? fa : a, s = e.style, l = s === void 0 ? {} : s, c = C$(e, ["fill", "width", "height", "style"]);
  return m1.default.createElement(
    "svg",
    p1({
      viewBox: "0 0 " + fa + " " + fa,
      style: p1({ fill: n, width: o, height: i }, l)
    }, c),
    m1.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, E$ = function(t) {
  var n = t.color, r = t.onClick, o = r === void 0 ? function() {
  } : r, a = t.onSwatchHover, i = t.first, s = t.last, l = t.active, c = le({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: n,
        marginBottom: "1px"
      },
      check: {
        color: Kl(n),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: i,
    last: s,
    active: l,
    "color-#FFFFFF": n === "#FFFFFF",
    transparent: n === "transparent"
  });
  return v.createElement(
    Kn,
    {
      color: n,
      style: c.color,
      onClick: o,
      onHover: a,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    v.createElement(
      "div",
      { style: c.check },
      v.createElement(S$, null)
    )
  );
}, k$ = function(t) {
  var n = t.onClick, r = t.onSwatchHover, o = t.group, a = t.active, i = le({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return v.createElement(
    "div",
    { style: i.group },
    Qn(o, function(s, l) {
      return v.createElement(E$, {
        key: s,
        color: s,
        active: s.toLowerCase() === a,
        first: l === 0,
        last: l === o.length - 1,
        onClick: n,
        onSwatchHover: r
      });
    })
  );
}, uc = function(t) {
  var n = t.width, r = t.height, o = t.onChange, a = t.onSwatchHover, i = t.colors, s = t.hex, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = le(gt({
    default: {
      picker: {
        width: n,
        height: r
      },
      overflow: {
        height: r,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, c)), h = function(m, g) {
    return o({ hex: m, source: "hex" }, g);
  };
  return v.createElement(
    "div",
    { style: f.picker, className: "swatches-picker " + d },
    v.createElement(
      ta,
      null,
      v.createElement(
        "div",
        { style: f.overflow },
        v.createElement(
          "div",
          { style: f.body },
          Qn(i, function(p) {
            return v.createElement(k$, {
              key: p.toString(),
              group: p,
              active: s,
              onClick: h,
              onSwatchHover: a
            });
          }),
          v.createElement("div", { style: f.clear })
        )
      )
    )
  );
};
uc.propTypes = {
  width: X.oneOfType([X.string, X.number]),
  height: X.oneOfType([X.string, X.number]),
  colors: X.arrayOf(X.arrayOf(X.string)),
  styles: X.object
  /* eslint-disable max-len */
};
uc.defaultProps = {
  width: 320,
  height: 240,
  colors: [[cr[900], cr[700], cr[500], cr[300], cr[100]], [ur[900], ur[700], ur[500], ur[300], ur[100]], [dr[900], dr[700], dr[500], dr[300], dr[100]], [fr[900], fr[700], fr[500], fr[300], fr[100]], [hr[900], hr[700], hr[500], hr[300], hr[100]], [pr[900], pr[700], pr[500], pr[300], pr[100]], [mr[900], mr[700], mr[500], mr[300], mr[100]], [gr[900], gr[700], gr[500], gr[300], gr[100]], [vr[900], vr[700], vr[500], vr[300], vr[100]], ["#194D33", So[700], So[500], So[300], So[100]], [br[900], br[700], br[500], br[300], br[100]], [yr[900], yr[700], yr[500], yr[300], yr[100]], [wr[900], wr[700], wr[500], wr[300], wr[100]], [xr[900], xr[700], xr[500], xr[300], xr[100]], [Cr[900], Cr[700], Cr[500], Cr[300], Cr[100]], [Sr[900], Sr[700], Sr[500], Sr[300], Sr[100]], [Er[900], Er[700], Er[500], Er[300], Er[100]], [kr[900], kr[700], kr[500], kr[300], kr[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
vt(uc);
var dc = function(t) {
  var n = t.onChange, r = t.onSwatchHover, o = t.hex, a = t.colors, i = t.width, s = t.triangle, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = le(gt({
    default: {
      card: {
        width: i,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, c), {
    "hide-triangle": s === "hide",
    "top-left-triangle": s === "top-left",
    "top-right-triangle": s === "top-right"
  }), h = function(m, g) {
    On(m) && n({
      hex: m,
      source: "hex"
    }, g);
  };
  return v.createElement(
    "div",
    { style: f.card, className: "twitter-picker " + d },
    v.createElement("div", { style: f.triangleShadow }),
    v.createElement("div", { style: f.triangle }),
    v.createElement(
      "div",
      { style: f.body },
      Qn(a, function(p, m) {
        return v.createElement(Kn, {
          key: m,
          color: p,
          hex: p,
          style: f.swatch,
          onClick: h,
          onHover: r,
          focusStyle: {
            boxShadow: "0 0 4px " + p
          }
        });
      }),
      v.createElement(
        "div",
        { style: f.hash },
        "#"
      ),
      v.createElement(be, {
        label: null,
        style: { input: f.input },
        value: o.replace("#", ""),
        onChange: h
      }),
      v.createElement("div", { style: f.clear })
    )
  );
};
dc.propTypes = {
  width: X.oneOfType([X.string, X.number]),
  triangle: X.oneOf(["hide", "top-left", "top-right"]),
  colors: X.arrayOf(X.string),
  styles: X.object
};
dc.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
vt(dc);
var fc = function(t) {
  var n = le({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", " + Math.round(t.hsl.s * 100) + "%, " + Math.round(t.hsl.l * 100) + "%)"
      }
    }
  });
  return v.createElement("div", { style: n.picker });
};
fc.propTypes = {
  hsl: X.shape({
    h: X.number,
    s: X.number,
    l: X.number,
    a: X.number
  })
};
fc.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var hc = function(t) {
  var n = le({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return v.createElement("div", { style: n.picker });
};
hc.propTypes = {
  hsl: X.shape({
    h: X.number,
    s: X.number,
    l: X.number,
    a: X.number
  })
};
hc.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var M$ = function(t) {
  var n = t.onChange, r = t.rgb, o = t.hsl, a = t.hex, i = t.hsv, s = function(h, p) {
    if (h.hex)
      On(h.hex) && n({
        hex: h.hex,
        source: "hex"
      }, p);
    else if (h.rgb) {
      var m = h.rgb.split(",");
      os(h.rgb, "rgb") && n({
        r: m[0],
        g: m[1],
        b: m[2],
        a: 1,
        source: "rgb"
      }, p);
    } else if (h.hsv) {
      var g = h.hsv.split(",");
      os(h.hsv, "hsv") && (g[2] = g[2].replace("%", ""), g[1] = g[1].replace("%", ""), g[0] = g[0].replace("°", ""), g[1] == 1 ? g[1] = 0.01 : g[2] == 1 && (g[2] = 0.01), n({
        h: Number(g[0]),
        s: Number(g[1]),
        v: Number(g[2]),
        source: "hsv"
      }, p));
    } else if (h.hsl) {
      var y = h.hsl.split(",");
      os(h.hsl, "hsl") && (y[2] = y[2].replace("%", ""), y[1] = y[1].replace("%", ""), y[0] = y[0].replace("°", ""), d[1] == 1 ? d[1] = 0.01 : d[2] == 1 && (d[2] = 0.01), n({
        h: Number(y[0]),
        s: Number(y[1]),
        v: Number(y[2]),
        source: "hsl"
      }, p));
    }
  }, l = le({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), c = r.r + ", " + r.g + ", " + r.b, u = Math.round(o.h) + "°, " + Math.round(o.s * 100) + "%, " + Math.round(o.l * 100) + "%", d = Math.round(i.h) + "°, " + Math.round(i.s * 100) + "%, " + Math.round(i.v * 100) + "%";
  return v.createElement(
    "div",
    { style: l.wrap, className: "flexbox-fix" },
    v.createElement(
      "div",
      { style: l.fields },
      v.createElement(
        "div",
        { style: l.double },
        v.createElement(be, {
          style: { input: l.input, label: l.label },
          label: "hex",
          value: a,
          onChange: s
        })
      ),
      v.createElement(
        "div",
        { style: l.column },
        v.createElement(
          "div",
          { style: l.single },
          v.createElement(be, {
            style: { input: l.input2, label: l.label2 },
            label: "rgb",
            value: c,
            onChange: s
          })
        ),
        v.createElement(
          "div",
          { style: l.single },
          v.createElement(be, {
            style: { input: l.input2, label: l.label2 },
            label: "hsv",
            value: d,
            onChange: s
          })
        ),
        v.createElement(
          "div",
          { style: l.single },
          v.createElement(be, {
            style: { input: l.input2, label: l.label2 },
            label: "hsl",
            value: u,
            onChange: s
          })
        )
      )
    )
  );
}, pc = function(t) {
  var n = t.width, r = t.onChange, o = t.rgb, a = t.hsl, i = t.hsv, s = t.hex, l = t.header, c = t.styles, u = c === void 0 ? {} : c, d = t.className, f = d === void 0 ? "" : d, h = le(gt({
    default: {
      picker: {
        width: n,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + o.r + ", " + o.g + ", " + o.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, u));
  return v.createElement(
    "div",
    { style: h.picker, className: "google-picker " + f },
    v.createElement(
      "div",
      { style: h.head },
      l
    ),
    v.createElement("div", { style: h.swatch }),
    v.createElement(
      "div",
      { style: h.saturation },
      v.createElement(mi, {
        hsl: a,
        hsv: i,
        pointer: fc,
        onChange: r
      })
    ),
    v.createElement(
      "div",
      { style: h.body },
      v.createElement(
        "div",
        { style: h.controls, className: "flexbox-fix" },
        v.createElement(
          "div",
          { style: h.hue },
          v.createElement(Yr, {
            style: h.Hue,
            hsl: a,
            radius: "4px",
            pointer: hc,
            onChange: r
          })
        )
      ),
      v.createElement(M$, {
        rgb: o,
        hsl: a,
        hex: s,
        hsv: i,
        onChange: r
      })
    )
  );
};
pc.propTypes = {
  width: X.oneOfType([X.string, X.number]),
  styles: X.object,
  header: X.string
};
pc.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
vt(pc);
const Rt = (e, t, n) => Math.min(Math.max(n, e), t), _$ = ({
  children: e,
  className: t,
  width: n = 0,
  height: r = 0,
  x: o = 0,
  y: a = 0,
  disableResizeX: i = !1,
  disableResizeY: s = !1,
  disableDragX: l = !1,
  disableDragY: c = !1,
  minWidth: u = 0,
  maxWidth: d = 1 / 0,
  minHeight: f = 0,
  maxHeight: h = 1 / 0,
  minX: p = -1 / 0,
  maxX: m = 1 / 0,
  minY: g = -1 / 0,
  maxY: y = 1 / 0,
  resizeThreshold: b = 20,
  focused: w = !0,
  onDragStart: S = () => {
  },
  onDragMove: x = () => {
  },
  onDragEnd: M = () => {
  },
  onResizeStart: _ = () => {
  },
  onResizeMove: R = () => {
  },
  onResizeEnd: B = () => {
  }
}) => {
  const U = jt(0), F = jt(0), [T, j] = he(null), [A, G] = he(null), [N, te] = he(n), [oe, Q] = he(r), [P, L] = he(o), [$, I] = he(a), [H, Y] = he(!1), [W, q] = he(!1), [Z, ee] = he(!1), [J, ie] = he(!1), [D, ye] = he(!1), We = Ue(
    (ne) => {
      for (; ne && ne !== T; )
        ne = ne.parentElement;
      return ne === T;
    },
    [T]
  ), we = Ue(
    (ne) => {
      if (!We(ne.target))
        return !1;
      if (A) {
        const Se = ne.x >= A.left - b && ne.x <= A.right + b && ne.y >= A.top - b && ne.y <= A.bottom + b, rt = Math.abs(ne.x - A.left), Ee = Math.abs(ne.x - A.right), Fe = Math.abs(ne.y - A.top), Ze = Math.abs(ne.y - A.bottom);
        return Se && ((rt <= b || Ee <= b) && !i || (Fe <= b || Ze <= b) && !s);
      }
      return !1;
    },
    [A, i, s, We, b]
  ), lt = Ue(
    (ne) => {
      if (!We(ne.target))
        return !1;
      let Se = ne.target;
      for (; Se && Se !== T; ) {
        if (Se.className.includes("skand-rnd-enable"))
          return !0;
        if (Se.tagName === "INPUT" || Se.onclick || Se.onmousedown || Se.onpointerdown || Se.className.includes("skand-rnd-disable"))
          return !1;
        Se = Se.parentElement;
      }
      return !0;
    },
    [We, T]
  ), xe = Ue(
    (ne) => {
      if (we(ne) && A) {
        ne.preventDefault();
        const Se = Math.abs(ne.x - A.left), rt = Math.abs(ne.x - A.right), Ee = Math.abs(ne.y - A.top), Fe = Math.abs(ne.y - A.bottom);
        _(N, oe), Y(Se <= b), q(rt <= b), ee(Ee <= b), ie(Fe <= b);
      } else
        lt(ne) && (ne.preventDefault(), S(P, $), ye(!0));
    },
    [
      A,
      lt,
      we,
      oe,
      N,
      P,
      $,
      S,
      _,
      b
    ]
  ), ce = Ue(
    (ne) => {
      const Se = ne.clientX - U.current, rt = ne.clientY - F.current;
      if (D ? (l || L((Ee) => Rt(p, m, Ee + Se)), c || I((Ee) => Rt(g, y, Ee + rt))) : (i || (H ? (te((Ee) => Rt(u, d, Ee - Se)), l || L((Ee) => Rt(p, m, Ee + Se))) : W && te((Ee) => Rt(u, d, Ee + Se))), s || (Z ? (Q((Ee) => Rt(f, h, Ee - rt)), c || I((Ee) => Rt(g, y, Ee + rt))) : J && Q((Ee) => Rt(f, h, Ee + rt)))), A && w) {
        const Ee = ne.x >= A.left - b && ne.x <= A.right + b && ne.y >= A.top - b && ne.y <= A.bottom + b, Fe = Math.abs(ne.x - A.left) <= b, Ze = Math.abs(ne.x - A.right) <= b, et = Math.abs(ne.y - A.top) <= b, ct = Math.abs(ne.y - A.bottom) <= b;
        (Fe || Ze) && !et && !ct && !i && Ee ? document.body.style.cursor = "ew-resize" : (et || ct) && !Fe && !Ze && !s && Ee ? document.body.style.cursor = "ns-resize" : et && Ze || ct && Fe && !i && !s && Ee ? document.body.style.cursor = "nesw-resize" : et && Fe || ct && Ze && !i && !s && Ee ? document.body.style.cursor = "nwse-resize" : document.body.style.cursor = "auto";
      }
      U.current = ne.clientX, F.current = ne.clientY;
    },
    [
      A,
      l,
      c,
      i,
      s,
      D,
      w,
      h,
      d,
      m,
      y,
      f,
      u,
      p,
      g,
      b,
      J,
      H,
      W,
      Z
    ]
  ), ue = Ue(() => {
    D && M(P, $), (H || W || Z || J) && B(N, oe), ye(!1), Y(!1), q(!1), ee(!1), ie(!1);
  }, [
    oe,
    N,
    P,
    $,
    D,
    M,
    B,
    J,
    H,
    W,
    Z
  ]);
  nt(() => {
    T && G(T.getBoundingClientRect());
  }, [T]), nt(() => {
    const ne = () => {
      T && G(T.getBoundingClientRect());
    };
    return document.addEventListener("mousemove", ce), document.addEventListener("mousemove", ne), document.addEventListener("mousedown", xe), document.addEventListener("mouseup", ue), () => {
      document.removeEventListener("mousemove", ce), document.removeEventListener("mousemove", ne), document.removeEventListener("mousedown", xe), document.removeEventListener("mouseup", ue);
    };
  }, [xe, ce, ue, T]), nt(() => {
    x(P, $);
  }, [P, $, x]), nt(() => {
    R(N, oe);
  }, [oe, N, R]);
  const Ve = Ct(() => {
    const ne = {};
    return i || (ne.width = `${N}px`), s || (ne.height = `${oe}px`), !l && !c ? ne.transform = `translate(${P}px, ${$}px)` : l ? c || (ne.transform = `translateY(${$}px)`) : ne.transform = `translateX(${P}px)`, ne;
  }, [
    oe,
    N,
    P,
    $,
    l,
    c,
    i,
    s
  ]);
  return /* @__PURE__ */ C.jsx("div", { className: z("skand-rnd-disable", t), ref: j, style: Ve, tabIndex: 0, children: e });
}, P$ = [
  "#D04A6B",
  "#F69C64",
  "#F6DF64",
  "#4CB176",
  "#3F8AE2",
  "#8A1AE3",
  "#8A858E",
  "#FFFFFF"
], JW = ({
  setColor: e,
  closeMenu: t,
  color: n,
  onSaveColorButton: r,
  colorSelection: o = P$,
  colorPickerHeader: a,
  openingCoordinates: i = { x: 0, y: 0 }
}) => /* @__PURE__ */ C.jsx(
  _$,
  {
    className: "fixed z-36",
    disableResizeX: !0,
    disableResizeY: !0,
    x: i.x,
    y: i.y,
    children: /* @__PURE__ */ C.jsxs(
      "div",
      {
        className: z(
          "flex",
          "w-220px",
          "bg-neutral-100",
          "p-10px",
          "rounded",
          "border",
          "border-solid",
          "border-neutral-400",
          "shadow-md"
        ),
        children: [
          /* @__PURE__ */ C.jsx(
            "button",
            {
              className: z("cursor-pointer bg-transparent b-none absolute right-12px"),
              onClick: t,
              children: /* @__PURE__ */ C.jsx("div", { className: z("text-12px text-right text-gray-400 i-skand-close") })
            }
          ),
          /* @__PURE__ */ C.jsxs("div", { className: z("flex flex-col w-full"), children: [
            a && /* @__PURE__ */ C.jsx(
              "p",
              {
                className: z(
                  "typo-text-small text-neutral-900 w-44 overflow-ellipsis overflow-hidden absolute whitespace-nowrap"
                ),
                children: a
              }
            ),
            /* @__PURE__ */ C.jsx("div", { className: "mt-6 w-full border-none", onClick: (s) => s.stopPropagation(), children: /* @__PURE__ */ C.jsx(
              v$,
              {
                className: "Z-10 border-none font-sans",
                color: n,
                disableAlpha: !0,
                onChange: e,
                presetColors: o,
                styles: {
                  picker: {}
                }
              }
            ) }),
            r && /* @__PURE__ */ C.jsx(
              xl,
              {
                className: "h-8 cursor-pointer px-1 py-2",
                filled: !0,
                onClick: () => r(n),
                primary: !0,
                size: "xs",
                children: "Save"
              }
            )
          ] })
        ]
      }
    )
  }
), O$ = ["top", "right", "bottom", "left"], kn = Math.min, xt = Math.max, za = Math.round, ha = Math.floor, Mn = (e) => ({
  x: e,
  y: e
}), T$ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, A$ = {
  start: "end",
  end: "start"
};
function Vs(e, t, n) {
  return xt(e, kn(t, n));
}
function tn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function nn(e) {
  return e.split("-")[0];
}
function Ur(e) {
  return e.split("-")[1];
}
function mc(e) {
  return e === "x" ? "y" : "x";
}
function gc(e) {
  return e === "y" ? "height" : "width";
}
function Gr(e) {
  return ["top", "bottom"].includes(nn(e)) ? "y" : "x";
}
function vc(e) {
  return mc(Gr(e));
}
function $$(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ur(e), o = vc(e), a = gc(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Ia(i)), [i, Ia(i)];
}
function R$(e) {
  const t = Ia(e);
  return [Ys(e), t, Ys(t)];
}
function Ys(e) {
  return e.replace(/start|end/g, (t) => A$[t]);
}
function D$(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function N$(e, t, n, r) {
  const o = Ur(e);
  let a = D$(nn(e), n === "start", r);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(Ys)))), a;
}
function Ia(e) {
  return e.replace(/left|right|bottom|top/g, (t) => T$[t]);
}
function L$(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function D2(e) {
  return typeof e != "number" ? L$(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Wa(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function g1(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Gr(t), i = vc(t), s = gc(i), l = nn(t), c = a === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ur(t)) {
    case "start":
      h[i] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const j$ = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = g1(c, r, l), f = r, h = {}, p = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: g,
      fn: y
    } = s[m], {
      x: b,
      y: w,
      data: S,
      reset: x
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = b ?? u, d = w ?? d, h = {
      ...h,
      [g]: {
        ...h[g],
        ...S
      }
    }, x && p <= 50) {
      p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (c = x.rects === !0 ? await i.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : x.rects), {
        x: u,
        y: d
      } = g1(c, f, l)), m = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function Lo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = tn(t, e), p = D2(h), g = s[f ? d === "floating" ? "reference" : "floating" : d], y = Wa(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), b = d === "floating" ? {
    ...i.floating,
    x: r,
    y: o
  } : i.reference, w = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), S = await (a.isElement == null ? void 0 : a.isElement(w)) ? await (a.getScale == null ? void 0 : a.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Wa(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: b,
    offsetParent: w,
    strategy: l
  }) : b);
  return {
    top: (y.top - x.top + p.top) / S.y,
    bottom: (x.bottom - y.bottom + p.bottom) / S.y,
    left: (y.left - x.left + p.left) / S.x,
    right: (x.right - y.right + p.right) / S.x
  };
}
const v1 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s
    } = t, {
      element: l,
      padding: c = 0
    } = tn(e, t) || {};
    if (l == null)
      return {};
    const u = D2(c), d = {
      x: n,
      y: r
    }, f = vc(o), h = gc(f), p = await i.getDimensions(l), m = f === "y", g = m ? "top" : "left", y = m ? "bottom" : "right", b = m ? "clientHeight" : "clientWidth", w = a.reference[h] + a.reference[f] - d[f] - a.floating[h], S = d[f] - a.reference[f], x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let M = x ? x[b] : 0;
    (!M || !await (i.isElement == null ? void 0 : i.isElement(x))) && (M = s.floating[b] || a.floating[h]);
    const _ = w / 2 - S / 2, R = M / 2 - p[h] / 2 - 1, B = kn(u[g], R), U = kn(u[y], R), F = B, T = M - p[h] - U, j = M / 2 - p[h] / 2 + _, A = Vs(F, j, T), N = Ur(o) != null && j != A && a.reference[h] / 2 - (j < F ? B : U) - p[h] / 2 < 0 ? j < F ? F - j : T - j : 0;
    return {
      [f]: d[f] - N,
      data: {
        [f]: A,
        centerOffset: j - A + N
      }
    };
  }
}), bc = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: a,
        initialPlacement: i,
        platform: s,
        elements: l
      } = t, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: p = !0,
        ...m
      } = tn(e, t), g = nn(r), y = nn(i) === i, b = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), w = d || (y || !p ? [Ia(i)] : R$(i));
      !d && h !== "none" && w.push(...N$(i, p, h, b));
      const S = [i, ...w], x = await Lo(t, m), M = [];
      let _ = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (c && M.push(x[g]), u) {
        const F = $$(r, a, b);
        M.push(x[F[0]], x[F[1]]);
      }
      if (_ = [..._, {
        placement: r,
        overflows: M
      }], !M.every((F) => F <= 0)) {
        var R, B;
        const F = (((R = o.flip) == null ? void 0 : R.index) || 0) + 1, T = S[F];
        if (T)
          return {
            data: {
              index: F,
              overflows: _
            },
            reset: {
              placement: T
            }
          };
        let j = (B = _.filter((A) => A.overflows[0] <= 0).sort((A, G) => A.overflows[1] - G.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!j)
          switch (f) {
            case "bestFit": {
              var U;
              const A = (U = _.map((G) => [G.placement, G.overflows.filter((N) => N > 0).reduce((N, te) => N + te, 0)]).sort((G, N) => G[1] - N[1])[0]) == null ? void 0 : U[0];
              A && (j = A);
              break;
            }
            case "initialPlacement":
              j = i;
              break;
          }
        if (r !== j)
          return {
            reset: {
              placement: j
            }
          };
      }
      return {};
    }
  };
};
function b1(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function y1(e) {
  return O$.some((t) => e[t] >= 0);
}
const H$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = tn(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Lo(t, {
            ...o,
            elementContext: "reference"
          }), i = b1(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: y1(i)
            }
          };
        }
        case "escaped": {
          const a = await Lo(t, {
            ...o,
            altBoundary: !0
          }), i = b1(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: y1(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function F$(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = nn(n), s = Ur(n), l = Gr(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = a && l ? -1 : 1, d = tn(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof p == "number" && (h = s === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const B$ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await F$(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, z$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: y,
              y: b
            } = g;
            return {
              x: y,
              y: b
            };
          }
        },
        ...l
      } = tn(e, t), c = {
        x: n,
        y: r
      }, u = await Lo(t, l), d = Gr(nn(o)), f = mc(d);
      let h = c[f], p = c[d];
      if (a) {
        const g = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", b = h + u[g], w = h - u[y];
        h = Vs(b, h, w);
      }
      if (i) {
        const g = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", b = p + u[g], w = p - u[y];
        p = Vs(b, p, w);
      }
      const m = s.fn({
        ...t,
        [f]: h,
        [d]: p
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r
        }
      };
    }
  };
}, I$ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = tn(e, t), u = {
        x: n,
        y: r
      }, d = Gr(o), f = mc(d);
      let h = u[f], p = u[d];
      const m = tn(s, t), g = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const w = f === "y" ? "height" : "width", S = a.reference[f] - a.floating[w] + g.mainAxis, x = a.reference[f] + a.reference[w] - g.mainAxis;
        h < S ? h = S : h > x && (h = x);
      }
      if (c) {
        var y, b;
        const w = f === "y" ? "width" : "height", S = ["top", "left"].includes(nn(o)), x = a.reference[d] - a.floating[w] + (S && ((y = i.offset) == null ? void 0 : y[d]) || 0) + (S ? 0 : g.crossAxis), M = a.reference[d] + a.reference[w] + (S ? 0 : ((b = i.offset) == null ? void 0 : b[d]) || 0) - (S ? g.crossAxis : 0);
        p < x ? p = x : p > M && (p = M);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, N2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: a
      } = t, {
        apply: i = () => {
        },
        ...s
      } = tn(e, t), l = await Lo(t, s), c = nn(n), u = Ur(n), d = Gr(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, m;
      c === "top" || c === "bottom" ? (p = c, m = u === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (m = c, p = u === "end" ? "top" : "bottom");
      const g = h - l[p], y = f - l[m], b = !t.middlewareData.shift;
      let w = g, S = y;
      if (d) {
        const M = f - l.left - l.right;
        S = u || b ? kn(y, M) : M;
      } else {
        const M = h - l.top - l.bottom;
        w = u || b ? kn(g, M) : M;
      }
      if (b && !u) {
        const M = xt(l.left, 0), _ = xt(l.right, 0), R = xt(l.top, 0), B = xt(l.bottom, 0);
        d ? S = f - 2 * (M !== 0 || _ !== 0 ? M + _ : xt(l.left, l.right)) : w = h - 2 * (R !== 0 || B !== 0 ? R + B : xt(l.top, l.bottom));
      }
      await i({
        ...t,
        availableWidth: S,
        availableHeight: w
      });
      const x = await o.getDimensions(a.floating);
      return f !== x.width || h !== x.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function _n(e) {
  return L2(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function St(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ln(e) {
  var t;
  return (t = (L2(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function L2(e) {
  return e instanceof Node || e instanceof St(e).Node;
}
function Ge(e) {
  return e instanceof Element || e instanceof St(e).Element;
}
function mt(e) {
  return e instanceof HTMLElement || e instanceof St(e).HTMLElement;
}
function qs(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof St(e).ShadowRoot;
}
function na(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = kt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function W$(e) {
  return ["table", "td", "th"].includes(_n(e));
}
function yc(e) {
  const t = wc(), n = kt(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function V$(e) {
  let t = zn(e);
  for (; mt(t) && !ra(t); ) {
    if (yc(t))
      return t;
    t = zn(t);
  }
  return null;
}
function wc() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ra(e) {
  return ["html", "body", "#document"].includes(_n(e));
}
function kt(e) {
  return St(e).getComputedStyle(e);
}
function bi(e) {
  return Ge(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function zn(e) {
  if (_n(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    qs(e) && e.host || // Fallback.
    ln(e)
  );
  return qs(t) ? t.host : t;
}
function j2(e) {
  const t = zn(e);
  return ra(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : mt(t) && na(t) ? t : j2(t);
}
function jn(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = j2(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = St(r);
  return o ? t.concat(a, a.visualViewport || [], na(r) ? r : []) : t.concat(r, jn(r));
}
function H2(e) {
  const t = kt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = mt(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, s = za(n) !== a || za(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function xc(e) {
  return Ge(e) ? e : e.contextElement;
}
function Pr(e) {
  const t = xc(e);
  if (!mt(t))
    return Mn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = H2(t);
  let i = (a ? za(n.width) : n.width) / r, s = (a ? za(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const Y$ = /* @__PURE__ */ Mn(0);
function F2(e) {
  const t = St(e);
  return !wc() || !t.visualViewport ? Y$ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function q$(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== St(e) ? !1 : t;
}
function In(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = xc(e);
  let i = Mn(1);
  t && (r ? Ge(r) && (i = Pr(r)) : i = Pr(e));
  const s = q$(a, n, r) ? F2(a) : Mn(0);
  let l = (o.left + s.x) / i.x, c = (o.top + s.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (a) {
    const f = St(a), h = r && Ge(r) ? St(r) : r;
    let p = f.frameElement;
    for (; p && r && h !== f; ) {
      const m = Pr(p), g = p.getBoundingClientRect(), y = kt(p), b = g.left + (p.clientLeft + parseFloat(y.paddingLeft)) * m.x, w = g.top + (p.clientTop + parseFloat(y.paddingTop)) * m.y;
      l *= m.x, c *= m.y, u *= m.x, d *= m.y, l += b, c += w, p = St(p).frameElement;
    }
  }
  return Wa({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function U$(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = mt(n), a = ln(n);
  if (n === a)
    return t;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Mn(1);
  const l = Mn(0);
  if ((o || !o && r !== "fixed") && ((_n(n) !== "body" || na(a)) && (i = bi(n)), mt(n))) {
    const c = In(n);
    s = Pr(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - i.scrollLeft * s.x + l.x,
    y: t.y * s.y - i.scrollTop * s.y + l.y
  };
}
function G$(e) {
  return Array.from(e.getClientRects());
}
function B2(e) {
  return In(ln(e)).left + bi(e).scrollLeft;
}
function X$(e) {
  const t = ln(e), n = bi(e), r = e.ownerDocument.body, o = xt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = xt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + B2(e);
  const s = -n.scrollTop;
  return kt(r).direction === "rtl" && (i += xt(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function Z$(e, t) {
  const n = St(e), r = ln(e), o = n.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const c = wc();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function K$(e, t) {
  const n = In(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = mt(e) ? Pr(e) : Mn(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, c = r * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function w1(e, t, n) {
  let r;
  if (t === "viewport")
    r = Z$(e, n);
  else if (t === "document")
    r = X$(ln(e));
  else if (Ge(t))
    r = K$(t, n);
  else {
    const o = F2(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Wa(r);
}
function z2(e, t) {
  const n = zn(e);
  return n === t || !Ge(n) || ra(n) ? !1 : kt(n).position === "fixed" || z2(n, t);
}
function Q$(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = jn(e).filter((s) => Ge(s) && _n(s) !== "body"), o = null;
  const a = kt(e).position === "fixed";
  let i = a ? zn(e) : e;
  for (; Ge(i) && !ra(i); ) {
    const s = kt(i), l = yc(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || na(i) && !l && z2(e, i)) ? r = r.filter((u) => u !== i) : o = s, i = zn(i);
  }
  return t.set(e, r), r;
}
function J$(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? Q$(t, this._c) : [].concat(n), r], s = i[0], l = i.reduce((c, u) => {
    const d = w1(t, u, o);
    return c.top = xt(d.top, c.top), c.right = kn(d.right, c.right), c.bottom = kn(d.bottom, c.bottom), c.left = xt(d.left, c.left), c;
  }, w1(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function eR(e) {
  return H2(e);
}
function tR(e, t, n) {
  const r = mt(t), o = ln(t), a = n === "fixed", i = In(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Mn(0);
  if (r || !r && !a)
    if ((_n(t) !== "body" || na(o)) && (s = bi(t)), r) {
      const c = In(t, !0, a, t);
      l.x = c.x + t.clientLeft, l.y = c.y + t.clientTop;
    } else
      o && (l.x = B2(o));
  return {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function x1(e, t) {
  return !mt(e) || kt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function I2(e, t) {
  const n = St(e);
  if (!mt(e))
    return n;
  let r = x1(e, t);
  for (; r && W$(r) && kt(r).position === "static"; )
    r = x1(r, t);
  return r && (_n(r) === "html" || _n(r) === "body" && kt(r).position === "static" && !yc(r)) ? n : r || V$(e) || n;
}
const nR = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || I2, a = this.getDimensions;
  return {
    reference: tR(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function rR(e) {
  return kt(e).direction === "rtl";
}
const oR = {
  convertOffsetParentRelativeRectToViewportRelativeRect: U$,
  getDocumentElement: ln,
  getClippingRect: J$,
  getOffsetParent: I2,
  getElementRects: nR,
  getClientRects: G$,
  getDimensions: eR,
  getScale: Pr,
  isElement: Ge,
  isRTL: rR
};
function aR(e, t) {
  let n = null, r;
  const o = ln(e);
  function a() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !d || !f)
      return;
    const h = ha(u), p = ha(o.clientWidth - (c + d)), m = ha(o.clientHeight - (u + f)), g = ha(c), b = {
      rootMargin: -h + "px " + -p + "px " + -m + "px " + -g + "px",
      threshold: xt(0, kn(1, l)) || 1
    };
    let w = !0;
    function S(x) {
      const M = x[0].intersectionRatio;
      if (M !== l) {
        if (!w)
          return i();
        M ? i(!1, M) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, b);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function Cc(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = xc(e), u = o || a ? [...c ? jn(c) : [], ...jn(t)] : [];
  u.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const d = c && s ? aR(c, n) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((y) => {
    let [b] = y;
    b && b.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let p, m = l ? In(e) : null;
  l && g();
  function g() {
    const y = In(e);
    m && (y.x !== m.x || y.y !== m.y || y.width !== m.width || y.height !== m.height) && n(), m = y, p = requestAnimationFrame(g);
  }
  return n(), () => {
    u.forEach((y) => {
      o && y.removeEventListener("scroll", n), a && y.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const iR = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: oR,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return j$(e, t, {
    ...o,
    platform: a
  });
}, sR = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? v1({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? v1({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var ka = typeof document < "u" ? vl : nt;
function Va(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Va(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !Va(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function W2(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function C1(e, t) {
  const n = W2(e);
  return Math.round(t * n) / n;
}
function S1(e) {
  const t = E.useRef(e);
  return ka(() => {
    t.current = e;
  }), t;
}
function V2(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = E.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = E.useState(r);
  Va(f, r) || h(r);
  const [p, m] = E.useState(null), [g, y] = E.useState(null), b = E.useCallback((N) => {
    N != M.current && (M.current = N, m(N));
  }, [m]), w = E.useCallback((N) => {
    N !== _.current && (_.current = N, y(N));
  }, [y]), S = a || p, x = i || g, M = E.useRef(null), _ = E.useRef(null), R = E.useRef(u), B = S1(l), U = S1(o), F = E.useCallback(() => {
    if (!M.current || !_.current)
      return;
    const N = {
      placement: t,
      strategy: n,
      middleware: f
    };
    U.current && (N.platform = U.current), iR(M.current, _.current, N).then((te) => {
      const oe = {
        ...te,
        isPositioned: !0
      };
      T.current && !Va(R.current, oe) && (R.current = oe, $d.flushSync(() => {
        d(oe);
      }));
    });
  }, [f, t, n, U]);
  ka(() => {
    c === !1 && R.current.isPositioned && (R.current.isPositioned = !1, d((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [c]);
  const T = E.useRef(!1);
  ka(() => (T.current = !0, () => {
    T.current = !1;
  }), []), ka(() => {
    if (S && (M.current = S), x && (_.current = x), S && x) {
      if (B.current)
        return B.current(S, x, F);
      F();
    }
  }, [S, x, F, B]);
  const j = E.useMemo(() => ({
    reference: M,
    floating: _,
    setReference: b,
    setFloating: w
  }), [b, w]), A = E.useMemo(() => ({
    reference: S,
    floating: x
  }), [S, x]), G = E.useMemo(() => {
    const N = {
      position: n,
      left: 0,
      top: 0
    };
    if (!A.floating)
      return N;
    const te = C1(A.floating, u.x), oe = C1(A.floating, u.y);
    return s ? {
      ...N,
      transform: "translate(" + te + "px, " + oe + "px)",
      ...W2(A.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: te,
      top: oe
    };
  }, [n, s, A.floating, u.x, u.y]);
  return E.useMemo(() => ({
    ...u,
    update: F,
    refs: j,
    elements: A,
    floatingStyles: G
  }), [u, F, j, A, G]);
}
function lR(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (r = n.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var n, r;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function Ya(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && qs(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function cR() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function uR() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function dR(e) {
  if (e.mozInputSource === 0 && e.isTrusted)
    return !0;
  const t = /Android/i;
  return (t.test(cR()) || t.test(uR())) && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function fR(e) {
  return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0;
}
function E1(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function hR(e) {
  return "nativeEvent" in e;
}
function pR(e) {
  return e.matches("html,body");
}
function Oo(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Ma(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function mR(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const gR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function vR(e) {
  return mt(e) && e.matches(gR);
}
var Y2 = typeof document < "u" ? vl : nt;
let is = !1, bR = 0;
const k1 = () => "floating-ui-" + bR++;
function yR() {
  const [e, t] = E.useState(() => is ? k1() : void 0);
  return Y2(() => {
    e == null && t(k1());
  }, []), E.useEffect(() => {
    is || (is = !0);
  }, []), e;
}
const wR = E[/* @__PURE__ */ "useId".toString()], xR = wR || yR;
function CR() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((o) => o !== n)) || []);
    }
  };
}
const SR = /* @__PURE__ */ E.createContext(null), ER = /* @__PURE__ */ E.createContext(null), kR = () => {
  var e;
  return ((e = E.useContext(SR)) == null ? void 0 : e.id) || null;
}, q2 = () => E.useContext(ER);
function U2(e) {
  return "data-floating-ui-" + e;
}
function ss(e, t) {
  let n = e.filter((o) => {
    var a;
    return o.parentId === t && ((a = o.context) == null ? void 0 : a.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((o) => {
      var a;
      return (a = r) == null ? void 0 : a.some((i) => {
        var s;
        return o.parentId === i.id && ((s = o.context) == null ? void 0 : s.open);
      });
    }), n = n.concat(r);
  return n;
}
function M1(e) {
  return mt(e.target) && e.target.tagName === "BUTTON";
}
function _1(e) {
  return vR(e);
}
function G2(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    elements: {
      domReference: a
    }
  } = e, {
    enabled: i = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: u = !0
  } = t, d = E.useRef(), f = E.useRef(!1);
  return E.useMemo(() => i ? {
    reference: {
      onPointerDown(h) {
        d.current = h.pointerType;
      },
      onMouseDown(h) {
        h.button === 0 && (E1(d.current, !0) && c || s !== "click" && (n && l && (!o.current.openEvent || o.current.openEvent.type === "mousedown") ? r(!1, h.nativeEvent) : (h.preventDefault(), r(!0, h.nativeEvent))));
      },
      onClick(h) {
        if (s === "mousedown" && d.current) {
          d.current = void 0;
          return;
        }
        E1(d.current, !0) && c || (n && l && (!o.current.openEvent || o.current.openEvent.type === "click") ? r(!1, h.nativeEvent) : r(!0, h.nativeEvent));
      },
      onKeyDown(h) {
        d.current = void 0, !(h.defaultPrevented || !u || M1(h)) && (h.key === " " && !_1(a) && (h.preventDefault(), f.current = !0), h.key === "Enter" && r(!(n && l), h.nativeEvent));
      },
      onKeyUp(h) {
        h.defaultPrevented || !u || M1(h) || _1(a) || h.key === " " && f.current && (f.current = !1, r(!(n && l), h.nativeEvent));
      }
    }
  } : {}, [i, o, s, c, u, a, l, n, r]);
}
const MR = E[/* @__PURE__ */ "useInsertionEffect".toString()], _R = MR || ((e) => e());
function _a(e) {
  const t = E.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return _R(() => {
    t.current = e;
  }), E.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const PR = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, OR = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, TR = (e) => {
  var t, n;
  return {
    escapeKeyBubbles: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePressBubbles: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function X2(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: o,
    nodeId: a,
    elements: {
      reference: i,
      domReference: s,
      floating: l
    },
    dataRef: c
  } = e, {
    enabled: u = !0,
    escapeKey: d = !0,
    outsidePress: f = !0,
    outsidePressEvent: h = "pointerdown",
    referencePress: p = !1,
    referencePressEvent: m = "pointerdown",
    ancestorScroll: g = !1,
    bubbles: y
  } = t, b = q2(), w = kR() != null, S = _a(typeof f == "function" ? f : () => !1), x = typeof f == "function" ? S : f, M = E.useRef(!1), {
    escapeKeyBubbles: _,
    outsidePressBubbles: R
  } = TR(y), B = _a((F) => {
    if (!n || !u || !d || F.key !== "Escape")
      return;
    const T = b ? ss(b.nodesRef.current, a) : [];
    if (!_ && (F.stopPropagation(), T.length > 0)) {
      let j = !0;
      if (T.forEach((A) => {
        var G;
        if ((G = A.context) != null && G.open && !A.context.dataRef.current.__escapeKeyBubbles) {
          j = !1;
          return;
        }
      }), !j)
        return;
    }
    o.emit("dismiss", {
      type: "escapeKey",
      data: {
        returnFocus: {
          preventScroll: !1
        }
      }
    }), r(!1, hR(F) ? F.nativeEvent : F);
  }), U = _a((F) => {
    const T = M.current;
    if (M.current = !1, T || typeof x == "function" && !x(F))
      return;
    const j = mR(F), A = "[" + U2("inert") + "]", G = Oo(l).querySelectorAll(A);
    let N = Ge(j) ? j : null;
    for (; N && !ra(N); ) {
      const Q = zn(N);
      if (Q === Oo(l).body || !Ge(Q))
        break;
      N = Q;
    }
    if (G.length && Ge(j) && !pR(j) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Ya(j, l) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(G).every((Q) => !Ya(N, Q)))
      return;
    if (mt(j) && l) {
      const Q = j.clientWidth > 0 && j.scrollWidth > j.clientWidth, P = j.clientHeight > 0 && j.scrollHeight > j.clientHeight;
      let L = P && F.offsetX > j.clientWidth;
      if (P && kt(j).direction === "rtl" && (L = F.offsetX <= j.offsetWidth - j.clientWidth), L || Q && F.offsetY > j.clientHeight)
        return;
    }
    const te = b && ss(b.nodesRef.current, a).some((Q) => {
      var P;
      return Ma(F, (P = Q.context) == null ? void 0 : P.elements.floating);
    });
    if (Ma(F, l) || Ma(F, s) || te)
      return;
    const oe = b ? ss(b.nodesRef.current, a) : [];
    if (oe.length > 0) {
      let Q = !0;
      if (oe.forEach((P) => {
        var L;
        if ((L = P.context) != null && L.open && !P.context.dataRef.current.__outsidePressBubbles) {
          Q = !1;
          return;
        }
      }), !Q)
        return;
    }
    o.emit("dismiss", {
      type: "outsidePress",
      data: {
        returnFocus: w ? {
          preventScroll: !0
        } : dR(F) || fR(F)
      }
    }), r(!1, F);
  });
  return E.useEffect(() => {
    if (!n || !u)
      return;
    c.current.__escapeKeyBubbles = _, c.current.__outsidePressBubbles = R;
    function F(A) {
      r(!1, A);
    }
    const T = Oo(l);
    d && T.addEventListener("keydown", B), x && T.addEventListener(h, U);
    let j = [];
    return g && (Ge(s) && (j = jn(s)), Ge(l) && (j = j.concat(jn(l))), !Ge(i) && i && i.contextElement && (j = j.concat(jn(i.contextElement)))), j = j.filter((A) => {
      var G;
      return A !== ((G = T.defaultView) == null ? void 0 : G.visualViewport);
    }), j.forEach((A) => {
      A.addEventListener("scroll", F, {
        passive: !0
      });
    }), () => {
      d && T.removeEventListener("keydown", B), x && T.removeEventListener(h, U), j.forEach((A) => {
        A.removeEventListener("scroll", F);
      });
    };
  }, [c, l, s, i, d, x, h, n, r, g, u, _, R, B, U]), E.useEffect(() => {
    M.current = !1;
  }, [x, h]), E.useMemo(() => u ? {
    reference: {
      onKeyDown: B,
      [PR[m]]: (F) => {
        p && (o.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), r(!1, F.nativeEvent));
      }
    },
    floating: {
      onKeyDown: B,
      [OR[h]]: () => {
        M.current = !0;
      }
    }
  } : {}, [u, o, p, h, m, r, B]);
}
let Us;
process.env.NODE_ENV !== "production" && (Us = /* @__PURE__ */ new Set());
function Z2(e) {
  var t;
  e === void 0 && (e = {});
  const {
    open: n = !1,
    onOpenChange: r,
    nodeId: o
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var a;
    const _ = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((a = e.elements) != null && a.reference && !Ge(e.elements.reference)) {
      var i;
      if (!((i = Us) != null && i.has(_))) {
        var s;
        (s = Us) == null || s.add(_), console.error(_);
      }
    }
  }
  const [l, c] = E.useState(null), u = ((t = e.elements) == null ? void 0 : t.reference) || l, d = V2(e), f = q2(), h = _a((_, R) => {
    _ && (m.current.openEvent = R), r == null || r(_, R);
  }), p = E.useRef(null), m = E.useRef({}), g = E.useState(() => CR())[0], y = xR(), b = E.useCallback((_) => {
    const R = Ge(_) ? {
      getBoundingClientRect: () => _.getBoundingClientRect(),
      contextElement: _
    } : _;
    d.refs.setReference(R);
  }, [d.refs]), w = E.useCallback((_) => {
    (Ge(_) || _ === null) && (p.current = _, c(_)), (Ge(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    _ !== null && !Ge(_)) && d.refs.setReference(_);
  }, [d.refs]), S = E.useMemo(() => ({
    ...d.refs,
    setReference: w,
    setPositionReference: b,
    domReference: p
  }), [d.refs, w, b]), x = E.useMemo(() => ({
    ...d.elements,
    domReference: u
  }), [d.elements, u]), M = E.useMemo(() => ({
    ...d,
    refs: S,
    elements: x,
    dataRef: m,
    nodeId: o,
    floatingId: y,
    events: g,
    open: n,
    onOpenChange: h
  }), [d, o, y, g, n, h, S, x]);
  return Y2(() => {
    const _ = f == null ? void 0 : f.nodesRef.current.find((R) => R.id === o);
    _ && (_.context = M);
  }), E.useMemo(() => ({
    ...d,
    context: M,
    refs: S,
    elements: x
  }), [d, S, x, M]);
}
function AR(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    events: a,
    refs: i,
    elements: {
      floating: s,
      domReference: l
    }
  } = e, {
    enabled: c = !0,
    keyboardOnly: u = !0
  } = t, d = E.useRef(""), f = E.useRef(!1), h = E.useRef();
  return E.useEffect(() => {
    if (!c)
      return;
    const m = Oo(s).defaultView || window;
    function g() {
      !n && mt(l) && l === lR(Oo(l)) && (f.current = !0);
    }
    return m.addEventListener("blur", g), () => {
      m.removeEventListener("blur", g);
    };
  }, [s, l, n, c]), E.useEffect(() => {
    if (!c)
      return;
    function p(m) {
      (m.type === "referencePress" || m.type === "escapeKey") && (f.current = !0);
    }
    return a.on("dismiss", p), () => {
      a.off("dismiss", p);
    };
  }, [a, c]), E.useEffect(() => () => {
    clearTimeout(h.current);
  }, []), E.useMemo(() => c ? {
    reference: {
      onPointerDown(p) {
        let {
          pointerType: m
        } = p;
        d.current = m, f.current = !!(m && u);
      },
      onMouseLeave() {
        f.current = !1;
      },
      onFocus(p) {
        var m;
        f.current || p.type === "focus" && ((m = o.current.openEvent) == null ? void 0 : m.type) === "mousedown" && Ma(o.current.openEvent, l) || r(!0, p.nativeEvent);
      },
      onBlur(p) {
        f.current = !1;
        const m = p.relatedTarget, g = Ge(m) && m.hasAttribute(U2("focus-guard")) && m.getAttribute("data-type") === "outside";
        h.current = setTimeout(() => {
          Ya(i.floating.current, m) || Ya(l, m) || g || r(!1, p.nativeEvent);
        });
      }
    }
  } : {}, [c, u, l, i, o, r]);
}
function ls(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...e,
    ...t.map((o) => o ? o[n] : null).concat(e).reduce((o, a) => (a && Object.entries(a).forEach((i) => {
      let [s, l] = i;
      if (s.indexOf("on") === 0) {
        if (r.has(s) || r.set(s, []), typeof l == "function") {
          var c;
          (c = r.get(s)) == null || c.push(l), o[s] = function() {
            for (var u, d = arguments.length, f = new Array(d), h = 0; h < d; h++)
              f[h] = arguments[h];
            return (u = r.get(s)) == null ? void 0 : u.map((p) => p(...f)).find((p) => p !== void 0);
          };
        }
      } else
        o[s] = l;
    }), o), {})
  };
}
function K2(e) {
  e === void 0 && (e = []);
  const t = e, n = E.useCallback(
    (a) => ls(a, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), r = E.useCallback(
    (a) => ls(a, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), o = E.useCallback(
    (a) => ls(a, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((a) => a == null ? void 0 : a.item)
  );
  return E.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: r,
    getItemProps: o
  }), [n, r, o]);
}
const $R = ({ className: e, children: t, ...n }) => /* @__PURE__ */ C.jsx(
  "li",
  {
    className: z(
      "color-neutral-600",
      "cursor-pointer",
      "flex-nowrap",
      "flex",
      "items-center",
      "justify-between",
      "px-2",
      "py-2px",
      "rounded-2px",
      "typo-text-s",
      "hover:bg-neutral-200",
      "hover:color-neutral-800",
      "hover:typo-text-s-em",
      "[&.disabled]:color-neutral-400",
      "[&.disabled]:hover:bg-transparent",
      "[&.disabled]:hover:color-neutral-400",
      "[&.disabled]:hover:typo-text-s",
      e
    ),
    ...n,
    children: t
  }
), RR = ({
  className: e,
  disabled: t,
  hint: n,
  label: r,
  onChange: o,
  options: a,
  placeholder: i,
  tail: s,
  value: l,
  width: c = "auto",
  xPlacement: u = "left",
  yPlacement: d = "bottom",
  warn: f,
  filterSlot: h,
  fallbackStrategy: p = "initialPlacement",
  ...m
}) => {
  const [g, y] = he(!1), [b, w] = he(l ?? null), S = Ct(() => a.find((Q) => Q.key === b) ?? null, [b, a]), x = Ct(() => `${d}-${u === "left" ? "start" : "end"}`, [u, d]), M = bc({ fallbackStrategy: p }), _ = N2({
    apply({ availableWidth: Q, availableHeight: P, elements: L }) {
      Object.assign(L.floating.style, {
        maxWidth: `${Q}px`,
        maxHeight: `${Math.max(40, P)}px`
      });
    }
  }), R = p === "bestFit" ? [M, _] : [_, M], { refs: B, floatingStyles: U, context: F } = Z2({
    middleware: R,
    onOpenChange: y,
    open: g,
    placement: x,
    whileElementsMounted: Cc
  }), T = G2(F, { enabled: !t }), j = X2(F), { getFloatingProps: A, getReferenceProps: G } = K2([T, j]), N = Ue(
    (Q) => {
      const P = a.find((L) => L.key === Q);
      P != null && P.disabled || (w((P == null ? void 0 : P.key) || null), y(!1), o == null || o(Q));
    },
    [o, a]
  );
  nt(() => {
    w(l ?? null);
  }, [l]);
  const te = Ct(() => S && S.tail ? S.tail : s === void 0 ? /* @__PURE__ */ C.jsx("div", { className: z("color-neutral-400", "i-skand-dropdown", "m-l-4") }) : s || null, [S, s]), oe = !!S;
  return /* @__PURE__ */ C.jsxs(
    "div",
    {
      className: z("group/select", "relative", "inline-block", t && "disabled", e),
      ...m,
      children: [
        /* @__PURE__ */ C.jsxs(
          "label",
          {
            className: z(
              "border-1",
              "border-solid",
              "flex-nowrap",
              "flex-row",
              "flex",
              "items-center",
              "justify-between",
              "p-x-3",
              "p-y-2",
              "rounded-1",
              "typo-text-s",
              "color-neutral-600",
              "cursor-pointer",
              t && f && "border-alert-300 bg-neutral-300",
              t && !f && "bg-neutral-300 border-neutral-300",
              f && !t && "border-alert-300 bg-neutral-100",
              !t && !f && "bg-neutral-100 border-neutral-400"
            ),
            ref: B.setReference,
            tabIndex: 0,
            ...G(),
            children: [
              oe ? /* @__PURE__ */ C.jsxs("div", { children: [
                r && /* @__PURE__ */ C.jsx("div", { className: z("typo-text-xxs", "color-neutral-800"), children: r }),
                /* @__PURE__ */ C.jsx("div", { className: z("typo-text-s", "color-neutral-600"), children: S == null ? void 0 : S.name })
              ] }) : /* @__PURE__ */ C.jsx("div", { children: r ? /* @__PURE__ */ C.jsx("span", { className: z("typo-text-s", "color-neutral-600"), children: r }) : i && /* @__PURE__ */ C.jsx("span", { className: z("typo-text-s", "color-neutral-400"), children: i }) }),
              te
            ]
          }
        ),
        n && /* @__PURE__ */ C.jsx(
          "span",
          {
            className: z("m-t-1", "typo-text-xs", f ? "color-alert-300" : "color-neutral-600"),
            children: n
          }
        ),
        !t && g && /* @__PURE__ */ C.jsxs(
          "ul",
          {
            className: z(
              "absolute",
              "bg-neutral-100",
              "border-1",
              "border-neutral-400",
              "border-solid",
              "list-none",
              "overflow-auto",
              "p-1",
              "rounded-1",
              "z-1",
              (c === "full" || a.length === 0) && "w-full"
            ),
            ref: B.setFloating,
            style: U,
            tabIndex: 0,
            ...A(),
            children: [
              h,
              a.length === 0 && /* @__PURE__ */ C.jsx(
                "li",
                {
                  className: z(
                    "color-neutral-400",
                    "flex-nowrap",
                    "flex",
                    "items-center",
                    "justify-between",
                    "px-2",
                    "py-2px",
                    "rounded-2px",
                    "typo-text-s"
                  ),
                  onClick: () => y(!1),
                  children: "No options"
                }
              ),
              a.map((Q) => /* @__PURE__ */ C.jsxs(
                $R,
                {
                  className: z(Q.disabled && "disabled"),
                  onClick: () => N(Q.key),
                  children: [
                    /* @__PURE__ */ C.jsx("div", { className: "whitespace-nowrap", children: Q.name }),
                    /* @__PURE__ */ C.jsx("div", { children: Q.tail })
                  ]
                },
                Q.key
              ))
            ]
          }
        )
      ]
    }
  );
}, DR = [
  { name: "Red", color: "#D04A6B" },
  { name: "Orange", color: "#F69C64" },
  { name: "Green", color: "#4CB176" },
  { name: "Blue", color: "#3F8AE2" },
  { name: "Purple", color: "#8A1AE3" },
  { name: "Grey", color: "#8A858E" },
  { name: "White", color: "#FFFFFF" }
].map((e) => ({
  ...e,
  key: e.color,
  tail: /* @__PURE__ */ C.jsx(
    "div",
    {
      className: z(
        "w-3",
        "h-3",
        "ml-4",
        "rounded-full",
        e.color === "#FFFFFF" && "ring-1 ring-inset ring-neutral-300"
      ),
      style: { background: e.color }
    }
  )
})), eV = ({ label: e = "Colour", value: t, ...n }) => {
  const r = [...DR];
  return t && !r.find((o) => o.key === t) && r.push({
    key: t,
    name: t,
    color: t,
    tail: /* @__PURE__ */ C.jsx("div", { className: z("w-3", "h-3", "ml-4", "rounded-full"), style: { background: t } })
  }), /* @__PURE__ */ C.jsx(
    RR,
    {
      label: e,
      options: r,
      tail: /* @__PURE__ */ C.jsx("div", { className: "i-skand-colors" }),
      value: t,
      ...n
    }
  );
}, NR = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Sc = (e, t, n) => {
  let r;
  const o = NR[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function en(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const LR = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, jR = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, HR = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, FR = {
  date: en({
    formats: LR,
    defaultWidth: "full"
  }),
  time: en({
    formats: jR,
    defaultWidth: "full"
  }),
  dateTime: en({
    formats: HR,
    defaultWidth: "full"
  })
}, BR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ec = (e, t, n, r) => BR[e];
function ho(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const zR = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, IR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, WR = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, VR = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, YR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, UR = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, kc = {
  ordinalNumber: UR,
  era: ho({
    values: zR,
    defaultWidth: "wide"
  }),
  quarter: ho({
    values: IR,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ho({
    values: WR,
    defaultWidth: "wide"
  }),
  day: ho({
    values: VR,
    defaultWidth: "wide"
  }),
  dayPeriod: ho({
    values: YR,
    defaultWidth: "wide",
    formattingValues: qR,
    defaultFormattingWidth: "wide"
  })
};
function po(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? XR(s, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      GR(s, (d) => d.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(i.length);
    return { value: c, rest: u };
  };
}
function GR(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function XR(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function ZR(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const KR = /^(\d+)(th|st|nd|rd)?/i, QR = /\d+/i, JR = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, eD = {
  any: [/^b/i, /^(a|c)/i]
}, tD = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, nD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, rD = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, oD = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, aD = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, iD = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, sD = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, lD = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Mc = {
  ordinalNumber: ZR({
    matchPattern: KR,
    parsePattern: QR,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: po({
    matchPatterns: JR,
    defaultMatchWidth: "wide",
    parsePatterns: eD,
    defaultParseWidth: "any"
  }),
  quarter: po({
    matchPatterns: tD,
    defaultMatchWidth: "wide",
    parsePatterns: nD,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: po({
    matchPatterns: rD,
    defaultMatchWidth: "wide",
    parsePatterns: oD,
    defaultParseWidth: "any"
  }),
  day: po({
    matchPatterns: aD,
    defaultMatchWidth: "wide",
    parsePatterns: iD,
    defaultParseWidth: "any"
  }),
  dayPeriod: po({
    matchPatterns: sD,
    defaultMatchWidth: "any",
    parsePatterns: lD,
    defaultParseWidth: "any"
  })
}, cD = {
  code: "en-AU",
  formatDistance: Sc,
  formatLong: FR,
  formatRelative: Ec,
  localize: kc,
  match: Mc,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, uD = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, dD = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, fD = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, hD = {
  date: en({
    formats: uD,
    defaultWidth: "full"
  }),
  time: en({
    formats: dD,
    defaultWidth: "full"
  }),
  dateTime: en({
    formats: fD,
    defaultWidth: "full"
  })
}, pD = {
  code: "en-GB",
  formatDistance: Sc,
  formatLong: hD,
  formatRelative: Ec,
  localize: kc,
  match: Mc,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, mD = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, gD = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, vD = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bD = {
  date: en({
    formats: mD,
    defaultWidth: "full"
  }),
  time: en({
    formats: gD,
    defaultWidth: "full"
  }),
  dateTime: en({
    formats: vD,
    defaultWidth: "full"
  })
}, Q2 = {
  code: "en-US",
  formatDistance: Sc,
  formatLong: bD,
  formatRelative: Ec,
  localize: kc,
  match: Mc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, yD = () => window.navigator.language, wD = {
  "en-US": Q2,
  "en-AU": cD,
  "en-GB": pD
}, xD = (e) => {
  const t = yD(), n = wD[t];
  return n || (e ?? void 0);
};
let CD = {};
function yi() {
  return CD;
}
const J2 = 6048e5, SD = 864e5, eh = 6e4, th = 36e5;
function At(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function P1(e) {
  const t = At(e);
  return t.setHours(0, 0, 0, 0), t;
}
function O1(e) {
  const t = At(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function ED(e, t) {
  const n = P1(e), r = P1(t), o = +n - O1(n), a = +r - O1(r);
  return Math.round((o - a) / SD);
}
function Wn(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function kD(e) {
  const t = At(e), n = Wn(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function MD(e) {
  const t = At(e);
  return ED(t, kD(t)) + 1;
}
function jo(e, t) {
  var s, l, c, u;
  const n = yi(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = At(e), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function qa(e) {
  return jo(e, { weekStartsOn: 1 });
}
function nh(e) {
  const t = At(e), n = t.getFullYear(), r = Wn(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = qa(r), a = Wn(e, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const i = qa(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function _D(e) {
  const t = nh(e), n = Wn(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), qa(n);
}
function PD(e) {
  const t = At(e), n = +qa(t) - +_D(t);
  return Math.round(n / J2) + 1;
}
function rh(e, t) {
  var u, d, f, h;
  const n = At(e), r = n.getFullYear(), o = yi(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = Wn(e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = jo(i, t), l = Wn(e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const c = jo(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function OD(e, t) {
  var s, l, c, u;
  const n = yi(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = rh(e, t), a = Wn(e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), jo(a, t);
}
function TD(e, t) {
  const n = At(e), r = +jo(n, t) - +OD(n, t);
  return Math.round(r / J2) + 1;
}
function me(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const mn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return me(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : me(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return me(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return me(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return me(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return me(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return me(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return me(o, t.length);
  }
}, or = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, T1 = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return mn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = rh(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return me(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : me(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = nh(e);
    return me(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return me(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return me(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return me(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return mn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return me(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = TD(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : me(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = PD(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : me(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : mn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = MD(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : me(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return me(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return me(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return me(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = or.noon : r === 0 ? o = or.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = or.evening : r >= 12 ? o = or.afternoon : r >= 4 ? o = or.morning : o = or.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return mn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : mn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : me(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : me(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : mn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : mn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return mn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return $1(r);
      case "XXXX":
      case "XX":
        return Nn(r);
      case "XXXXX":
      case "XXX":
      default:
        return Nn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return $1(r);
      case "xxxx":
      case "xx":
        return Nn(r);
      case "xxxxx":
      case "xxx":
      default:
        return Nn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + A1(r, ":");
      case "OOOO":
      default:
        return "GMT" + Nn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + A1(r, ":");
      case "zzzz":
      default:
        return "GMT" + Nn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return me(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return me(r, t.length);
  }
};
function A1(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + me(a, 2);
}
function $1(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + me(Math.abs(e) / 60, 2) : Nn(e, t);
}
function Nn(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = me(Math.trunc(r / 60), 2), a = me(r % 60, 2);
  return n + o + t + a;
}
const R1 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, oh = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, AD = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return R1(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", R1(r, t)).replace("{{time}}", oh(o, t));
}, $D = {
  p: oh,
  P: AD
}, RD = /^D+$/, DD = /^Y+$/, ND = ["D", "DD", "YY", "YYYY"];
function LD(e) {
  return RD.test(e);
}
function jD(e) {
  return DD.test(e);
}
function HD(e, t, n) {
  const r = FD(e, t, n);
  if (console.warn(r), ND.includes(e))
    throw new RangeError(r);
}
function FD(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function BD(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function zD(e) {
  if (!BD(e) && typeof e != "number")
    return !1;
  const t = At(e);
  return !isNaN(Number(t));
}
const ID = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, WD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, VD = /^'([^]*?)'?$/, YD = /''/g, qD = /[a-zA-Z]/;
function UD(e, t, n) {
  var u, d, f, h, p, m, g, y;
  const r = yi(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Q2, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((y = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = At(e);
  if (!zD(s))
    throw new RangeError("Invalid time value");
  let l = t.match(WD).map((b) => {
    const w = b[0];
    if (w === "p" || w === "P") {
      const S = $D[w];
      return S(b, o.formatLong);
    }
    return b;
  }).join("").match(ID).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const w = b[0];
    if (w === "'")
      return { isToken: !1, value: GD(b) };
    if (T1[w])
      return { isToken: !0, value: b };
    if (w.match(qD))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: b };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((b) => {
    if (!b.isToken)
      return b.value;
    const w = b.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && jD(w) || !(n != null && n.useAdditionalDayOfYearTokens) && LD(w)) && HD(w, t, String(e));
    const S = T1[w[0]];
    return S(s, w, o.localize, c);
  }).join("");
}
function GD(e) {
  const t = e.match(VD);
  return t ? t[1].replace(YD, "'") : e;
}
function XD(e, t) {
  const n = At(e);
  if (isNaN(n.getTime()))
    throw new RangeError("Invalid time value");
  const r = (t == null ? void 0 : t.format) ?? "extended", o = (t == null ? void 0 : t.representation) ?? "complete";
  let a = "", i = "";
  const s = r === "extended" ? "-" : "", l = r === "extended" ? ":" : "";
  if (o !== "time") {
    const c = me(n.getDate(), 2), u = me(n.getMonth() + 1, 2);
    a = `${me(n.getFullYear(), 4)}${s}${u}${s}${c}`;
  }
  if (o !== "date") {
    const c = n.getTimezoneOffset();
    if (c !== 0) {
      const m = Math.abs(c), g = me(Math.trunc(m / 60), 2), y = me(m % 60, 2);
      i = `${c < 0 ? "+" : "-"}${g}:${y}`;
    } else
      i = "Z";
    const u = me(n.getHours(), 2), d = me(n.getMinutes(), 2), f = me(n.getSeconds(), 2), h = a === "" ? "" : "T", p = [u, d, f].join(l);
    a = `${a}${h}${p}${i}`;
  }
  return a;
}
function ZD(e, t) {
  const n = (t == null ? void 0 : t.additionalDigits) ?? 2, r = eN(e);
  let o;
  if (r.date) {
    const l = tN(r.date, n);
    o = nN(l.restDateString, l.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const a = o.getTime();
  let i = 0, s;
  if (r.time && (i = rN(r.time), isNaN(i)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (s = oN(r.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(a + i), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), c.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), c;
  }
  return new Date(a + i + s);
}
const pa = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, KD = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, QD = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, JD = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function eN(e) {
  const t = {}, n = e.split(pa.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], pa.timeZoneDelimiter.test(t.date) && (t.date = e.split(pa.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const o = pa.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function tN(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r)
    return { year: NaN, restDateString: "" };
  const o = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
  return {
    year: a === null ? o : a * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function nN(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = e.match(KD);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], o = mo(n[1]), a = mo(n[2]) - 1, i = mo(n[3]), s = mo(n[4]), l = mo(n[5]) - 1;
  if (r)
    return cN(t, s, l) ? aN(t, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !sN(t, a, i) || !lN(t, o) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, a, Math.max(o, i)), c);
  }
}
function mo(e) {
  return e ? parseInt(e) : 1;
}
function rN(e) {
  const t = e.match(QD);
  if (!t)
    return NaN;
  const n = cs(t[1]), r = cs(t[2]), o = cs(t[3]);
  return uN(n, r, o) ? n * th + r * eh + o * 1e3 : NaN;
}
function cs(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function oN(e) {
  if (e === "Z")
    return 0;
  const t = e.match(JD);
  if (!t)
    return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return dN(r, o) ? n * (r * th + o * eh) : NaN;
}
function aN(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const o = r.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
const iN = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function ah(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function sN(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (iN[t] || (ah(e) ? 29 : 28));
}
function lN(e, t) {
  return t >= 1 && t <= (ah(e) ? 366 : 365);
}
function cN(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function uN(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function dN(e, t) {
  return t >= 0 && t <= 59;
}
const tV = ({
  defaultValue: e,
  disabled: t,
  hint: n,
  label: r,
  onChange: o,
  placeholder: a,
  value: i,
  warn: s,
  startMonth: l,
  endMonth: c
}) => {
  const [u, d] = he(e ?? i ?? ""), [f, h] = he(!1), { refs: p, floatingStyles: m, context: g } = Z2({
    middleware: [bc()],
    open: f,
    onOpenChange: h,
    placement: "bottom-end",
    whileElementsMounted: Cc
  }), y = G2(g, { toggle: !1, enabled: !t }), b = AR(g, { enabled: !t }), w = X2(g), { getReferenceProps: S, getFloatingProps: x } = K2([y, b, w]), M = (B) => {
    const U = B === void 0 ? "" : XD(B);
    d(U), o == null || o(U), h(!1);
  }, _ = Ct(() => {
    if (u === "")
      return "";
    const B = xD();
    return UD(new Date(u), "P", B ? { locale: B } : void 0);
  }, [u]), R = Ct(() => {
    if (u !== "")
      return ZD(u);
  }, [u]);
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ C.jsxs(
        "div",
        {
          className: z(
            "bg-neutral-100",
            "border-1",
            "border-solid",
            "flex-nowrap",
            "flex-row",
            "flex",
            "items-center",
            "p-x-3",
            "p-y-2",
            "rounded-1",
            s ? "border-alert-300" : f ? "border-neutral-800" : "border-neutral-400"
          ),
          ref: p.setReference,
          tabIndex: 0,
          ...S(),
          children: [
            /* @__PURE__ */ C.jsxs("div", { className: "w-full flex flex-auto flex-row flex-wrap", children: [
              r && /* @__PURE__ */ C.jsx(
                "label",
                {
                  className: z(
                    "cursor-text",
                    _ && ["color-neutral-800", "flex-auto", "typo-text-xxs", "w-full"],
                    _ ? ["color-neutral-800", "flex-auto", "typo-text-xxs", "w-full"] : [
                      "color-neutral-600",
                      "flex-basis-auto",
                      "flex-grow-0",
                      "flex-shrink-0",
                      "typo-text-s"
                    ]
                  ),
                  children: r
                }
              ),
              !_ && a && /* @__PURE__ */ C.jsx("span", { className: "color-neutral-400 typo-text-s", children: a }),
              _ && /* @__PURE__ */ C.jsx(
                "span",
                {
                  className: z(
                    "bg-transparent",
                    "border-0",
                    "flex-1",
                    "outline-none",
                    "typo-text-s",
                    s ? "color-neutral-400" : "color-neutral-600"
                  ),
                  children: _
                }
              )
            ] }),
            /* @__PURE__ */ C.jsx("div", { className: "i-skand-date cursor-pointer text-3 color-neutral-600" })
          ]
        }
      ),
      n && /* @__PURE__ */ C.jsx(
        "span",
        {
          className: z("m-t-1", "typo-text-xs", s ? "color-alert-300" : "color-neutral-600"),
          children: n
        }
      )
    ] }),
    f && /* @__PURE__ */ C.jsx("div", { className: "z-1", ref: p.setFloating, style: m, ...x(), children: /* @__PURE__ */ C.jsx(
      vf,
      {
        endMonth: c,
        mode: "single",
        onSelect: M,
        selected: R,
        showOutsideDays: !0,
        startMonth: l
      }
    ) })
  ] });
}, fN = z("group/dropdown", "relative", "inline-block"), hN = z(
  "border-1",
  "border-solid",
  "flex-nowrap",
  "flex-row",
  "flex",
  "items-center",
  "justify-between",
  "p-x-3",
  "p-y-2",
  "rounded-1",
  "typo-text-s",
  "border-neutral-400",
  "bg-neutral-100",
  "color-neutral-600",
  "cursor-pointer",
  "group-focus-within/dropdown:bg-neutral-200",
  "group-focus/dropdown:bg-neutral-200",
  "group-[.disabled]/dropdown:border-neutral-300",
  "group-[.disabled]/dropdown:bg-neutral-300",
  "group-[.disabled]/dropdown:color-neutral-400",
  "group-[.disabled]/dropdown:cursor-not-allowed",
  "group-[.disabled]/dropdown:focus-within:bg-neutral-300",
  "group-[.disabled]/dropdown:focus:bg-neutral-300"
), pN = z(
  "absolute",
  "border-1",
  "border-neutral-400",
  "border-solid",
  "bg-neutral-100",
  "list-none",
  "m-y-1",
  "p-1",
  "rounded-1",
  "z-1",
  "[&.placement-right]:right-0",
  "[&.placement-top]:bottom-full",
  "invisible",
  "opacity-0",
  "group-focus-within/dropdown:opacity-100",
  "group-focus-within/dropdown:visible",
  "group-focus/dropdown:opacity-100",
  "group-focus/dropdown:visible",
  "group-[.disabled]/dropdown:invisible",
  "group-[.disabled]/dropdown:opacity-0",
  "group-[.disabled]/dropdown:focus-within:invisible",
  "group-[.disabled]/dropdown:focus-within:opacity-0",
  "group-[.disabled]/dropdown:focus:invisible",
  "group-[.disabled]/dropdown:focus:opacity-0"
), mN = z("color-neutral-400", "i-skand-dropdown", "m-l-4");
z(
  "color-neutral-600",
  "cursor-pointer",
  "first:m-t-0",
  "m-t-1",
  "typo-text-s"
);
const ih = qt(
  ({
    children: e,
    label: t,
    disabled: n,
    className: r,
    tail: o,
    width: a = "auto",
    xPlacement: i = "left",
    yPlacement: s = "bottom",
    ...l
  }, c) => /* @__PURE__ */ C.jsxs("div", { className: z(fN, n && "disabled", r), ...l, children: [
    /* @__PURE__ */ C.jsxs("label", { className: z(hN), ref: c, tabIndex: 0, children: [
      t,
      o === null ? null : o === void 0 ? /* @__PURE__ */ C.jsx("div", { className: mN }) : o
    ] }),
    e && /* @__PURE__ */ C.jsx(
      "ul",
      {
        className: z(
          pN,
          a === "full" && "w-full",
          i === "right" && "placement-right",
          s === "top" && "placement-top"
        ),
        tabIndex: 0,
        children: e
      }
    )
  ] })
);
ih.displayName = "Dropdown";
ih.defaultProps = {
  disabled: !1
};
const nV = ({ className: e, children: t, ...n }) => /* @__PURE__ */ C.jsx(
  "li",
  {
    className: z(
      "color-neutral-600",
      "cursor-pointer",
      "typo-text-s",
      "px-2",
      "py-2px",
      "rounded-2px",
      "hover:bg-neutral-200",
      "hover:color-neutral-800",
      "hover:typo-text-s-em",
      e
    ),
    ...n,
    children: t
  }
);
function Ua() {
  return Ua = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ua.apply(this, arguments);
}
function gN(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function vN(...e) {
  return (t) => e.forEach(
    (n) => gN(n, t)
  );
}
const wi = /* @__PURE__ */ qt((e, t) => {
  const { children: n, ...r } = e, o = Mo.toArray(n), a = o.find(yN);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? Mo.count(i) > 1 ? Mo.only(null) : /* @__PURE__ */ Ao(i) ? i.props.children : null : l);
    return /* @__PURE__ */ _s(Gs, Ua({}, r, {
      ref: t
    }), /* @__PURE__ */ Ao(i) ? /* @__PURE__ */ Td(i, void 0, s) : null);
  }
  return /* @__PURE__ */ _s(Gs, Ua({}, r, {
    ref: t
  }), n);
});
wi.displayName = "Slot";
const Gs = /* @__PURE__ */ qt((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Ao(n) ? /* @__PURE__ */ Td(n, {
    ...wN(r, n.props),
    ref: t ? vN(t, n.ref) : n.ref
  }) : Mo.count(n) > 1 ? Mo.only(null) : null;
});
Gs.displayName = "SlotClone";
const bN = ({ children: e }) => /* @__PURE__ */ _s(Z3, null, e);
function yN(e) {
  return /* @__PURE__ */ Ao(e) && e.type === bN;
}
function wN(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...a
    } : r === "className" && (n[r] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const sh = ({
  type: e = "info",
  message: t = "",
  clickToDismiss: n,
  dismiss: r,
  props: { className: o, ...a } = {},
  size: i = "m"
}) => /* @__PURE__ */ C.jsxs(
  "div",
  {
    className: z(
      "inline-flex items-center b-1 b-solid rounded-1",
      "shadow-[0px_2px_2px_0px_rgba(0,0,0,0.15)]",
      i === "m" && "px-2 py-1",
      i === "l" && "px-3 py-2",
      n && "cursor-pointer",
      e === "info" && "bg-info-100 b-info-400",
      e === "success" && "bg-success-100 b-success-400",
      (e === "warn" || e === "warning") && "bg-alert-100 b-alert-400",
      o
    ),
    onClick: n ? r : void 0,
    ...a,
    children: [
      /* @__PURE__ */ C.jsx(
        "div",
        {
          className: z(
            e === "info" && "i-skand-info color-info-400",
            e === "success" && "i-skand-done color-success-400",
            (e === "warn" || e === "warning") && "i-skand-warn color-alert-400"
          )
        }
      ),
      /* @__PURE__ */ C.jsx(
        "span",
        {
          className: z(
            "ml-2 color-neutral-800",
            i === "m" && "typo-text-xs",
            i === "l" && "typo-text-s"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ C.jsx(
        "div",
        {
          className: z(
            "i-skand-close cursor-pointer",
            "ml-2 color-neutral-600",
            i === "m" && "typo-text-xs",
            i === "l" && "typo-text-s"
          ),
          onClick: r
        }
      )
    ]
  }
), xN = (e) => new Promise((t) => {
  setTimeout(t, e);
});
let ma;
const CN = new Uint8Array(16);
function SN() {
  if (!ma && (ma = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ma))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ma(CN);
}
const st = [];
for (let e = 0; e < 256; ++e)
  st.push((e + 256).toString(16).slice(1));
function EN(e, t = 0) {
  return (st[e[t + 0]] + st[e[t + 1]] + st[e[t + 2]] + st[e[t + 3]] + "-" + st[e[t + 4]] + st[e[t + 5]] + "-" + st[e[t + 6]] + st[e[t + 7]] + "-" + st[e[t + 8]] + st[e[t + 9]] + "-" + st[e[t + 10]] + st[e[t + 11]] + st[e[t + 12]] + st[e[t + 13]] + st[e[t + 14]] + st[e[t + 15]]).toLowerCase();
}
let D1, us, ds = 0, fs = 0;
function kN(e, t, n) {
  let r = t && n || 0;
  const o = t || new Array(16);
  e = e || {};
  let a = e.node || D1, i = e.clockseq !== void 0 ? e.clockseq : us;
  if (a == null || i == null) {
    const f = e.random || (e.rng || SN)();
    a == null && (a = D1 = [f[0] | 1, f[1], f[2], f[3], f[4], f[5]]), i == null && (i = us = (f[6] << 8 | f[7]) & 16383);
  }
  let s = e.msecs !== void 0 ? e.msecs : Date.now(), l = e.nsecs !== void 0 ? e.nsecs : fs + 1;
  const c = s - ds + (l - fs) / 1e4;
  if (c < 0 && e.clockseq === void 0 && (i = i + 1 & 16383), (c < 0 || s > ds) && e.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  ds = s, fs = l, us = i, s += 122192928e5;
  const u = ((s & 268435455) * 1e4 + l) % 4294967296;
  o[r++] = u >>> 24 & 255, o[r++] = u >>> 16 & 255, o[r++] = u >>> 8 & 255, o[r++] = u & 255;
  const d = s / 4294967296 * 1e4 & 268435455;
  o[r++] = d >>> 8 & 255, o[r++] = d & 255, o[r++] = d >>> 24 & 15 | 16, o[r++] = d >>> 16 & 255, o[r++] = i >>> 8 | 128, o[r++] = i & 255;
  for (let f = 0; f < 6; ++f)
    o[r + f] = a[f];
  return t || EN(o);
}
const N1 = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (l, c) => {
    const u = typeof l == "function" ? l(t) : l;
    if (!Object.is(u, t)) {
      const d = t;
      t = c ?? typeof u != "object" ? u : Object.assign({}, t, u), n.forEach((f) => f(t, d));
    }
  }, o = () => t, s = { setState: r, getState: o, subscribe: (l) => (n.add(l), () => n.delete(l)), destroy: () => {
    n.clear();
  } };
  return t = e(r, o, s), s;
}, MN = (e) => e ? N1(e) : N1;
var Xs = { exports: {} }, hs = {}, ga = { exports: {} }, ps = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L1;
function _N() {
  if (L1)
    return ps;
  L1 = 1;
  var e = v;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, a = e.useLayoutEffect, i = e.useDebugValue;
  function s(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), m = p[0].inst, g = p[1];
    return a(function() {
      m.value = h, m.getSnapshot = f, l(m) && g({ inst: m });
    }, [d, h, f]), o(function() {
      return l(m) && g({ inst: m }), d(function() {
        l(m) && g({ inst: m });
      });
    }, [d]), i(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return ps.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, ps;
}
var ms = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j1;
function PN() {
  return j1 || (j1 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = v, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(w) {
      {
        for (var S = arguments.length, x = new Array(S > 1 ? S - 1 : 0), M = 1; M < S; M++)
          x[M - 1] = arguments[M];
        r("error", w, x);
      }
    }
    function r(w, S, x) {
      {
        var M = t.ReactDebugCurrentFrame, _ = M.getStackAddendum();
        _ !== "" && (S += "%s", x = x.concat([_]));
        var R = x.map(function(B) {
          return String(B);
        });
        R.unshift("Warning: " + S), Function.prototype.apply.call(console[w], console, R);
      }
    }
    function o(w, S) {
      return w === S && (w !== 0 || 1 / w === 1 / S) || w !== w && S !== S;
    }
    var a = typeof Object.is == "function" ? Object.is : o, i = e.useState, s = e.useEffect, l = e.useLayoutEffect, c = e.useDebugValue, u = !1, d = !1;
    function f(w, S, x) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var M = S();
      if (!d) {
        var _ = S();
        a(M, _) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var R = i({
        inst: {
          value: M,
          getSnapshot: S
        }
      }), B = R[0].inst, U = R[1];
      return l(function() {
        B.value = M, B.getSnapshot = S, h(B) && U({
          inst: B
        });
      }, [w, M, S]), s(function() {
        h(B) && U({
          inst: B
        });
        var F = function() {
          h(B) && U({
            inst: B
          });
        };
        return w(F);
      }, [w]), c(M), M;
    }
    function h(w) {
      var S = w.getSnapshot, x = w.value;
      try {
        var M = S();
        return !a(x, M);
      } catch {
        return !0;
      }
    }
    function p(w, S, x) {
      return S();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", g = !m, y = g ? p : f, b = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : y;
    ms.useSyncExternalStore = b, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ms;
}
var H1;
function lh() {
  return H1 || (H1 = 1, process.env.NODE_ENV === "production" ? ga.exports = _N() : ga.exports = PN()), ga.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F1;
function ON() {
  if (F1)
    return hs;
  F1 = 1;
  var e = v, t = lh();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, a = e.useRef, i = e.useEffect, s = e.useMemo, l = e.useDebugValue;
  return hs.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var p = a(null);
    if (p.current === null) {
      var m = { hasValue: !1, value: null };
      p.current = m;
    } else
      m = p.current;
    p = s(function() {
      function y(M) {
        if (!b) {
          if (b = !0, w = M, M = f(M), h !== void 0 && m.hasValue) {
            var _ = m.value;
            if (h(_, M))
              return S = _;
          }
          return S = M;
        }
        if (_ = S, r(w, M))
          return _;
        var R = f(M);
        return h !== void 0 && h(_, R) ? _ : (w = M, S = R);
      }
      var b = !1, w, S, x = d === void 0 ? null : d;
      return [function() {
        return y(u());
      }, x === null ? void 0 : function() {
        return y(x());
      }];
    }, [u, d, f, h]);
    var g = o(c, p[0], p[1]);
    return i(function() {
      m.hasValue = !0, m.value = g;
    }, [g]), l(g), g;
  }, hs;
}
var gs = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var B1;
function TN() {
  return B1 || (B1 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = v, t = lh();
    function n(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, a = e.useRef, i = e.useEffect, s = e.useMemo, l = e.useDebugValue;
    function c(u, d, f, h, p) {
      var m = a(null), g;
      m.current === null ? (g = {
        hasValue: !1,
        value: null
      }, m.current = g) : g = m.current;
      var y = s(function() {
        var x = !1, M, _, R = function(T) {
          if (!x) {
            x = !0, M = T;
            var j = h(T);
            if (p !== void 0 && g.hasValue) {
              var A = g.value;
              if (p(A, j))
                return _ = A, A;
            }
            return _ = j, j;
          }
          var G = M, N = _;
          if (r(G, T))
            return N;
          var te = h(T);
          return p !== void 0 && p(N, te) ? N : (M = T, _ = te, te);
        }, B = f === void 0 ? null : f, U = function() {
          return R(d());
        }, F = B === null ? void 0 : function() {
          return R(B());
        };
        return [U, F];
      }, [d, f, h, p]), b = y[0], w = y[1], S = o(u, b, w);
      return i(function() {
        g.hasValue = !0, g.value = S;
      }, [S]), l(S), S;
    }
    gs.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), gs;
}
process.env.NODE_ENV === "production" ? Xs.exports = ON() : Xs.exports = TN();
var AN = Xs.exports;
const $N = /* @__PURE__ */ yl(AN), { useSyncExternalStoreWithSelector: RN } = $N;
function DN(e, t = e.getState, n) {
  const r = RN(
    e.subscribe,
    e.getState,
    e.getServerState || e.getState,
    t,
    n
  );
  return K3(r), r;
}
const z1 = (e) => {
  const t = typeof e == "function" ? MN(e) : e, n = (r, o) => DN(t, r, o);
  return Object.assign(n, t), n;
}, NN = (e) => e ? z1(e) : z1, _c = NN()(() => ({
  toasts: []
})), LN = (e) => {
  _c.setState((t) => ({ toasts: t.toasts.filter((n) => n.id !== e) }));
}, rV = (e = {}) => {
  const { body: t, id: n = kN(), lifespan: r, message: o, type: a, props: i, clickToDismiss: s } = e, l = () => LN(n);
  return _c.setState((c) => {
    const u = {
      body: t instanceof Function ? t(l) : t,
      clickToDismiss: s,
      dismiss: l,
      id: n,
      message: o instanceof Function ? o(l) : o,
      props: i,
      type: a
    };
    return { toasts: [...c.toasts, u] };
  }), r !== void 0 && xN(r).then(l), { id: n, dismiss: l };
}, oV = ({ className: e, size: t, ...n }) => {
  const { toasts: r } = _c();
  return /* @__PURE__ */ C.jsx(
    "div",
    {
      className: z("fixed bottom-18px right-18px flex flex-col items-end gap-2", e),
      ...n,
      children: r.map((o) => {
        const { body: a, clickToDismiss: i, dismiss: s, id: l, message: c, props: u, type: d } = o;
        return a || /* @__PURE__ */ C.jsx(
          sh,
          {
            clickToDismiss: i,
            dismiss: s,
            message: c,
            props: u,
            size: t,
            type: d
          },
          l
        );
      })
    }
  );
}, aV = ({ asChild: e, ...t }) => {
  const n = e ? wi : sh;
  return /* @__PURE__ */ C.jsx(n, { props: { className: "absolute left-3 top-3" }, type: "info", ...t });
}, iV = ({ asChild: e, children: t, className: n, ...r }) => {
  const o = e ? wi : "p";
  return /* @__PURE__ */ C.jsx(o, { className: z("color-neutral-500 typo-text-l", n), ...r, children: t });
}, sV = ({ asChild: e, children: t, className: n, ...r }) => {
  const o = e ? wi : "p";
  return /* @__PURE__ */ C.jsx(o, { className: z("color-neutral-500 typo-text-s", n), ...r, children: t });
}, jN = qt(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ C.jsx(
    "div",
    {
      className: z("relative flex flex-col items-center gap-3 p-3 justify-center", t),
      ref: r,
      ...n,
      children: e
    }
  )
);
jN.displayName = "EmptyRoot";
function ch(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: HN } = Object.prototype, { getPrototypeOf: Pc } = Object, xi = ((e) => (t) => {
  const n = HN.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Bt = (e) => (e = e.toLowerCase(), (t) => xi(t) === e), Ci = (e) => (t) => typeof t === e, { isArray: Xr } = Array, Ho = Ci("undefined");
function FN(e) {
  return e !== null && !Ho(e) && e.constructor !== null && !Ho(e.constructor) && Ot(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const uh = Bt("ArrayBuffer");
function BN(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && uh(e.buffer), t;
}
const zN = Ci("string"), Ot = Ci("function"), dh = Ci("number"), Si = (e) => e !== null && typeof e == "object", IN = (e) => e === !0 || e === !1, Pa = (e) => {
  if (xi(e) !== "object")
    return !1;
  const t = Pc(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, WN = Bt("Date"), VN = Bt("File"), YN = Bt("Blob"), qN = Bt("FileList"), UN = (e) => Si(e) && Ot(e.pipe), GN = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ot(e.append) && ((t = xi(e)) === "formdata" || // detect form-data instance
  t === "object" && Ot(e.toString) && e.toString() === "[object FormData]"));
}, XN = Bt("URLSearchParams"), [ZN, KN, QN, JN] = ["ReadableStream", "Request", "Response", "Headers"].map(Bt), eL = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function oa(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), Xr(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const a = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = a.length;
    let s;
    for (r = 0; r < i; r++)
      s = a[r], t.call(null, e[s], s, e);
  }
}
function fh(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const hh = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), ph = (e) => !Ho(e) && e !== hh;
function Zs() {
  const { caseless: e } = ph(this) && this || {}, t = {}, n = (r, o) => {
    const a = e && fh(t, o) || o;
    Pa(t[a]) && Pa(r) ? t[a] = Zs(t[a], r) : Pa(r) ? t[a] = Zs({}, r) : Xr(r) ? t[a] = r.slice() : t[a] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && oa(arguments[r], n);
  return t;
}
const tL = (e, t, n, { allOwnKeys: r } = {}) => (oa(t, (o, a) => {
  n && Ot(o) ? e[a] = ch(o, n) : e[a] = o;
}, { allOwnKeys: r }), e), nL = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), rL = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, oL = (e, t, n, r) => {
  let o, a, i;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), a = o.length; a-- > 0; )
      i = o[a], (!r || r(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && Pc(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, aL = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, iL = (e) => {
  if (!e)
    return null;
  if (Xr(e))
    return e;
  let t = e.length;
  if (!dh(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, sL = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Pc(Uint8Array)), lL = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, cL = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, uL = Bt("HTMLFormElement"), dL = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), I1 = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), fL = Bt("RegExp"), mh = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  oa(n, (o, a) => {
    let i;
    (i = t(o, a, e)) !== !1 && (r[a] = i || o);
  }), Object.defineProperties(e, r);
}, hL = (e) => {
  mh(e, (t, n) => {
    if (Ot(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Ot(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, pL = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((a) => {
      n[a] = !0;
    });
  };
  return Xr(e) ? r(e) : r(String(e).split(t)), n;
}, mL = () => {
}, gL = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, vs = "abcdefghijklmnopqrstuvwxyz", W1 = "0123456789", gh = {
  DIGIT: W1,
  ALPHA: vs,
  ALPHA_DIGIT: vs + vs.toUpperCase() + W1
}, vL = (e = 16, t = gh.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function bL(e) {
  return !!(e && Ot(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const yL = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (Si(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const a = Xr(r) ? [] : {};
        return oa(r, (i, s) => {
          const l = n(i, o + 1);
          !Ho(l) && (a[s] = l);
        }), t[o] = void 0, a;
      }
    }
    return r;
  };
  return n(e, 0);
}, wL = Bt("AsyncFunction"), xL = (e) => e && (Si(e) || Ot(e)) && Ot(e.then) && Ot(e.catch), O = {
  isArray: Xr,
  isArrayBuffer: uh,
  isBuffer: FN,
  isFormData: GN,
  isArrayBufferView: BN,
  isString: zN,
  isNumber: dh,
  isBoolean: IN,
  isObject: Si,
  isPlainObject: Pa,
  isReadableStream: ZN,
  isRequest: KN,
  isResponse: QN,
  isHeaders: JN,
  isUndefined: Ho,
  isDate: WN,
  isFile: VN,
  isBlob: YN,
  isRegExp: fL,
  isFunction: Ot,
  isStream: UN,
  isURLSearchParams: XN,
  isTypedArray: sL,
  isFileList: qN,
  forEach: oa,
  merge: Zs,
  extend: tL,
  trim: eL,
  stripBOM: nL,
  inherits: rL,
  toFlatObject: oL,
  kindOf: xi,
  kindOfTest: Bt,
  endsWith: aL,
  toArray: iL,
  forEachEntry: lL,
  matchAll: cL,
  isHTMLForm: uL,
  hasOwnProperty: I1,
  hasOwnProp: I1,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: mh,
  freezeMethods: hL,
  toObjectSet: pL,
  toCamelCase: dL,
  noop: mL,
  toFiniteNumber: gL,
  findKey: fh,
  global: hh,
  isContextDefined: ph,
  ALPHABET: gh,
  generateString: vL,
  isSpecCompliantForm: bL,
  toJSONObject: yL,
  isAsyncFn: wL,
  isThenable: xL
};
function fe(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
O.inherits(fe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: O.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const vh = fe.prototype, bh = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  bh[e] = { value: e };
});
Object.defineProperties(fe, bh);
Object.defineProperty(vh, "isAxiosError", { value: !0 });
fe.from = (e, t, n, r, o, a) => {
  const i = Object.create(vh);
  return O.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), fe.call(i, e.message, t, n, r, o), i.cause = e, i.name = e.name, a && Object.assign(i, a), i;
};
const CL = null;
function Ks(e) {
  return O.isPlainObject(e) || O.isArray(e);
}
function yh(e) {
  return O.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function V1(e, t, n) {
  return e ? e.concat(t).map(function(o, a) {
    return o = yh(o), !n && a ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function SL(e) {
  return O.isArray(e) && !e.some(Ks);
}
const EL = O.toFlatObject(O, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Ei(e, t, n) {
  if (!O.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = O.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, g) {
    return !O.isUndefined(g[m]);
  });
  const r = n.metaTokens, o = n.visitor || u, a = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && O.isSpecCompliantForm(t);
  if (!O.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(p) {
    if (p === null)
      return "";
    if (O.isDate(p))
      return p.toISOString();
    if (!l && O.isBlob(p))
      throw new fe("Blob is not supported. Use a Buffer instead.");
    return O.isArrayBuffer(p) || O.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function u(p, m, g) {
    let y = p;
    if (p && !g && typeof p == "object") {
      if (O.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), p = JSON.stringify(p);
      else if (O.isArray(p) && SL(p) || (O.isFileList(p) || O.endsWith(m, "[]")) && (y = O.toArray(p)))
        return m = yh(m), y.forEach(function(w, S) {
          !(O.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? V1([m], S, a) : i === null ? m : m + "[]",
            c(w)
          );
        }), !1;
    }
    return Ks(p) ? !0 : (t.append(V1(g, m, a), c(p)), !1);
  }
  const d = [], f = Object.assign(EL, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Ks
  });
  function h(p, m) {
    if (!O.isUndefined(p)) {
      if (d.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      d.push(p), O.forEach(p, function(y, b) {
        (!(O.isUndefined(y) || y === null) && o.call(
          t,
          y,
          O.isString(b) ? b.trim() : b,
          m,
          f
        )) === !0 && h(y, m ? m.concat(b) : [b]);
      }), d.pop();
    }
  }
  if (!O.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function Y1(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Oc(e, t) {
  this._pairs = [], e && Ei(e, this, t);
}
const wh = Oc.prototype;
wh.append = function(t, n) {
  this._pairs.push([t, n]);
};
wh.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Y1);
  } : Y1;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function kL(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function xh(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || kL, o = n && n.serialize;
  let a;
  if (o ? a = o(t, n) : a = O.isURLSearchParams(t) ? t.toString() : new Oc(t, n).toString(r), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class ML {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    O.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const q1 = ML, Ch = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, _L = typeof URLSearchParams < "u" ? URLSearchParams : Oc, PL = typeof FormData < "u" ? FormData : null, OL = typeof Blob < "u" ? Blob : null, TL = {
  isBrowser: !0,
  classes: {
    URLSearchParams: _L,
    FormData: PL,
    Blob: OL
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Tc = typeof window < "u" && typeof document < "u", AL = ((e) => Tc && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), $L = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), RL = Tc && window.location.href || "http://localhost", DL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Tc,
  hasStandardBrowserEnv: AL,
  hasStandardBrowserWebWorkerEnv: $L,
  origin: RL
}, Symbol.toStringTag, { value: "Module" })), Nt = {
  ...DL,
  ...TL
};
function NL(e, t) {
  return Ei(e, new Nt.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, a) {
      return Nt.isNode && O.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function LL(e) {
  return O.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function jL(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let a;
  for (r = 0; r < o; r++)
    a = n[r], t[a] = e[a];
  return t;
}
function Sh(e) {
  function t(n, r, o, a) {
    let i = n[a++];
    if (i === "__proto__")
      return !0;
    const s = Number.isFinite(+i), l = a >= n.length;
    return i = !i && O.isArray(o) ? o.length : i, l ? (O.hasOwnProp(o, i) ? o[i] = [o[i], r] : o[i] = r, !s) : ((!o[i] || !O.isObject(o[i])) && (o[i] = []), t(n, r, o[i], a) && O.isArray(o[i]) && (o[i] = jL(o[i])), !s);
  }
  if (O.isFormData(e) && O.isFunction(e.entries)) {
    const n = {};
    return O.forEachEntry(e, (r, o) => {
      t(LL(r), o, n, 0);
    }), n;
  }
  return null;
}
function HL(e, t, n) {
  if (O.isString(e))
    try {
      return (t || JSON.parse)(e), O.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Ac = {
  transitional: Ch,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, a = O.isObject(t);
    if (a && O.isHTMLForm(t) && (t = new FormData(t)), O.isFormData(t))
      return o ? JSON.stringify(Sh(t)) : t;
    if (O.isArrayBuffer(t) || O.isBuffer(t) || O.isStream(t) || O.isFile(t) || O.isBlob(t) || O.isReadableStream(t))
      return t;
    if (O.isArrayBufferView(t))
      return t.buffer;
    if (O.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (a) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return NL(t, this.formSerializer).toString();
      if ((s = O.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Ei(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return a || o ? (n.setContentType("application/json", !1), HL(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Ac.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (O.isResponse(t) || O.isReadableStream(t))
      return t;
    if (t && O.isString(t) && (r && !this.responseType || o)) {
      const i = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? fe.from(s, fe.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Nt.classes.FormData,
    Blob: Nt.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
O.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ac.headers[e] = {};
});
const $c = Ac, FL = O.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), BL = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), n = i.substring(0, o).trim().toLowerCase(), r = i.substring(o + 1).trim(), !(!n || t[n] && FL[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, U1 = Symbol("internals");
function go(e) {
  return e && String(e).trim().toLowerCase();
}
function Oa(e) {
  return e === !1 || e == null ? e : O.isArray(e) ? e.map(Oa) : String(e);
}
function zL(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const IL = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function bs(e, t, n, r, o) {
  if (O.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!O.isString(t)) {
    if (O.isString(r))
      return t.indexOf(r) !== -1;
    if (O.isRegExp(r))
      return r.test(t);
  }
}
function WL(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function VL(e, t) {
  const n = O.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, a, i) {
        return this[r].call(this, t, o, a, i);
      },
      configurable: !0
    });
  });
}
class ki {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function a(s, l, c) {
      const u = go(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = O.findKey(o, u);
      (!d || o[d] === void 0 || c === !0 || c === void 0 && o[d] !== !1) && (o[d || l] = Oa(s));
    }
    const i = (s, l) => O.forEach(s, (c, u) => a(c, u, l));
    if (O.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (O.isString(t) && (t = t.trim()) && !IL(t))
      i(BL(t), n);
    else if (O.isHeaders(t))
      for (const [s, l] of t.entries())
        a(l, s, r);
    else
      t != null && a(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = go(t), t) {
      const r = O.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return zL(o);
        if (O.isFunction(n))
          return n.call(this, o, r);
        if (O.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = go(t), t) {
      const r = O.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || bs(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function a(i) {
      if (i = go(i), i) {
        const s = O.findKey(r, i);
        s && (!n || bs(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return O.isArray(t) ? t.forEach(a) : a(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const a = n[r];
      (!t || bs(this, this[a], a, t, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return O.forEach(this, (o, a) => {
      const i = O.findKey(r, a);
      if (i) {
        n[i] = Oa(o), delete n[a];
        return;
      }
      const s = t ? WL(a) : String(a).trim();
      s !== a && delete n[a], n[s] = Oa(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return O.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && O.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[U1] = this[U1] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(i) {
      const s = go(i);
      r[s] || (VL(o, i), r[s] = !0);
    }
    return O.isArray(t) ? t.forEach(a) : a(t), this;
  }
}
ki.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
O.reduceDescriptors(ki.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
O.freezeMethods(ki);
const Lt = ki;
function ys(e, t) {
  const n = this || $c, r = t || n, o = Lt.from(r.headers);
  let a = r.data;
  return O.forEach(e, function(s) {
    a = s.call(n, a, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), a;
}
function Eh(e) {
  return !!(e && e.__CANCEL__);
}
function Zr(e, t, n) {
  fe.call(this, e ?? "canceled", fe.ERR_CANCELED, t, n), this.name = "CanceledError";
}
O.inherits(Zr, fe, {
  __CANCEL__: !0
});
function kh(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new fe(
    "Request failed with status code " + n.status,
    [fe.ERR_BAD_REQUEST, fe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function YL(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function qL(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, a = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[a];
    i || (i = c), n[o] = l, r[o] = c;
    let d = a, f = 0;
    for (; d !== o; )
      f += n[d++], d = d % e;
    if (o = (o + 1) % e, o === a && (a = (a + 1) % e), c - i < t)
      return;
    const h = u && c - u;
    return h ? Math.round(f * 1e3 / h) : void 0;
  };
}
function UL(e, t) {
  let n = 0;
  const r = 1e3 / t;
  let o = null;
  return function() {
    const i = this === !0, s = Date.now();
    if (i || s - n > r)
      return o && (clearTimeout(o), o = null), n = s, e.apply(null, arguments);
    o || (o = setTimeout(() => (o = null, n = Date.now(), e.apply(null, arguments)), r - (s - n)));
  };
}
const Ga = (e, t, n = 3) => {
  let r = 0;
  const o = qL(50, 250);
  return UL((a) => {
    const i = a.loaded, s = a.lengthComputable ? a.total : void 0, l = i - r, c = o(l), u = i <= s;
    r = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: a,
      lengthComputable: s != null
    };
    d[t ? "download" : "upload"] = !0, e(d);
  }, n);
}, GL = Nt.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function o(a) {
      let i = a;
      return t && (n.setAttribute("href", i), i = n.href), n.setAttribute("href", i), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(i) {
      const s = O.isString(i) ? o(i) : i;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
), XL = Nt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, a) {
      const i = [e + "=" + encodeURIComponent(t)];
      O.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), O.isString(r) && i.push("path=" + r), O.isString(o) && i.push("domain=" + o), a === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ZL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function KL(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Mh(e, t) {
  return e && !ZL(t) ? KL(e, t) : t;
}
const G1 = (e) => e instanceof Lt ? { ...e } : e;
function Vn(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return O.isPlainObject(c) && O.isPlainObject(u) ? O.merge.call({ caseless: d }, c, u) : O.isPlainObject(u) ? O.merge({}, u) : O.isArray(u) ? u.slice() : u;
  }
  function o(c, u, d) {
    if (O.isUndefined(u)) {
      if (!O.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function a(c, u) {
    if (!O.isUndefined(u))
      return r(void 0, u);
  }
  function i(c, u) {
    if (O.isUndefined(u)) {
      if (!O.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u) => o(G1(c), G1(u), !0)
  };
  return O.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || o, f = d(e[u], t[u], u);
    O.isUndefined(f) && d !== s || (n[u] = f);
  }), n;
}
const _h = (e) => {
  const t = Vn({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: a, headers: i, auth: s } = t;
  t.headers = i = Lt.from(i), t.url = xh(Mh(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (O.isFormData(n)) {
    if (Nt.hasStandardBrowserEnv || Nt.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Nt.hasStandardBrowserEnv && (r && O.isFunction(r) && (r = r(t)), r || r !== !1 && GL(t.url))) {
    const c = o && a && XL.read(a);
    c && i.set(o, c);
  }
  return t;
}, QL = typeof XMLHttpRequest < "u", JL = QL && function(e) {
  return new Promise(function(n, r) {
    const o = _h(e);
    let a = o.data;
    const i = Lt.from(o.headers).normalize();
    let { responseType: s } = o, l;
    function c() {
      o.cancelToken && o.cancelToken.unsubscribe(l), o.signal && o.signal.removeEventListener("abort", l);
    }
    let u = new XMLHttpRequest();
    u.open(o.method.toUpperCase(), o.url, !0), u.timeout = o.timeout;
    function d() {
      if (!u)
        return;
      const h = Lt.from(
        "getAllResponseHeaders" in u && u.getAllResponseHeaders()
      ), m = {
        data: !s || s === "text" || s === "json" ? u.responseText : u.response,
        status: u.status,
        statusText: u.statusText,
        headers: h,
        config: e,
        request: u
      };
      kh(function(y) {
        n(y), c();
      }, function(y) {
        r(y), c();
      }, m), u = null;
    }
    "onloadend" in u ? u.onloadend = d : u.onreadystatechange = function() {
      !u || u.readyState !== 4 || u.status === 0 && !(u.responseURL && u.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, u.onabort = function() {
      u && (r(new fe("Request aborted", fe.ECONNABORTED, o, u)), u = null);
    }, u.onerror = function() {
      r(new fe("Network Error", fe.ERR_NETWORK, o, u)), u = null;
    }, u.ontimeout = function() {
      let p = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const m = o.transitional || Ch;
      o.timeoutErrorMessage && (p = o.timeoutErrorMessage), r(new fe(
        p,
        m.clarifyTimeoutError ? fe.ETIMEDOUT : fe.ECONNABORTED,
        o,
        u
      )), u = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in u && O.forEach(i.toJSON(), function(p, m) {
      u.setRequestHeader(m, p);
    }), O.isUndefined(o.withCredentials) || (u.withCredentials = !!o.withCredentials), s && s !== "json" && (u.responseType = o.responseType), typeof o.onDownloadProgress == "function" && u.addEventListener("progress", Ga(o.onDownloadProgress, !0)), typeof o.onUploadProgress == "function" && u.upload && u.upload.addEventListener("progress", Ga(o.onUploadProgress)), (o.cancelToken || o.signal) && (l = (h) => {
      u && (r(!h || h.type ? new Zr(null, e, u) : h), u.abort(), u = null);
    }, o.cancelToken && o.cancelToken.subscribe(l), o.signal && (o.signal.aborted ? l() : o.signal.addEventListener("abort", l)));
    const f = YL(o.url);
    if (f && Nt.protocols.indexOf(f) === -1) {
      r(new fe("Unsupported protocol " + f + ":", fe.ERR_BAD_REQUEST, e));
      return;
    }
    u.send(a || null);
  });
}, ej = (e, t) => {
  let n = new AbortController(), r;
  const o = function(l) {
    if (!r) {
      r = !0, i();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof fe ? c : new Zr(c instanceof Error ? c.message : c));
    }
  };
  let a = t && setTimeout(() => {
    o(new fe(`timeout ${t} of ms exceeded`, fe.ETIMEDOUT));
  }, t);
  const i = () => {
    e && (a && clearTimeout(a), a = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", o) : l.unsubscribe(o));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", o));
  const { signal: s } = n;
  return s.unsubscribe = i, [s, () => {
    a && clearTimeout(a), a = null;
  }];
}, tj = ej, nj = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, rj = async function* (e, t, n) {
  for await (const r of e)
    yield* nj(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, X1 = (e, t, n, r, o) => {
  const a = rj(e, t, o);
  let i = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(s) {
      const { done: l, value: c } = await a.next();
      if (l) {
        s.close(), r();
        return;
      }
      let u = c.byteLength;
      n && n(i += u), s.enqueue(new Uint8Array(c));
    },
    cancel(s) {
      return r(s), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Z1 = (e, t) => {
  const n = e != null;
  return (r) => setTimeout(() => t({
    lengthComputable: n,
    total: e,
    loaded: r
  }));
}, Mi = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Ph = Mi && typeof ReadableStream == "function", Qs = Mi && (typeof TextEncoder == "function" ? ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), oj = Ph && (() => {
  let e = !1;
  const t = new Request(Nt.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
})(), K1 = 64 * 1024, Js = Ph && !!(() => {
  try {
    return O.isReadableStream(new Response("").body);
  } catch {
  }
})(), Xa = {
  stream: Js && ((e) => e.body)
};
Mi && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Xa[t] && (Xa[t] = O.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new fe(`Response type '${t}' is not supported`, fe.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const aj = async (e) => {
  if (e == null)
    return 0;
  if (O.isBlob(e))
    return e.size;
  if (O.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (O.isArrayBufferView(e))
    return e.byteLength;
  if (O.isURLSearchParams(e) && (e = e + ""), O.isString(e))
    return (await Qs(e)).byteLength;
}, ij = async (e, t) => {
  const n = O.toFiniteNumber(e.getContentLength());
  return n ?? aj(t);
}, sj = Mi && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: a,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = _h(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, p] = o || a || i ? tj([o, a], i) : [], m, g;
  const y = () => {
    !m && setTimeout(() => {
      h && h.unsubscribe();
    }), m = !0;
  };
  let b;
  try {
    if (l && oj && n !== "get" && n !== "head" && (b = await ij(u, r)) !== 0) {
      let M = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), _;
      O.isFormData(r) && (_ = M.headers.get("content-type")) && u.setContentType(_), M.body && (r = X1(M.body, K1, Z1(
        b,
        Ga(l)
      ), null, Qs));
    }
    O.isString(d) || (d = d ? "cors" : "omit"), g = new Request(t, {
      ...f,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      withCredentials: d
    });
    let w = await fetch(g);
    const S = Js && (c === "stream" || c === "response");
    if (Js && (s || S)) {
      const M = {};
      ["status", "statusText", "headers"].forEach((R) => {
        M[R] = w[R];
      });
      const _ = O.toFiniteNumber(w.headers.get("content-length"));
      w = new Response(
        X1(w.body, K1, s && Z1(
          _,
          Ga(s, !0)
        ), S && y, Qs),
        M
      );
    }
    c = c || "text";
    let x = await Xa[O.findKey(Xa, c) || "text"](w, e);
    return !S && y(), p && p(), await new Promise((M, _) => {
      kh(M, _, {
        data: x,
        headers: Lt.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: g
      });
    });
  } catch (w) {
    throw y(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new fe("Network Error", fe.ERR_NETWORK, e, g),
      {
        cause: w.cause || w
      }
    ) : fe.from(w, w && w.code, e, g);
  }
}), el = {
  http: CL,
  xhr: JL,
  fetch: sj
};
O.forEach(el, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Q1 = (e) => `- ${e}`, lj = (e) => O.isFunction(e) || e === null || e === !1, Oh = {
  getAdapter: (e) => {
    e = O.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let a = 0; a < t; a++) {
      n = e[a];
      let i;
      if (r = n, !lj(n) && (r = el[(i = String(n)).toLowerCase()], r === void 0))
        throw new fe(`Unknown adapter '${i}'`);
      if (r)
        break;
      o[i || "#" + a] = r;
    }
    if (!r) {
      const a = Object.entries(o).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? a.length > 1 ? `since :
` + a.map(Q1).join(`
`) : " " + Q1(a[0]) : "as no adapter specified";
      throw new fe(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: el
};
function ws(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Zr(null, e);
}
function J1(e) {
  return ws(e), e.headers = Lt.from(e.headers), e.data = ys.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Oh.getAdapter(e.adapter || $c.adapter)(e).then(function(r) {
    return ws(e), r.data = ys.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Lt.from(r.headers), r;
  }, function(r) {
    return Eh(r) || (ws(e), r && r.response && (r.response.data = ys.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Lt.from(r.response.headers))), Promise.reject(r);
  });
}
const Th = "1.7.2", Rc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Rc[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ed = {};
Rc.transitional = function(t, n, r) {
  function o(a, i) {
    return "[Axios v" + Th + "] Transitional option '" + a + "'" + i + (r ? ". " + r : "");
  }
  return (a, i, s) => {
    if (t === !1)
      throw new fe(
        o(i, " has been removed" + (n ? " in " + n : "")),
        fe.ERR_DEPRECATED
      );
    return n && !ed[i] && (ed[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(a, i, s) : !0;
  };
};
function cj(e, t, n) {
  if (typeof e != "object")
    throw new fe("options must be an object", fe.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const a = r[o], i = t[a];
    if (i) {
      const s = e[a], l = s === void 0 || i(s, a, e);
      if (l !== !0)
        throw new fe("option " + a + " must be " + l, fe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new fe("Unknown option " + a, fe.ERR_BAD_OPTION);
  }
}
const tl = {
  assertOptions: cj,
  validators: Rc
}, gn = tl.validators;
class Za {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new q1(),
      response: new q1()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? a && !String(r.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + a) : r.stack = a;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Vn(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: a } = n;
    r !== void 0 && tl.assertOptions(r, {
      silentJSONParsing: gn.transitional(gn.boolean),
      forcedJSONParsing: gn.transitional(gn.boolean),
      clarifyTimeoutError: gn.transitional(gn.boolean)
    }, !1), o != null && (O.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : tl.assertOptions(o, {
      encode: gn.function,
      serialize: gn.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = a && O.merge(
      a.common,
      a[n.method]
    );
    a && O.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete a[p];
      }
    ), n.headers = Lt.concat(i, a);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (l = l && m.synchronous, s.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let u, d = 0, f;
    if (!l) {
      const p = [J1.bind(this), void 0];
      for (p.unshift.apply(p, s), p.push.apply(p, c), f = p.length, u = Promise.resolve(n); d < f; )
        u = u.then(p[d++], p[d++]);
      return u;
    }
    f = s.length;
    let h = n;
    for (d = 0; d < f; ) {
      const p = s[d++], m = s[d++];
      try {
        h = p(h);
      } catch (g) {
        m.call(this, g);
        break;
      }
    }
    try {
      u = J1.call(this, h);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, f = c.length; d < f; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Vn(this.defaults, t);
    const n = Mh(t.baseURL, t.url);
    return xh(n, t.params, t.paramsSerializer);
  }
}
O.forEach(["delete", "get", "head", "options"], function(t) {
  Za.prototype[t] = function(n, r) {
    return this.request(Vn(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
O.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(a, i, s) {
      return this.request(Vn(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  Za.prototype[t] = n(), Za.prototype[t + "Form"] = n(!0);
});
const Ta = Za;
class Dc {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const i = new Promise((s) => {
        r.subscribe(s), a = s;
      }).then(o);
      return i.cancel = function() {
        r.unsubscribe(a);
      }, i;
    }, t(function(a, i, s) {
      r.reason || (r.reason = new Zr(a, i, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Dc(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const uj = Dc;
function dj(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function fj(e) {
  return O.isObject(e) && e.isAxiosError === !0;
}
const nl = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(nl).forEach(([e, t]) => {
  nl[t] = e;
});
const hj = nl;
function Ah(e) {
  const t = new Ta(e), n = ch(Ta.prototype.request, t);
  return O.extend(n, Ta.prototype, t, { allOwnKeys: !0 }), O.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return Ah(Vn(e, o));
  }, n;
}
const Je = Ah($c);
Je.Axios = Ta;
Je.CanceledError = Zr;
Je.CancelToken = uj;
Je.isCancel = Eh;
Je.VERSION = Th;
Je.toFormData = Ei;
Je.AxiosError = fe;
Je.Cancel = Je.CanceledError;
Je.all = function(t) {
  return Promise.all(t);
};
Je.spread = dj;
Je.isAxiosError = fj;
Je.mergeConfig = Vn;
Je.AxiosHeaders = Lt;
Je.formToJSON = (e) => Sh(O.isHTMLForm(e) ? new FormData(e) : e);
Je.getAdapter = Oh.getAdapter;
Je.HttpStatusCode = hj;
Je.default = Je;
const pj = Je, mj = (e, t) => {
  const n = new AbortController(), r = pj.get(e, {
    onDownloadProgress: (o) => t(o.progress ?? 0),
    responseType: "blob",
    signal: n.signal
  }).then((o) => new Blob([o.data], { type: o.headers["content-type"] }));
  return { controller: n, promise: r };
}, gj = (e, t) => {
  const n = document.createElement("a");
  n.href = window.URL.createObjectURL(e), n.setAttribute("download", t ?? ""), n.click();
}, $h = ({ children: e, className: t }) => {
  const n = jt(!1);
  return nt(() => (n.current || (document.body.style.overflow = "hidden", n.current = !0), () => {
    document.body.style.overflow = "auto";
  }), []), /* @__PURE__ */ C.jsx(
    "div",
    {
      className: z(
        "fixed left-0 top-0 z-50 h-full w-full flex items-center justify-center",
        " bg-black bg-opacity-30"
      ),
      children: /* @__PURE__ */ C.jsx(
        "div",
        {
          className: z(
            "justify-between flex flex-col shadow-lg z-50 border-1 border-neutral-400 rounded-md border-solid bg-white",
            t || "min-h-[128px] w-[650px] p-6 gap-6"
          ),
          children: e
        }
      )
    }
  );
};
function Kr(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = E.createContext(i), l = n.length;
    n = [...n, i];
    function c(d) {
      const { scope: f, children: h, ...p } = d, m = (f == null ? void 0 : f[e][l]) || s, g = E.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ C.jsx(m.Provider, { value: g, children: h });
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[e][l]) || s, p = E.useContext(h);
      if (p)
        return p;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return c.displayName = a + "Provider", [c, u];
  }
  const o = () => {
    const a = n.map((i) => E.createContext(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return E.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, vj(o, ...t)];
}
function vj(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(a)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return E.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function bj(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Rh(...e) {
  return (t) => e.forEach((n) => bj(n, t));
}
function ut(...e) {
  return E.useCallback(Rh(...e), e);
}
var Ka = E.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = E.Children.toArray(n), a = o.find(yj);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? E.Children.count(i) > 1 ? E.Children.only(null) : E.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ C.jsx(rl, { ...r, ref: t, children: E.isValidElement(i) ? E.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ C.jsx(rl, { ...r, ref: t, children: n });
});
Ka.displayName = "Slot";
var rl = E.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (E.isValidElement(n)) {
    const o = xj(n);
    return E.cloneElement(n, {
      ...wj(r, n.props),
      // @ts-ignore
      ref: t ? Rh(t, o) : o
    });
  }
  return E.Children.count(n) > 1 ? E.Children.only(null) : null;
});
rl.displayName = "SlotClone";
var Dh = ({ children: e }) => /* @__PURE__ */ C.jsx(C.Fragment, { children: e });
function yj(e) {
  return E.isValidElement(e) && e.type === Dh;
}
function wj(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function xj(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Cj = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Xe = Cj.reduce((e, t) => {
  const n = E.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? Ka : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ C.jsx(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Sj(e, t) {
  e && $d.flushSync(() => e.dispatchEvent(t));
}
var Nc = "Progress", Lc = 100, [Ej, lV] = Kr(Nc), [kj, Mj] = Ej(Nc), Nh = E.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: o,
      getValueLabel: a = _j,
      ...i
    } = e;
    (o || o === 0) && !td(o) && console.error(Pj(`${o}`, "Progress"));
    const s = td(o) ? o : Lc;
    r !== null && !nd(r, s) && console.error(Oj(`${r}`, "Progress"));
    const l = nd(r, s) ? r : null, c = Qa(l) ? a(l, s) : void 0;
    return /* @__PURE__ */ C.jsx(kj, { scope: n, value: l, max: s, children: /* @__PURE__ */ C.jsx(
      Xe.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": Qa(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": Hh(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
Nh.displayName = Nc;
var Lh = "ProgressIndicator", jh = E.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, o = Mj(Lh, n);
    return /* @__PURE__ */ C.jsx(
      Xe.div,
      {
        "data-state": Hh(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: t
      }
    );
  }
);
jh.displayName = Lh;
function _j(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Hh(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Qa(e) {
  return typeof e == "number";
}
function td(e) {
  return Qa(e) && !isNaN(e) && e > 0;
}
function nd(e, t) {
  return Qa(e) && !isNaN(e) && e <= t && e >= 0;
}
function Pj(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Lc}\`.`;
}
function Oj(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Lc} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var Tj = Nh, Aj = jh;
const Fh = qt(
  ({ animated: e, className: t, progress: n, v1: r, ...o }, a) => /* @__PURE__ */ C.jsx(
    Tj,
    {
      className: z(
        "relative overflow-hidden h-2 rounded-full b-1 b-neutral-300 b-solid bg-neutral-100",
        t
      ),
      ref: a,
      ...o,
      children: /* @__PURE__ */ C.jsx(
        Aj,
        {
          className: z(
            e && "animate-pulse",
            r ? "bg-skandI-400" : "bg-primary-300",
            "h-full w-full flex-1 transition-all"
          ),
          style: { transform: `translateX(-${100 - Rt(0, 1, n) * 100}%)` }
        }
      )
    }
  )
);
Fh.displayName = "Progress";
function Bh(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function He(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Jn(e) {
  const t = E.useRef(e);
  return E.useEffect(() => {
    t.current = e;
  }), E.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function aa({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = $j({ defaultProp: t, onChange: n }), a = e !== void 0, i = a ? e : r, s = Jn(n), l = E.useCallback(
    (c) => {
      if (a) {
        const d = typeof c == "function" ? c(e) : c;
        d !== e && s(d);
      } else
        o(c);
    },
    [a, e, o, s]
  );
  return [i, l];
}
function $j({
  defaultProp: e,
  onChange: t
}) {
  const n = E.useState(e), [r] = n, o = E.useRef(r), a = Jn(t);
  return E.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), n;
}
var Rj = E.createContext(void 0);
function jc(e) {
  const t = E.useContext(Rj);
  return e || t || "ltr";
}
function zh(e) {
  const t = E.useRef({ value: e, previous: e });
  return E.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Ar = globalThis != null && globalThis.document ? E.useLayoutEffect : () => {
};
function Hc(e) {
  const [t, n] = E.useState(void 0);
  return Ar(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function Ih(e) {
  const t = e + "CollectionProvider", [n, r] = Kr(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (h) => {
    const { scope: p, children: m } = h, g = v.useRef(null), y = v.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ C.jsx(o, { scope: p, itemMap: y, collectionRef: g, children: m });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = v.forwardRef(
    (h, p) => {
      const { scope: m, children: g } = h, y = a(s, m), b = ut(p, y.collectionRef);
      return /* @__PURE__ */ C.jsx(Ka, { ref: b, children: g });
    }
  );
  l.displayName = s;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = v.forwardRef(
    (h, p) => {
      const { scope: m, children: g, ...y } = h, b = v.useRef(null), w = ut(p, b), S = a(c, m);
      return v.useEffect(() => (S.itemMap.set(b, { ref: b, ...y }), () => void S.itemMap.delete(b))), /* @__PURE__ */ C.jsx(Ka, { [u]: "", ref: w, children: g });
    }
  );
  d.displayName = c;
  function f(h) {
    const p = a(e + "CollectionConsumer", h);
    return v.useCallback(() => {
      const g = p.collectionRef.current;
      if (!g)
        return [];
      const y = Array.from(g.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (S, x) => y.indexOf(S.ref.current) - y.indexOf(x.ref.current)
      );
    }, [p.collectionRef, p.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
var Wh = ["PageUp", "PageDown"], Vh = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Yh = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Qr = "Slider", [ol, Dj, Nj] = Ih(Qr), [qh, cV] = Kr(Qr, [
  Nj
]), [Lj, _i] = qh(Qr), Uh = E.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: o = 100,
      step: a = 1,
      orientation: i = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: c = [r],
      value: u,
      onValueChange: d = () => {
      },
      onValueCommit: f = () => {
      },
      inverted: h = !1,
      ...p
    } = e, m = E.useRef(/* @__PURE__ */ new Set()), g = E.useRef(0), b = i === "horizontal" ? jj : Hj, [w = [], S] = aa({
      prop: u,
      defaultProp: c,
      onChange: (U) => {
        var T;
        (T = [...m.current][g.current]) == null || T.focus(), d(U);
      }
    }), x = E.useRef(w);
    function M(U) {
      const F = Wj(w, U);
      B(U, F);
    }
    function _(U) {
      B(U, g.current);
    }
    function R() {
      const U = x.current[g.current];
      w[g.current] !== U && f(w);
    }
    function B(U, F, { commit: T } = { commit: !1 }) {
      const j = Uj(a), A = Gj(Math.round((U - r) / a) * a + r, j), G = Bh(A, [r, o]);
      S((N = []) => {
        const te = zj(N, G, F);
        if (qj(te, l * a)) {
          g.current = te.indexOf(G);
          const oe = String(te) !== String(N);
          return oe && T && f(te), oe ? te : N;
        } else
          return N;
      });
    }
    return /* @__PURE__ */ C.jsx(
      Lj,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: o,
        valueIndexToChangeRef: g,
        thumbs: m.current,
        values: w,
        orientation: i,
        children: /* @__PURE__ */ C.jsx(ol.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ C.jsx(ol.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ C.jsx(
          b,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...p,
            ref: t,
            onPointerDown: He(p.onPointerDown, () => {
              s || (x.current = w);
            }),
            min: r,
            max: o,
            inverted: h,
            onSlideStart: s ? void 0 : M,
            onSlideMove: s ? void 0 : _,
            onSlideEnd: s ? void 0 : R,
            onHomeKeyDown: () => !s && B(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && B(o, w.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: U, direction: F }) => {
              if (!s) {
                const A = Wh.includes(U.key) || U.shiftKey && Vh.includes(U.key) ? 10 : 1, G = g.current, N = w[G], te = a * A * F;
                B(N + te, G, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
Uh.displayName = Qr;
var [Gh, Xh] = qh(Qr, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), jj = E.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: o,
      inverted: a,
      onSlideStart: i,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: c,
      ...u
    } = e, [d, f] = E.useState(null), h = ut(t, (w) => f(w)), p = E.useRef(), m = jc(o), g = m === "ltr", y = g && !a || !g && a;
    function b(w) {
      const S = p.current || d.getBoundingClientRect(), x = [0, S.width], _ = Fc(x, y ? [n, r] : [r, n]);
      return p.current = S, _(w - S.left);
    }
    return /* @__PURE__ */ C.jsx(
      Gh,
      {
        scope: e.__scopeSlider,
        startEdge: y ? "left" : "right",
        endEdge: y ? "right" : "left",
        direction: y ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ C.jsx(
          Zh,
          {
            dir: m,
            "data-orientation": "horizontal",
            ...u,
            ref: h,
            style: {
              ...u.style,
              ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (w) => {
              const S = b(w.clientX);
              i == null || i(S);
            },
            onSlideMove: (w) => {
              const S = b(w.clientX);
              s == null || s(S);
            },
            onSlideEnd: () => {
              p.current = void 0, l == null || l();
            },
            onStepKeyDown: (w) => {
              const x = Yh[y ? "from-left" : "from-right"].includes(w.key);
              c == null || c({ event: w, direction: x ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Hj = E.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: o,
      onSlideStart: a,
      onSlideMove: i,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...c
    } = e, u = E.useRef(null), d = ut(t, u), f = E.useRef(), h = !o;
    function p(m) {
      const g = f.current || u.current.getBoundingClientRect(), y = [0, g.height], w = Fc(y, h ? [r, n] : [n, r]);
      return f.current = g, w(m - g.top);
    }
    return /* @__PURE__ */ C.jsx(
      Gh,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ C.jsx(
          Zh,
          {
            "data-orientation": "vertical",
            ...c,
            ref: d,
            style: {
              ...c.style,
              ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (m) => {
              const g = p(m.clientY);
              a == null || a(g);
            },
            onSlideMove: (m) => {
              const g = p(m.clientY);
              i == null || i(g);
            },
            onSlideEnd: () => {
              f.current = void 0, s == null || s();
            },
            onStepKeyDown: (m) => {
              const y = Yh[h ? "from-bottom" : "from-top"].includes(m.key);
              l == null || l({ event: m, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Zh = E.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: o,
      onSlideEnd: a,
      onHomeKeyDown: i,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...c
    } = e, u = _i(Qr, n);
    return /* @__PURE__ */ C.jsx(
      Xe.span,
      {
        ...c,
        ref: t,
        onKeyDown: He(e.onKeyDown, (d) => {
          d.key === "Home" ? (i(d), d.preventDefault()) : d.key === "End" ? (s(d), d.preventDefault()) : Wh.concat(Vh).includes(d.key) && (l(d), d.preventDefault());
        }),
        onPointerDown: He(e.onPointerDown, (d) => {
          const f = d.target;
          f.setPointerCapture(d.pointerId), d.preventDefault(), u.thumbs.has(f) ? f.focus() : r(d);
        }),
        onPointerMove: He(e.onPointerMove, (d) => {
          d.target.hasPointerCapture(d.pointerId) && o(d);
        }),
        onPointerUp: He(e.onPointerUp, (d) => {
          const f = d.target;
          f.hasPointerCapture(d.pointerId) && (f.releasePointerCapture(d.pointerId), a(d));
        })
      }
    );
  }
), Kh = "SliderTrack", Qh = E.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = _i(Kh, n);
    return /* @__PURE__ */ C.jsx(
      Xe.span,
      {
        "data-disabled": o.disabled ? "" : void 0,
        "data-orientation": o.orientation,
        ...r,
        ref: t
      }
    );
  }
);
Qh.displayName = Kh;
var al = "SliderRange", Jh = E.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = _i(al, n), a = Xh(al, n), i = E.useRef(null), s = ut(t, i), l = o.values.length, c = o.values.map(
      (f) => tp(f, o.min, o.max)
    ), u = l > 1 ? Math.min(...c) : 0, d = 100 - Math.max(...c);
    return /* @__PURE__ */ C.jsx(
      Xe.span,
      {
        "data-orientation": o.orientation,
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...e.style,
          [a.startEdge]: u + "%",
          [a.endEdge]: d + "%"
        }
      }
    );
  }
);
Jh.displayName = al;
var il = "SliderThumb", ep = E.forwardRef(
  (e, t) => {
    const n = Dj(e.__scopeSlider), [r, o] = E.useState(null), a = ut(t, (s) => o(s)), i = E.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ C.jsx(Fj, { ...e, ref: a, index: i });
  }
), Fj = E.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: o, ...a } = e, i = _i(il, n), s = Xh(il, n), [l, c] = E.useState(null), u = ut(t, (b) => c(b)), d = l ? !!l.closest("form") : !0, f = Hc(l), h = i.values[r], p = h === void 0 ? 0 : tp(h, i.min, i.max), m = Ij(r, i.values.length), g = f == null ? void 0 : f[s.size], y = g ? Vj(g, p, s.direction) : 0;
    return E.useEffect(() => {
      if (l)
        return i.thumbs.add(l), () => {
          i.thumbs.delete(l);
        };
    }, [l, i.thumbs]), /* @__PURE__ */ C.jsxs(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${p}% + ${y}px)`
        },
        children: [
          /* @__PURE__ */ C.jsx(ol.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ C.jsx(
            Xe.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || m,
              "aria-valuemin": i.min,
              "aria-valuenow": h,
              "aria-valuemax": i.max,
              "aria-orientation": i.orientation,
              "data-orientation": i.orientation,
              "data-disabled": i.disabled ? "" : void 0,
              tabIndex: i.disabled ? void 0 : 0,
              ...a,
              ref: u,
              style: h === void 0 ? { display: "none" } : e.style,
              onFocus: He(e.onFocus, () => {
                i.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          d && /* @__PURE__ */ C.jsx(
            Bj,
            {
              name: o ?? (i.name ? i.name + (i.values.length > 1 ? "[]" : "") : void 0),
              value: h
            },
            r
          )
        ]
      }
    );
  }
);
ep.displayName = il;
var Bj = (e) => {
  const { value: t, ...n } = e, r = E.useRef(null), o = zh(t);
  return E.useEffect(() => {
    const a = r.current, i = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(i, "value").set;
    if (o !== t && l) {
      const c = new Event("input", { bubbles: !0 });
      l.call(a, t), a.dispatchEvent(c);
    }
  }, [o, t]), /* @__PURE__ */ C.jsx("input", { style: { display: "none" }, ...n, ref: r, defaultValue: t });
};
function zj(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((o, a) => o - a);
}
function tp(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return Bh(a, [0, 100]);
}
function Ij(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function Wj(e, t) {
  if (e.length === 1)
    return 0;
  const n = e.map((o) => Math.abs(o - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function Vj(e, t, n) {
  const r = e / 2, a = Fc([0, 50], [0, r]);
  return (r - a(t) * n) * n;
}
function Yj(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function qj(e, t) {
  if (t > 0) {
    const n = Yj(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function Fc(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Uj(e) {
  return (String(e).split(".")[1] || "").length;
}
function Gj(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var Xj = Uh, Zj = Qh, Kj = Jh, Qj = ep;
const np = E.forwardRef(
  ({
    className: e,
    disabled: t = !1,
    max: n = 100,
    min: r = 0,
    value: o = [0],
    onValueChange: a,
    step: i = 1,
    onPointerDown: s,
    ...l
  }, c) => /* @__PURE__ */ C.jsxs(
    Xj,
    {
      className: z(
        "relative flex w-full touch-none select-none items-center",
        e,
        t && "opacity-50 cursor-not-allowed"
      ),
      disabled: t,
      max: n,
      min: r,
      onPointerDown: s,
      onValueChange: a,
      ref: c,
      step: i,
      value: o,
      ...l,
      children: [
        /* @__PURE__ */ C.jsx(Zj, { className: "relative h-6px w-full grow overflow-hidden border border-neutral-400 rounded-full border-solid bg-neutral-100", children: /* @__PURE__ */ C.jsx(Kj, { className: "absolute h-full bg-primary-300" }) }),
        /* @__PURE__ */ C.jsx(
          Qj,
          {
            className: z(
              "focus-visible:ring-ring block border border-neutral-400 rounded-full border-solid bg-neutral-100 ring-offset-primary-300 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
              "h-3.4 w-3.4",
              t && "pointer-events-none"
            )
          }
        )
      ]
    }
  )
);
np.displayName = "Slider";
var Pt = function(e, t) {
  return Number(e.toFixed(t));
}, Jj = function(e, t) {
  return typeof e == "number" ? e : t;
}, ze = function(e, t, n) {
  n && typeof n == "function" && n(e, t);
}, eH = function(e) {
  return -Math.cos(e * Math.PI) / 2 + 0.5;
}, tH = function(e) {
  return e;
}, nH = function(e) {
  return e * e;
}, rH = function(e) {
  return e * (2 - e);
}, oH = function(e) {
  return e < 0.5 ? 2 * e * e : -1 + (4 - 2 * e) * e;
}, aH = function(e) {
  return e * e * e;
}, iH = function(e) {
  return --e * e * e + 1;
}, sH = function(e) {
  return e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
}, lH = function(e) {
  return e * e * e * e;
}, cH = function(e) {
  return 1 - --e * e * e * e;
}, uH = function(e) {
  return e < 0.5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
}, dH = function(e) {
  return e * e * e * e * e;
}, fH = function(e) {
  return 1 + --e * e * e * e * e;
}, hH = function(e) {
  return e < 0.5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
}, rp = {
  easeOut: eH,
  linear: tH,
  easeInQuad: nH,
  easeOutQuad: rH,
  easeInOutQuad: oH,
  easeInCubic: aH,
  easeOutCubic: iH,
  easeInOutCubic: sH,
  easeInQuart: lH,
  easeOutQuart: cH,
  easeInOutQuart: uH,
  easeInQuint: dH,
  easeOutQuint: fH,
  easeInOutQuint: hH
}, op = function(e) {
  typeof e == "number" && cancelAnimationFrame(e);
}, It = function(e) {
  e.mounted && (op(e.animation), e.animate = !1, e.animation = null, e.velocity = null);
};
function ap(e, t, n, r) {
  if (e.mounted) {
    var o = (/* @__PURE__ */ new Date()).getTime(), a = 1;
    It(e), e.animation = function() {
      if (!e.mounted)
        return op(e.animation);
      var i = (/* @__PURE__ */ new Date()).getTime() - o, s = i / n, l = rp[t], c = l(s);
      i >= n ? (r(a), e.animation = null) : e.animation && (r(c), requestAnimationFrame(e.animation));
    }, requestAnimationFrame(e.animation);
  }
}
function pH(e) {
  var t = e.scale, n = e.positionX, r = e.positionY;
  return !(Number.isNaN(t) || Number.isNaN(n) || Number.isNaN(r));
}
function Tn(e, t, n, r) {
  var o = pH(t);
  if (!(!e.mounted || !o)) {
    var a = e.setTransformState, i = e.transformState, s = i.scale, l = i.positionX, c = i.positionY, u = t.scale - s, d = t.positionX - l, f = t.positionY - c;
    n === 0 ? a(t.scale, t.positionX, t.positionY) : ap(e, r, n, function(h) {
      var p = s + u * h, m = l + d * h, g = c + f * h;
      a(p, m, g);
    });
  }
}
function mH(e, t, n) {
  var r = e.offsetWidth, o = e.offsetHeight, a = t.offsetWidth, i = t.offsetHeight, s = a * n, l = i * n, c = r - s, u = o - l;
  return {
    wrapperWidth: r,
    wrapperHeight: o,
    newContentWidth: s,
    newDiffWidth: c,
    newContentHeight: l,
    newDiffHeight: u
  };
}
var gH = function(e, t, n, r, o, a, i) {
  var s = e > t ? n * (i ? 1 : 0.5) : 0, l = r > o ? a * (i ? 1 : 0.5) : 0, c = e - t - s, u = s, d = r - o - l, f = l;
  return { minPositionX: c, maxPositionX: u, minPositionY: d, maxPositionY: f };
}, Bc = function(e, t) {
  var n = e.wrapperComponent, r = e.contentComponent, o = e.setup.centerZoomedOut;
  if (!n || !r)
    throw new Error("Components are not mounted");
  var a = mH(n, r, t), i = a.wrapperWidth, s = a.wrapperHeight, l = a.newContentWidth, c = a.newDiffWidth, u = a.newContentHeight, d = a.newDiffHeight, f = gH(i, l, c, s, u, d, !!o);
  return f;
}, sl = function(e, t, n, r) {
  return r ? e < t ? Pt(t, 2) : e > n ? Pt(n, 2) : Pt(e, 2) : Pt(e, 2);
}, $r = function(e, t) {
  var n = Bc(e, t);
  return e.bounds = n, n;
};
function Pi(e, t, n, r, o, a, i) {
  var s = n.minPositionX, l = n.minPositionY, c = n.maxPositionX, u = n.maxPositionY, d = 0, f = 0;
  i && (d = o, f = a);
  var h = sl(e, s - d, c + d, r), p = sl(t, l - f, u + f, r);
  return { x: h, y: p };
}
function Oi(e, t, n, r, o, a) {
  var i = e.transformState, s = i.scale, l = i.positionX, c = i.positionY, u = r - s;
  if (typeof t != "number" || typeof n != "number")
    return console.error("Mouse X and Y position were not provided!"), { x: l, y: c };
  var d = l - t * u, f = c - n * u, h = Pi(d, f, o, a, 0, 0, null);
  return h;
}
function ia(e, t, n, r, o) {
  var a = o ? r : 0, i = t - a;
  return !Number.isNaN(n) && e >= n ? n : !Number.isNaN(t) && e <= i ? i : e;
}
var rd = function(e, t) {
  var n = e.setup.panning.excluded, r = e.isInitialized, o = e.wrapperComponent, a = t.target, i = "shadowRoot" in a && "composedPath" in t, s = i ? t.composedPath().some(function(u) {
    return u instanceof Element ? o == null ? void 0 : o.contains(u) : !1;
  }) : o == null ? void 0 : o.contains(a), l = r && a && s;
  if (!l)
    return !1;
  var c = Ti(a, n);
  return !c;
}, od = function(e) {
  var t = e.isInitialized, n = e.isPanning, r = e.setup, o = r.panning.disabled, a = t && n && !o;
  return !!a;
}, vH = function(e, t) {
  var n = e.transformState, r = n.positionX, o = n.positionY;
  e.isPanning = !0;
  var a = t.clientX, i = t.clientY;
  e.startCoords = { x: a - r, y: i - o };
}, bH = function(e, t) {
  var n = t.touches, r = e.transformState, o = r.positionX, a = r.positionY;
  e.isPanning = !0;
  var i = n.length === 1;
  if (i) {
    var s = n[0].clientX, l = n[0].clientY;
    e.startCoords = { x: s - o, y: l - a };
  }
};
function yH(e) {
  var t = e.transformState, n = t.positionX, r = t.positionY, o = t.scale, a = e.setup, i = a.disabled, s = a.limitToBounds, l = a.centerZoomedOut, c = e.wrapperComponent;
  if (!(i || !c || !e.bounds)) {
    var u = e.bounds, d = u.maxPositionX, f = u.minPositionX, h = u.maxPositionY, p = u.minPositionY, m = n > d || n < f, g = r > h || r < p, y = n > d ? c.offsetWidth : e.setup.minPositionX || 0, b = r > h ? c.offsetHeight : e.setup.minPositionY || 0, w = Oi(e, y, b, o, e.bounds, s || l), S = w.x, x = w.y;
    return {
      scale: o,
      positionX: m ? S : n,
      positionY: g ? x : r
    };
  }
}
function ip(e, t, n, r, o) {
  var a = e.setup.limitToBounds, i = e.wrapperComponent, s = e.bounds, l = e.transformState, c = l.scale, u = l.positionX, d = l.positionY;
  if (!(i === null || s === null || t === u && n === d)) {
    var f = Pi(t, n, s, a, r, o, i), h = f.x, p = f.y;
    e.setTransformState(c, h, p);
  }
}
var wH = function(e, t, n) {
  var r = e.startCoords, o = e.transformState, a = e.setup.panning, i = a.lockAxisX, s = a.lockAxisY, l = o.positionX, c = o.positionY;
  if (!r)
    return { x: l, y: c };
  var u = t - r.x, d = n - r.y, f = i ? l : u, h = s ? c : d;
  return { x: f, y: h };
}, Rr = function(e, t) {
  var n = e.setup, r = e.transformState, o = r.scale, a = n.minScale, i = n.disablePadding;
  return t > 0 && o >= a && !i ? t : 0;
}, xH = function(e) {
  var t = e.mounted, n = e.setup, r = n.disabled, o = n.velocityAnimation, a = e.transformState.scale, i = o.disabled, s = !i || a > 1 || !r || t;
  return !!s;
}, CH = function(e) {
  var t = e.mounted, n = e.velocity, r = e.bounds, o = e.setup, a = o.disabled, i = o.velocityAnimation, s = e.transformState.scale, l = i.disabled, c = !l || s > 1 || !a || t;
  return !(!c || !n || !r);
};
function SH(e, t) {
  var n = e.setup.velocityAnimation, r = n.equalToMove, o = n.animationTime, a = n.sensitivity;
  return r ? o * t * a : o;
}
function ad(e, t, n, r, o, a, i, s, l, c) {
  if (o) {
    if (t > i && n > i) {
      var u = i + (e - i) * c;
      return u > l ? l : u < i ? i : u;
    }
    if (t < a && n < a) {
      var u = a + (e - a) * c;
      return u < s ? s : u > a ? a : u;
    }
  }
  return r ? t : sl(e, a, i, o);
}
function EH(e, t) {
  var n = 1;
  return t ? Math.min(n, e.offsetWidth / window.innerWidth) : n;
}
function kH(e, t) {
  var n = xH(e);
  if (n) {
    var r = e.lastMousePosition, o = e.velocityTime, a = e.setup, i = e.wrapperComponent, s = a.velocityAnimation.equalToMove, l = Date.now();
    if (r && o && i) {
      var c = EH(i, s), u = t.x - r.x, d = t.y - r.y, f = u / c, h = d / c, p = l - o, m = u * u + d * d, g = Math.sqrt(m) / p;
      e.velocity = { velocityX: f, velocityY: h, total: g };
    }
    e.lastMousePosition = t, e.velocityTime = l;
  }
}
function MH(e) {
  var t = e.velocity, n = e.bounds, r = e.setup, o = e.wrapperComponent, a = CH(e);
  if (!(!a || !t || !n || !o)) {
    var i = t.velocityX, s = t.velocityY, l = t.total, c = n.maxPositionX, u = n.minPositionX, d = n.maxPositionY, f = n.minPositionY, h = r.limitToBounds, p = r.alignmentAnimation, m = r.zoomAnimation, g = r.panning, y = g.lockAxisY, b = g.lockAxisX, w = m.animationType, S = p.sizeX, x = p.sizeY, M = p.velocityAlignmentTime, _ = M, R = SH(e, l), B = Math.max(R, _), U = Rr(e, S), F = Rr(e, x), T = U * o.offsetWidth / 100, j = F * o.offsetHeight / 100, A = c + T, G = u - T, N = d + j, te = f - j, oe = e.transformState, Q = (/* @__PURE__ */ new Date()).getTime();
    ap(e, w, B, function(P) {
      var L = e.transformState, $ = L.scale, I = L.positionX, H = L.positionY, Y = (/* @__PURE__ */ new Date()).getTime() - Q, W = Y / _, q = rp[p.animationType], Z = 1 - q(Math.min(1, W)), ee = 1 - P, J = I + i * ee, ie = H + s * ee, D = ad(J, oe.positionX, I, b, h, u, c, G, A, Z), ye = ad(ie, oe.positionY, H, y, h, f, d, te, N, Z);
      (I !== J || H !== ie) && e.setTransformState($, D, ye);
    });
  }
}
function id(e, t) {
  var n = e.transformState.scale;
  It(e), $r(e, n), window.TouchEvent !== void 0 && t instanceof TouchEvent ? bH(e, t) : vH(e, t);
}
function sp(e) {
  var t = e.transformState.scale, n = e.setup, r = n.minScale, o = n.alignmentAnimation, a = o.disabled, i = o.sizeX, s = o.sizeY, l = o.animationTime, c = o.animationType, u = a || t < r || !i && !s;
  if (!u) {
    var d = yH(e);
    d && Tn(e, d, l, c);
  }
}
function sd(e, t, n) {
  var r = e.startCoords, o = e.setup, a = o.alignmentAnimation, i = a.sizeX, s = a.sizeY;
  if (r) {
    var l = wH(e, t, n), c = l.x, u = l.y, d = Rr(e, i), f = Rr(e, s);
    kH(e, { x: c, y: u }), ip(e, c, u, d, f);
  }
}
function _H(e) {
  if (e.isPanning) {
    var t = e.setup.panning.velocityDisabled, n = e.velocity, r = e.wrapperComponent, o = e.contentComponent;
    e.isPanning = !1, e.animate = !1, e.animation = null;
    var a = r == null ? void 0 : r.getBoundingClientRect(), i = o == null ? void 0 : o.getBoundingClientRect(), s = (a == null ? void 0 : a.width) || 0, l = (a == null ? void 0 : a.height) || 0, c = (i == null ? void 0 : i.width) || 0, u = (i == null ? void 0 : i.height) || 0, d = s < c || l < u, f = !t && n && (n == null ? void 0 : n.total) > 0.1 && d;
    f ? MH(e) : sp(e);
  }
}
function zc(e, t, n, r) {
  var o = e.setup, a = o.minScale, i = o.maxScale, s = o.limitToBounds, l = ia(Pt(t, 2), a, i, 0, !1), c = $r(e, l), u = Oi(e, n, r, l, c, s), d = u.x, f = u.y;
  return { scale: l, positionX: d, positionY: f };
}
function lp(e, t, n) {
  var r = e.transformState.scale, o = e.wrapperComponent, a = e.setup, i = a.minScale, s = a.limitToBounds, l = a.zoomAnimation, c = l.disabled, u = l.animationTime, d = l.animationType, f = c || r >= i;
  if ((r >= 1 || s) && sp(e), !(f || !o || !e.mounted)) {
    var h = t || o.offsetWidth / 2, p = n || o.offsetHeight / 2, m = zc(e, i, h, p);
    m && Tn(e, m, u, d);
  }
}
var Cn = function() {
  return Cn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Cn.apply(this, arguments);
};
function ld(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var va = {
  previousScale: 1,
  scale: 1,
  positionX: 0,
  positionY: 0
}, vo = {
  disabled: !1,
  minPositionX: null,
  maxPositionX: null,
  minPositionY: null,
  maxPositionY: null,
  minScale: 1,
  maxScale: 8,
  limitToBounds: !0,
  centerZoomedOut: !1,
  centerOnInit: !1,
  disablePadding: !1,
  smooth: !0,
  wheel: {
    step: 0.2,
    disabled: !1,
    smoothStep: 1e-3,
    wheelDisabled: !1,
    touchPadDisabled: !1,
    activationKeys: [],
    excluded: []
  },
  panning: {
    disabled: !1,
    velocityDisabled: !1,
    lockAxisX: !1,
    lockAxisY: !1,
    allowLeftClickPan: !0,
    allowMiddleClickPan: !0,
    allowRightClickPan: !0,
    wheelPanning: !1,
    activationKeys: [],
    excluded: []
  },
  pinch: {
    step: 5,
    disabled: !1,
    excluded: []
  },
  doubleClick: {
    disabled: !1,
    step: 0.7,
    mode: "zoomIn",
    animationType: "easeOut",
    animationTime: 200,
    excluded: []
  },
  zoomAnimation: {
    disabled: !1,
    size: 0.4,
    animationTime: 200,
    animationType: "easeOut"
  },
  alignmentAnimation: {
    disabled: !1,
    sizeX: 100,
    sizeY: 100,
    animationTime: 200,
    velocityAlignmentTime: 400,
    animationType: "easeOut"
  },
  velocityAnimation: {
    disabled: !1,
    sensitivity: 1,
    animationTime: 400,
    animationType: "easeOut",
    equalToMove: !0
  }
}, cp = function(e) {
  var t, n, r, o;
  return {
    previousScale: (t = e.initialScale) !== null && t !== void 0 ? t : va.scale,
    scale: (n = e.initialScale) !== null && n !== void 0 ? n : va.scale,
    positionX: (r = e.initialPositionX) !== null && r !== void 0 ? r : va.positionX,
    positionY: (o = e.initialPositionY) !== null && o !== void 0 ? o : va.positionY
  };
}, cd = function(e) {
  var t = Cn({}, vo);
  return Object.keys(e).forEach(function(n) {
    var r = typeof e[n] < "u", o = typeof vo[n] < "u";
    if (o && r) {
      var a = Object.prototype.toString.call(vo[n]), i = a === "[object Object]", s = a === "[object Array]";
      i ? t[n] = Cn(Cn({}, vo[n]), e[n]) : s ? t[n] = ld(ld([], vo[n], !0), e[n], !0) : t[n] = e[n];
    }
  }), t;
}, up = function(e, t, n) {
  var r = e.transformState.scale, o = e.wrapperComponent, a = e.setup, i = a.maxScale, s = a.minScale, l = a.zoomAnimation, c = a.smooth, u = l.size;
  if (!o)
    throw new Error("Wrapper is not mounted");
  var d = c ? r * Math.exp(t * n) : r + t * n, f = ia(Pt(d, 3), s, i, u, !1);
  return f;
};
function dp(e, t, n, r, o) {
  var a = e.wrapperComponent, i = e.transformState, s = i.scale, l = i.positionX, c = i.positionY;
  if (!a)
    return console.error("No WrapperComponent found");
  var u = a.offsetWidth, d = a.offsetHeight, f = (u / 2 - l) / s, h = (d / 2 - c) / s, p = up(e, t, n), m = zc(e, p, f, h);
  if (!m)
    return console.error("Error during zoom event. New transformation state was not calculated.");
  Tn(e, m, r, o);
}
function fp(e, t, n, r) {
  var o = e.setup, a = e.wrapperComponent, i = o.limitToBounds, s = cp(e.props), l = e.transformState, c = l.scale, u = l.positionX, d = l.positionY;
  if (a) {
    var f = Bc(e, s.scale), h = Pi(s.positionX, s.positionY, f, i, 0, 0, a), p = {
      scale: s.scale,
      positionX: h.x,
      positionY: h.y
    };
    c === s.scale && u === s.positionX && d === s.positionY || (r == null || r(), Tn(e, p, t, n));
  }
}
function PH(e, t, n, r) {
  var o = e.getBoundingClientRect(), a = t.getBoundingClientRect(), i = n.getBoundingClientRect(), s = a.x * r.scale, l = a.y * r.scale;
  return {
    x: (o.x - i.x + s) / r.scale,
    y: (o.y - i.y + l) / r.scale
  };
}
function OH(e, t, n) {
  var r = e.wrapperComponent, o = e.contentComponent, a = e.transformState, i = e.setup, s = i.limitToBounds, l = i.minScale, c = i.maxScale;
  if (!r || !o)
    return a;
  var u = r.getBoundingClientRect(), d = t.getBoundingClientRect(), f = PH(t, r, o, a), h = f.x, p = f.y, m = d.width / a.scale, g = d.height / a.scale, y = r.offsetWidth / m, b = r.offsetHeight / g, w = ia(n || Math.min(y, b), l, c, 0, !1), S = (u.width - m * w) / 2, x = (u.height - g * w) / 2, M = (u.left - h) * w + S, _ = (u.top - p) * w + x, R = Bc(e, w), B = Pi(M, _, R, s, 0, 0, r), U = B.x, F = B.y;
  return { positionX: U, positionY: F, scale: w };
}
var TH = function(e) {
  return function(t, n, r) {
    t === void 0 && (t = 0.5), n === void 0 && (n = 300), r === void 0 && (r = "easeOut"), dp(e, 1, t, n, r);
  };
}, AH = function(e) {
  return function(t, n, r) {
    t === void 0 && (t = 0.5), n === void 0 && (n = 300), r === void 0 && (r = "easeOut"), dp(e, -1, t, n, r);
  };
}, $H = function(e) {
  return function(t, n, r, o, a) {
    o === void 0 && (o = 300), a === void 0 && (a = "easeOut");
    var i = e.transformState, s = i.positionX, l = i.positionY, c = i.scale, u = e.wrapperComponent, d = e.contentComponent, f = e.setup.disabled;
    if (!(f || !u || !d)) {
      var h = {
        positionX: Number.isNaN(t) ? s : t,
        positionY: Number.isNaN(n) ? l : n,
        scale: Number.isNaN(r) ? c : r
      };
      Tn(e, h, o, a);
    }
  };
}, RH = function(e) {
  return function(t, n) {
    t === void 0 && (t = 200), n === void 0 && (n = "easeOut"), fp(e, t, n);
  };
}, DH = function(e) {
  return function(t, n, r) {
    n === void 0 && (n = 200), r === void 0 && (r = "easeOut");
    var o = e.transformState, a = e.wrapperComponent, i = e.contentComponent;
    if (a && i) {
      var s = hp(t || o.scale, a, i);
      Tn(e, s, n, r);
    }
  };
}, NH = function(e) {
  return function(t, n, r, o) {
    r === void 0 && (r = 600), o === void 0 && (o = "easeOut"), It(e);
    var a = e.wrapperComponent, i = typeof t == "string" ? document.getElementById(t) : t;
    if (a && i && a.contains(i)) {
      var s = OH(e, i, n);
      Tn(e, s, r, o);
    }
  };
}, ll = function(e) {
  return {
    instance: e,
    zoomIn: TH(e),
    zoomOut: AH(e),
    setTransform: $H(e),
    resetTransform: RH(e),
    centerView: DH(e),
    zoomToElement: NH(e)
  };
}, LH = function(e) {
  return {
    instance: e,
    state: e.transformState
  };
}, Ae = function(e) {
  var t = {};
  return Object.assign(t, LH(e)), Object.assign(t, ll(e)), t;
}, xs = !1;
function Cs() {
  try {
    var e = {
      get passive() {
        return xs = !0, !1;
      }
    };
    return e;
  } catch {
    return xs = !1, xs;
  }
}
var Ti = function(e, t) {
  return t.some(function(n) {
    return e.matches("".concat(n, ", .").concat(n, ", ").concat(n, " *, .").concat(n, " *"));
  });
}, cl = function(e) {
  e && clearTimeout(e);
}, jH = function(e, t, n) {
  return "translate(".concat(e, "px, ").concat(t, "px) scale(").concat(n, ")");
}, hp = function(e, t, n) {
  var r = n.offsetWidth * e, o = n.offsetHeight * e, a = (t.offsetWidth - r) / 2, i = (t.offsetHeight - o) / 2;
  return {
    scale: e,
    positionX: a,
    positionY: i
  };
};
function HH(e) {
  return function(t) {
    e.forEach(function(n) {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
var FH = function(e, t) {
  var n = e.setup.wheel, r = n.disabled, o = n.wheelDisabled, a = n.touchPadDisabled, i = n.excluded, s = e.isInitialized, l = e.isPanning, c = t.target, u = s && !l && !r && c;
  if (!u || o && !t.ctrlKey || a && t.ctrlKey)
    return !1;
  var d = Ti(c, i);
  return !d;
}, BH = function(e) {
  return e ? e.deltaY < 0 ? 1 : -1 : 0;
};
function zH(e, t) {
  var n = BH(e), r = Jj(t, n);
  return r;
}
function pp(e, t, n) {
  var r = t.getBoundingClientRect(), o = 0, a = 0;
  if ("clientX" in e)
    o = (e.clientX - r.left) / n, a = (e.clientY - r.top) / n;
  else {
    var i = e.touches[0];
    o = (i.clientX - r.left) / n, a = (i.clientY - r.top) / n;
  }
  return (Number.isNaN(o) || Number.isNaN(a)) && console.error("No mouse or touch offset found"), {
    x: o,
    y: a
  };
}
var IH = function(e, t, n, r, o) {
  var a = e.transformState.scale, i = e.wrapperComponent, s = e.setup, l = s.maxScale, c = s.minScale, u = s.zoomAnimation, d = s.disablePadding, f = u.size, h = u.disabled;
  if (!i)
    throw new Error("Wrapper is not mounted");
  var p = a + t * n;
  if (o)
    return p;
  var m = r ? !1 : !h, g = ia(Pt(p, 3), c, l, f, m && !d);
  return g;
}, WH = function(e, t) {
  var n = e.previousWheelEvent, r = e.transformState.scale, o = e.setup, a = o.maxScale, i = o.minScale;
  return n ? r < a || r > i || Math.sign(n.deltaY) !== Math.sign(t.deltaY) || n.deltaY > 0 && n.deltaY < t.deltaY || n.deltaY < 0 && n.deltaY > t.deltaY || Math.sign(n.deltaY) !== Math.sign(t.deltaY) : !1;
}, VH = function(e, t) {
  var n = e.setup.pinch, r = n.disabled, o = n.excluded, a = e.isInitialized, i = t.target, s = a && !r && i;
  if (!s)
    return !1;
  var l = Ti(i, o);
  return !l;
}, YH = function(e) {
  var t = e.setup.pinch.disabled, n = e.isInitialized, r = e.pinchStartDistance, o = n && !t && r;
  return !!o;
}, qH = function(e, t, n) {
  var r = n.getBoundingClientRect(), o = e.touches, a = Pt(o[0].clientX - r.left, 5), i = Pt(o[0].clientY - r.top, 5), s = Pt(o[1].clientX - r.left, 5), l = Pt(o[1].clientY - r.top, 5);
  return {
    x: (a + s) / 2 / t,
    y: (i + l) / 2 / t
  };
}, mp = function(e) {
  return Math.sqrt(Math.pow(e.touches[0].pageX - e.touches[1].pageX, 2) + Math.pow(e.touches[0].pageY - e.touches[1].pageY, 2));
}, UH = function(e, t) {
  var n = e.pinchStartScale, r = e.pinchStartDistance, o = e.setup, a = o.maxScale, i = o.minScale, s = o.zoomAnimation, l = o.disablePadding, c = s.size, u = s.disabled;
  if (!n || r === null || !t)
    throw new Error("Pinch touches distance was not provided");
  if (t < 0)
    return e.transformState.scale;
  var d = t / r, f = d * n;
  return ia(Pt(f, 2), i, a, c, !u && !l);
}, GH = 160, XH = 100, ZH = function(e, t) {
  var n = e.props, r = n.onWheelStart, o = n.onZoomStart;
  e.wheelStopEventTimer || (It(e), ze(Ae(e), t, r), ze(Ae(e), t, o));
}, KH = function(e, t) {
  var n = e.props, r = n.onWheel, o = n.onZoom, a = e.contentComponent, i = e.setup, s = e.transformState, l = s.scale, c = i.limitToBounds, u = i.centerZoomedOut, d = i.zoomAnimation, f = i.wheel, h = i.disablePadding, p = i.smooth, m = d.size, g = d.disabled, y = f.step, b = f.smoothStep;
  if (!a)
    throw new Error("Component not mounted");
  t.preventDefault(), t.stopPropagation();
  var w = zH(t, null), S = p ? b * Math.abs(t.deltaY) : y, x = IH(e, w, S, !t.ctrlKey);
  if (l !== x) {
    var M = $r(e, x), _ = pp(t, a, l), R = g || m === 0 || u || h, B = c && R, U = Oi(e, _.x, _.y, x, M, B), F = U.x, T = U.y;
    e.previousWheelEvent = t, e.setTransformState(x, F, T), ze(Ae(e), t, r), ze(Ae(e), t, o);
  }
}, QH = function(e, t) {
  var n = e.props, r = n.onWheelStop, o = n.onZoomStop;
  cl(e.wheelAnimationTimer), e.wheelAnimationTimer = setTimeout(function() {
    e.mounted && (lp(e, t.x, t.y), e.wheelAnimationTimer = null);
  }, XH);
  var a = WH(e, t);
  a && (cl(e.wheelStopEventTimer), e.wheelStopEventTimer = setTimeout(function() {
    e.mounted && (e.wheelStopEventTimer = null, ze(Ae(e), t, r), ze(Ae(e), t, o));
  }, GH));
}, JH = function(e, t) {
  var n = mp(t);
  e.pinchStartDistance = n, e.lastDistance = n, e.pinchStartScale = e.transformState.scale, e.isPanning = !1, It(e);
}, eF = function(e, t) {
  var n = e.contentComponent, r = e.pinchStartDistance, o = e.transformState.scale, a = e.setup, i = a.limitToBounds, s = a.centerZoomedOut, l = a.zoomAnimation, c = l.disabled, u = l.size;
  if (!(r === null || !n)) {
    var d = qH(t, o, n);
    if (!(!Number.isFinite(d.x) || !Number.isFinite(d.y))) {
      var f = mp(t), h = UH(e, f);
      if (h !== o) {
        var p = $r(e, h), m = c || u === 0 || s, g = i && m, y = Oi(e, d.x, d.y, h, p, g), b = y.x, w = y.y;
        e.pinchMidpoint = d, e.lastDistance = f, e.setTransformState(h, b, w);
      }
    }
  }
}, tF = function(e) {
  var t = e.pinchMidpoint;
  e.velocity = null, e.lastDistance = null, e.pinchMidpoint = null, e.pinchStartScale = null, e.pinchStartDistance = null, lp(e, t == null ? void 0 : t.x, t == null ? void 0 : t.y);
}, gp = function(e, t) {
  var n = e.props.onZoomStop, r = e.setup.doubleClick.animationTime;
  cl(e.doubleClickStopEventTimer), e.doubleClickStopEventTimer = setTimeout(function() {
    e.doubleClickStopEventTimer = null, ze(Ae(e), t, n);
  }, r);
}, nF = function(e, t) {
  var n = e.props, r = n.onZoomStart, o = n.onZoom, a = e.setup.doubleClick, i = a.animationTime, s = a.animationType;
  ze(Ae(e), t, r), fp(e, i, s, function() {
    return ze(Ae(e), t, o);
  }), gp(e, t);
};
function rF(e, t) {
  return e === "toggle" ? t === 1 ? 1 : -1 : e === "zoomOut" ? -1 : 1;
}
function oF(e, t) {
  var n = e.setup, r = e.doubleClickStopEventTimer, o = e.transformState, a = e.contentComponent, i = o.scale, s = e.props, l = s.onZoomStart, c = s.onZoom, u = n.doubleClick, d = u.disabled, f = u.mode, h = u.step, p = u.animationTime, m = u.animationType;
  if (!d && !r) {
    if (f === "reset")
      return nF(e, t);
    if (!a)
      return console.error("No ContentComponent found");
    var g = rF(f, e.transformState.scale), y = up(e, g, h);
    if (i !== y) {
      ze(Ae(e), t, l);
      var b = pp(t, a, i), w = zc(e, y, b.x, b.y);
      if (!w)
        return console.error("Error during zoom event. New transformation state was not calculated.");
      ze(Ae(e), t, c), Tn(e, w, p, m), gp(e, t);
    }
  }
}
var aF = function(e, t) {
  var n = e.isInitialized, r = e.setup, o = e.wrapperComponent, a = r.doubleClick, i = a.disabled, s = a.excluded, l = t.target, c = o == null ? void 0 : o.contains(l), u = n && l && c && !i;
  if (!u)
    return !1;
  var d = Ti(l, s);
  return !d;
}, iF = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      this.mounted = !0, this.onChangeCallbacks = /* @__PURE__ */ new Set(), this.onInitCallbacks = /* @__PURE__ */ new Set(), this.wrapperComponent = null, this.contentComponent = null, this.isInitialized = !1, this.bounds = null, this.previousWheelEvent = null, this.wheelStopEventTimer = null, this.wheelAnimationTimer = null, this.isPanning = !1, this.isWheelPanning = !1, this.startCoords = null, this.lastTouch = null, this.distance = null, this.lastDistance = null, this.pinchStartDistance = null, this.pinchStartScale = null, this.pinchMidpoint = null, this.doubleClickStopEventTimer = null, this.velocity = null, this.velocityTime = null, this.lastMousePosition = null, this.animate = !1, this.animation = null, this.maxBounds = null, this.pressedKeys = {}, this.mount = function() {
        n.initializeWindowEvents();
      }, this.unmount = function() {
        n.cleanupWindowEvents();
      }, this.update = function(r) {
        n.props = r, $r(n, n.transformState.scale), n.setup = cd(r);
      }, this.initializeWindowEvents = function() {
        var r, o, a = Cs(), i = (r = n.wrapperComponent) === null || r === void 0 ? void 0 : r.ownerDocument, s = i == null ? void 0 : i.defaultView;
        (o = n.wrapperComponent) === null || o === void 0 || o.addEventListener("wheel", n.onWheelPanning, a), s == null || s.addEventListener("mousedown", n.onPanningStart, a), s == null || s.addEventListener("mousemove", n.onPanning, a), s == null || s.addEventListener("mouseup", n.onPanningStop, a), i == null || i.addEventListener("mouseleave", n.clearPanning, a), s == null || s.addEventListener("keyup", n.setKeyUnPressed, a), s == null || s.addEventListener("keydown", n.setKeyPressed, a);
      }, this.cleanupWindowEvents = function() {
        var r, o, a = Cs(), i = (r = n.wrapperComponent) === null || r === void 0 ? void 0 : r.ownerDocument, s = i == null ? void 0 : i.defaultView;
        s == null || s.removeEventListener("mousedown", n.onPanningStart, a), s == null || s.removeEventListener("mousemove", n.onPanning, a), s == null || s.removeEventListener("mouseup", n.onPanningStop, a), i == null || i.removeEventListener("mouseleave", n.clearPanning, a), s == null || s.removeEventListener("keyup", n.setKeyUnPressed, a), s == null || s.removeEventListener("keydown", n.setKeyPressed, a), document.removeEventListener("mouseleave", n.clearPanning, a), It(n), (o = n.observer) === null || o === void 0 || o.disconnect();
      }, this.handleInitializeWrapperEvents = function(r) {
        var o = Cs();
        r.addEventListener("wheel", n.onWheelZoom, o), r.addEventListener("dblclick", n.onDoubleClick, o), r.addEventListener("touchstart", n.onTouchPanningStart, o), r.addEventListener("touchmove", n.onTouchPanning, o), r.addEventListener("touchend", n.onTouchPanningStop, o);
      }, this.handleInitialize = function(r) {
        var o = n.setup.centerOnInit;
        n.applyTransformation(), n.onInitCallbacks.forEach(function(a) {
          return a(Ae(n));
        }), o && (n.setCenter(), n.observer = new ResizeObserver(function() {
          var a, i = r.offsetWidth, s = r.offsetHeight;
          (i > 0 || s > 0) && (n.onInitCallbacks.forEach(function(l) {
            return l(Ae(n));
          }), n.setCenter(), (a = n.observer) === null || a === void 0 || a.disconnect());
        }), setTimeout(function() {
          var a;
          (a = n.observer) === null || a === void 0 || a.disconnect();
        }, 5e3), n.observer.observe(r));
      }, this.onWheelZoom = function(r) {
        var o = n.setup.disabled;
        if (!o) {
          var a = FH(n, r);
          if (a) {
            var i = n.isPressingKeys(n.setup.wheel.activationKeys);
            i && (ZH(n, r), KH(n, r), QH(n, r));
          }
        }
      }, this.onWheelPanning = function(r) {
        var o = n.setup, a = o.disabled, i = o.wheel, s = o.panning;
        if (!(!n.wrapperComponent || !n.contentComponent || a || !i.wheelDisabled || s.disabled || !s.wheelPanning || r.ctrlKey)) {
          r.preventDefault(), r.stopPropagation();
          var l = n.transformState, c = l.positionX, u = l.positionY, d = c - r.deltaX, f = u - r.deltaY, h = s.lockAxisX ? c : d, p = s.lockAxisY ? u : f, m = n.setup.alignmentAnimation, g = m.sizeX, y = m.sizeY, b = Rr(n, g), w = Rr(n, y);
          h === c && p === u || ip(n, h, p, b, w);
        }
      }, this.onPanningStart = function(r) {
        var o = n.setup.disabled, a = n.props.onPanningStart;
        if (!o) {
          var i = rd(n, r);
          if (i) {
            var s = n.isPressingKeys(n.setup.panning.activationKeys);
            s && (r.button === 0 && !n.setup.panning.allowLeftClickPan || r.button === 1 && !n.setup.panning.allowMiddleClickPan || r.button === 2 && !n.setup.panning.allowRightClickPan || (r.preventDefault(), r.stopPropagation(), It(n), id(n, r), ze(Ae(n), r, a)));
          }
        }
      }, this.onPanning = function(r) {
        var o = n.setup.disabled, a = n.props.onPanning;
        if (!o) {
          var i = od(n);
          if (i) {
            var s = n.isPressingKeys(n.setup.panning.activationKeys);
            s && (r.preventDefault(), r.stopPropagation(), sd(n, r.clientX, r.clientY), ze(Ae(n), r, a));
          }
        }
      }, this.onPanningStop = function(r) {
        var o = n.props.onPanningStop;
        n.isPanning && (_H(n), ze(Ae(n), r, o));
      }, this.onPinchStart = function(r) {
        var o = n.setup.disabled, a = n.props, i = a.onPinchingStart, s = a.onZoomStart;
        if (!o) {
          var l = VH(n, r);
          l && (JH(n, r), It(n), ze(Ae(n), r, i), ze(Ae(n), r, s));
        }
      }, this.onPinch = function(r) {
        var o = n.setup.disabled, a = n.props, i = a.onPinching, s = a.onZoom;
        if (!o) {
          var l = YH(n);
          l && (r.preventDefault(), r.stopPropagation(), eF(n, r), ze(Ae(n), r, i), ze(Ae(n), r, s));
        }
      }, this.onPinchStop = function(r) {
        var o = n.props, a = o.onPinchingStop, i = o.onZoomStop;
        n.pinchStartScale && (tF(n), ze(Ae(n), r, a), ze(Ae(n), r, i));
      }, this.onTouchPanningStart = function(r) {
        var o = n.setup.disabled, a = n.props.onPanningStart;
        if (!o) {
          var i = rd(n, r);
          if (i) {
            var s = n.lastTouch && +/* @__PURE__ */ new Date() - n.lastTouch < 200;
            if (s && r.touches.length === 1)
              n.onDoubleClick(r);
            else {
              n.lastTouch = +/* @__PURE__ */ new Date(), It(n);
              var l = r.touches, c = l.length === 1, u = l.length === 2;
              c && (It(n), id(n, r), ze(Ae(n), r, a)), u && n.onPinchStart(r);
            }
          }
        }
      }, this.onTouchPanning = function(r) {
        var o = n.setup.disabled, a = n.props.onPanning;
        if (n.isPanning && r.touches.length === 1) {
          if (o)
            return;
          var i = od(n);
          if (!i)
            return;
          r.preventDefault(), r.stopPropagation();
          var s = r.touches[0];
          sd(n, s.clientX, s.clientY), ze(Ae(n), r, a);
        } else
          r.touches.length > 1 && n.onPinch(r);
      }, this.onTouchPanningStop = function(r) {
        n.onPanningStop(r), n.onPinchStop(r);
      }, this.onDoubleClick = function(r) {
        var o = n.setup.disabled;
        if (!o) {
          var a = aF(n, r);
          a && oF(n, r);
        }
      }, this.clearPanning = function(r) {
        n.isPanning && n.onPanningStop(r);
      }, this.setKeyPressed = function(r) {
        n.pressedKeys[r.key] = !0;
      }, this.setKeyUnPressed = function(r) {
        n.pressedKeys[r.key] = !1;
      }, this.isPressingKeys = function(r) {
        return r.length ? !!r.find(function(o) {
          return n.pressedKeys[o];
        }) : !0;
      }, this.setTransformState = function(r, o, a) {
        var i = n.props.onTransformed;
        if (!Number.isNaN(r) && !Number.isNaN(o) && !Number.isNaN(a)) {
          r !== n.transformState.scale && (n.transformState.previousScale = n.transformState.scale, n.transformState.scale = r), n.transformState.positionX = o, n.transformState.positionY = a, n.applyTransformation();
          var s = Ae(n);
          n.onChangeCallbacks.forEach(function(l) {
            return l(s);
          }), ze(s, { scale: r, positionX: o, positionY: a }, i);
        } else
          console.error("Detected NaN set state values");
      }, this.setCenter = function() {
        if (n.wrapperComponent && n.contentComponent) {
          var r = hp(n.transformState.scale, n.wrapperComponent, n.contentComponent);
          n.setTransformState(r.scale, r.positionX, r.positionY);
        }
      }, this.handleTransformStyles = function(r, o, a) {
        return n.props.customTransform ? n.props.customTransform(r, o, a) : jH(r, o, a);
      }, this.applyTransformation = function() {
        if (!(!n.mounted || !n.contentComponent)) {
          var r = n.transformState, o = r.scale, a = r.positionX, i = r.positionY, s = n.handleTransformStyles(a, i, o);
          n.contentComponent.style.transform = s;
        }
      }, this.getContext = function() {
        return Ae(n);
      }, this.onChange = function(r) {
        return n.onChangeCallbacks.has(r) || n.onChangeCallbacks.add(r), function() {
          n.onChangeCallbacks.delete(r);
        };
      }, this.onInit = function(r) {
        return n.onInitCallbacks.has(r) || n.onInitCallbacks.add(r), function() {
          n.onInitCallbacks.delete(r);
        };
      }, this.init = function(r, o) {
        n.cleanupWindowEvents(), n.wrapperComponent = r, n.contentComponent = o, $r(n, n.transformState.scale), n.handleInitializeWrapperEvents(r), n.handleInitialize(o), n.initializeWindowEvents(), n.isInitialized = !0;
        var a = Ae(n);
        ze(a, void 0, n.props.onInit);
      }, this.props = t, this.setup = cd(this.props), this.transformState = cp(this.props);
    }
    return e;
  }()
), Ic = v.createContext(null), sF = function(e, t) {
  return typeof e == "function" ? e(t) : e;
}, lF = v.forwardRef(function(e, t) {
  var n = jt(new iF(e)).current, r = sF(e.children, ll(n));
  return Ad(t, function() {
    return ll(n);
  }, [n]), nt(function() {
    n.update(e);
  }, [n, e]), v.createElement(Ic.Provider, { value: n }, r);
});
v.forwardRef(function(e, t) {
  var n = jt(null), r = gl(Ic);
  return nt(function() {
    return r.onChange(function(o) {
      if (n.current) {
        var a = 0, i = 0;
        n.current.style.transform = r.handleTransformStyles(a, i, 1 / o.instance.transformState.scale);
      }
    });
  }, [r]), v.createElement("div", Cn({}, e, { ref: HH([n, t]) }));
});
function cF(e, t) {
  t === void 0 && (t = {});
  var n = t.insertAt;
  if (!(!e || typeof document > "u")) {
    var r = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
    o.type = "text/css", n === "top" && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}
var uF = `.transform-component-module_wrapper__SPB86 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}
.transform-component-module_content__FBWxo {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}
.transform-component-module_content__FBWxo img {
  pointer-events: none;
}
`, ud = { wrapper: "transform-component-module_wrapper__SPB86", content: "transform-component-module_content__FBWxo" };
cF(uF);
var dF = function(e) {
  var t = e.children, n = e.wrapperClass, r = n === void 0 ? "" : n, o = e.contentClass, a = o === void 0 ? "" : o, i = e.wrapperStyle, s = e.contentStyle, l = e.wrapperProps, c = l === void 0 ? {} : l, u = e.contentProps, d = u === void 0 ? {} : u, f = gl(Ic), h = f.init, p = f.cleanupWindowEvents, m = jt(null), g = jt(null);
  return nt(function() {
    var y = m.current, b = g.current;
    return y !== null && b !== null && h && (h == null || h(y, b)), function() {
      p == null || p();
    };
  }, []), v.createElement(
    "div",
    Cn({}, c, { ref: m, className: "react-transform-wrapper ".concat(ud.wrapper, " ").concat(r), style: i }),
    v.createElement("div", Cn({}, d, { ref: g, className: "react-transform-component ".concat(ud.content, " ").concat(a), style: s }), t)
  );
};
const uV = ({
  url: e,
  close: t,
  downloadable: n,
  zoomable: r,
  imageFileName: o
}) => {
  const [a, i] = he(0), [s, l] = he(null), c = s === null, u = jt(null), [d, f] = he(1);
  nt(() => {
    e && (async () => {
      const y = await mj(e, i).promise;
      l(window.URL.createObjectURL(y));
    })();
  }, [e]);
  const h = () => {
    u.current && u.current.zoomIn();
  }, p = () => {
    u.current && u.current.zoomOut();
  }, m = async () => {
    if (s) {
      const g = await fetch(s), y = g.headers.get("Content-Type"), b = (y == null ? void 0 : y.split("/")[1]) || "jpg", w = await g.blob();
      gj(w, `${o}.${b}`);
    }
  };
  return /* @__PURE__ */ C.jsxs($h, { className: "m-4 max-h-screen max-w-screen overflow-hidden", children: [
    /* @__PURE__ */ C.jsxs("div", { className: z("flex", "flex-col", "relative"), children: [
      /* @__PURE__ */ C.jsxs(
        "div",
        {
          className: z(
            "flex",
            "flex-row",
            "items-center gap-2",
            "justify-end",
            "absolute",
            "right-2",
            "top-2"
          ),
          children: [
            n && !c && /* @__PURE__ */ C.jsx(
              "div",
              {
                className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                onClick: m,
                children: /* @__PURE__ */ C.jsx("div", { className: "i-skand-download cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
              }
            ),
            /* @__PURE__ */ C.jsx(
              "div",
              {
                className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                onClick: t,
                children: /* @__PURE__ */ C.jsx("div", { className: "i-skand-close cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
              }
            )
          ]
        }
      ),
      c && /* @__PURE__ */ C.jsx(
        "div",
        {
          className: z(
            "flex",
            "h-full",
            "absolute",
            "w-full",
            "justify-center",
            "items-center",
            "bg-neutral-200"
          ),
          children: /* @__PURE__ */ C.jsx(
            Fh,
            {
              className: "relative w-153px b-1px b-rounded-1",
              progress: a * 100
            }
          )
        }
      ),
      s && /* @__PURE__ */ C.jsxs(
        lF,
        {
          initialScale: 1,
          onTransformed: (g, y) => f(y.scale),
          ref: u,
          wheel: {
            smoothStep: 0.1
          },
          children: [
            r && /* @__PURE__ */ C.jsxs(
              "div",
              {
                className: z(
                  "flex",
                  "flex-row",
                  "absolute",
                  "left-12px",
                  "top-8px",
                  "z-2",
                  "gap-4px",
                  "flex",
                  "flex-row",
                  "items-center",
                  "justify-between"
                ),
                children: [
                  /* @__PURE__ */ C.jsx(
                    "div",
                    {
                      className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                      onClick: p,
                      children: /* @__PURE__ */ C.jsx(
                        "svg",
                        {
                          className: "cursor-pointer text-12px color-neutral-600 hover:color-primary-400",
                          fill: "none",
                          height: "12",
                          viewBox: "0 0 12 12",
                          width: "12",
                          xmlns: "http://www.w3.org/2000/svg",
                          children: /* @__PURE__ */ C.jsx("rect", { fill: "#8A858E", height: "2", width: "12", y: "5" })
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ C.jsx("div", { className: "w-163px", children: /* @__PURE__ */ C.jsx(
                    np,
                    {
                      max: 8,
                      min: 1,
                      onValueChange: (g) => {
                        const y = g[0];
                        if (u.current) {
                          const { setTransform: b, instance: w } = u.current, { positionX: S, positionY: x } = w.transformState;
                          b(S, x, y);
                        }
                        f(y);
                      },
                      step: 0.1,
                      value: [d]
                    }
                  ) }),
                  /* @__PURE__ */ C.jsx(
                    "div",
                    {
                      className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                      onClick: h,
                      children: /* @__PURE__ */ C.jsx("div", { className: "i-skand-add cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ C.jsx(dF, { children: /* @__PURE__ */ C.jsx("img", { className: z("object-fit max-h-60vh w-fit max-w-80vw "), src: s }) })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ C.jsx("div", {})
  ] });
}, fF = ({
  inputRef: e,
  value: t,
  handleChange: n,
  placeholder: r,
  warn: o,
  props: a,
  disabled: i
}) => (nt(() => {
  const s = e.current;
  if (s) {
    s.style.height = "0px";
    const l = s.scrollHeight;
    s.style.height = l + "px";
  }
}, [e, t]), /* @__PURE__ */ C.jsx(
  "textarea",
  {
    className: z(
      "bg-transparent",
      "border-0",
      "min-w-1",
      "flex-1",
      "outline-none",
      "typo-text-s",
      "placeholder:typo-text-s",
      "placeholder:color-neutral-400",
      o ? "color-neutral-400" : "color-neutral-600",
      "max-h-120px overflow-y-auto"
    ),
    disabled: i,
    onChange: n,
    placeholder: r,
    ref: e,
    rows: 1,
    style: { resize: "none" },
    value: t,
    ...a
  }
)), dV = ({
  defaultValue: e,
  hint: t,
  label: n,
  labelProps: r,
  onChange: o,
  placeholder: a,
  tail: i,
  value: s,
  warn: l,
  expandable: c,
  disabled: u,
  ...d
}) => {
  const f = jt(null), h = jt(null), [p, m] = he(e ?? s ?? "");
  nt(() => {
    m(s ?? "");
  }, [s]);
  const g = Ue(
    (b) => {
      o == null || o(b.target.value), m(b.target.value);
    },
    [o]
  ), y = Ue(() => {
    var b, w;
    (b = f.current) == null || b.focus(), (w = h.current) == null || w.focus();
  }, []);
  return /* @__PURE__ */ C.jsxs("div", { className: "group/input flex flex-col", children: [
    /* @__PURE__ */ C.jsxs(
      "div",
      {
        className: z(
          "bg-neutral-100",
          "border-1",
          "border-solid",
          "flex-nowrap",
          "flex-row",
          "flex",
          "items-center",
          "p-x-3",
          "p-y-2",
          "rounded-1",
          l ? "border-alert-300 focus-within:border-alert-300" : "border-neutral-400 focus-within:border-neutral-800",
          u && "bg-neutral-300"
        ),
        children: [
          /* @__PURE__ */ C.jsxs("div", { className: "w-full flex flex-auto flex-row flex-wrap", children: [
            n && /* @__PURE__ */ C.jsx(
              "label",
              {
                className: z(
                  "cursor-text",
                  "group-focus-within/input:color-neutral-800",
                  "group-focus-within/input:flex-auto",
                  "group-focus-within/input:typo-text-xxs",
                  "group-focus-within/input:w-full",
                  p || n && a ? ["color-neutral-800", "flex-auto", "typo-text-xxs", "w-full"] : [
                    "color-neutral-600",
                    "flex-basis-auto",
                    "flex-grow-0",
                    "flex-shrink-0",
                    "typo-text-s"
                  ]
                ),
                onClick: y,
                ...r,
                children: n
              }
            ),
            c ? /* @__PURE__ */ C.jsx(
              fF,
              {
                disabled: u,
                handleChange: g,
                inputRef: f,
                placeholder: a,
                props: d,
                value: p.toString(),
                warn: l
              }
            ) : /* @__PURE__ */ C.jsx(
              "input",
              {
                className: z(
                  "bg-transparent",
                  "border-0",
                  "min-w-1",
                  "flex-1",
                  "outline-none",
                  "typo-text-s",
                  "placeholder:typo-text-s",
                  "placeholder:color-neutral-400",
                  l ? "color-neutral-400" : "color-neutral-600"
                ),
                disabled: u,
                onChange: g,
                placeholder: a,
                ref: h,
                value: p,
                ...d
              }
            )
          ] }),
          i && /* @__PURE__ */ C.jsx("div", { className: z("flex-none"), children: i })
        ]
      }
    ),
    t && /* @__PURE__ */ C.jsx(
      "span",
      {
        className: z("m-t-1", "typo-text-xs", l ? "color-alert-300" : "color-neutral-600"),
        children: t
      }
    )
  ] });
}, hF = qt(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ C.jsx(
    "div",
    {
      className: z(
        "my-1 list-none b-1 b-neutral-400 rounded-1 b-solid bg-neutral-100 p-1",
        t
      ),
      ref: r,
      role: "menu",
      ...n,
      children: e
    }
  )
);
hF.displayName = "Menu";
const pF = qt(
  ({ children: e, className: t, disabled: n, size: r = "s", ...o }, a) => /* @__PURE__ */ C.jsx(
    "button",
    {
      className: z(
        "border-0 block w-full",
        "bg-transparent color-neutral-600 rounded-2px px-2 py-2px whitespace-nowrap text-left",
        "hover:bg-neutral-200  hover:color-neutral-800",
        "disabled:color-neutral-400",
        "disabled:hover:bg-transparent",
        "disabled:hover:color-neutral-400",
        (r === "s" || r === "small") && "typo-text-s hover:typo-text-s-em disabled:hover:typo-text-s",
        (r === "xs" || r === "extraSmall") && "typo-button-xs",
        t
      ),
      disabled: n,
      ref: a,
      role: "menuitem",
      tabIndex: 0,
      ...o,
      children: e
    }
  )
);
pF.displayName = "MenuItem";
const vp = ({ className: e, ...t }) => /* @__PURE__ */ C.jsx(
  "nav",
  {
    "aria-label": "pagination",
    className: z("mx-auto flex w-full justify-center", e),
    role: "navigation",
    ...t
  }
);
vp.displayName = "PaginationRoot";
const bp = E.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx(
    "ul",
    {
      className: z("flex flex-row items-center gap-1 list-none", e),
      ref: n,
      ...t
    }
  )
);
bp.displayName = "PaginationContent";
const yn = E.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx("li", { className: z("h-4 w-4", e), ref: n, ...t })
);
yn.displayName = "PaginationItem";
const Or = ({
  className: e,
  isActive: t,
  ...n
}) => /* @__PURE__ */ C.jsx(
  "a",
  {
    "aria-current": t ? "page" : void 0,
    className: z(
      "typo-text-xs-em color-neutral-600 decoration-none h-4 w-4 flex items-center justify-center",
      "aria-[current=page]:color-neutral-800",
      "hover:color-neutral-800",
      "cursor-pointer",
      e
    ),
    ...n
  }
);
Or.displayName = "PaginationLink";
const yp = ({
  className: e,
  disabled: t,
  ...n
}) => /* @__PURE__ */ C.jsx(
  Or,
  {
    "aria-disabled": t,
    "aria-label": "Go to previous page",
    className: z(
      "color-neutral-400",
      t && "cursor-not-allowed pointer-events-none color-neutral-200",
      e
    ),
    ...n,
    children: /* @__PURE__ */ C.jsx("div", { className: z("i-skand-dropdown h-3 w-3 rotate-90") })
  }
);
yp.displayName = "PaginationPrevious";
const wp = ({
  className: e,
  disabled: t,
  ...n
}) => /* @__PURE__ */ C.jsx(
  Or,
  {
    "aria-disabled": t,
    "aria-label": "Go to next page",
    className: z(
      "color-neutral-400",
      t && "cursor-not-allowed pointer-events-none color-neutral-200",
      e
    ),
    ...n,
    children: /* @__PURE__ */ C.jsx("div", { className: z("i-skand-dropdown h-3 w-3 rotate-270") })
  }
);
wp.displayName = "PaginationNext";
const ul = ({ className: e, ...t }) => /* @__PURE__ */ C.jsxs(
  "span",
  {
    "aria-hidden": !0,
    className: z("color-neutral-400 h-4 w-4 flex items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ C.jsx("div", { className: "i-skand-more h-3 w-3" }),
      /* @__PURE__ */ C.jsx("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
ul.displayName = "PaginationEllipsis";
const mF = ({
  currentPageIndex: e,
  totalNumberOfPages: t
}) => {
  const n = t - 1, r = [];
  if (t <= 5)
    for (let o = 0; o < t; o++)
      r.push(o);
  else {
    const o = e, a = n - e;
    if (o >= 2 && a >= 2)
      for (let i = -2; i <= 2; i++)
        r.push(i + e);
    else if (o < 2 && a >= 2)
      for (let i = 0; i < 5; i++)
        r.push(i);
    else if (o >= 2 && a < 2)
      for (let i = 0; i < 5; i++)
        r.unshift(n - i);
  }
  return r;
}, gF = ({ totalNumberOfPages: e, currentPageIndex: t }) => {
  const n = e - 1, r = 0, o = t > r, a = t < n, i = mF({ currentPageIndex: t, totalNumberOfPages: e }), s = i.map((m) => ({
    index: m,
    isCurrent: m === t,
    label: `${m + 1}`
  })), l = i[0], c = i[i.length - 1], u = l === 0 ? !1 : { index: 0, isCurrent: !1, label: `${r + 1}` }, d = c === n ? !1 : { index: n, isCurrent: !1, label: `${n + 1}` }, f = l > 1, h = c < n - 1;
  return {
    prev: o,
    firstPage: u,
    leftEllipsis: f,
    visiblePages: s,
    rightEllipsis: h,
    lastPage: d,
    next: a
  };
}, fV = ({
  totalNumberOfPages: e,
  currentPageIndex: t,
  onChangePage: n
}) => {
  const { prev: r, firstPage: o, leftEllipsis: a, visiblePages: i, rightEllipsis: s, lastPage: l, next: c } = gF({ currentPageIndex: t, totalNumberOfPages: e });
  return /* @__PURE__ */ C.jsx(vp, { children: /* @__PURE__ */ C.jsxs(bp, { children: [
    /* @__PURE__ */ C.jsx(yn, { children: /* @__PURE__ */ C.jsx(
      yp,
      {
        disabled: !r,
        onClick: () => n == null ? void 0 : n(t - 1)
      }
    ) }),
    o && /* @__PURE__ */ C.jsx(yn, { children: /* @__PURE__ */ C.jsx(Or, { onClick: () => n == null ? void 0 : n(o.index), children: o.label }) }),
    a && /* @__PURE__ */ C.jsx(yn, { children: /* @__PURE__ */ C.jsx(ul, {}) }),
    i.map((u) => /* @__PURE__ */ C.jsx(yn, { children: /* @__PURE__ */ C.jsx(Or, { isActive: u.isCurrent, onClick: () => n == null ? void 0 : n(u.index), children: u.label }) }, u.index)),
    s && /* @__PURE__ */ C.jsx(yn, { children: /* @__PURE__ */ C.jsx(ul, {}) }),
    l && /* @__PURE__ */ C.jsx(yn, { children: /* @__PURE__ */ C.jsx(Or, { onClick: () => n == null ? void 0 : n(l.index), children: l.label }) }),
    /* @__PURE__ */ C.jsx(yn, { children: /* @__PURE__ */ C.jsx(wp, { disabled: !c, onClick: () => n == null ? void 0 : n(t + 1) }) })
  ] }) });
}, vF = ({
  children: e,
  itemCount: t,
  horizontal: n = !1,
  buffer: r = 0.5,
  onScroll: o = () => {
  },
  scrollbarSpace: a = 0
}, i) => {
  const [s, l] = he(null), [c, u] = he(null), [d, f] = he(0), [h, p] = he(0), m = Ct(() => {
    if (s && h) {
      const w = n ? s.clientWidth : s.clientHeight;
      return Rt(0, t, Math.floor((d + w * -r) / h));
    } else
      return 0;
  }, [r, s, n, t, h, d]), g = Ct(() => {
    if (s && h) {
      const w = n ? s.clientWidth : s.clientHeight;
      return Rt(
        m,
        t,
        Math.ceil((d + w * (1 + r)) / h)
      );
    } else
      return 0;
  }, [r, s, n, t, h, d, m]);
  Ad(
    i,
    () => s === null ? null : {
      scrollBy: (w) => {
        n ? s.scrollBy(w, 0) : s.scrollBy(0, w);
      },
      scrollTo: (w) => {
        n ? s.scrollTo(w, 0) : s.scrollTo(0, w);
      },
      itemSize: h,
      start: m,
      stop: g
    },
    [s, n, h, m, g]
  ), vl(() => {
    if (c && t) {
      const w = c.getBoundingClientRect();
      p(n ? w.width : w.height);
    }
  }, [n, c, t]);
  const y = (w) => {
    const S = n ? w.currentTarget.scrollLeft : w.currentTarget.scrollTop;
    f(S), o(S);
  }, b = Ct(
    () => n ? { width: t * h + a } : { height: t * h + a },
    [n, t, h, a]
  );
  return /* @__PURE__ */ C.jsxs(
    "div",
    {
      className: z("relative h-full w-full", "[will-change:transform]"),
      onScroll: y,
      ref: l,
      style: {
        overflow: n ? "auto hidden" : "hidden auto"
      },
      children: [
        Q3.createPortal(
          /* @__PURE__ */ C.jsx("div", { className: "fixed opacity-0", ref: u, children: t && e({ index: 0 }) }),
          document.body
        ),
        /* @__PURE__ */ C.jsx(
          "div",
          {
            className: z("relative h-full w-full overscroll-auto"),
            style: {
              ...b,
              overflow: n ? "hidden auto" : "auto hidden"
            },
            children: Array(g - m).fill(0).map((w, S) => /* @__PURE__ */ C.jsx(
              "div",
              {
                className: z("absolute h-full w-full", n ? "top-0" : "left-0"),
                style: n ? {
                  left: (m + S) * h,
                  width: h
                } : {
                  top: (m + S) * h,
                  height: h
                },
                children: e({ index: m + S })
              },
              S
            ))
          }
        )
      ]
    }
  );
}, bF = qt(vF), {
  createElement: Dr,
  createContext: yF,
  createRef: hV,
  forwardRef: xp,
  useCallback: bt,
  useContext: Cp,
  useEffect: Hn,
  useImperativeHandle: Sp,
  useLayoutEffect: wF,
  useMemo: xF,
  useRef: pt,
  useState: To
} = E, dd = E["useId".toString()], CF = wF, Ai = yF(null);
Ai.displayName = "PanelGroupContext";
const Fn = CF, SF = typeof dd == "function" ? dd : () => null;
let EF = 0;
function Wc(e = null) {
  const t = SF(), n = pt(e || t || null);
  return n.current === null && (n.current = "" + EF++), e ?? n.current;
}
function Ep({
  children: e,
  className: t = "",
  collapsedSize: n,
  collapsible: r,
  defaultSize: o,
  forwardedRef: a,
  id: i,
  maxSize: s,
  minSize: l,
  onCollapse: c,
  onExpand: u,
  onResize: d,
  order: f,
  style: h,
  tagName: p = "div",
  ...m
}) {
  const g = Cp(Ai);
  if (g === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: y,
    expandPanel: b,
    getPanelSize: w,
    getPanelStyle: S,
    groupId: x,
    isPanelCollapsed: M,
    reevaluatePanelConstraints: _,
    registerPanel: R,
    resizePanel: B,
    unregisterPanel: U
  } = g, F = Wc(i), T = pt({
    callbacks: {
      onCollapse: c,
      onExpand: u,
      onResize: d
    },
    constraints: {
      collapsedSize: n,
      collapsible: r,
      defaultSize: o,
      maxSize: s,
      minSize: l
    },
    id: F,
    idIsFromProps: i !== void 0,
    order: f
  });
  pt({
    didLogMissingDefaultSizeWarning: !1
  }), Fn(() => {
    const {
      callbacks: A,
      constraints: G
    } = T.current, N = {
      ...G
    };
    T.current.id = F, T.current.idIsFromProps = i !== void 0, T.current.order = f, A.onCollapse = c, A.onExpand = u, A.onResize = d, G.collapsedSize = n, G.collapsible = r, G.defaultSize = o, G.maxSize = s, G.minSize = l, (N.collapsedSize !== G.collapsedSize || N.collapsible !== G.collapsible || N.maxSize !== G.maxSize || N.minSize !== G.minSize) && _(T.current, N);
  }), Fn(() => {
    const A = T.current;
    return R(A), () => {
      U(A);
    };
  }, [f, F, R, U]), Sp(a, () => ({
    collapse: () => {
      y(T.current);
    },
    expand: () => {
      b(T.current);
    },
    getId() {
      return F;
    },
    getSize() {
      return w(T.current);
    },
    isCollapsed() {
      return M(T.current);
    },
    isExpanded() {
      return !M(T.current);
    },
    resize: (A) => {
      B(T.current, A);
    }
  }), [y, b, w, M, F, B]);
  const j = S(T.current, o);
  return Dr(p, {
    ...m,
    children: e,
    className: t,
    id: i,
    style: {
      ...j,
      ...h
    },
    // CSS selectors
    "data-panel": "",
    "data-panel-collapsible": r || void 0,
    "data-panel-group-id": x,
    "data-panel-id": F,
    "data-panel-size": parseFloat("" + j.flexGrow).toFixed(1)
  });
}
const kp = xp((e, t) => Dr(Ep, {
  ...e,
  forwardedRef: t
}));
Ep.displayName = "Panel";
kp.displayName = "forwardRef(Panel)";
let dl = null, Ln = null;
function kF(e, t) {
  if (t) {
    const n = (t & Tp) !== 0, r = (t & Ap) !== 0, o = (t & $p) !== 0, a = (t & Rp) !== 0;
    if (n)
      return o ? "se-resize" : a ? "ne-resize" : "e-resize";
    if (r)
      return o ? "sw-resize" : a ? "nw-resize" : "w-resize";
    if (o)
      return "s-resize";
    if (a)
      return "n-resize";
  }
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function MF() {
  Ln !== null && (document.head.removeChild(Ln), dl = null, Ln = null);
}
function Ss(e, t) {
  const n = kF(e, t);
  dl !== n && (dl = n, Ln === null && (Ln = document.createElement("style"), document.head.appendChild(Ln)), Ln.innerHTML = `*{cursor: ${n}!important;}`);
}
function Mp(e) {
  return e.type === "keydown";
}
function _p(e) {
  return e.type.startsWith("mouse");
}
function Pp(e) {
  return e.type.startsWith("touch");
}
function $i(e) {
  if (_p(e))
    return {
      x: e.pageX,
      y: e.pageY
    };
  if (Pp(e)) {
    const t = e.touches[0];
    if (t && t.pageX && t.pageY)
      return {
        x: t.pageX,
        y: t.pageY
      };
  }
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function _F() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function PF(e, t, n) {
  return n ? e.x < t.x + t.width && e.x + e.width > t.x && e.y < t.y + t.height && e.y + e.height > t.y : e.x <= t.x + t.width && e.x + e.width >= t.x && e.y <= t.y + t.height && e.y + e.height >= t.y;
}
function OF(e, t) {
  if (e === t)
    throw new Error("Cannot compare node with itself");
  const n = {
    a: pd(e),
    b: pd(t)
  };
  let r;
  for (; n.a.at(-1) === n.b.at(-1); )
    e = n.a.pop(), t = n.b.pop(), r = e;
  pe(r);
  const o = {
    a: hd(fd(n.a)),
    b: hd(fd(n.b))
  };
  if (o.a === o.b) {
    const a = r.childNodes, i = {
      a: n.a.at(-1),
      b: n.b.at(-1)
    };
    let s = a.length;
    for (; s--; ) {
      const l = a[s];
      if (l === i.a)
        return 1;
      if (l === i.b)
        return -1;
    }
  }
  return Math.sign(o.a - o.b);
}
const TF = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function AF(e) {
  const t = getComputedStyle(Op(e)).display;
  return t === "flex" || t === "inline-flex";
}
function $F(e) {
  const t = getComputedStyle(e);
  return !!(t.position === "fixed" || t.zIndex !== "auto" && (t.position !== "static" || AF(e)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || TF.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function fd(e) {
  let t = e.length;
  for (; t--; ) {
    const n = e[t];
    if (pe(n), $F(n))
      return n;
  }
  return null;
}
function hd(e) {
  return e && Number(getComputedStyle(e).zIndex) || 0;
}
function pd(e) {
  const t = [];
  for (; e; )
    t.push(e), e = Op(e);
  return t;
}
function Op(e) {
  var t;
  return ((t = e.parentNode) === null || t === void 0 ? void 0 : t.host) || e.parentNode;
}
const Tp = 1, Ap = 2, $p = 4, Rp = 8, RF = _F() === "coarse";
let Pn = [], Ri = !1, wn = /* @__PURE__ */ new Map(), Di = /* @__PURE__ */ new Map();
const Fo = /* @__PURE__ */ new Set();
function DF(e, t, n, r, o) {
  var a;
  const {
    ownerDocument: i
  } = t, s = {
    direction: n,
    element: t,
    hitAreaMargins: r,
    setResizeHandlerState: o
  }, l = (a = wn.get(i)) !== null && a !== void 0 ? a : 0;
  return wn.set(i, l + 1), Fo.add(s), Ja(), function() {
    var u;
    Di.delete(e), Fo.delete(s);
    const d = (u = wn.get(i)) !== null && u !== void 0 ? u : 1;
    wn.set(i, d - 1), Ja(), d === 1 && wn.delete(i);
  };
}
function ba(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = $i(e);
  Ri = !0, Vc({
    target: t,
    x: n,
    y: r
  }), Ja(), Pn.length > 0 && (Yc("down", e), e.preventDefault());
}
function vn(e) {
  const {
    x: t,
    y: n
  } = $i(e);
  if (!Ri) {
    const {
      target: r
    } = e;
    Vc({
      target: r,
      x: t,
      y: n
    });
  }
  Yc("move", e), Dp(), Pn.length > 0 && e.preventDefault();
}
function bn(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = $i(e);
  Di.clear(), Ri = !1, Pn.length > 0 && e.preventDefault(), Yc("up", e), Vc({
    target: t,
    x: n,
    y: r
  }), Dp(), Ja();
}
function Vc({
  target: e,
  x: t,
  y: n
}) {
  Pn.splice(0);
  let r = null;
  e instanceof HTMLElement && (r = e), Fo.forEach((o) => {
    const {
      element: a,
      hitAreaMargins: i
    } = o, s = a.getBoundingClientRect(), {
      bottom: l,
      left: c,
      right: u,
      top: d
    } = s, f = RF ? i.coarse : i.fine;
    if (t >= c - f && t <= u + f && n >= d - f && n <= l + f) {
      if (r !== null && a !== r && !a.contains(r) && !r.contains(a) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      OF(r, a) > 0) {
        let p = r, m = !1;
        for (; p && !p.contains(a); ) {
          if (PF(p.getBoundingClientRect(), s, !0)) {
            m = !0;
            break;
          }
          p = p.parentElement;
        }
        if (m)
          return;
      }
      Pn.push(o);
    }
  });
}
function Es(e, t) {
  Di.set(e, t);
}
function Dp() {
  let e = !1, t = !1;
  Pn.forEach((r) => {
    const {
      direction: o
    } = r;
    o === "horizontal" ? e = !0 : t = !0;
  });
  let n = 0;
  Di.forEach((r) => {
    n |= r;
  }), e && t ? Ss("intersection", n) : e ? Ss("horizontal", n) : t ? Ss("vertical", n) : MF();
}
function Ja() {
  wn.forEach((e, t) => {
    const {
      body: n
    } = t;
    n.removeEventListener("contextmenu", bn), n.removeEventListener("mousedown", ba), n.removeEventListener("mouseleave", vn), n.removeEventListener("mousemove", vn), n.removeEventListener("touchmove", vn), n.removeEventListener("touchstart", ba);
  }), window.removeEventListener("mouseup", bn), window.removeEventListener("touchcancel", bn), window.removeEventListener("touchend", bn), Fo.size > 0 && (Ri ? (Pn.length > 0 && wn.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("contextmenu", bn), n.addEventListener("mouseleave", vn), n.addEventListener("mousemove", vn), n.addEventListener("touchmove", vn, {
      passive: !1
    }));
  }), window.addEventListener("mouseup", bn), window.addEventListener("touchcancel", bn), window.addEventListener("touchend", bn)) : wn.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("mousedown", ba), n.addEventListener("mousemove", vn), n.addEventListener("touchmove", vn, {
      passive: !1
    }), n.addEventListener("touchstart", ba));
  }));
}
function Yc(e, t) {
  Fo.forEach((n) => {
    const {
      setResizeHandlerState: r
    } = n, o = Pn.includes(n);
    r(e, o, t);
  });
}
function pe(e, t = "Assertion failed!") {
  if (!e)
    throw console.error(t), Error(t);
}
const Np = 10;
function Bo(e, t, n = Np) {
  e = parseFloat(e.toFixed(n)), t = parseFloat(t.toFixed(n));
  const r = e - t;
  return r === 0 ? 0 : r > 0 ? 1 : -1;
}
function wt(e, t, n) {
  return Bo(e, t, n) === 0;
}
function _r({
  panelConstraints: e,
  panelIndex: t,
  size: n
}) {
  const r = e[t];
  pe(r != null);
  let {
    collapsedSize: o = 0,
    collapsible: a,
    maxSize: i = 100,
    minSize: s = 0
  } = r;
  if (Bo(n, s) < 0)
    if (a) {
      const l = (o + s) / 2;
      Bo(n, l) < 0 ? n = o : n = s;
    } else
      n = s;
  return n = Math.min(i, n), n = parseFloat(n.toFixed(Np)), n;
}
function Eo({
  delta: e,
  layout: t,
  panelConstraints: n,
  pivotIndices: r,
  trigger: o
}) {
  if (wt(e, 0))
    return t;
  const a = [...t], [i, s] = r;
  pe(i != null), pe(s != null);
  let l = 0;
  if (o === "keyboard") {
    {
      const u = e < 0 ? s : i, d = n[u];
      if (pe(d), d.collapsible) {
        const f = t[u];
        pe(f != null);
        const h = n[u];
        pe(h);
        const {
          collapsedSize: p = 0,
          minSize: m = 0
        } = h;
        if (wt(f, p)) {
          const g = m - f;
          Bo(g, Math.abs(e)) > 0 && (e = e < 0 ? 0 - g : g);
        }
      }
    }
    {
      const u = e < 0 ? i : s, d = n[u];
      pe(d);
      const {
        collapsible: f
      } = d;
      if (f) {
        const h = t[u];
        pe(h != null);
        const p = n[u];
        pe(p);
        const {
          collapsedSize: m = 0,
          minSize: g = 0
        } = p;
        if (wt(h, g)) {
          const y = h - m;
          Bo(y, Math.abs(e)) > 0 && (e = e < 0 ? 0 - y : y);
        }
      }
    }
  }
  {
    const u = e < 0 ? 1 : -1;
    let d = e < 0 ? s : i, f = 0;
    for (; ; ) {
      const p = t[d];
      pe(p != null);
      const g = _r({
        panelConstraints: n,
        panelIndex: d,
        size: 100
      }) - p;
      if (f += g, d += u, d < 0 || d >= n.length)
        break;
    }
    const h = Math.min(Math.abs(e), Math.abs(f));
    e = e < 0 ? 0 - h : h;
  }
  {
    let d = e < 0 ? i : s;
    for (; d >= 0 && d < n.length; ) {
      const f = Math.abs(e) - Math.abs(l), h = t[d];
      pe(h != null);
      const p = h - f, m = _r({
        panelConstraints: n,
        panelIndex: d,
        size: p
      });
      if (!wt(h, m) && (l += h - m, a[d] = m, l.toPrecision(3).localeCompare(Math.abs(e).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      e < 0 ? d-- : d++;
    }
  }
  if (wt(l, 0))
    return t;
  {
    const u = e < 0 ? s : i, d = t[u];
    pe(d != null);
    const f = d + l, h = _r({
      panelConstraints: n,
      panelIndex: u,
      size: f
    });
    if (a[u] = h, !wt(h, f)) {
      let p = f - h, g = e < 0 ? s : i;
      for (; g >= 0 && g < n.length; ) {
        const y = a[g];
        pe(y != null);
        const b = y + p, w = _r({
          panelConstraints: n,
          panelIndex: g,
          size: b
        });
        if (wt(y, w) || (p -= w - y, a[g] = w), wt(p, 0))
          break;
        e > 0 ? g-- : g++;
      }
    }
  }
  const c = a.reduce((u, d) => d + u, 0);
  return wt(c, 100) ? a : t;
}
function NF({
  layout: e,
  panelsArray: t,
  pivotIndices: n
}) {
  let r = 0, o = 100, a = 0, i = 0;
  const s = n[0];
  pe(s != null), t.forEach((d, f) => {
    const {
      constraints: h
    } = d, {
      maxSize: p = 100,
      minSize: m = 0
    } = h;
    f === s ? (r = m, o = p) : (a += m, i += p);
  });
  const l = Math.min(o, 100 - a), c = Math.max(r, 100 - i), u = e[s];
  return {
    valueMax: l,
    valueMin: c,
    valueNow: u
  };
}
function zo(e, t = document) {
  return Array.from(t.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function Lp(e, t, n = document) {
  const o = zo(e, n).findIndex((a) => a.getAttribute("data-panel-resize-handle-id") === t);
  return o ?? null;
}
function jp(e, t, n) {
  const r = Lp(e, t, n);
  return r != null ? [r, r + 1] : [-1, -1];
}
function Hp(e, t = document) {
  var n;
  if (t instanceof HTMLElement && (t == null || (n = t.dataset) === null || n === void 0 ? void 0 : n.panelGroupId) == e)
    return t;
  const r = t.querySelector(`[data-panel-group][data-panel-group-id="${e}"]`);
  return r || null;
}
function Ni(e, t = document) {
  const n = t.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return n || null;
}
function LF(e, t, n, r = document) {
  var o, a, i, s;
  const l = Ni(t, r), c = zo(e, r), u = l ? c.indexOf(l) : -1, d = (o = (a = n[u]) === null || a === void 0 ? void 0 : a.id) !== null && o !== void 0 ? o : null, f = (i = (s = n[u + 1]) === null || s === void 0 ? void 0 : s.id) !== null && i !== void 0 ? i : null;
  return [d, f];
}
function jF({
  committedValuesRef: e,
  eagerValuesRef: t,
  groupId: n,
  layout: r,
  panelDataArray: o,
  panelGroupElement: a,
  setLayout: i
}) {
  pt({
    didWarnAboutMissingResizeHandle: !1
  }), Fn(() => {
    if (!a)
      return;
    const s = zo(n, a);
    for (let l = 0; l < o.length - 1; l++) {
      const {
        valueMax: c,
        valueMin: u,
        valueNow: d
      } = NF({
        layout: r,
        panelsArray: o,
        pivotIndices: [l, l + 1]
      }), f = s[l];
      if (f != null) {
        const h = o[l];
        pe(h), f.setAttribute("aria-controls", h.id), f.setAttribute("aria-valuemax", "" + Math.round(c)), f.setAttribute("aria-valuemin", "" + Math.round(u)), f.setAttribute("aria-valuenow", d != null ? "" + Math.round(d) : "");
      }
    }
    return () => {
      s.forEach((l, c) => {
        l.removeAttribute("aria-controls"), l.removeAttribute("aria-valuemax"), l.removeAttribute("aria-valuemin"), l.removeAttribute("aria-valuenow");
      });
    };
  }, [n, r, o, a]), Hn(() => {
    if (!a)
      return;
    const s = t.current;
    pe(s);
    const {
      panelDataArray: l
    } = s, c = Hp(n, a);
    pe(c != null, `No group found for id "${n}"`);
    const u = zo(n, a);
    pe(u);
    const d = u.map((f) => {
      const h = f.getAttribute("data-panel-resize-handle-id");
      pe(h);
      const [p, m] = LF(n, h, l, a);
      if (p == null || m == null)
        return () => {
        };
      const g = (y) => {
        if (!y.defaultPrevented)
          switch (y.key) {
            case "Enter": {
              y.preventDefault();
              const b = l.findIndex((w) => w.id === p);
              if (b >= 0) {
                const w = l[b];
                pe(w);
                const S = r[b], {
                  collapsedSize: x = 0,
                  collapsible: M,
                  minSize: _ = 0
                } = w.constraints;
                if (S != null && M) {
                  const R = Eo({
                    delta: wt(S, x) ? _ - x : x - S,
                    layout: r,
                    panelConstraints: l.map((B) => B.constraints),
                    pivotIndices: jp(n, h, a),
                    trigger: "keyboard"
                  });
                  r !== R && i(R);
                }
              }
              break;
            }
          }
      };
      return f.addEventListener("keydown", g), () => {
        f.removeEventListener("keydown", g);
      };
    });
    return () => {
      d.forEach((f) => f());
    };
  }, [a, e, t, n, r, o, i]);
}
function md(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Fp(e, t) {
  const n = e === "horizontal", {
    x: r,
    y: o
  } = $i(t);
  return n ? r : o;
}
function HF(e, t, n, r, o) {
  const a = n === "horizontal", i = Ni(t, o);
  pe(i);
  const s = i.getAttribute("data-panel-group-id");
  pe(s);
  let {
    initialCursorPosition: l
  } = r;
  const c = Fp(n, e), u = Hp(s, o);
  pe(u);
  const d = u.getBoundingClientRect(), f = a ? d.width : d.height;
  return (c - l) / f * 100;
}
function FF(e, t, n, r, o, a) {
  if (Mp(e)) {
    const i = n === "horizontal";
    let s = 0;
    e.shiftKey ? s = 100 : o != null ? s = o : s = 10;
    let l = 0;
    switch (e.key) {
      case "ArrowDown":
        l = i ? 0 : s;
        break;
      case "ArrowLeft":
        l = i ? -s : 0;
        break;
      case "ArrowRight":
        l = i ? s : 0;
        break;
      case "ArrowUp":
        l = i ? 0 : -s;
        break;
      case "End":
        l = 100;
        break;
      case "Home":
        l = -100;
        break;
    }
    return l;
  } else
    return r == null ? 0 : HF(e, t, n, r, a);
}
function BF({
  panelDataArray: e
}) {
  const t = Array(e.length), n = e.map((a) => a.constraints);
  let r = 0, o = 100;
  for (let a = 0; a < e.length; a++) {
    const i = n[a];
    pe(i);
    const {
      defaultSize: s
    } = i;
    s != null && (r++, t[a] = s, o -= s);
  }
  for (let a = 0; a < e.length; a++) {
    const i = n[a];
    pe(i);
    const {
      defaultSize: s
    } = i;
    if (s != null)
      continue;
    const l = e.length - r, c = o / l;
    r++, t[a] = c, o -= c;
  }
  return t;
}
function ar(e, t, n) {
  t.forEach((r, o) => {
    const a = e[o];
    pe(a);
    const {
      callbacks: i,
      constraints: s,
      id: l
    } = a, {
      collapsedSize: c = 0,
      collapsible: u
    } = s, d = n[l];
    if (d == null || r !== d) {
      n[l] = r;
      const {
        onCollapse: f,
        onExpand: h,
        onResize: p
      } = i;
      p && p(r, d), u && (f || h) && (h && (d == null || d === c) && r !== c && h(), f && (d == null || d !== c) && r === c && f());
    }
  });
}
function ya(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n])
      return !1;
  return !0;
}
function zF({
  defaultSize: e,
  dragState: t,
  layout: n,
  panelData: r,
  panelIndex: o,
  precision: a = 3
}) {
  const i = n[o];
  let s;
  return i == null ? s = e != null ? e.toPrecision(a) : "1" : r.length === 1 ? s = "1" : s = i.toPrecision(a), {
    flexBasis: 0,
    flexGrow: s,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: t !== null ? "none" : void 0
  };
}
function IF(e, t = 10) {
  let n = null;
  return (...o) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...o);
    }, t);
  };
}
function gd(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
function Bp(e) {
  return `react-resizable-panels:${e}`;
}
function zp(e) {
  return e.map((t) => {
    const {
      constraints: n,
      id: r,
      idIsFromProps: o,
      order: a
    } = t;
    return o ? r : a ? `${a}:${JSON.stringify(n)}` : JSON.stringify(n);
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function Ip(e, t) {
  try {
    const n = Bp(e), r = t.getItem(n);
    if (r) {
      const o = JSON.parse(r);
      if (typeof o == "object" && o != null)
        return o;
    }
  } catch {
  }
  return null;
}
function WF(e, t, n) {
  var r, o;
  const a = (r = Ip(e, n)) !== null && r !== void 0 ? r : {}, i = zp(t);
  return (o = a[i]) !== null && o !== void 0 ? o : null;
}
function VF(e, t, n, r, o) {
  var a;
  const i = Bp(e), s = zp(t), l = (a = Ip(e, o)) !== null && a !== void 0 ? a : {};
  l[s] = {
    expandToSizes: Object.fromEntries(n.entries()),
    layout: r
  };
  try {
    o.setItem(i, JSON.stringify(l));
  } catch (c) {
    console.error(c);
  }
}
function vd({
  layout: e,
  panelConstraints: t
}) {
  const n = [...e], r = n.reduce((a, i) => a + i, 0);
  if (n.length !== t.length)
    throw Error(`Invalid ${t.length} panel layout: ${n.map((a) => `${a}%`).join(", ")}`);
  if (!wt(r, 100))
    for (let a = 0; a < t.length; a++) {
      const i = n[a];
      pe(i != null);
      const s = 100 / r * i;
      n[a] = s;
    }
  let o = 0;
  for (let a = 0; a < t.length; a++) {
    const i = n[a];
    pe(i != null);
    const s = _r({
      panelConstraints: t,
      panelIndex: a,
      size: i
    });
    i != s && (o += i - s, n[a] = s);
  }
  if (!wt(o, 0))
    for (let a = 0; a < t.length; a++) {
      const i = n[a];
      pe(i != null);
      const s = i + o, l = _r({
        panelConstraints: t,
        panelIndex: a,
        size: s
      });
      if (i !== l && (o -= l - i, n[a] = l, wt(o, 0)))
        break;
    }
  return n;
}
const YF = 100, ko = {
  getItem: (e) => (gd(ko), ko.getItem(e)),
  setItem: (e, t) => {
    gd(ko), ko.setItem(e, t);
  }
}, bd = {};
function Wp({
  autoSaveId: e = null,
  children: t,
  className: n = "",
  direction: r,
  forwardedRef: o,
  id: a = null,
  onLayout: i = null,
  keyboardResizeBy: s = null,
  storage: l = ko,
  style: c,
  tagName: u = "div",
  ...d
}) {
  const f = Wc(a), h = pt(null), [p, m] = To(null), [g, y] = To([]), b = pt({}), w = pt(/* @__PURE__ */ new Map()), S = pt(0), x = pt({
    autoSaveId: e,
    direction: r,
    dragState: p,
    id: f,
    keyboardResizeBy: s,
    onLayout: i,
    storage: l
  }), M = pt({
    layout: g,
    panelDataArray: [],
    panelDataArrayChanged: !1
  });
  pt({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  }), Sp(o, () => ({
    getId: () => x.current.id,
    getLayout: () => {
      const {
        layout: $
      } = M.current;
      return $;
    },
    setLayout: ($) => {
      const {
        onLayout: I
      } = x.current, {
        layout: H,
        panelDataArray: Y
      } = M.current, W = vd({
        layout: $,
        panelConstraints: Y.map((q) => q.constraints)
      });
      md(H, W) || (y(W), M.current.layout = W, I && I(W), ar(Y, W, b.current));
    }
  }), []), Fn(() => {
    x.current.autoSaveId = e, x.current.direction = r, x.current.dragState = p, x.current.id = f, x.current.onLayout = i, x.current.storage = l;
  }), jF({
    committedValuesRef: x,
    eagerValuesRef: M,
    groupId: f,
    layout: g,
    panelDataArray: M.current.panelDataArray,
    setLayout: y,
    panelGroupElement: h.current
  }), Hn(() => {
    const {
      panelDataArray: $
    } = M.current;
    if (e) {
      if (g.length === 0 || g.length !== $.length)
        return;
      let I = bd[e];
      I == null && (I = IF(VF, YF), bd[e] = I);
      const H = [...$], Y = new Map(w.current);
      I(e, H, Y, g, l);
    }
  }, [e, g, l]), Hn(() => {
  });
  const _ = bt(($) => {
    const {
      onLayout: I
    } = x.current, {
      layout: H,
      panelDataArray: Y
    } = M.current;
    if ($.constraints.collapsible) {
      const W = Y.map((J) => J.constraints), {
        collapsedSize: q = 0,
        panelSize: Z,
        pivotIndices: ee
      } = An(Y, $, H);
      if (pe(Z != null), Z !== q) {
        w.current.set($.id, Z);
        const ie = Mr(Y, $) === Y.length - 1 ? Z - q : q - Z, D = Eo({
          delta: ie,
          layout: H,
          panelConstraints: W,
          pivotIndices: ee,
          trigger: "imperative-api"
        });
        ya(H, D) || (y(D), M.current.layout = D, I && I(D), ar(Y, D, b.current));
      }
    }
  }, []), R = bt(($) => {
    const {
      onLayout: I
    } = x.current, {
      layout: H,
      panelDataArray: Y
    } = M.current;
    if ($.constraints.collapsible) {
      const W = Y.map((ie) => ie.constraints), {
        collapsedSize: q = 0,
        panelSize: Z,
        minSize: ee = 0,
        pivotIndices: J
      } = An(Y, $, H);
      if (Z === q) {
        const ie = w.current.get($.id), D = ie != null && ie >= ee ? ie : ee, We = Mr(Y, $) === Y.length - 1 ? Z - D : D - Z, we = Eo({
          delta: We,
          layout: H,
          panelConstraints: W,
          pivotIndices: J,
          trigger: "imperative-api"
        });
        ya(H, we) || (y(we), M.current.layout = we, I && I(we), ar(Y, we, b.current));
      }
    }
  }, []), B = bt(($) => {
    const {
      layout: I,
      panelDataArray: H
    } = M.current, {
      panelSize: Y
    } = An(H, $, I);
    return pe(Y != null), Y;
  }, []), U = bt(($, I) => {
    const {
      panelDataArray: H
    } = M.current, Y = Mr(H, $);
    return zF({
      defaultSize: I,
      dragState: p,
      layout: g,
      panelData: H,
      panelIndex: Y
    });
  }, [p, g]), F = bt(($) => {
    const {
      layout: I,
      panelDataArray: H
    } = M.current, {
      collapsedSize: Y = 0,
      collapsible: W,
      panelSize: q
    } = An(H, $, I);
    return W === !0 && q === Y;
  }, []), T = bt(($) => {
    const {
      layout: I,
      panelDataArray: H
    } = M.current, {
      collapsedSize: Y = 0,
      collapsible: W,
      panelSize: q
    } = An(H, $, I);
    return pe(q != null), !W || q > Y;
  }, []), j = bt(($) => {
    const {
      panelDataArray: I
    } = M.current;
    I.push($), I.sort((H, Y) => {
      const W = H.order, q = Y.order;
      return W == null && q == null ? 0 : W == null ? -1 : q == null ? 1 : W - q;
    }), M.current.panelDataArrayChanged = !0;
  }, []);
  Fn(() => {
    if (M.current.panelDataArrayChanged) {
      M.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: $,
        onLayout: I,
        storage: H
      } = x.current, {
        layout: Y,
        panelDataArray: W
      } = M.current;
      let q = null;
      if ($) {
        const ee = WF($, W, H);
        ee && (w.current = new Map(Object.entries(ee.expandToSizes)), q = ee.layout);
      }
      q == null && (q = BF({
        panelDataArray: W
      }));
      const Z = vd({
        layout: q,
        panelConstraints: W.map((ee) => ee.constraints)
      });
      md(Y, Z) || (y(Z), M.current.layout = Z, I && I(Z), ar(W, Z, b.current));
    }
  }), Fn(() => {
    const $ = M.current;
    return () => {
      $.layout = [];
    };
  }, []);
  const A = bt(($) => function(H) {
    H.preventDefault();
    const Y = h.current;
    if (!Y)
      return () => null;
    const {
      direction: W,
      dragState: q,
      id: Z,
      keyboardResizeBy: ee,
      onLayout: J
    } = x.current, {
      layout: ie,
      panelDataArray: D
    } = M.current, {
      initialLayout: ye
    } = q ?? {}, We = jp(Z, $, Y);
    let we = FF(H, $, W, q, ee, Y);
    if (we === 0)
      return;
    const lt = W === "horizontal";
    document.dir === "rtl" && lt && (we = -we);
    const xe = D.map((Ve) => Ve.constraints), ce = Eo({
      delta: we,
      layout: ye ?? ie,
      panelConstraints: xe,
      pivotIndices: We,
      trigger: Mp(H) ? "keyboard" : "mouse-or-touch"
    }), ue = !ya(ie, ce);
    (_p(H) || Pp(H)) && S.current != we && (S.current = we, ue ? Es($, 0) : lt ? Es($, we < 0 ? Tp : Ap) : Es($, we < 0 ? $p : Rp)), ue && (y(ce), M.current.layout = ce, J && J(ce), ar(D, ce, b.current));
  }, []), G = bt(($, I) => {
    const {
      onLayout: H
    } = x.current, {
      layout: Y,
      panelDataArray: W
    } = M.current, q = W.map((ye) => ye.constraints), {
      panelSize: Z,
      pivotIndices: ee
    } = An(W, $, Y);
    pe(Z != null);
    const ie = Mr(W, $) === W.length - 1 ? Z - I : I - Z, D = Eo({
      delta: ie,
      layout: Y,
      panelConstraints: q,
      pivotIndices: ee,
      trigger: "imperative-api"
    });
    ya(Y, D) || (y(D), M.current.layout = D, H && H(D), ar(W, D, b.current));
  }, []), N = bt(($, I) => {
    const {
      layout: H,
      panelDataArray: Y
    } = M.current, {
      collapsedSize: W = 0,
      collapsible: q
    } = I, {
      collapsedSize: Z = 0,
      collapsible: ee,
      maxSize: J = 100,
      minSize: ie = 0
    } = $.constraints, {
      panelSize: D
    } = An(Y, $, H);
    pe(D != null), q && ee && D === W ? W !== Z && G($, Z) : D < ie ? G($, ie) : D > J && G($, J);
  }, [G]), te = bt(($, I) => {
    const {
      direction: H
    } = x.current, {
      layout: Y
    } = M.current;
    if (!h.current)
      return;
    const W = Ni($, h.current);
    pe(W);
    const q = Fp(H, I);
    m({
      dragHandleId: $,
      dragHandleRect: W.getBoundingClientRect(),
      initialCursorPosition: q,
      initialLayout: Y
    });
  }, []), oe = bt(() => {
    m(null);
  }, []), Q = bt(($) => {
    const {
      panelDataArray: I
    } = M.current, H = Mr(I, $);
    H >= 0 && (I.splice(H, 1), delete b.current[$.id], M.current.panelDataArrayChanged = !0);
  }, []), P = xF(() => ({
    collapsePanel: _,
    direction: r,
    dragState: p,
    expandPanel: R,
    getPanelSize: B,
    getPanelStyle: U,
    groupId: f,
    isPanelCollapsed: F,
    isPanelExpanded: T,
    reevaluatePanelConstraints: N,
    registerPanel: j,
    registerResizeHandle: A,
    resizePanel: G,
    startDragging: te,
    stopDragging: oe,
    unregisterPanel: Q,
    panelGroupElement: h.current
  }), [_, p, r, R, B, U, f, F, T, N, j, A, G, te, oe, Q]), L = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return Dr(Ai.Provider, {
    value: P
  }, Dr(u, {
    ...d,
    children: t,
    className: n,
    id: a,
    ref: h,
    style: {
      ...L,
      ...c
    },
    // CSS selectors
    "data-panel-group": "",
    "data-panel-group-direction": r,
    "data-panel-group-id": f
  }));
}
const Vp = xp((e, t) => Dr(Wp, {
  ...e,
  forwardedRef: t
}));
Wp.displayName = "PanelGroup";
Vp.displayName = "forwardRef(PanelGroup)";
function Mr(e, t) {
  return e.findIndex((n) => n === t || n.id === t.id);
}
function An(e, t, n) {
  const r = Mr(e, t), a = r === e.length - 1 ? [r - 1, r] : [r, r + 1], i = n[r];
  return {
    ...t.constraints,
    panelSize: i,
    pivotIndices: a
  };
}
function qF({
  disabled: e,
  handleId: t,
  resizeHandler: n,
  panelGroupElement: r
}) {
  Hn(() => {
    if (e || n == null || r == null)
      return;
    const o = Ni(t, r);
    if (o == null)
      return;
    const a = (i) => {
      if (!i.defaultPrevented)
        switch (i.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            i.preventDefault(), n(i);
            break;
          }
          case "F6": {
            i.preventDefault();
            const s = o.getAttribute("data-panel-group-id");
            pe(s);
            const l = zo(s, r), c = Lp(s, t, r);
            pe(c !== null);
            const u = i.shiftKey ? c > 0 ? c - 1 : l.length - 1 : c + 1 < l.length ? c + 1 : 0;
            l[u].focus();
            break;
          }
        }
    };
    return o.addEventListener("keydown", a), () => {
      o.removeEventListener("keydown", a);
    };
  }, [r, e, t, n]);
}
function Yp({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  hitAreaMargins: r,
  id: o,
  onDragging: a,
  style: i = {},
  tabIndex: s = 0,
  tagName: l = "div",
  ...c
}) {
  const u = pt(null), d = pt({
    onDragging: a
  });
  Hn(() => {
    d.current.onDragging = a;
  });
  const f = Cp(Ai);
  if (f === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    direction: h,
    groupId: p,
    registerResizeHandle: m,
    startDragging: g,
    stopDragging: y,
    panelGroupElement: b
  } = f, w = Wc(o), [S, x] = To("inactive"), [M, _] = To(!1), [R, B] = To(null), U = pt({
    state: S
  });
  return Fn(() => {
    U.current.state = S;
  }), Hn(() => {
    if (n)
      B(null);
    else {
      const T = m(w);
      B(() => T);
    }
  }, [n, w, m]), Hn(() => {
    var T, j;
    if (n || R == null)
      return;
    const A = u.current;
    pe(A);
    const G = (N, te, oe) => {
      if (te)
        switch (N) {
          case "down": {
            x("drag"), g(w, oe);
            const {
              onDragging: Q
            } = d.current;
            Q && Q(!0);
            break;
          }
          case "move": {
            const {
              state: Q
            } = U.current;
            Q !== "drag" && x("hover"), R(oe);
            break;
          }
          case "up": {
            x("hover"), y();
            const {
              onDragging: Q
            } = d.current;
            Q && Q(!1);
            break;
          }
        }
      else
        x("inactive");
    };
    return DF(w, A, h, {
      // Coarse inputs (e.g. finger/touch)
      coarse: (T = r == null ? void 0 : r.coarse) !== null && T !== void 0 ? T : 15,
      // Fine inputs (e.g. mouse)
      fine: (j = r == null ? void 0 : r.fine) !== null && j !== void 0 ? j : 5
    }, G);
  }, [h, n, r, m, w, R, g, y]), qF({
    disabled: n,
    handleId: w,
    resizeHandler: R,
    panelGroupElement: b
  }), Dr(l, {
    ...c,
    children: e,
    className: t,
    id: o,
    onBlur: () => _(!1),
    onFocus: () => _(!0),
    ref: u,
    role: "separator",
    style: {
      ...{
        touchAction: "none",
        userSelect: "none"
      },
      ...i
    },
    tabIndex: s,
    // CSS selectors
    "data-panel-group-direction": h,
    "data-panel-group-id": p,
    "data-resize-handle": "",
    "data-resize-handle-active": S === "drag" ? "pointer" : M ? "keyboard" : void 0,
    "data-resize-handle-state": S,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": w
  });
}
Yp.displayName = "PanelResizeHandle";
const UF = /* @__PURE__ */ C.jsxs(
  "svg",
  {
    className: "h-4 w-4 color-neutral-400",
    fill: "none",
    height: "18",
    viewBox: "0 0 18 18",
    width: "18",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C.jsx("circle", { cx: "9", cy: "9", fill: "white", r: "8.5", stroke: "currentColor", transform: "rotate(-180 9 9)" }),
      /* @__PURE__ */ C.jsx("path", { d: "M10.5 12.3333L14.5 8.90468L10.5 5.47611", stroke: "currentColor", strokeLinecap: "round" }),
      /* @__PURE__ */ C.jsx("path", { d: "M7.5 12.3333L3.5 8.90468L7.5 5.47611", stroke: "currentColor", strokeLinecap: "round" })
    ]
  }
), pV = ({
  className: e,
  ...t
}) => /* @__PURE__ */ C.jsx(
  Vp,
  {
    className: z("flex h-full w-full data-[panel-group-direction=vertical]:flex-col", e),
    ...t
  }
), mV = kp, gV = ({
  withHandle: e,
  className: t,
  ...n
}) => /* @__PURE__ */ C.jsx(
  Yp,
  {
    className: z(
      "relative flex w-px items-center justify-center bg-neutral-400 after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
      t
    ),
    ...n,
    children: e && /* @__PURE__ */ C.jsx("div", { className: "z-10 h-4 w-4 flex items-center justify-center", children: UF })
  }
), vV = ({ className: e, ...t }) => /* @__PURE__ */ C.jsx("div", { className: z("animate-pulse rounded-1 bg-neutral-300", e), ...t }), bV = ({ className: e, color: t = "neutral" }) => /* @__PURE__ */ C.jsx(
  "div",
  {
    className: z(
      "h-3 w-3 rounded-full",
      "b-2 b-solid",
      t === "dark" && "b-b-black/25 b-l-black/25 b-r-black/25 b-t-black",
      t === "light" && "b-b-neutral-100/25 b-l-neutral-100/25 b-r-neutral-100/25 b-t-neutral-100",
      t === "neutral" && "b-b-neutral-400 b-l-neutral-400 b-r-neutral-400 b-t-neutral-500",
      t === "primary" && "b-b-primary-100 b-l-primary-100 b-r-primary-100 b-t-primary-400",
      e
    )
  }
);
var qc = "Switch", [GF, yV] = Kr(qc), [XF, ZF] = GF(qc), qp = E.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      ...u
    } = e, [d, f] = E.useState(null), h = ut(t, (b) => f(b)), p = E.useRef(!1), m = d ? !!d.closest("form") : !0, [g = !1, y] = aa({
      prop: o,
      defaultProp: a,
      onChange: c
    });
    return /* @__PURE__ */ C.jsxs(XF, { scope: n, checked: g, disabled: s, children: [
      /* @__PURE__ */ C.jsx(
        Xe.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": g,
          "aria-required": i,
          "data-state": Xp(g),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...u,
          ref: h,
          onClick: He(e.onClick, (b) => {
            y((w) => !w), m && (p.current = b.isPropagationStopped(), p.current || b.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ C.jsx(
        KF,
        {
          control: d,
          bubbles: !p.current,
          name: r,
          value: l,
          checked: g,
          required: i,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
qp.displayName = qc;
var Up = "SwitchThumb", Gp = E.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = ZF(Up, n);
    return /* @__PURE__ */ C.jsx(
      Xe.span,
      {
        "data-state": Xp(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
Gp.displayName = Up;
var KF = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = E.useRef(null), i = zh(n), s = Hc(t);
  return E.useEffect(() => {
    const l = a.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (i !== n && d) {
      const f = new Event("click", { bubbles: r });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [i, n, r]), /* @__PURE__ */ C.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Xp(e) {
  return e ? "checked" : "unchecked";
}
var QF = qp, JF = Gp;
const eB = v.forwardRef(
  ({ className: e, v1: t, onChange: n, disabled: r, ...o }, a) => /* @__PURE__ */ C.jsx(
    QF,
    {
      className: z(
        "peer inline-flex h-4.5 w-9 shrink-0 cursor-pointer items-center rounded-full border-3 border-solid border-transparent transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=unchecked]:bg-neutral-400",
        t ? "data-[state=checked]:bg-skandI-400" : "data-[state=checked]:bg-primary-400",
        e
      ),
      disabled: r,
      onCheckedChange: n,
      ...o,
      ref: a,
      children: /* @__PURE__ */ C.jsx(
        JF,
        {
          className: z(
            "pointer-events-none block h-3 w-3 rounded-full ring-0 transition-transform bg-neutral-100",
            "data-[state=checked]:translate-x-4.5 data-[state=unchecked]:translate-x-0"
          )
        }
      )
    }
  )
);
eB.displayName = "Switch";
function Zp(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = E.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      var y;
      const { scope: f, children: h, ...p } = d, m = ((y = f == null ? void 0 : f[e]) == null ? void 0 : y[l]) || s, g = E.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ C.jsx(m.Provider, { value: g, children: h });
    };
    c.displayName = a + "Provider";
    function u(d, f) {
      var m;
      const h = ((m = f == null ? void 0 : f[e]) == null ? void 0 : m[l]) || s, p = E.useContext(h);
      if (p)
        return p;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return [c, u];
  }
  const o = () => {
    const a = n.map((i) => E.createContext(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return E.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, tB(o, ...t)];
}
function tB(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(a)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return E.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var nB = E["useId".toString()] || (() => {
}), rB = 0;
function Uc(e) {
  const [t, n] = E.useState(nB());
  return Ar(() => {
    e || n((r) => r ?? String(rB++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var ks = "rovingFocusGroup.onEntryFocus", oB = { bubbles: !1, cancelable: !0 }, Li = "RovingFocusGroup", [fl, Kp, aB] = Ih(Li), [iB, Qp] = Kr(
  Li,
  [aB]
), [sB, lB] = iB(Li), Jp = E.forwardRef(
  (e, t) => /* @__PURE__ */ C.jsx(fl.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ C.jsx(fl.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ C.jsx(cB, { ...e, ref: t }) }) })
);
Jp.displayName = Li;
var cB = E.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = E.useRef(null), h = ut(t, f), p = jc(a), [m = null, g] = aa({
    prop: i,
    defaultProp: s,
    onChange: l
  }), [y, b] = E.useState(!1), w = Jn(c), S = Kp(n), x = E.useRef(!1), [M, _] = E.useState(0);
  return E.useEffect(() => {
    const R = f.current;
    if (R)
      return R.addEventListener(ks, w), () => R.removeEventListener(ks, w);
  }, [w]), /* @__PURE__ */ C.jsx(
    sB,
    {
      scope: n,
      orientation: r,
      dir: p,
      loop: o,
      currentTabStopId: m,
      onItemFocus: E.useCallback(
        (R) => g(R),
        [g]
      ),
      onItemShiftTab: E.useCallback(() => b(!0), []),
      onFocusableItemAdd: E.useCallback(
        () => _((R) => R + 1),
        []
      ),
      onFocusableItemRemove: E.useCallback(
        () => _((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ C.jsx(
        Xe.div,
        {
          tabIndex: y || M === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: He(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: He(e.onFocus, (R) => {
            const B = !x.current;
            if (R.target === R.currentTarget && B && !y) {
              const U = new CustomEvent(ks, oB);
              if (R.currentTarget.dispatchEvent(U), !U.defaultPrevented) {
                const F = S().filter((N) => N.focusable), T = F.find((N) => N.active), j = F.find((N) => N.id === m), G = [T, j, ...F].filter(
                  Boolean
                ).map((N) => N.ref.current);
                n3(G, u);
              }
            }
            x.current = !1;
          }),
          onBlur: He(e.onBlur, () => b(!1))
        }
      )
    }
  );
}), e3 = "RovingFocusGroupItem", t3 = E.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      ...i
    } = e, s = Uc(), l = a || s, c = lB(e3, n), u = c.currentTabStopId === l, d = Kp(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
    return E.useEffect(() => {
      if (r)
        return f(), () => h();
    }, [r, f, h]), /* @__PURE__ */ C.jsx(
      fl.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ C.jsx(
          Xe.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...i,
            ref: t,
            onMouseDown: He(e.onMouseDown, (p) => {
              r ? c.onItemFocus(l) : p.preventDefault();
            }),
            onFocus: He(e.onFocus, () => c.onItemFocus(l)),
            onKeyDown: He(e.onKeyDown, (p) => {
              if (p.key === "Tab" && p.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (p.target !== p.currentTarget)
                return;
              const m = fB(p, c.orientation, c.dir);
              if (m !== void 0) {
                if (p.metaKey || p.ctrlKey || p.altKey || p.shiftKey)
                  return;
                p.preventDefault();
                let y = d().filter((b) => b.focusable).map((b) => b.ref.current);
                if (m === "last")
                  y.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && y.reverse();
                  const b = y.indexOf(p.currentTarget);
                  y = c.loop ? hB(y, b + 1) : y.slice(b + 1);
                }
                setTimeout(() => n3(y));
              }
            })
          }
        )
      }
    );
  }
);
t3.displayName = e3;
var uB = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function dB(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function fB(e, t, n) {
  const r = dB(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return uB[r];
}
function n3(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function hB(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var pB = Jp, mB = t3;
function gB(e, t) {
  return E.useReducer((n, r) => t[n][r] ?? n, e);
}
var Gc = (e) => {
  const { present: t, children: n } = e, r = vB(t), o = typeof n == "function" ? n({ present: r.isPresent }) : E.Children.only(n), a = ut(r.ref, bB(o));
  return typeof n == "function" || r.isPresent ? E.cloneElement(o, { ref: a }) : null;
};
Gc.displayName = "Presence";
function vB(e) {
  const [t, n] = E.useState(), r = E.useRef({}), o = E.useRef(e), a = E.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = gB(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return E.useEffect(() => {
    const c = wa(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [s]), Ar(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = a.current, h = wa(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), Ar(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const m = wa(r.current).includes(h.animationName);
        if (h.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, f = (h) => {
        h.target === t && (a.current = wa(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: E.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function wa(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function bB(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Xc = "Tabs", [yB, wV] = Zp(Xc, [
  Qp
]), r3 = Qp(), [wB, Zc] = yB(Xc), o3 = E.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = jc(s), [d, f] = aa({
      prop: r,
      onChange: o,
      defaultProp: a
    });
    return /* @__PURE__ */ C.jsx(
      wB,
      {
        scope: n,
        baseId: Uc(),
        value: d,
        onValueChange: f,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ C.jsx(
          Xe.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
o3.displayName = Xc;
var a3 = "TabsList", i3 = E.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, a = Zc(a3, n), i = r3(n);
    return /* @__PURE__ */ C.jsx(
      pB,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ C.jsx(
          Xe.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
i3.displayName = a3;
var s3 = "TabsTrigger", l3 = E.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...a } = e, i = Zc(s3, n), s = r3(n), l = d3(i.baseId, r), c = f3(i.baseId, r), u = r === i.value;
    return /* @__PURE__ */ C.jsx(
      mB,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: u,
        children: /* @__PURE__ */ C.jsx(
          Xe.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...a,
            ref: t,
            onMouseDown: He(e.onMouseDown, (d) => {
              !o && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: He(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(r);
            }),
            onFocus: He(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !o && d && i.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
l3.displayName = s3;
var c3 = "TabsContent", u3 = E.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: a, ...i } = e, s = Zc(c3, n), l = d3(s.baseId, r), c = f3(s.baseId, r), u = r === s.value, d = E.useRef(u);
    return E.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ C.jsx(Gc, { present: o || u, children: ({ present: f }) => /* @__PURE__ */ C.jsx(
      Xe.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && a
      }
    ) });
  }
);
u3.displayName = c3;
function d3(e, t) {
  return `${e}-trigger-${t}`;
}
function f3(e, t) {
  return `${e}-content-${t}`;
}
var xB = o3, h3 = i3, p3 = l3, m3 = u3;
const xV = xB, CB = E.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx(h3, { className: z("flex", e), ref: n, ...t }));
CB.displayName = h3.displayName;
const SB = E.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx(
  p3,
  {
    className: z(
      "b-solid b-0 bg-transparent uppercase cursor-pointer flex-1",
      "inline-flex items-center justify-center whitespace-nowrap px-3 pt-3",
      "disabled:pointer-events-none disabled:opacity-50",
      "focus-visible:ring-ring",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
      "data-[state=active]:pb-10px data-[state=active]:b-b-2 data-[state=active]:b-b-primary-400 data-[state=active]:text-primary-400 data-[state=active]:typo-text-s-em",
      "data-[state=inactive]:pb-12px data-[state=inactive]:b-b-1 data-[state=inactive]:b-neutral-300 data-[state=inactive]:text-neutral-500 data-[state=inactive]:typo-text-s",
      e
    ),
    ref: n,
    ...t
  }
));
SB.displayName = p3.displayName;
const EB = E.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx(
  m3,
  {
    className: z(
      "mt-2",
      "ring-offset-background focus-visible:ring-ring",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
      e
    ),
    ref: n,
    ...t
  }
));
EB.displayName = m3.displayName;
function kB(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Jn(e);
  E.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var MB = "DismissableLayer", hl = "dismissableLayer.update", _B = "dismissableLayer.pointerDownOutside", PB = "dismissableLayer.focusOutside", yd, g3 = E.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), v3 = E.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = E.useContext(g3), [u, d] = E.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = E.useState({}), p = ut(t, (_) => d(_)), m = Array.from(c.layers), [g] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = m.indexOf(g), b = u ? m.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, S = b >= y, x = AB((_) => {
      const R = _.target, B = [...c.branches].some((U) => U.contains(R));
      !S || B || (o == null || o(_), i == null || i(_), _.defaultPrevented || s == null || s());
    }, f), M = $B((_) => {
      const R = _.target;
      [...c.branches].some((U) => U.contains(R)) || (a == null || a(_), i == null || i(_), _.defaultPrevented || s == null || s());
    }, f);
    return kB((_) => {
      b === c.layers.size - 1 && (r == null || r(_), !_.defaultPrevented && s && (_.preventDefault(), s()));
    }, f), E.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (yd = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), wd(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = yd);
        };
    }, [u, f, n, c]), E.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), wd());
    }, [u, c]), E.useEffect(() => {
      const _ = () => h({});
      return document.addEventListener(hl, _), () => document.removeEventListener(hl, _);
    }, []), /* @__PURE__ */ C.jsx(
      Xe.div,
      {
        ...l,
        ref: p,
        style: {
          pointerEvents: w ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: He(e.onFocusCapture, M.onFocusCapture),
        onBlurCapture: He(e.onBlurCapture, M.onBlurCapture),
        onPointerDownCapture: He(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
v3.displayName = MB;
var OB = "DismissableLayerBranch", TB = E.forwardRef((e, t) => {
  const n = E.useContext(g3), r = E.useRef(null), o = ut(t, r);
  return E.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ C.jsx(Xe.div, { ...e, ref: o });
});
TB.displayName = OB;
function AB(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Jn(e), r = E.useRef(!1), o = E.useRef(() => {
  });
  return E.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          b3(
            _B,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function $B(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Jn(e), r = E.useRef(!1);
  return E.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && b3(PB, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function wd() {
  const e = new CustomEvent(hl);
  document.dispatchEvent(e);
}
function b3(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Sj(o, a) : o.dispatchEvent(a);
}
var RB = "Arrow", y3 = E.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ C.jsx(
    Xe.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ C.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
y3.displayName = RB;
var DB = y3, Kc = "Popper", [w3, x3] = Kr(Kc), [NB, C3] = w3(Kc), S3 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = E.useState(null);
  return /* @__PURE__ */ C.jsx(NB, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
S3.displayName = Kc;
var E3 = "PopperAnchor", k3 = E.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = C3(E3, n), i = E.useRef(null), s = ut(t, i);
    return E.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */ C.jsx(Xe.div, { ...o, ref: s });
  }
);
k3.displayName = E3;
var Qc = "PopperContent", [LB, jB] = w3(Qc), M3 = E.forwardRef(
  (e, t) => {
    var q, Z, ee, J, ie, D;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: p,
      ...m
    } = e, g = C3(Qc, n), [y, b] = E.useState(null), w = ut(t, (ye) => b(ye)), [S, x] = E.useState(null), M = Hc(S), _ = (M == null ? void 0 : M.width) ?? 0, R = (M == null ? void 0 : M.height) ?? 0, B = r + (a !== "center" ? "-" + a : ""), U = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, F = Array.isArray(c) ? c : [c], T = F.length > 0, j = {
      padding: U,
      boundary: F.filter(FB),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: T
    }, { refs: A, floatingStyles: G, placement: N, isPositioned: te, middlewareData: oe } = V2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: B,
      whileElementsMounted: (...ye) => Cc(...ye, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        B$({ mainAxis: o + R, alignmentAxis: i }),
        l && z$({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? I$() : void 0,
          ...j
        }),
        l && bc({ ...j }),
        N2({
          ...j,
          apply: ({ elements: ye, rects: We, availableWidth: we, availableHeight: lt }) => {
            const { width: xe, height: ce } = We.reference, ue = ye.floating.style;
            ue.setProperty("--radix-popper-available-width", `${we}px`), ue.setProperty("--radix-popper-available-height", `${lt}px`), ue.setProperty("--radix-popper-anchor-width", `${xe}px`), ue.setProperty("--radix-popper-anchor-height", `${ce}px`);
          }
        }),
        S && sR({ element: S, padding: s }),
        BB({ arrowWidth: _, arrowHeight: R }),
        f && H$({ strategy: "referenceHidden", ...j })
      ]
    }), [Q, P] = O3(N), L = Jn(p);
    Ar(() => {
      te && (L == null || L());
    }, [te, L]);
    const $ = (q = oe.arrow) == null ? void 0 : q.x, I = (Z = oe.arrow) == null ? void 0 : Z.y, H = ((ee = oe.arrow) == null ? void 0 : ee.centerOffset) !== 0, [Y, W] = E.useState();
    return Ar(() => {
      y && W(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ C.jsx(
      "div",
      {
        ref: A.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: te ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Y,
          ["--radix-popper-transform-origin"]: [
            (J = oe.transformOrigin) == null ? void 0 : J.x,
            (ie = oe.transformOrigin) == null ? void 0 : ie.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((D = oe.hide) == null ? void 0 : D.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ C.jsx(
          LB,
          {
            scope: n,
            placedSide: Q,
            onArrowChange: x,
            arrowX: $,
            arrowY: I,
            shouldHideArrow: H,
            children: /* @__PURE__ */ C.jsx(
              Xe.div,
              {
                "data-side": Q,
                "data-align": P,
                ...m,
                ref: w,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: te ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
M3.displayName = Qc;
var _3 = "PopperArrow", HB = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, P3 = E.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = jB(_3, r), i = HB[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ C.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ C.jsx(
          DB,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
P3.displayName = _3;
function FB(e) {
  return e !== null;
}
var BB = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, y, b;
    const { placement: n, rects: r, middlewareData: o } = t, i = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [c, u] = O3(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + s / 2, h = (((b = o.arrow) == null ? void 0 : b.y) ?? 0) + l / 2;
    let p = "", m = "";
    return c === "bottom" ? (p = i ? d : `${f}px`, m = `${-l}px`) : c === "top" ? (p = i ? d : `${f}px`, m = `${r.floating.height + l}px`) : c === "right" ? (p = `${-l}px`, m = i ? d : `${h}px`) : c === "left" && (p = `${r.floating.width + l}px`, m = i ? d : `${h}px`), { data: { x: p, y: m } };
  }
});
function O3(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var zB = S3, IB = k3, WB = M3, VB = P3, YB = "VisuallyHidden", T3 = E.forwardRef(
  (e, t) => /* @__PURE__ */ C.jsx(
    Xe.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
T3.displayName = YB;
var qB = T3, [ji, CV] = Zp("Tooltip", [
  x3
]), Hi = x3(), A3 = "TooltipProvider", UB = 700, pl = "tooltip.open", [GB, Jc] = ji(A3), $3 = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = UB,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, [i, s] = E.useState(!0), l = E.useRef(!1), c = E.useRef(0);
  return E.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ C.jsx(
    GB,
    {
      scope: t,
      isOpenDelayed: i,
      delayDuration: n,
      onOpen: E.useCallback(() => {
        window.clearTimeout(c.current), s(!1);
      }, []),
      onClose: E.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: E.useCallback((u) => {
        l.current = u;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
$3.displayName = A3;
var Fi = "Tooltip", [XB, Bi] = ji(Fi), R3 = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, l = Jc(Fi, e.__scopeTooltip), c = Hi(t), [u, d] = E.useState(null), f = Uc(), h = E.useRef(0), p = i ?? l.disableHoverableContent, m = s ?? l.delayDuration, g = E.useRef(!1), [y = !1, b] = aa({
    prop: r,
    defaultProp: o,
    onChange: (_) => {
      _ ? (l.onOpen(), document.dispatchEvent(new CustomEvent(pl))) : l.onClose(), a == null || a(_);
    }
  }), w = E.useMemo(() => y ? g.current ? "delayed-open" : "instant-open" : "closed", [y]), S = E.useCallback(() => {
    window.clearTimeout(h.current), g.current = !1, b(!0);
  }, [b]), x = E.useCallback(() => {
    window.clearTimeout(h.current), b(!1);
  }, [b]), M = E.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      g.current = !0, b(!0);
    }, m);
  }, [m, b]);
  return E.useEffect(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ C.jsx(zB, { ...c, children: /* @__PURE__ */ C.jsx(
    XB,
    {
      scope: t,
      contentId: f,
      open: y,
      stateAttribute: w,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: E.useCallback(() => {
        l.isOpenDelayed ? M() : S();
      }, [l.isOpenDelayed, M, S]),
      onTriggerLeave: E.useCallback(() => {
        p ? x() : window.clearTimeout(h.current);
      }, [x, p]),
      onOpen: S,
      onClose: x,
      disableHoverableContent: p,
      children: n
    }
  ) });
};
R3.displayName = Fi;
var ml = "TooltipTrigger", D3 = E.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Bi(ml, n), a = Jc(ml, n), i = Hi(n), s = E.useRef(null), l = ut(t, s, o.onTriggerChange), c = E.useRef(!1), u = E.useRef(!1), d = E.useCallback(() => c.current = !1, []);
    return E.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ C.jsx(IB, { asChild: !0, ...i, children: /* @__PURE__ */ C.jsx(
      Xe.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: He(e.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: He(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: He(e.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: He(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: He(e.onBlur, o.onClose),
        onClick: He(e.onClick, o.onClose)
      }
    ) });
  }
);
D3.displayName = ml;
var ZB = "TooltipPortal", [SV, KB] = ji(ZB, {
  forceMount: void 0
}), Nr = "TooltipContent", N3 = E.forwardRef(
  (e, t) => {
    const n = KB(Nr, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, i = Bi(Nr, e.__scopeTooltip);
    return /* @__PURE__ */ C.jsx(Gc, { present: r || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ C.jsx(L3, { side: o, ...a, ref: t }) : /* @__PURE__ */ C.jsx(QB, { side: o, ...a, ref: t }) });
  }
), QB = E.forwardRef((e, t) => {
  const n = Bi(Nr, e.__scopeTooltip), r = Jc(Nr, e.__scopeTooltip), o = E.useRef(null), a = ut(t, o), [i, s] = E.useState(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: d } = r, f = E.useCallback(() => {
    s(null), d(!1);
  }, [d]), h = E.useCallback(
    (p, m) => {
      const g = p.currentTarget, y = { x: p.clientX, y: p.clientY }, b = nz(y, g.getBoundingClientRect()), w = rz(y, b), S = oz(m.getBoundingClientRect()), x = iz([...w, ...S]);
      s(x), d(!0);
    },
    [d]
  );
  return E.useEffect(() => () => f(), [f]), E.useEffect(() => {
    if (l && u) {
      const p = (g) => h(g, u), m = (g) => h(g, l);
      return l.addEventListener("pointerleave", p), u.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", p), u.removeEventListener("pointerleave", m);
      };
    }
  }, [l, u, h, f]), E.useEffect(() => {
    if (i) {
      const p = (m) => {
        const g = m.target, y = { x: m.clientX, y: m.clientY }, b = (l == null ? void 0 : l.contains(g)) || (u == null ? void 0 : u.contains(g)), w = !az(y, i);
        b ? f() : w && (f(), c());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [l, u, i, c, f]), /* @__PURE__ */ C.jsx(L3, { ...e, ref: a });
}), [JB, ez] = ji(Fi, { isInside: !1 }), L3 = E.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, l = Bi(Nr, n), c = Hi(n), { onClose: u } = l;
    return E.useEffect(() => (document.addEventListener(pl, u), () => document.removeEventListener(pl, u)), [u]), E.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          const h = f.target;
          h != null && h.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ C.jsx(
      v3,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ C.jsxs(
          WB,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ C.jsx(Dh, { children: r }),
              /* @__PURE__ */ C.jsx(JB, { scope: n, isInside: !0, children: /* @__PURE__ */ C.jsx(qB, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
N3.displayName = Nr;
var j3 = "TooltipArrow", tz = E.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Hi(n);
    return ez(
      j3,
      n
    ).isInside ? null : /* @__PURE__ */ C.jsx(VB, { ...o, ...r, ref: t });
  }
);
tz.displayName = j3;
function nz(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function rz(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function oz(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function az(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, l = t[a].y, c = t[i].x, u = t[i].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function iz(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), sz(t);
}
function sz(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var lz = $3, cz = R3, uz = D3, H3 = N3;
const EV = lz, kV = cz, MV = uz, dz = E.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ C.jsx(
  H3,
  {
    className: z(
      "z-50 overflow-hidden",
      // animate classes, not in use
      // 'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
      e
    ),
    ref: r,
    sideOffset: t,
    ...n
  }
));
dz.displayName = H3.displayName;
function _V({
  children: e,
  roots: t,
  walker: n,
  getKey: r,
  expandedKeys: o,
  sortCmp: a = () => 0,
  onDragEnd: i = () => {
  },
  buffer: s = 0.5,
  draggableClassName: l,
  quickListProps: c,
  selected: u,
  onSelected: d,
  draggableThreshold: f = 3,
  multiSelectClassName: h,
  dragHandle: p,
  treeNodeClassName: m
}) {
  const g = jt(), [y, b] = he(null), [w, S] = he(null), x = w == null ? void 0 : w.getBoundingClientRect(), [M, _] = he(/* @__PURE__ */ new Set()), [R, B] = he(0), [U, F] = he(0), [T, j] = he([]), [A, G] = he(null), [N, te] = he(!1), [oe, Q] = he(!1), [P, L] = he(null), [$, I] = he(!1), [H, Y] = he({ x: 0, y: 0 }), [W, q] = he([]), [Z, ee] = he(!1);
  nt(() => {
    $ && j(W);
  }, [W, $]), nt(() => {
    const xe = () => {
      if (T.length && x && y) {
        const ce = U + x.top + x.height, ue = 0.1 * x.height, Ve = Math.max(1, ce - x.top), ne = Math.max(1, x.bottom - ce), Se = 5;
        Ve < ue ? y.scrollBy(-Se / Ve) : ne < ue && y.scrollBy(Se / ne);
      }
      g.current = requestAnimationFrame(xe);
    };
    return g.current = requestAnimationFrame(xe), () => {
      g.current && cancelAnimationFrame(g.current);
    };
  }, [x, T, U, y]), nt(() => {
    o && (o.length ? ye(o) : We());
  }, [o]);
  const J = Ue((xe) => {
    B(xe.clientX), F(xe.clientY);
  }, []), ie = Ue(() => {
    T.length && A && i(T, A), j([]), G(null), q([]);
  }, [A, T, i]), D = Ue((xe, ce) => {
    _(xe ? (ue) => new Set(ue).add(ce) : (ue) => {
      const Ve = new Set(ue);
      return Ve.delete(ce), Ve;
    });
  }, []), ye = (xe) => {
    _((ce) => /* @__PURE__ */ new Set([...ce, ...xe]));
  }, We = () => {
    _(/* @__PURE__ */ new Set());
  }, we = Ct(() => {
    const xe = [], ce = t.map((ue) => [ue, 0]);
    for (a && ce.sort((ue, Ve) => a(ue[0], Ve[0])); ce.length > 0; ) {
      const ue = ce.pop();
      if (!ue)
        continue;
      const [Ve, ne] = ue, Se = r(Ve), rt = n(Ve), Ee = rt.length === 0, Fe = M.has(Se), Ze = (ct) => D(ct, Se), et = (ct, cn) => {
        u && q([.../* @__PURE__ */ new Set([Ve, ...u])]), x && (B(ct - x.left), F(cn - x.top - x.height));
      };
      if (xe.push({
        data: Ve,
        depth: ne,
        isLeaf: Ee,
        isOpen: Fe,
        dragTarget: T,
        dragDestination: A,
        setOpen: Ze,
        startDrag: et
      }), Fe) {
        rt.sort(a);
        for (const ct of rt)
          ce.push([ct, ne + 1]);
      }
    }
    return xe;
  }, [
    x,
    A,
    T,
    r,
    D,
    M,
    t,
    u,
    a,
    n
  ]), lt = Ue(
    ({ index: xe }) => {
      const ce = we[xe], ue = () => {
        T.length && !(T != null && T.includes(ce.data)) && G(ce.data);
      }, Ve = () => {
        A === ce.data && G(null);
      }, ne = (Fe) => {
        ee(!0), I(!1), Y({ x: Fe.clientX, y: Fe.clientY });
      }, Se = (Fe) => {
        if (Z) {
          const Ze = { x: Fe.clientX, y: Fe.clientY };
          Math.sqrt(
            Math.pow(Ze.x - H.x, 2) + Math.pow(Ze.y - H.y, 2)
          ) > f && I(!0);
        } else
          I(!1);
      }, rt = () => {
        ee(!1), I(!1);
      }, Ee = (Fe) => {
        const Ze = Fe.target;
        if (!(!u || !d || Ze && typeof Ze.className == "string" && Ze.className.includes("skand-tree-row-override")))
          if (L(xe), oe)
            u.includes(ce.data) ? d(u.filter((et) => et !== ce.data)) : d([...u, ce.data]);
          else if (N && P !== null) {
            const et = Math.min(P, xe), ct = Math.max(P, xe), cn = we.slice(et, ct + 1).map((ve) => ve.data);
            d([.../* @__PURE__ */ new Set([...u, ...cn])]);
          } else
            d([ce.data]);
      };
      return /* @__PURE__ */ C.jsx(
        "div",
        {
          className: z(
            u && u.includes(ce.data) && !$ && h,
            m
          ),
          onClick: Ee,
          onMouseDown: ne,
          onMouseEnter: ue,
          onMouseLeave: Ve,
          onMouseMove: Se,
          onMouseUp: rt,
          children: Array.isArray(e) ? e[0](ce) : e(ce)
        }
      );
    },
    [
      we,
      u,
      $,
      h,
      m,
      e,
      T,
      A,
      Z,
      H.x,
      H.y,
      f,
      d,
      oe,
      N,
      P
    ]
  );
  return nt(() => {
    const xe = (ue) => {
      (ue.key === "Meta" || ue.key === "Control") && Q(!0), ue.key === "Shift" && te(!0);
    }, ce = (ue) => {
      (ue.key === "Meta" || ue.key === "Control") && Q(!1), ue.key === "Shift" && te(!1);
    };
    return window.addEventListener("keydown", xe), window.addEventListener("keyup", ce), window.addEventListener("mousemove", J), window.addEventListener("mouseup", ie), () => {
      window.removeEventListener("keydown", xe), window.removeEventListener("keyup", ce), window.removeEventListener("mousemove", J), window.removeEventListener("mouseup", ie);
    };
  }, [ie, J]), /* @__PURE__ */ C.jsxs("div", { className: "h-full select-none", ref: S, children: [
    /* @__PURE__ */ C.jsx(bF, { buffer: s, itemCount: we.length, ref: b, ...c, children: lt }),
    T.length && x && /* @__PURE__ */ C.jsx(
      "div",
      {
        className: z(l, "absolute", "left-0", "top-0", "pointer-events-none"),
        style: {
          transform: `translate(${R - x.left}px, ${U - x.top}px)`
        },
        children: p ?? /* @__PURE__ */ C.jsx(C.Fragment, {})
      }
    )
  ] });
}
const PV = ({ url: e, close: t, type: n }) => /* @__PURE__ */ C.jsxs($h, { className: "m-4 max-h-screen max-w-screen overflow-hidden", children: [
  /* @__PURE__ */ C.jsxs("div", { className: z("flex", "flex-col", "relative"), children: [
    /* @__PURE__ */ C.jsx(
      "div",
      {
        className: z(
          "flex",
          "flex-row",
          "items-center gap-2",
          "justify-end",
          "absolute",
          "right-2",
          "top-2"
        ),
        children: /* @__PURE__ */ C.jsx(
          "div",
          {
            className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
            onClick: t,
            children: /* @__PURE__ */ C.jsx("div", { className: "i-skand-close cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
          }
        )
      }
    ),
    /* @__PURE__ */ C.jsx("video", { controls: !0, width: "800", children: /* @__PURE__ */ C.jsx("source", { src: e, type: n }) })
  ] }),
  /* @__PURE__ */ C.jsx("div", {})
] }), fz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 5V0H5V5H0V7H5V12H7V7H12V5H7Z"
    fill="currentColor"
  />
</svg>
`, hz = `
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.34 16.7831C11.599 16.7211 11.817 16.5491 11.937 16.3111L14.597 11.0921C14.775 10.7391 14.709 10.3131 14.429 10.0341L10.287 5.89214C10.008 5.61214 9.581 5.54614 9.23 5.72314L4.008 8.38314C3.773 8.50414 3.601 8.72114 3.538 8.98114L1 19.3201L11.34 16.7831Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M8.74149 11.5801L1.00049 19.3201" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.2599 2.1865L12.1799 1.2665C12.5349 0.911501 13.1139 0.911501 13.4689 1.2645L19.0539 6.8505C19.4089 7.2065 19.4089 7.7855 19.0539 8.1405L18.1339 9.0605C17.7789 9.4165 17.1979 9.4165 16.8429 9.0605L11.2579 3.4755C10.9039 3.1225 10.9039 2.5415 11.2599 2.1865Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, pz = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.37109 11V10.1875H4.83984L5.94922 8.95312C6.13151 8.76823 6.29688 8.58724 6.44531 8.41016C6.59375 8.23307 6.72135 8.05859 6.82812 7.88672C6.9375 7.71224 7.02214 7.53646 7.08203 7.35938C7.14193 7.18229 7.17188 7.0026 7.17188 6.82031C7.17188 6.49219 7.10156 6.20964 6.96094 5.97266C6.82031 5.73568 6.61458 5.55339 6.34375 5.42578C6.07292 5.29557 5.74219 5.23047 5.35156 5.23047C4.95052 5.23047 4.60417 5.3138 4.3125 5.48047C4.02083 5.64714 3.79688 5.86979 3.64062 6.14844C3.48438 6.42448 3.40625 6.73047 3.40625 7.06641H4.44141C4.44141 6.86849 4.47526 6.69271 4.54297 6.53906C4.61328 6.38542 4.71484 6.26562 4.84766 6.17969C4.98307 6.09115 5.14583 6.04688 5.33594 6.04688C5.50781 6.04688 5.65234 6.08333 5.76953 6.15625C5.88932 6.22917 5.98047 6.33203 6.04297 6.46484C6.10547 6.59505 6.13672 6.7474 6.13672 6.92188C6.13672 7.04167 6.11198 7.16797 6.0625 7.30078C6.01562 7.43099 5.9362 7.57682 5.82422 7.73828C5.71224 7.89974 5.5599 8.08984 5.36719 8.30859L3.51953 10.3047V11H7.37109ZM9.29688 11H9.92188C10.3099 11 10.6628 10.9362 10.9805 10.8086C11.2982 10.681 11.5716 10.4987 11.8008 10.2617C12.0326 10.0247 12.2096 9.74089 12.332 9.41016C12.457 9.07682 12.5195 8.70703 12.5195 8.30078V8.01562C12.5195 7.60677 12.457 7.23698 12.332 6.90625C12.2096 6.57552 12.0326 6.29167 11.8008 6.05469C11.5716 5.8151 11.2995 5.63151 10.9844 5.50391C10.6719 5.3763 10.3255 5.3125 9.94531 5.3125H9.29688H8.67188H8.22266V11H8.69531H9.29688ZM9.29688 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H9.29688V10.1562Z"
    fill="currentColor" />
</svg>
`, mz = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
  <path
    d="M7.37109 10.1875V11H3.51953V10.3047L5.36719 8.30859C5.5599 8.08984 5.71224 7.89974 5.82422 7.73828C5.9362 7.57682 6.01562 7.43099 6.0625 7.30078C6.11198 7.16797 6.13672 7.04167 6.13672 6.92188C6.13672 6.7474 6.10547 6.59505 6.04297 6.46484C5.98047 6.33203 5.88932 6.22917 5.76953 6.15625C5.65234 6.08333 5.50781 6.04688 5.33594 6.04688C5.14583 6.04688 4.98307 6.09115 4.84766 6.17969C4.71484 6.26562 4.61328 6.38542 4.54297 6.53906C4.47526 6.69271 4.44141 6.86849 4.44141 7.06641H3.40625C3.40625 6.73047 3.48438 6.42448 3.64062 6.14844C3.79688 5.86979 4.02083 5.64714 4.3125 5.48047C4.60417 5.3138 4.95052 5.23047 5.35156 5.23047C5.74219 5.23047 6.07292 5.29557 6.34375 5.42578C6.61458 5.55339 6.82031 5.73568 6.96094 5.97266C7.10156 6.20964 7.17188 6.49219 7.17188 6.82031C7.17188 7.0026 7.14193 7.18229 7.08203 7.35938C7.02214 7.53646 6.9375 7.71224 6.82812 7.88672C6.72135 8.05859 6.59375 8.23307 6.44531 8.41016C6.29688 8.58724 6.13151 8.76823 5.94922 8.95312L4.83984 10.1875H7.37109Z"
    fill="currentColor" />
  <path
    d="M9.92188 11H8.69531L8.70312 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H8.67188V5.3125H9.94531C10.3255 5.3125 10.6719 5.3763 10.9844 5.50391C11.2995 5.63151 11.5716 5.8151 11.8008 6.05469C12.0326 6.29167 12.2096 6.57552 12.332 6.90625C12.457 7.23698 12.5195 7.60677 12.5195 8.01562V8.30078C12.5195 8.70703 12.457 9.07682 12.332 9.41016C12.2096 9.74089 12.0326 10.0247 11.8008 10.2617C11.5716 10.4987 11.2982 10.681 10.9805 10.8086C10.6628 10.9362 10.3099 11 9.92188 11ZM9.29688 5.3125V11H8.22266V5.3125H9.29688Z"
    fill="currentColor" />
</svg>
`, gz = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.23047 7.69922H4.64844V7.94531V8.25781V8.49609H5.23047C5.4362 8.49609 5.61328 8.52734 5.76172 8.58984C5.91276 8.65234 6.02865 8.75 6.10938 8.88281C6.1901 9.01562 6.23047 9.1888 6.23047 9.40234C6.23047 9.58203 6.19401 9.73698 6.12109 9.86719C6.04818 9.99479 5.94271 10.0938 5.80469 10.1641C5.66927 10.2318 5.50651 10.2656 5.31641 10.2656C5.14453 10.2656 4.98958 10.2318 4.85156 10.1641C4.71615 10.0938 4.60938 9.9974 4.53125 9.875C4.45573 9.7526 4.41797 9.61328 4.41797 9.45703H3.38281C3.38281 9.72786 3.4362 9.96615 3.54297 10.1719C3.64974 10.375 3.79427 10.5443 3.97656 10.6797C4.15885 10.8125 4.36328 10.9128 4.58984 10.9805C4.81901 11.0456 5.05469 11.0781 5.29688 11.0781C5.57552 11.0781 5.83464 11.0417 6.07422 10.9688C6.3138 10.8932 6.52214 10.7839 6.69922 10.6406C6.87891 10.4974 7.01823 10.3229 7.11719 10.1172C7.21615 9.90885 7.26562 9.67188 7.26562 9.40625C7.26562 9.20312 7.22786 9.01302 7.15234 8.83594C7.07943 8.65885 6.96615 8.50391 6.8125 8.37109C6.67241 8.24763 6.49769 8.15014 6.28833 8.07863C6.44938 8.00504 6.58895 7.91633 6.70703 7.8125C6.86068 7.67708 6.97656 7.52604 7.05469 7.35938C7.13542 7.1901 7.17578 7.02083 7.17578 6.85156C7.17578 6.4974 7.09635 6.20052 6.9375 5.96094C6.78125 5.72135 6.5612 5.54036 6.27734 5.41797C5.99609 5.29297 5.66797 5.23047 5.29297 5.23047C4.94922 5.23047 4.63802 5.29688 4.35938 5.42969C4.08073 5.5625 3.85938 5.74609 3.69531 5.98047C3.53385 6.21224 3.45312 6.48177 3.45312 6.78906H4.48828C4.48828 6.63542 4.52474 6.50391 4.59766 6.39453C4.67318 6.28255 4.77344 6.19661 4.89844 6.13672C5.02604 6.07682 5.16536 6.04688 5.31641 6.04688C5.50391 6.04688 5.65755 6.08073 5.77734 6.14844C5.89974 6.21354 5.99089 6.30729 6.05078 6.42969C6.11068 6.54948 6.14062 6.69141 6.14062 6.85547C6.14062 7.02214 6.10677 7.16927 6.03906 7.29688C5.97396 7.42188 5.8737 7.52083 5.73828 7.59375C5.60547 7.66406 5.4362 7.69922 5.23047 7.69922ZM9.29688 11H9.92188C10.3099 11 10.6628 10.9362 10.9805 10.8086C11.2982 10.681 11.5716 10.4987 11.8008 10.2617C12.0326 10.0247 12.2096 9.74089 12.332 9.41016C12.457 9.07682 12.5195 8.70703 12.5195 8.30078V8.01562C12.5195 7.60677 12.457 7.23698 12.332 6.90625C12.2096 6.57552 12.0326 6.29167 11.8008 6.05469C11.5716 5.8151 11.2995 5.63151 10.9844 5.50391C10.6719 5.3763 10.3255 5.3125 9.94531 5.3125H9.29688H8.67188H8.22266V11H8.69531H9.29688ZM9.29688 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H9.29688V10.1562Z"
    fill="currentColor" />
</svg>
`, vz = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
  <path
    d="M4.64844 7.69922H5.23047C5.4362 7.69922 5.60547 7.66406 5.73828 7.59375C5.8737 7.52083 5.97396 7.42188 6.03906 7.29688C6.10677 7.16927 6.14062 7.02214 6.14062 6.85547C6.14062 6.69141 6.11068 6.54948 6.05078 6.42969C5.99089 6.30729 5.89974 6.21354 5.77734 6.14844C5.65755 6.08073 5.50391 6.04688 5.31641 6.04688C5.16536 6.04688 5.02604 6.07682 4.89844 6.13672C4.77344 6.19661 4.67318 6.28255 4.59766 6.39453C4.52474 6.50391 4.48828 6.63542 4.48828 6.78906H3.45312C3.45312 6.48177 3.53385 6.21224 3.69531 5.98047C3.85938 5.74609 4.08073 5.5625 4.35938 5.42969C4.63802 5.29688 4.94922 5.23047 5.29297 5.23047C5.66797 5.23047 5.99609 5.29297 6.27734 5.41797C6.5612 5.54036 6.78125 5.72135 6.9375 5.96094C7.09635 6.20052 7.17578 6.4974 7.17578 6.85156C7.17578 7.02083 7.13542 7.1901 7.05469 7.35938C6.97656 7.52604 6.86068 7.67708 6.70703 7.8125C6.55599 7.94531 6.36979 8.05339 6.14844 8.13672C5.92969 8.21745 5.67839 8.25781 5.39453 8.25781H4.64844V7.69922ZM4.64844 8.49609V7.94531H5.39453C5.71484 7.94531 5.99219 7.98307 6.22656 8.05859C6.46354 8.13151 6.65885 8.23568 6.8125 8.37109C6.96615 8.50391 7.07943 8.65885 7.15234 8.83594C7.22786 9.01302 7.26562 9.20312 7.26562 9.40625C7.26562 9.67188 7.21615 9.90885 7.11719 10.1172C7.01823 10.3229 6.87891 10.4974 6.69922 10.6406C6.52214 10.7839 6.3138 10.8932 6.07422 10.9688C5.83464 11.0417 5.57552 11.0781 5.29688 11.0781C5.05469 11.0781 4.81901 11.0456 4.58984 10.9805C4.36328 10.9128 4.15885 10.8125 3.97656 10.6797C3.79427 10.5443 3.64974 10.375 3.54297 10.1719C3.4362 9.96615 3.38281 9.72786 3.38281 9.45703H4.41797C4.41797 9.61328 4.45573 9.7526 4.53125 9.875C4.60938 9.9974 4.71615 10.0938 4.85156 10.1641C4.98958 10.2318 5.14453 10.2656 5.31641 10.2656C5.50651 10.2656 5.66927 10.2318 5.80469 10.1641C5.94271 10.0938 6.04818 9.99479 6.12109 9.86719C6.19401 9.73698 6.23047 9.58203 6.23047 9.40234C6.23047 9.1888 6.1901 9.01562 6.10938 8.88281C6.02865 8.75 5.91276 8.65234 5.76172 8.58984C5.61328 8.52734 5.4362 8.49609 5.23047 8.49609H4.64844Z"
    fill="currentColor" />
  <path
    d="M9.92188 11H8.69531L8.70312 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H8.67188V5.3125H9.94531C10.3255 5.3125 10.6719 5.3763 10.9844 5.50391C11.2995 5.63151 11.5716 5.8151 11.8008 6.05469C12.0326 6.29167 12.2096 6.57552 12.332 6.90625C12.457 7.23698 12.5195 7.60677 12.5195 8.01562V8.30078C12.5195 8.70703 12.457 9.07682 12.332 9.41016C12.2096 9.74089 12.0326 10.0247 11.8008 10.2617C11.5716 10.4987 11.2982 10.681 10.9805 10.8086C10.6628 10.9362 10.3099 11 9.92188 11ZM9.29688 5.3125V11H8.22266V5.3125H9.29688Z"
    fill="currentColor" />
</svg>
`, bz = `
<svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.86959 14.7481L10.0876 12.3121C10.5656 12.0371 11.1776 12.2001 11.4536 12.6791L12.4566 14.4171C12.7326 14.8951 12.5686 15.5071 12.0916 15.7831L7.87359 18.2181C7.39459 18.4941 6.78359 18.3301 6.50759 17.8521L5.50459 16.1141C5.22759 15.6361 5.39159 15.0231 5.86959 14.7481Z"
    fill="black" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.86959 14.7481L10.0876 12.3121C10.5656 12.0371 11.1776 12.2001 11.4536 12.6791L12.4566 14.4171C12.7326 14.8951 12.5686 15.5071 12.0916 15.7831L7.87359 18.2181C7.39459 18.4941 6.78359 18.3301 6.50759 17.8521L5.50459 16.1141C5.22759 15.6361 5.39159 15.0231 5.86959 14.7481Z"
    stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M1.12651 10.3155L2.46851 11.0185C3.28951 11.4925 4.07651 12.1605 4.67851 12.8925L5.77051 14.3095L5.88351 14.4555L6.02551 14.3735L9.68451 12.2605L9.82651 12.1785L9.75651 12.0075L9.07551 10.3535C8.74251 9.4665 8.55751 8.4505 8.55851 7.5025L8.61951 5.9895L0.432512 0.250504L4.08951 6.5845C4.43951 6.4405 4.85051 6.5745 5.04451 6.9105C5.25651 7.2775 5.13051 7.7465 4.76451 7.9585C4.39751 8.1695 3.92851 8.0445 3.71651 7.6775C3.52251 7.3425 3.61051 6.9215 3.90751 6.6905L0.249512 0.355504L1.12651 10.3155Z"
    fill="black" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M1.12651 10.3155L2.46851 11.0185C3.28951 11.4925 4.07651 12.1605 4.67851 12.8925L5.77051 14.3095L5.88351 14.4555L6.02551 14.3735L9.68451 12.2605L9.82651 12.1785L9.75651 12.0075L9.07551 10.3535C8.74251 9.4665 8.55751 8.4505 8.55851 7.5025L8.61951 5.9895L0.432512 0.250504L4.08951 6.5845C4.43951 6.4405 4.85051 6.5745 5.04451 6.9105C5.25651 7.2775 5.13051 7.7465 4.76451 7.9585C4.39751 8.1695 3.92851 8.0445 3.71651 7.6775C3.52251 7.3425 3.61051 6.9215 3.90751 6.6905L0.249512 0.355504L1.12651 10.3155Z"
    stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, yz = `
<svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 9L7 15L13 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M8 1.5C8 0.947715 7.55228 0.5 7 0.5C6.44772 0.5 6 0.947715 6 1.5H8ZM8 15V1.5H6V15H8Z"
    fill="currentColor" />
</svg>
  
`, wz = `
<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M5.22266 6.46484H3.76953L3.76172 5.70703H5.00781C5.22135 5.70703 5.39974 5.67708 5.54297 5.61719C5.6862 5.55729 5.79427 5.47005 5.86719 5.35547C5.94271 5.24089 5.98047 5.10156 5.98047 4.9375C5.98047 4.75521 5.94531 4.60677 5.875 4.49219C5.80729 4.3776 5.70052 4.29427 5.55469 4.24219C5.40885 4.1875 5.22396 4.16016 5 4.16016H4.11719V9H3.04297V3.3125H5C5.32292 3.3125 5.61068 3.34375 5.86328 3.40625C6.11849 3.46615 6.33464 3.5599 6.51172 3.6875C6.6888 3.8151 6.82292 3.97526 6.91406 4.16797C7.00781 4.36068 7.05469 4.58984 7.05469 4.85547C7.05469 5.08984 7 5.30599 6.89062 5.50391C6.78385 5.69922 6.61849 5.85807 6.39453 5.98047C6.17318 6.10286 5.89193 6.17318 5.55078 6.19141L5.22266 6.46484ZM5.17578 9H3.45312L3.90234 8.15625H5.17578C5.38932 8.15625 5.5651 8.12109 5.70312 8.05078C5.84375 7.98047 5.94792 7.88411 6.01562 7.76172C6.08594 7.63672 6.12109 7.49349 6.12109 7.33203C6.12109 7.15495 6.08984 7.0013 6.02734 6.87109C5.96745 6.74089 5.87109 6.64062 5.73828 6.57031C5.60807 6.5 5.4362 6.46484 5.22266 6.46484H4.10547L4.11328 5.70703H5.53516L5.78125 6C6.10938 6.0026 6.3763 6.06771 6.58203 6.19531C6.79036 6.32292 6.94401 6.48698 7.04297 6.6875C7.14193 6.88802 7.19141 7.10417 7.19141 7.33594C7.19141 7.70052 7.11198 8.00651 6.95312 8.25391C6.79688 8.5013 6.56771 8.6875 6.26562 8.8125C5.96615 8.9375 5.60286 9 5.17578 9ZM9.26562 3.3125V9H8.19141V3.3125H9.26562ZM10.8945 3.3125H11.8242L13.3789 7.59375L14.9297 3.3125H15.8633L13.75 9H13.0039L10.8945 3.3125ZM10.4258 3.3125H11.3359L11.5 7.24609V9H10.4258V3.3125ZM15.418 3.3125H16.332V9H15.2578V7.24609L15.418 3.3125Z"
    fill="currentColor" />
  <rect x="1" y="0.5" width="18" height="11" rx="1.5" stroke="currentColor" />
</svg>
  
`, xz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M2 0C0.895431 0 0 0.895431 0 2V10C0 11.1046 0.895431 12 2 12H10C11.1046 12 12 11.1046 12 10V2C12 0.895431 11.1046 0 10 0H2ZM10.3841 3.32009C10.5609 3.10795 10.5322 2.79267 10.3201 2.61589C10.108 2.43911 9.79267 2.46777 9.61589 2.67991L4.9664 8.25929L2.35355 5.64645C2.15829 5.45118 1.84171 5.45118 1.64645 5.64645C1.45118 5.84171 1.45118 6.15829 1.64645 6.35355L4.64645 9.35355C4.74578 9.45289 4.88232 9.50585 5.02266 9.49949C5.16299 9.49312 5.29418 9.42801 5.38411 9.32009L10.3841 3.32009Z"
    fill="currentColor" />
</svg>
  
`, Cz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="11" height="11" rx="1.5" stroke="currentColor" />
</svg>
  
`, Sz = `
<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M5.87109 7.12891H6.94531C6.91667 7.50911 6.8112 7.84635 6.62891 8.14062C6.44661 8.43229 6.19271 8.66146 5.86719 8.82812C5.54167 8.99479 5.14714 9.07812 4.68359 9.07812C4.32682 9.07812 4.00521 9.01562 3.71875 8.89062C3.4349 8.76302 3.19141 8.58203 2.98828 8.34766C2.78776 8.11068 2.63411 7.82682 2.52734 7.49609C2.42057 7.16276 2.36719 6.78906 2.36719 6.375V5.94141C2.36719 5.52734 2.42188 5.15365 2.53125 4.82031C2.64062 4.48698 2.79688 4.20312 3 3.96875C3.20573 3.73177 3.45182 3.54948 3.73828 3.42188C4.02734 3.29427 4.35026 3.23047 4.70703 3.23047C5.17057 3.23047 5.5625 3.31641 5.88281 3.48828C6.20312 3.65755 6.45182 3.89062 6.62891 4.1875C6.80599 4.48438 6.91276 4.82552 6.94922 5.21094H5.875C5.85417 4.97135 5.80208 4.76823 5.71875 4.60156C5.63802 4.4349 5.51562 4.30859 5.35156 4.22266C5.1901 4.13411 4.97526 4.08984 4.70703 4.08984C4.4987 4.08984 4.3151 4.12891 4.15625 4.20703C4 4.28516 3.86979 4.40234 3.76562 4.55859C3.66146 4.71224 3.58333 4.90495 3.53125 5.13672C3.47917 5.36589 3.45312 5.63151 3.45312 5.93359V6.375C3.45312 6.66406 3.47656 6.92318 3.52344 7.15234C3.57031 7.38151 3.64323 7.57552 3.74219 7.73438C3.84115 7.89323 3.96875 8.01432 4.125 8.09766C4.28125 8.18099 4.46745 8.22266 4.68359 8.22266C4.94661 8.22266 5.16016 8.18099 5.32422 8.09766C5.49089 8.01432 5.61719 7.89193 5.70312 7.73047C5.79167 7.56901 5.84766 7.36849 5.87109 7.12891ZM10.0391 4.17578L8.41797 9H7.28125L9.40625 3.3125H10.1328L10.0391 4.17578ZM11.3945 9L9.76562 4.17578L9.66797 3.3125H10.3984L12.5352 9H11.3945ZM11.3203 6.88672V7.73438H8.26953V6.88672H11.3203ZM14.8203 9H13.5938L13.6016 8.15625H14.8203C15.151 8.15625 15.4284 8.08333 15.6523 7.9375C15.8763 7.78906 16.0456 7.57682 16.1602 7.30078C16.2747 7.02214 16.332 6.6888 16.332 6.30078V6.00781C16.332 5.70833 16.2995 5.44401 16.2344 5.21484C16.1693 4.98568 16.0729 4.79297 15.9453 4.63672C15.8203 4.48047 15.6654 4.36198 15.4805 4.28125C15.2956 4.20052 15.0833 4.16016 14.8438 4.16016H13.5703V3.3125H14.8438C15.224 3.3125 15.5703 3.3763 15.8828 3.50391C16.1979 3.63151 16.4701 3.8151 16.6992 4.05469C16.931 4.29167 17.1081 4.57552 17.2305 4.90625C17.3555 5.23698 17.418 5.60677 17.418 6.01562V6.30078C17.418 6.70703 17.3555 7.07682 17.2305 7.41016C17.1081 7.74089 16.931 8.02474 16.6992 8.26172C16.4701 8.4987 16.1966 8.68099 15.8789 8.80859C15.5612 8.9362 15.2083 9 14.8203 9ZM14.1953 3.3125V9H13.1211V3.3125H14.1953Z"
    fill="currentColor" />
  <rect x="0.5" y="0.5" width="19" height="11" rx="1.5" stroke="currentColor" />
</svg>
  
`, Ez = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.50629 12.4H0.736328V8" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M8.50629 7.92H0.736328L5.88904 4H10.96" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M10.469 7.11575L13.6973 4.40001V8.45807L10.469 11.6" stroke="currentColor"
    stroke-width="0.4"
    stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="1.2 1.2" />
  <path d="M15.2126 9.606L8.66943 15.2V6.01595L15.2126 0.800003V9.606Z" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
  
`, kz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 1L1 11" stroke="currentColor" stroke-width="1.685" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M1 1L11 11" stroke="currentColor" stroke-width="1.685" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
`, Mz = `
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.33341 1.66667L1.66675 8.33334" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M1.66675 1.66667L8.33341 8.33334" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, _z = `
<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="2" cy="14" r="2" transform="rotate(-90 2 14)" fill="#4CB176" />
  <circle cx="8" cy="14" r="2" transform="rotate(-90 8 14)" fill="#8A858E" />
  <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#D04A6B" />
  <circle cx="8" cy="2" r="2" transform="rotate(-90 8 2)" fill="#3F8AE2" />
  <circle cx="8" cy="8" r="2" transform="rotate(-90 8 8)" fill="#8A1AE3" />
  <circle cx="2" cy="8" r="2" transform="rotate(-90 2 8)" fill="#F69C64" />
</svg>
`, Pz = `
<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.5 12C2.5 12.2761 2.27614 12.5 2 12.5C1.72386 12.5 1.5 12.2761 1.5 12H2.5ZM2 6H1.5C1.5 5.72386 1.72386 5.5 2 5.5V6ZM10.3536 5.64645C10.5488 5.84171 10.5488 6.15829 10.3536 6.35355L7.17157 9.53553C6.97631 9.7308 6.65973 9.7308 6.46447 9.53553C6.2692 9.34027 6.2692 9.02369 6.46447 8.82843L9.29289 6L6.46447 3.17157C6.2692 2.97631 6.2692 2.65973 6.46447 2.46447C6.65973 2.2692 6.97631 2.2692 7.17157 2.46447L10.3536 5.64645ZM1.5 12V6H2.5V12H1.5ZM2 5.5H10V6.5H2V5.5Z"
    fill="currentColor" />
</svg>
  
`, Oz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.75 0H2.25V1.5H2C0.895431 1.5 0 2.39543 0 3.5V9.25C0 10.3546 0.895431 11.25 2 11.25H10C11.1046 11.25 12 10.3546 12 9.25V3.5C12 2.39543 11.1046 1.5 10 1.5H9.75V0H8.25V1.5H3.75V0ZM2 2.5H10C10.5523 2.5 11 2.94772 11 3.5V4.5H1V3.5C1 2.94772 1.44772 2.5 2 2.5ZM1 5.25V9.25C1 9.80228 1.44772 10.25 2 10.25H10C10.5523 10.25 11 9.80229 11 9.25V5.25H1Z"
    fill="currentColor"
  />
</svg>
`, Tz = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.00073 9.19987L7.88266 15.0842L17.9918 4.99235" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, Az = `
<svg width="16" height="16" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.1379 9.39111L7.98058 12.5484L4.82324 9.39111" stroke="currentColor"
    stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M15.0729 12.9129V15.3502C15.0729 15.8391 14.6729 16.2391 14.184 16.2391H1.7778C1.28892 16.2391 0.888916 15.8391 0.888916 15.3502V12.9129"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M7.99303 12.4158V1.74915" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
  
`, $z = `
<svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
</svg>
`, Rz = `
<svg
  width="12"
  height="6"
  viewBox="0 0 12 6"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.135182 0.121919C0.315423 -0.0406395 0.607653 -0.0406395 0.787895 0.121919L6 4.82265L11.2121 0.121919C11.3923 -0.0406395 11.6846 -0.0406395 11.8648 0.121919C12.0451 0.284477 12.0451 0.548035 11.8648 0.710593L6 6L0.135182 0.710593C-0.0450605 0.548035 -0.0450605 0.284477 0.135182 0.121919Z"
    fill="currentColor"
  />
</svg>
`, Dz = `
<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4.74219 9H3.51562L3.52344 8.15625H4.74219C5.07292 8.15625 5.35026 8.08333 5.57422 7.9375C5.79818 7.78906 5.96745 7.57682 6.08203 7.30078C6.19661 7.02214 6.25391 6.6888 6.25391 6.30078V6.00781C6.25391 5.70833 6.22135 5.44401 6.15625 5.21484C6.09115 4.98568 5.99479 4.79297 5.86719 4.63672C5.74219 4.48047 5.58724 4.36198 5.40234 4.28125C5.21745 4.20052 5.00521 4.16016 4.76562 4.16016H3.49219V3.3125H4.76562C5.14583 3.3125 5.49219 3.3763 5.80469 3.50391C6.11979 3.63151 6.39193 3.8151 6.62109 4.05469C6.85286 4.29167 7.02995 4.57552 7.15234 4.90625C7.27734 5.23698 7.33984 5.60677 7.33984 6.01562V6.30078C7.33984 6.70703 7.27734 7.07682 7.15234 7.41016C7.02995 7.74089 6.85286 8.02474 6.62109 8.26172C6.39193 8.4987 6.11849 8.68099 5.80078 8.80859C5.48307 8.9362 5.13021 9 4.74219 9ZM4.11719 3.3125V9H3.04297V3.3125H4.11719ZM9.02344 3.3125L10.1602 5.33984L11.3008 3.3125H12.5352L10.8477 6.13281L12.5781 9H11.332L10.1602 6.93359L8.99219 9H7.74219L9.47266 6.13281L7.78516 3.3125H9.02344ZM14.3125 3.3125V9H13.2383V3.3125H14.3125ZM16.6055 5.76953V6.61719H14.0312V5.76953H16.6055ZM16.9062 3.3125V4.16016H14.0312V3.3125H16.9062Z"
    fill="currentColor" />
  <rect x="1" y="0.5" width="18" height="11" rx="1.5" stroke="currentColor" />
</svg>
  
`, Nz = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.30194 0.699951V3.27625C5.30194 3.77169 4.90169 4.06895 4.50145 4.06895H1.7998L5.30194 0.699951Z" fill="currentColor"/>
<path d="M4.80176 6.94312H10.5052" stroke="currentColor" stroke-width="0.6" stroke-linecap="round"/>
<path d="M4.80176 9.32007H10.5052" stroke="currentColor" stroke-width="0.6" stroke-linecap="round"/>
<path d="M4.80176 11.7976H10.5052" stroke="currentColor" stroke-width="0.6" stroke-linecap="round"/>
<path d="M1.7998 3.67361V14.7715C1.7998 15.2669 2.20005 15.5642 2.60029 15.5642H12.7064C13.2067 15.5642 13.5069 15.1678 13.5069 14.7715V1.59275C13.5069 1.1964 13.1067 0.800049 12.7064 0.800049H4.90169L1.7998 3.67361Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.50202 15.5627L4.40196 16.1573C4.3019 16.5536 4.60208 17.0491 5.00233 17.1482L14.9084 19.1299C15.3086 19.229 15.8089 18.9317 15.909 18.5354L18.5105 5.65392C18.6106 5.25756 18.3104 4.76212 17.9102 4.66303L13.6076 3.77124" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`, Lz = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_303_16378)">
    <path
      d="M1 6.51126V3.45695C1.0015 2.98724 1.19001 2.53721 1.52437 2.20508C1.85874 1.87295 2.3118 1.68569 2.78466 1.6842H9.20681C9.67966 1.68569 10.1327 1.87295 10.4671 2.20508C10.8015 2.53721 10.99 2.98724 10.9915 3.45695V4.68771H16.8118C17.3917 4.6892 17.9474 4.91868 18.3574 5.32598C18.7675 5.73329 18.9985 6.28528 19 6.86129V15.4616C18.9985 16.1909 18.7066 16.8899 18.188 17.4061C17.6694 17.9223 16.9662 18.2137 16.2321 18.2167H3.7736C3.03892 18.2137 2.3352 17.9225 1.8157 17.4065C1.2962 16.8904 1.00299 16.1914 1 15.4616V6.51126Z"
      stroke="currentColor" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M17.9412 8H1" stroke="currentColor" stroke-width="1.68" stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_303_16378">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
`, jz = `
<svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.875 1V11.984" stroke="currentColor" stroke-width="1.685" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M6.875 1.94238H15.434L13.605 4.21638L15.434 6.49238H6.875" stroke="currentColor"
    stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M16.627 10.4922C18.284 10.9952 19.309 11.6902 19.309 12.4592C19.309 13.9942 15.21 15.2402 10.154 15.2402C5.099 15.2402 1 13.9942 1 12.4592C1 11.7092 1.976 11.0292 3.563 10.5282"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, Hz = `
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M12.606 4.1C13.174 4.268 13.814 4.128 14.262 3.68C14.915 3.028 15.972 3.028 16.625 3.68L16.627 3.683C17.28 4.335 17.28 5.393 16.627 6.045C16.179 6.493 16.039 7.133 16.208 7.701L16.169 7.608C16.452 8.128 17.003 8.482 17.637 8.482C18.559 8.482 19.307 9.229 19.307 10.152V10.157C19.307 11.079 18.559 11.827 17.637 11.827C17.003 11.827 16.452 12.18 16.169 12.701L16.208 12.607C16.04 13.176 16.179 13.815 16.627 14.264C17.28 14.916 17.28 15.974 16.627 16.626L16.625 16.629C15.972 17.281 14.915 17.281 14.263 16.629C13.814 16.181 13.174 16.041 12.606 16.209L12.7 16.17C12.179 16.453 11.826 17.005 11.826 17.639C11.826 18.56 11.078 19.308 10.156 19.308H10.151C9.229 19.308 8.481 18.56 8.481 17.639C8.481 17.005 8.127 16.453 7.607 16.17L7.7 16.209C7.132 16.041 6.493 16.181 6.044 16.629C5.392 17.281 4.335 17.281 3.682 16.629L3.679 16.626C3.027 15.974 3.027 14.916 3.679 14.265C4.127 13.816 4.267 13.176 4.099 12.608L4.137 12.701C3.855 12.181 3.303 11.827 2.669 11.827C1.747 11.827 1 11.079 1 10.157V10.152C1 9.23 1.747 8.482 2.669 8.482C3.303 8.482 3.855 8.129 4.137 7.608L4.099 7.702C4.267 7.134 4.127 6.494 3.678 6.045C3.026 5.393 3.026 4.336 3.678 3.683L3.682 3.68C4.334 3.028 5.391 3.028 6.044 3.68C6.492 4.129 7.131 4.269 7.7 4.1L7.607 4.139C8.127 3.856 8.481 3.305 8.481 2.671C8.481 1.748 9.228 1 10.151 1H10.155C11.078 1 11.825 1.748 11.825 2.671C11.825 3.305 12.178 3.856 12.699 4.139L12.606 4.1Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M12.1528 10.1542C12.1528 11.2582 11.2568 12.1542 10.1528 12.1542C9.04883 12.1542 8.15283 11.2582 8.15283 10.1542C8.15283 9.05021 9.04883 8.15421 10.1528 8.15421C11.2568 8.15421 12.1528 9.05021 12.1528 10.1542"
    fill="currentColor" />
</svg>
`, Fz = `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M27.0005 31.0003H5.00049C2.79049 31.0003 1.00049 29.2093 1.00049 27.0003V5.00031C1.00049 2.79131 2.79049 1.00031 5.00049 1.00031H27.0005C29.2095 1.00031 31.0005 2.79131 31.0005 5.00031V27.0003C31.0005 29.2093 29.2095 31.0003 27.0005 31.0003"
    stroke="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M18.606 10.1C19.174 10.268 19.814 10.128 20.262 9.68C20.915 9.028 21.972 9.028 22.625 9.68L22.627 9.683C23.28 10.335 23.28 11.393 22.627 12.045C22.179 12.493 22.039 13.133 22.208 13.701L22.169 13.608C22.452 14.128 23.003 14.482 23.637 14.482C24.559 14.482 25.307 15.229 25.307 16.152V16.157C25.307 17.079 24.559 17.827 23.637 17.827C23.003 17.827 22.452 18.18 22.169 18.701L22.208 18.607C22.04 19.176 22.179 19.815 22.627 20.264C23.28 20.916 23.28 21.974 22.627 22.626L22.625 22.629C21.972 23.281 20.915 23.281 20.263 22.629C19.814 22.181 19.174 22.041 18.606 22.209L18.7 22.17C18.179 22.453 17.826 23.005 17.826 23.639C17.826 24.56 17.078 25.308 16.156 25.308H16.151C15.229 25.308 14.481 24.56 14.481 23.639C14.481 23.005 14.127 22.453 13.607 22.17L13.7 22.209C13.132 22.041 12.493 22.181 12.044 22.629C11.392 23.281 10.335 23.281 9.682 22.629L9.679 22.626C9.027 21.974 9.027 20.916 9.679 20.265C10.127 19.816 10.267 19.176 10.099 18.608L10.137 18.701C9.855 18.181 9.303 17.827 8.669 17.827C7.747 17.827 7 17.079 7 16.157V16.152C7 15.23 7.747 14.482 8.669 14.482C9.303 14.482 9.855 14.129 10.137 13.608L10.099 13.702C10.267 13.134 10.127 12.494 9.678 12.045C9.026 11.393 9.026 10.336 9.678 9.683L9.682 9.68C10.334 9.028 11.391 9.028 12.044 9.68C12.492 10.129 13.131 10.269 13.7 10.1L13.607 10.139C14.127 9.856 14.481 9.305 14.481 8.671C14.481 7.748 15.228 7 16.151 7H16.155C17.078 7 17.825 7.748 17.825 8.671C17.825 9.305 18.178 9.856 18.699 10.139L18.606 10.1Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M18.1528 16.1542C18.1528 17.2582 17.2568 18.1542 16.1528 18.1542C15.0488 18.1542 14.1528 17.2582 14.1528 16.1542C14.1528 15.0502 15.0488 14.1542 16.1528 14.1542C17.2568 14.1542 18.1528 15.0502 18.1528 16.1542Z"
    fill="currentColor" />
</svg>
`, Bz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM5.53292 6.91992H6.5332C6.53599 6.70787 6.56529 6.52093 6.62109 6.3591C6.6769 6.19727 6.78432 6.0452 6.94336 5.9029C7.12472 5.7327 7.29353 5.5639 7.44978 5.39648C7.60603 5.22907 7.73158 5.04911 7.82645 4.85659C7.92132 4.66127 7.96875 4.44085 7.96875 4.19531C7.96875 3.85212 7.8962 3.55915 7.75112 3.31641C7.60882 3.07366 7.40095 2.88951 7.12751 2.76395C6.85686 2.6356 6.53041 2.57143 6.14816 2.57143C5.80218 2.57143 5.48968 2.63281 5.21066 2.75558C4.93164 2.87556 4.70982 3.05831 4.5452 3.30385C4.38058 3.5466 4.29408 3.85073 4.28571 4.21624H5.39481C5.40039 4.04046 5.43806 3.89816 5.50781 3.78934C5.57757 3.67773 5.66964 3.59542 5.78404 3.54241C5.89844 3.4894 6.01981 3.46289 6.14816 3.46289C6.30441 3.46289 6.43415 3.49358 6.53739 3.55497C6.64341 3.61356 6.72294 3.70006 6.77595 3.81445C6.83175 3.92885 6.85965 4.07115 6.85965 4.24135C6.85965 4.39202 6.83036 4.52734 6.77176 4.64732C6.71317 4.76451 6.63225 4.87751 6.52902 4.98633C6.42857 5.09235 6.31417 5.20536 6.18583 5.32534C6.024 5.47879 5.89565 5.62946 5.80078 5.77734C5.70591 5.92243 5.63756 6.08566 5.5957 6.26702C5.55664 6.44838 5.53571 6.66602 5.53292 6.91992ZM5.5957 7.80301C5.4841 7.91462 5.42829 8.05413 5.42829 8.22154C5.42829 8.38337 5.4841 8.52009 5.5957 8.6317C5.7101 8.7433 5.86356 8.79911 6.05608 8.79911C6.2486 8.79911 6.40067 8.7433 6.51228 8.6317C6.62667 8.52009 6.68387 8.38337 6.68387 8.22154C6.68387 8.05413 6.62667 7.91462 6.51228 7.80301C6.40067 7.69141 6.2486 7.6356 6.05608 7.6356C5.86356 7.6356 5.7101 7.69141 5.5957 7.80301Z"
    fill="currentColor"
  />
</svg>
`, zz = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_287_10475)">
    <path d="M5.12087 5.12097C3.32743 6.38318 1.86193 8.05607 0.84668 10" stroke="currentColor"
      stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M19.1532 9.99999C16.996 6.07862 13.6996 3.56854 10 3.56854C9.01532 3.56887 8.03873 3.74643 7.11694 4.09274"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M16.5422 13.5181C17.5755 12.4756 18.4547 11.291 19.1531 10" stroke="currentColor"
      stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M0.84668 10C3.00394 13.9214 6.30031 16.4314 9.99991 16.4314C11.7455 16.417 13.446 15.8759 14.8789 14.879"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M11.8749 11.875C11.63 12.123 11.3379 12.3194 11.0159 12.4527C10.6939 12.586 10.3484 12.6535 9.9999 12.6512C9.29676 12.6512 8.62241 12.3719 8.12521 11.8747C7.62801 11.3775 7.34869 10.7031 7.34869 10C7.34638 9.65148 7.41386 9.30602 7.54717 8.984C7.68049 8.66198 7.87692 8.3699 8.1249 8.125"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M10.3628 7.36896C10.9144 7.44404 11.4284 7.69088 11.8319 8.07446C12.2354 8.45805 12.5079 8.95892 12.6108 9.50605"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M0.84668 0.846802L14.8789 14.8791L19.1531 19.1533" stroke="currentColor"
      stroke-width="1.69"
      stroke-linecap="round" stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_287_10475">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
`, Iz = `
<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.6875 3.3125V9H2.61328V3.3125H3.6875ZM5.92188 3.3125V9H4.84766V3.3125H5.92188ZM8.21484 5.76953V6.61719H5.64062V5.76953H8.21484ZM8.51562 3.3125V4.16016H5.64062V3.3125H8.51562ZM12.5742 7.12891H13.6484C13.6198 7.50911 13.5143 7.84635 13.332 8.14062C13.1497 8.43229 12.8958 8.66146 12.5703 8.82812C12.2448 8.99479 11.8503 9.07812 11.3867 9.07812C11.0299 9.07812 10.7083 9.01562 10.4219 8.89062C10.138 8.76302 9.89453 8.58203 9.69141 8.34766C9.49089 8.11068 9.33724 7.82682 9.23047 7.49609C9.1237 7.16276 9.07031 6.78906 9.07031 6.375V5.94141C9.07031 5.52734 9.125 5.15365 9.23438 4.82031C9.34375 4.48698 9.5 4.20312 9.70312 3.96875C9.90885 3.73177 10.1549 3.54948 10.4414 3.42188C10.7305 3.29427 11.0534 3.23047 11.4102 3.23047C11.8737 3.23047 12.2656 3.31641 12.5859 3.48828C12.9062 3.65755 13.1549 3.89062 13.332 4.1875C13.5091 4.48438 13.6159 4.82552 13.6523 5.21094H12.5781C12.5573 4.97135 12.5052 4.76823 12.4219 4.60156C12.3411 4.4349 12.2188 4.30859 12.0547 4.22266C11.8932 4.13411 11.6784 4.08984 11.4102 4.08984C11.2018 4.08984 11.0182 4.12891 10.8594 4.20703C10.7031 4.28516 10.5729 4.40234 10.4688 4.55859C10.3646 4.71224 10.2865 4.90495 10.2344 5.13672C10.1823 5.36589 10.1562 5.63151 10.1562 5.93359V6.375C10.1562 6.66406 10.1797 6.92318 10.2266 7.15234C10.2734 7.38151 10.3464 7.57552 10.4453 7.73438C10.5443 7.89323 10.6719 8.01432 10.8281 8.09766C10.9844 8.18099 11.1706 8.22266 11.3867 8.22266C11.6497 8.22266 11.8633 8.18099 12.0273 8.09766C12.194 8.01432 12.3203 7.89193 12.4062 7.73047C12.4948 7.56901 12.5508 7.36849 12.5742 7.12891Z"
    fill="currentColor" />
  <rect x="0.5" y="0.5" width="15" height="11" rx="1.5" stroke="currentColor" />
</svg>
  
`, Wz = `
<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.08032 10.2865L5.00546 8.47742L7.25145 10.6483L9.56161 8.47742L11.4226 10.2865V12.397H3.08032V10.2865Z"
    fill="currentColor" />
  <path
    d="M11.2398 12.5176H3.34677C3.21843 12.5176 3.09009 12.397 3.09009 12.2764V3.83422C3.09009 3.71362 3.21843 3.59302 3.34677 3.59302H11.2398C11.3682 3.59302 11.4965 3.71362 11.4965 3.83422V12.2764C11.4965 12.397 11.3682 12.5176 11.2398 12.5176Z"
    stroke="currentColor" stroke-width="1.008" stroke-miterlimit="10" />
  <path
    d="M3.0161 10.4673H0.770112C0.64177 10.4673 0.513428 10.3467 0.513428 10.2261V1.78393C0.513428 1.60302 0.64177 1.48242 0.770112 1.48242H8.66316C8.85567 1.48242 8.98402 1.60302 8.98402 1.72363V3.53267"
    stroke="currentColor" stroke-width="1.008" stroke-miterlimit="10" />
</svg>
  
`, Vz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6.47656 9.60703V4.32382H5.56836V9.60703H6.47656ZM5.63184 2.55136C5.54395 2.65227 5.5 2.77597 5.5 2.92245C5.5 3.06243 5.54395 3.18287 5.63184 3.28378C5.72298 3.38144 5.85645 3.43027 6.03223 3.43027C6.20475 3.43027 6.33659 3.38144 6.42773 3.28378C6.52214 3.18287 6.56934 3.06243 6.56934 2.92245C6.56934 2.77597 6.52214 2.65227 6.42773 2.55136C6.33659 2.45045 6.20475 2.39999 6.03223 2.39999C5.85645 2.39999 5.72298 2.45045 5.63184 2.55136Z"
    fill="currentColor" />
</svg>
  
`, Yz = `
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.22426 9.03792L1 5.82275L11.1909 1L19.3258 4.21517L9.22426 9.03792Z"
    stroke="currentColor"
    stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M19.3258 7.73087L9.22426 12.4531L1 9.23797" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M19.3258 11.1309L9.22426 15.8531L1 12.7384" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M19.3258 14.4308L9.22426 19.2536L1 16.0384" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, qz = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="9.14307" y="5.71426" width="1.61626" height="4.84879"
    transform="rotate(45 9.14307 5.71426)" fill="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8.65386 10.9394L7.51093 12.0823C6.51874 13.0745 4.91008 13.0745 3.9179 12.0823C2.92571 11.0901 2.92571 9.48144 3.9179 8.48925L5.06083 7.34632L4.00017 6.28566L2.85724 7.42859C1.27926 9.00657 1.27926 11.565 2.85723 13.1429C4.43521 14.7209 6.99361 14.7209 8.57159 13.1429L9.71452 12L8.65386 10.9394ZM10.9396 8.65361L12.0003 9.71427L13.1431 8.57146C14.721 6.99349 14.721 4.43509 13.1431 2.85711C11.5651 1.27914 9.00669 1.27914 7.42871 2.85711L6.28591 3.99992L7.34657 5.06058L8.48937 3.91778C9.48156 2.92559 11.0902 2.92559 12.0824 3.91777C13.0746 4.90996 13.0746 6.51862 12.0824 7.5108L10.9396 8.65361Z"
    fill="currentColor" />
</svg>
`, Uz = `
<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.5 4.50098V3.50098C6.5 2.10098 5.4 1.00098 4 1.00098C2.6 1.00098 1.5 2.10098 1.5 3.50098V4.50098C0.65 4.50098 0 5.15098 0 6.00098V9.50098C0 10.351 0.65 11.001 1.5 11.001H6.5C7.35 11.001 8 10.351 8 9.50098V6.00098C8 5.15098 7.35 4.50098 6.5 4.50098ZM2.5 3.50098C2.5 2.65098 3.15 2.00098 4 2.00098C4.85 2.00098 5.5 2.65098 5.5 3.50098V4.50098H2.5V3.50098ZM4.55 7.75098L4.5 7.80098V8.50098C4.5 8.80098 4.3 9.00098 4 9.00098C3.7 9.00098 3.5 8.80098 3.5 8.50098V7.80098C3.2 7.50098 3.15 7.05098 3.45 6.75098C3.75 6.45098 4.2 6.40098 4.5 6.70098C4.8 6.95098 4.85 7.45098 4.55 7.75098Z"
    fill="currentColor"
  />
</svg>

`, Gz = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.72526 16.0569L0.895264 18.2449V3.94391L5.72526 1.75491L14.2743 3.94391L19.1043 1.75491V16.0569L14.2743 18.2449L5.72526 16.0569Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M14.2742 18.2444V3.94342" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M5.72534 1.75522V16.0572" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
`, Xz = `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M26.9998 31.0003H4.99976C2.79076 31.0003 0.999756 29.2093 0.999756 27.0003V5.00031C0.999756 2.79131 2.79076 1.00031 4.99976 1.00031H26.9998C29.2088 1.00031 30.9998 2.79131 30.9998 5.00031V27.0003C30.9998 29.2093 29.2088 31.0003 26.9998 31.0003"
    stroke="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.7253 22.0569L6.89526 24.2449V9.94391L11.7253 7.75491L20.2743 9.94391L25.1043 7.75491V22.0569L20.2743 24.2449L11.7253 22.0569Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M20.2742 24.2444V9.94342" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M11.7253 7.75522V22.0572" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
`, Zz = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.857178 3.5293V8.70314L5.48563 11.1479V6.25836L0.857178 3.5293Z" stroke="currentColor"
    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5.48584 11.148L11.1428 8.13468V3.24512L5.48584 6.25845" stroke="currentColor"
    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.1426 3.24508L6.32132 0.800293L0.857178 3.52935" stroke="currentColor"
    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
</svg>
  
`, Kz = `
<svg width="20" height="4" viewBox="0 0 20 4" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="2" cy="2" r="2" fill="currentColor" />
  <circle cx="10" cy="2" r="2" fill="currentColor" />
  <circle cx="18" cy="2" r="2" fill="currentColor" />
</svg>
`, Qz = `
<svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
  <circle cx="4.30005" cy="5.7998" r="2" stroke="currentColor" />
  <circle cx="7.30005" cy="4.7998" r="2" stroke="currentColor" />
  <circle cx="6.30005" cy="7.7998" r="2" stroke="currentColor" />
</svg>
`, Jz = `
<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.14844 6.01172V6.30469C7.14844 6.73438 7.09115 7.12109 6.97656 7.46484C6.86198 7.80599 6.69922 8.09635 6.48828 8.33594C6.27734 8.57552 6.02604 8.75911 5.73438 8.88672C5.44271 9.01432 5.11849 9.07812 4.76172 9.07812C4.41016 9.07812 4.08724 9.01432 3.79297 8.88672C3.5013 8.75911 3.2487 8.57552 3.03516 8.33594C2.82161 8.09635 2.65625 7.80599 2.53906 7.46484C2.42188 7.12109 2.36328 6.73438 2.36328 6.30469V6.01172C2.36328 5.57943 2.42188 5.19271 2.53906 4.85156C2.65625 4.51042 2.82031 4.22005 3.03125 3.98047C3.24219 3.73828 3.49349 3.55339 3.78516 3.42578C4.07943 3.29818 4.40234 3.23438 4.75391 3.23438C5.11068 3.23438 5.4349 3.29818 5.72656 3.42578C6.01823 3.55339 6.26953 3.73828 6.48047 3.98047C6.69401 4.22005 6.85807 4.51042 6.97266 4.85156C7.08984 5.19271 7.14844 5.57943 7.14844 6.01172ZM6.0625 6.30469V6.00391C6.0625 5.69401 6.03385 5.42188 5.97656 5.1875C5.91927 4.95052 5.83464 4.7513 5.72266 4.58984C5.61068 4.42839 5.47266 4.30729 5.30859 4.22656C5.14453 4.14323 4.95964 4.10156 4.75391 4.10156C4.54557 4.10156 4.36068 4.14323 4.19922 4.22656C4.04036 4.30729 3.90495 4.42839 3.79297 4.58984C3.68099 4.7513 3.59505 4.95052 3.53516 5.1875C3.47786 5.42188 3.44922 5.69401 3.44922 6.00391V6.30469C3.44922 6.61198 3.47786 6.88411 3.53516 7.12109C3.59505 7.35807 3.68099 7.55859 3.79297 7.72266C3.90755 7.88411 4.04557 8.00651 4.20703 8.08984C4.36849 8.17318 4.55339 8.21484 4.76172 8.21484C4.97005 8.21484 5.15495 8.17318 5.31641 8.08984C5.47786 8.00651 5.61328 7.88411 5.72266 7.72266C5.83464 7.55859 5.91927 7.35807 5.97656 7.12109C6.03385 6.88411 6.0625 6.61198 6.0625 6.30469ZM10.2383 6.46484H8.78516L8.77734 5.70703H10.0234C10.237 5.70703 10.4154 5.67708 10.5586 5.61719C10.7018 5.55729 10.8099 5.47005 10.8828 5.35547C10.9583 5.24089 10.9961 5.10156 10.9961 4.9375C10.9961 4.75521 10.9609 4.60677 10.8906 4.49219C10.8229 4.3776 10.7161 4.29427 10.5703 4.24219C10.4245 4.1875 10.2396 4.16016 10.0156 4.16016H9.13281V9H8.05859V3.3125H10.0156C10.3385 3.3125 10.6263 3.34375 10.8789 3.40625C11.1341 3.46615 11.3503 3.5599 11.5273 3.6875C11.7044 3.8151 11.8385 3.97526 11.9297 4.16797C12.0234 4.36068 12.0703 4.58984 12.0703 4.85547C12.0703 5.08984 12.0156 5.30599 11.9062 5.50391C11.7995 5.69922 11.6341 5.85807 11.4102 5.98047C11.1888 6.10286 10.9076 6.17318 10.5664 6.19141L10.2383 6.46484ZM10.1914 9H8.46875L8.91797 8.15625H10.1914C10.4049 8.15625 10.5807 8.12109 10.7188 8.05078C10.8594 7.98047 10.9635 7.88411 11.0312 7.76172C11.1016 7.63672 11.1367 7.49349 11.1367 7.33203C11.1367 7.15495 11.1055 7.0013 11.043 6.87109C10.9831 6.74089 10.8867 6.64062 10.7539 6.57031C10.6237 6.5 10.4518 6.46484 10.2383 6.46484H9.12109L9.12891 5.70703H10.5508L10.7969 6C11.125 6.0026 11.3919 6.06771 11.5977 6.19531C11.806 6.32292 11.9596 6.48698 12.0586 6.6875C12.1576 6.88802 12.207 7.10417 12.207 7.33594C12.207 7.70052 12.1276 8.00651 11.9688 8.25391C11.8125 8.5013 11.5833 8.6875 11.2812 8.8125C10.9818 8.9375 10.6185 9 10.1914 9ZM15.457 7.27344V3.3125H16.5312V7.27344C16.5312 7.65104 16.4492 7.97526 16.2852 8.24609C16.1211 8.51432 15.8971 8.72005 15.6133 8.86328C15.3294 9.00651 15.0091 9.07812 14.6523 9.07812C14.2852 9.07812 13.9596 9.01693 13.6758 8.89453C13.3919 8.76953 13.1693 8.57943 13.0078 8.32422C12.849 8.06901 12.7695 7.74479 12.7695 7.35156H13.8477C13.8477 7.5651 13.8802 7.73698 13.9453 7.86719C14.0104 7.9974 14.1029 8.09115 14.2227 8.14844C14.3451 8.20573 14.4883 8.23438 14.6523 8.23438C14.8112 8.23438 14.9505 8.19792 15.0703 8.125C15.1927 8.04948 15.2878 7.9401 15.3555 7.79688C15.4232 7.65365 15.457 7.47917 15.457 7.27344Z"
    fill="currentColor" />
  <rect x="0.5" y="0.5" width="19" height="11" rx="1.5" stroke="currentColor" />
</svg>
  
`, eI = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="path-1-inside-1_1379_42451" fill="white">
    <rect width="12" height="12" rx="0.6" />
  </mask>
  <rect width="12" height="12" rx="0.6" stroke="currentColor" stroke-width="2.016"
    mask="url(#path-1-inside-1_1379_42451)" />
  <line x1="0.600098" y1="4.29605" x2="11.4001" y2="4.29605" stroke="currentColor"
    stroke-width="1.008" />
  <line x1="0.600098" y1="7.89602" x2="11.4001" y2="7.89602" stroke="currentColor"
    stroke-width="1.008" />
  <line x1="4.29605" y1="11.4" x2="4.29605" y2="0.600024" stroke="currentColor" stroke-width="1.008" />
  <line x1="7.8959" y1="11.4" x2="7.8959" y2="0.600024" stroke="currentColor" stroke-width="1.008" />
</svg>
  
`, tI = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.15987 2.7136C2.45811 2.7136 2.69987 2.47062 2.69987 2.17089C2.69987 1.87115 2.45811 1.62817 2.15987 1.62817C1.86164 1.62817 1.61987 1.87115 1.61987 2.17089C1.61987 2.47062 1.86164 2.7136 2.15987 2.7136Z"
    fill="currentColor" />
  <path
    d="M4.62008 2.7136C4.91831 2.7136 5.16008 2.47062 5.16008 2.17089C5.16008 1.87115 4.91831 1.62817 4.62008 1.62817C4.32184 1.62817 4.08008 1.87115 4.08008 2.17089C4.08008 2.47062 4.32184 2.7136 4.62008 2.7136Z"
    fill="currentColor" />
  <path
    d="M7.37984 2.7136C7.67808 2.7136 7.91984 2.47062 7.91984 2.17089C7.91984 1.87115 7.67808 1.62817 7.37984 1.62817C7.08161 1.62817 6.83984 1.87115 6.83984 2.17089C6.83984 2.47062 7.08161 2.7136 7.37984 2.7136Z"
    fill="currentColor" />
  <path
    d="M9.84005 2.7136C10.1383 2.7136 10.38 2.47062 10.38 2.17089C10.38 1.87115 10.1383 1.62817 9.84005 1.62817C9.54181 1.62817 9.30005 1.87115 9.30005 2.17089C9.30005 2.47062 9.54181 2.7136 9.84005 2.7136Z"
    fill="currentColor" />
  <path
    d="M2.15987 10.3719C2.45811 10.3719 2.69987 10.1289 2.69987 9.82921C2.69987 9.52948 2.45811 9.2865 2.15987 9.2865C1.86164 9.2865 1.61987 9.52948 1.61987 9.82921C1.61987 10.1289 1.86164 10.3719 2.15987 10.3719Z"
    fill="currentColor" />
  <path
    d="M4.62008 10.3719C4.91831 10.3719 5.16008 10.1289 5.16008 9.82921C5.16008 9.52948 4.91831 9.2865 4.62008 9.2865C4.32184 9.2865 4.08008 9.52948 4.08008 9.82921C4.08008 10.1289 4.32184 10.3719 4.62008 10.3719Z"
    fill="currentColor" />
  <path
    d="M7.37984 10.3719C7.67808 10.3719 7.91984 10.1289 7.91984 9.82921C7.91984 9.52948 7.67808 9.2865 7.37984 9.2865C7.08161 9.2865 6.83984 9.52948 6.83984 9.82921C6.83984 10.1289 7.08161 10.3719 7.37984 10.3719Z"
    fill="currentColor" />
  <path
    d="M9.84005 10.3719C10.1383 10.3719 10.38 10.1289 10.38 9.82921C10.38 9.52948 10.1383 9.2865 9.84005 9.2865C9.54181 9.2865 9.30005 9.52948 9.30005 9.82921C9.30005 10.1289 9.54181 10.3719 9.84005 10.3719Z"
    fill="currentColor" />
  <path
    d="M4.62007 0.603015C4.78575 0.603015 4.92007 0.468026 4.92007 0.301508C4.92007 0.13499 4.78575 0 4.62007 0C4.45438 0 4.32007 0.13499 4.32007 0.301508C4.32007 0.468026 4.45438 0.603015 4.62007 0.603015Z"
    fill="currentColor" />
  <path
    d="M7.38008 0.603015C7.54576 0.603015 7.68008 0.468026 7.68008 0.301508C7.68008 0.13499 7.54576 0 7.38008 0C7.21439 0 7.08008 0.13499 7.08008 0.301508C7.08008 0.468026 7.21439 0.603015 7.38008 0.603015Z"
    fill="currentColor" />
  <path
    d="M4.62007 12C4.78575 12 4.92007 11.865 4.92007 11.6985C4.92007 11.532 4.78575 11.397 4.62007 11.397C4.45438 11.397 4.32007 11.532 4.32007 11.6985C4.32007 11.865 4.45438 12 4.62007 12Z"
    fill="currentColor" />
  <path
    d="M7.38008 12C7.54576 12 7.68008 11.865 7.68008 11.6985C7.68008 11.532 7.54576 11.397 7.38008 11.397C7.21439 11.397 7.08008 11.532 7.08008 11.6985C7.08008 11.865 7.21439 12 7.38008 12Z"
    fill="currentColor" />
  <path
    d="M2.15987 5.12559C2.45811 5.12559 2.69987 4.88261 2.69987 4.58287C2.69987 4.28314 2.45811 4.04016 2.15987 4.04016C1.86164 4.04016 1.61987 4.28314 1.61987 4.58287C1.61987 4.88261 1.86164 5.12559 2.15987 5.12559Z"
    fill="currentColor" />
  <path
    d="M9.84005 5.12559C10.1383 5.12559 10.38 4.88261 10.38 4.58287C10.38 4.28314 10.1383 4.04016 9.84005 4.04016C9.54181 4.04016 9.30005 4.28314 9.30005 4.58287C9.30005 4.88261 9.54181 5.12559 9.84005 5.12559Z"
    fill="currentColor" />
  <path
    d="M4.62003 5.42721C5.08395 5.42721 5.46003 5.04924 5.46003 4.58299C5.46003 4.11674 5.08395 3.73877 4.62003 3.73877C4.15611 3.73877 3.78003 4.11674 3.78003 4.58299C3.78003 5.04924 4.15611 5.42721 4.62003 5.42721Z"
    fill="currentColor" />
  <path
    d="M7.38004 5.42721C7.84396 5.42721 8.22004 5.04924 8.22004 4.58299C8.22004 4.11674 7.84396 3.73877 7.38004 3.73877C6.91612 3.73877 6.54004 4.11674 6.54004 4.58299C6.54004 5.04924 6.91612 5.42721 7.38004 5.42721Z"
    fill="currentColor" />
  <path
    d="M2.15987 7.89952C2.45811 7.89952 2.69987 7.65653 2.69987 7.3568C2.69987 7.05707 2.45811 6.81409 2.15987 6.81409C1.86164 6.81409 1.61987 7.05707 1.61987 7.3568C1.61987 7.65653 1.86164 7.89952 2.15987 7.89952Z"
    fill="currentColor" />
  <path
    d="M9.84005 7.89952C10.1383 7.89952 10.38 7.65653 10.38 7.3568C10.38 7.05707 10.1383 6.81409 9.84005 6.81409C9.54181 6.81409 9.30005 7.05707 9.30005 7.3568C9.30005 7.65653 9.54181 7.89952 9.84005 7.89952Z"
    fill="currentColor" />
  <path
    d="M4.62003 8.20102C5.08395 8.20102 5.46003 7.82305 5.46003 7.35679C5.46003 6.89054 5.08395 6.51257 4.62003 6.51257C4.15611 6.51257 3.78003 6.89054 3.78003 7.35679C3.78003 7.82305 4.15611 8.20102 4.62003 8.20102Z"
    fill="currentColor" />
  <path
    d="M7.38004 8.20102C7.84396 8.20102 8.22004 7.82305 8.22004 7.35679C8.22004 6.89054 7.84396 6.51257 7.38004 6.51257C6.91612 6.51257 6.54004 6.89054 6.54004 7.35679C6.54004 7.82305 6.91612 8.20102 7.38004 8.20102Z"
    fill="currentColor" />
  <path
    d="M11.6999 4.88439C11.8656 4.88439 11.9999 4.7494 11.9999 4.58288C11.9999 4.41636 11.8656 4.28137 11.6999 4.28137C11.5342 4.28137 11.3999 4.41636 11.3999 4.58288C11.3999 4.7494 11.5342 4.88439 11.6999 4.88439Z"
    fill="currentColor" />
  <path
    d="M11.6999 7.65831C11.8656 7.65831 11.9999 7.52332 11.9999 7.35681C11.9999 7.19029 11.8656 7.0553 11.6999 7.0553C11.5342 7.0553 11.3999 7.19029 11.3999 7.35681C11.3999 7.52332 11.5342 7.65831 11.6999 7.65831Z"
    fill="currentColor" />
  <path
    d="M0.3 4.88439C0.465685 4.88439 0.6 4.7494 0.6 4.58288C0.6 4.41636 0.465685 4.28137 0.3 4.28137C0.134315 4.28137 0 4.41636 0 4.58288C0 4.7494 0.134315 4.88439 0.3 4.88439Z"
    fill="currentColor" />
  <path
    d="M0.3 7.65831C0.465685 7.65831 0.6 7.52332 0.6 7.35681C0.6 7.19029 0.465685 7.0553 0.3 7.0553C0.134315 7.0553 0 7.19029 0 7.35681C0 7.52332 0.134315 7.65831 0.3 7.65831Z"
    fill="currentColor" />
</svg>
  
`, nI = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
  <circle cx="6" cy="6" r="4" fill="currentColor" />
</svg>
  
`, rI = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
</svg>
  
`, oI = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="2" cy="2" r="2" fill="currentColor" />
  <circle cx="10" cy="2" r="2" fill="currentColor" />
  <circle cx="10" cy="10" r="2" fill="currentColor" />
  <circle cx="2" cy="10" r="2" fill="currentColor" />
</svg>
`, aI = `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.27472 11.5494C9.18787 11.5494 11.5494 9.18787 11.5494 6.27472C11.5494 3.36157 9.18787 1 6.27472 1C3.36157 1 1 3.36157 1 6.27472C1 9.18787 3.36157 11.5494 6.27472 11.5494Z"
    stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M10.033 10.033L13 13" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
  
`, iI = `
<svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M17.6507 3.86C17.6507 5.439 16.3707 6.719 14.7917 6.719C13.2117 6.719 11.9307 5.439 11.9307 3.86C11.9307 2.281 13.2117 1 14.7917 1C16.3707 1 17.6507 2.281 17.6507 3.86Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M17.6507 16.4567C17.6507 18.0357 16.3707 19.3157 14.7917 19.3157C13.2117 19.3157 11.9307 18.0357 11.9307 16.4567C11.9307 14.8767 13.2117 13.5967 14.7917 13.5967C16.3707 13.5967 17.6507 14.8767 17.6507 16.4567Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M6.72 10.1549C6.72 11.7339 5.44 13.0139 3.86 13.0139C2.281 13.0139 1 11.7339 1 10.1549C1 8.5759 2.281 7.2959 3.86 7.2959C5.44 7.2959 6.72 8.5759 6.72 10.1549Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M12.2493 5.14746L6.29126 8.63246" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M12.2493 15.1618L6.29126 11.6768" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, sI = `
<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_287_10459)">
    <path
      d="M19.1919 7.99998C17.0707 3.93748 13.7374 1.33331 10 1.33331C6.26265 1.33331 3.03033 3.93748 0.808105 7.99998"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M0.808105 8C2.92932 12.0625 6.26265 14.6667 10 14.6667C13.7374 14.6667 16.9697 12.0625 19.1919 8"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M10 10.7084C11.4505 10.7084 12.6263 9.49579 12.6263 8.00002C12.6263 6.50425 11.4505 5.29169 10 5.29169C8.5496 5.29169 7.37378 6.50425 7.37378 8.00002C7.37378 9.49579 8.5496 10.7084 10 10.7084Z"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_287_10459">
      <rect width="20" height="15" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
`, lI = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect fill="currentColor" height="2" width="12" y="5" />
</svg>
`, cI = `
<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="sec-nav/templates">
    <path id="Union" fill-rule="evenodd" clip-rule="evenodd"
      d="M2 1.68H16C16.1767 1.68 16.32 1.82327 16.32 2V18C16.32 18.1767 16.1767 18.32 16 18.32H2C1.82327 18.32 1.68 18.1767 1.68 18V2C1.68 1.82327 1.82327 1.68 2 1.68ZM0 2C0 0.895431 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V18C18 19.1046 17.1046 20 16 20H2C0.89543 20 0 19.1046 0 18V2ZM4.84 4C4.37608 4 4 4.37608 4 4.84C4 5.30392 4.37608 5.68 4.84 5.68H13.16C13.6239 5.68 14 5.30392 14 4.84C14 4.37608 13.6239 4 13.16 4H4.84ZM4 9.84C4 9.37608 4.37608 9 4.84 9H13.16C13.6239 9 14 9.37608 14 9.84C14 10.3039 13.6239 10.68 13.16 10.68H4.84C4.37608 10.68 4 10.3039 4 9.84ZM4.84 14C4.37608 14 4 14.3761 4 14.84C4 15.3039 4.37608 15.68 4.84 15.68H13.16C13.6239 15.68 14 15.3039 14 14.84C14 14.3761 13.6239 14 13.16 14H4.84Z"
      fill="currentColor" />
  </g>
</svg>
`, uI = `
<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.23358 4.38753V1.49701H5.75713V10.503H7.31785V12H2.41274V10.503H3.94161V1.49701H1.48109V4.38753H0V0H9.71466V4.38753H8.23358Z"
    fill="currentColor" />
</svg>
`, dI = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.0269 7.9891V16.5931" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M13.2583 7.9891L12.4243 16.5931" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M6.7959 7.9891L7.6289 16.5931" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M1.84229 6.408C1.84229 4.947 3.03829 3.752 4.49929 3.752H15.5543C17.0163 3.752 18.2113 4.947 18.2113 6.408"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" />
  <path
    d="M16.021 7.9998L15.021 17.1318C15.021 18.2308 14.203 19.1318 13.202 19.1318H6.85198C5.85098 19.1318 5.03198 18.2308 5.03198 17.1318L4.03198 7.9998"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.481 2.2967C11.481 3.1007 10.83 3.7517 10.027 3.7517C9.22402 3.7517 8.57202 3.1007 8.57202 2.2967C8.57202 1.4937 9.22402 0.842697 10.027 0.842697C10.83 0.842697 11.481 1.4937 11.481 2.2967Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" />
</svg>
`, fI = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_414_20676)">
    <path
      d="M6.73365 16.4C8.04018 17.3 9.54772 17.8 11.2563 17.8C15.5779 17.8 19.0955 14.3 19.0955 10C19.0955 5.7 15.5779 2.2 11.2563 2.2C6.93466 2.2 3.41707 5.7 3.41707 10"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M3.51755 13.2L4.82408 11.5L6.13062 9.79999H3.51755H0.803983L2.11052 11.5L3.51755 13.2Z"
      fill="currentColor" stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10"
      stroke-linecap="round" stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_414_20676">
      <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
    </clipPath>
  </defs>
</svg>
`, hI = `
<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M13.2613 9.25001L8.49818 1.00001C7.72838 -0.333324 5.80388 -0.333328 5.03407 1.00001L0.270935 9.25001C-0.498865 10.5833 0.463382 12.25 2.00298 12.25H11.5293C13.0689 12.25 14.0311 10.5833 13.2613 9.25001ZM5.9001 1.50001C6.285 0.83334 7.24725 0.833341 7.63215 1.50001L12.3953 9.75001C12.7802 10.4167 12.2991 11.25 11.5293 11.25H2.00298C1.23318 11.25 0.75206 10.4167 1.13696 9.75001L5.9001 1.50001ZM7.28175 7.98048L7.39503 4.00001H6.29738L6.41066 7.98048H7.28175ZM6.42238 8.82032C6.31821 8.92449 6.26613 9.05339 6.26613 9.20704C6.26613 9.35808 6.31821 9.48568 6.42238 9.58985C6.52915 9.69402 6.67238 9.7461 6.85206 9.7461C7.03175 9.7461 7.17368 9.69402 7.27784 9.58985C7.38461 9.48568 7.438 9.35808 7.438 9.20704C7.438 9.05339 7.38461 8.92449 7.27784 8.82032C7.17368 8.71355 7.03175 8.66016 6.85206 8.66016C6.67238 8.66016 6.52915 8.71355 6.42238 8.82032Z"
    fill="currentColor" />
</svg>
`, pI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  add: fz,
  annotation: hz,
  annotation2dfilled: pz,
  annotation2doutlined: mz,
  annotation3dfilled: gz,
  annotation3doutlined: vz,
  annotationcursor: bz,
  arrow: yz,
  bim: wz,
  boxchecked: xz,
  boxunchecked: Cz,
  cad: Sz,
  clip: Ez,
  close: kz,
  closesmall: Mz,
  colors: _z,
  cornerupright: Pz,
  date: Oz,
  done: Tz,
  download: Az,
  dropdown: $z,
  dropdownarrow: Rz,
  dxf: Dz,
  file: Nz,
  files: Lz,
  flyto: jz,
  gear: Hz,
  geartrapped: Fz,
  help: Bz,
  hide: zz,
  ifc: Iz,
  image: Wz,
  info: Vz,
  layers: Yz,
  link: qz,
  lock: Uz,
  map: Gz,
  maptrapped: Xz,
  mesh3d: Zz,
  more: Kz,
  nodegroup: Qz,
  obj: Jz,
  ortho: eI,
  pointcloud: tI,
  radioselected: nI,
  radiounselected: rI,
  reorder: oI,
  search: aI,
  sharelink: iI,
  show: sI,
  subtract: lI,
  templates: cI,
  textfield: uI,
  trashbin: dI,
  undo: fI,
  warn: hI
}, Symbol.toStringTag, { value: "Module" })), mI = "fs", gI = 1730097689, vI = {
  docx: {
    body: '<g fill="none"><path fill="#1B5EBE" fill-rule="evenodd" d="M6.241 1.001v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#1B5EBE" stroke-linecap="round" stroke-linejoin="round" d="M2 4.626v13.53c0 .604.547.967 1.094.967h13.812c.684 0 1.094-.484 1.094-.967V2.09c0-.483-.547-.966-1.094-.966H6.239z"/><path fill="#1B5EBE" d="m8.037 12.639 1.416-5.747h.767l.048 1.21-1.513 5.9h-.81zm-.893-5.747 1.162 5.727v1.382h-.884L5.81 6.891zm4.594 5.703 1.143-5.703h1.338l-1.612 7.11h-.883zm-1.152-5.703 1.416 5.767.083 1.342h-.81l-1.51-5.903.06-1.206z"/></g>'
  },
  "docx-link": {
    body: '<g fill="none"><path fill="#1B5EBE" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1B5EBE" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#1B5EBE" d="M7.037 11.638 8.453 5.89h.767l.049 1.21L7.755 13h-.81zM6.144 5.89l1.162 5.727V13h-.884L4.81 5.89zm4.594 5.703 1.143-5.703h1.338L11.607 13h-.883zM9.586 5.89l1.416 5.766.083 1.343h-.81l-1.51-5.903.06-1.206z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.349.349 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.605-.073.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "docx-sync": {
    body: '<g fill="none"><path fill="#1B5EBE" fill-rule="evenodd" d="M5.241 1.001v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1B5EBE" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.123H2.094c-.547 0-1.094-.363-1.094-.967V4.626l4.24-3.503h10.666c.547 0 1.094.483 1.094.966v6.912"/><path fill="#1B5EBE" d="m7.037 11.639 1.416-5.747h.767l.049 1.21-1.514 5.9h-.81zm-.893-5.747 1.162 5.727v1.382h-.884L4.81 5.891zm4.594 5.703 1.143-5.703h1.338l-1.612 7.11h-.883zM9.586 5.892l1.416 5.766.083 1.343h-.81l-1.51-5.903.06-1.206z"/><path fill="#726F74" d="M17.14 12.468a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.334v2.638a.47.47 0 01-.473.473h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.497.24.24 0 01.228-.18h1.13c.148 0 .259.135.232.28a4.88 4.88 0 01-4.797 3.974 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  dwg: {
    body: '<g fill="none"><path fill="#E51050" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#E51050" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><g clip-path="url(#svgID0)"><path fill="#E51050" d="M5.34 12.236h-.866l.006-.595h.86q.351 0 .587-.155a.97.97 0 00.359-.45q.12-.294.121-.705v-.207q0-.317-.069-.56a1.1 1.1 0 00-.204-.408.85.85 0 00-.328-.25 1.1 1.1 0 00-.45-.086h-.898v-.6h.899q.402 0 .733.136.335.136.576.388.246.252.375.601a2.2 2.2 0 01.133.784v.2q0 .432-.133.784a1.7 1.7 0 01-.375.601 1.65 1.65 0 01-.579.386q-.336.135-.747.135M4.9 8.221v4.015h-.76V8.221zm3.907 3.246.8-3.246h.433l.027.684-.855 3.331h-.457zM8.301 8.22l.657 3.235v.78h-.5l-.91-4.015zm2.595 3.221.645-3.22h.756l-.91 4.014h-.5zm-.65-3.22.799 3.256.047.758h-.458l-.852-3.333.033-.682zm5.663 1.938v1.563a1.3 1.3 0 01-.279.246 1.8 1.8 0 01-.49.229 2.6 2.6 0 01-.745.093 1.9 1.9 0 01-.7-.127 1.5 1.5 0 01-.546-.377 1.7 1.7 0 01-.353-.607 2.5 2.5 0 01-.124-.819v-.265q0-.46.116-.818a1.7 1.7 0 01.336-.607q.22-.248.527-.378.309-.13.689-.13.51 0 .838.169.33.168.508.463.175.293.22.673h-.739q-.03-.21-.121-.367a.63.63 0 00-.26-.248.9.9 0 00-.43-.091q-.223 0-.394.088a.8.8 0 00-.287.257q-.116.168-.176.416a2.5 2.5 0 00-.058.568v.27q0 .322.066.574.067.248.19.419a.84.84 0 00.312.256q.188.086.425.086.215 0 .356-.036a1 1 0 00.228-.091.7.7 0 00.133-.102v-.753h-.797v-.554z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M4 8h12v4.941H4z"/></clipPath></defs></g>'
  },
  "dwg-link": {
    body: '<g fill="none"><path fill="#E51050" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E51050" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><g clip-path="url(#svgID0)"><path fill="#E51050" d="M4.34 10.236h-.866l.006-.595h.86q.351 0 .587-.155a.97.97 0 00.359-.45q.12-.294.121-.705v-.207q0-.317-.069-.56a1.1 1.1 0 00-.204-.408.85.85 0 00-.328-.25 1.1 1.1 0 00-.45-.086h-.898v-.6h.899q.402 0 .733.136.335.136.576.388.246.252.375.601a2.2 2.2 0 01.133.784v.2q0 .432-.133.784a1.7 1.7 0 01-.375.601 1.65 1.65 0 01-.579.386q-.336.135-.747.135M3.9 6.221v4.015h-.76V6.221zm3.907 3.246.8-3.246h.433l.027.684-.855 3.331h-.457zM7.301 6.22l.657 3.235v.78h-.5l-.91-4.015zm2.595 3.221.645-3.22h.756l-.91 4.014h-.5zm-.65-3.22.799 3.256.047.758h-.458l-.852-3.333.033-.682zm5.663 1.938v1.563a1.3 1.3 0 01-.279.246 1.8 1.8 0 01-.49.229 2.6 2.6 0 01-.745.093 1.9 1.9 0 01-.7-.127 1.5 1.5 0 01-.546-.377 1.7 1.7 0 01-.353-.607 2.5 2.5 0 01-.124-.819v-.265q0-.46.116-.818a1.7 1.7 0 01.336-.607q.22-.248.527-.378.309-.13.689-.13.51 0 .838.169.33.168.508.463.175.293.22.673h-.739q-.03-.21-.121-.367a.63.63 0 00-.26-.248.9.9 0 00-.43-.091q-.223 0-.394.088a.8.8 0 00-.287.257q-.116.167-.176.416a2.5 2.5 0 00-.058.568v.27q0 .322.066.574.067.248.19.419a.84.84 0 00.312.256q.188.086.425.086.215 0 .356-.036a1 1 0 00.228-.091.7.7 0 00.133-.102v-.753h-.797V8.16z"/></g><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/><defs><clipPath id="svgID0"><path fill="#fff" d="M3 6h12v4.941H3z"/></clipPath></defs></g>'
  },
  "dwg-sync": {
    body: '<g fill="none"><path fill="#E51050" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E51050" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><g clip-path="url(#svgID0)"><path fill="#E51050" d="M4.34 10.236h-.866l.006-.595h.86q.351 0 .587-.155a.97.97 0 00.359-.45q.12-.294.121-.705v-.207q0-.317-.069-.56a1.1 1.1 0 00-.204-.408.85.85 0 00-.328-.25 1.1 1.1 0 00-.45-.086h-.898v-.6h.899q.402 0 .733.136.335.136.576.388.246.252.375.601a2.2 2.2 0 01.133.784v.2q0 .432-.133.784a1.7 1.7 0 01-.375.601 1.65 1.65 0 01-.579.386q-.336.135-.747.135M3.9 6.221v4.015h-.76V6.221zm3.907 3.246.8-3.246h.433l.027.684-.855 3.331h-.457zM7.301 6.22l.657 3.235v.78h-.5l-.91-4.015zm2.595 3.221.645-3.22h.756l-.91 4.014h-.5zm-.65-3.22.799 3.256.047.758h-.458l-.852-3.333.033-.682zm5.663 1.938v1.563a1.3 1.3 0 01-.279.246 1.8 1.8 0 01-.49.229 2.6 2.6 0 01-.745.093 1.9 1.9 0 01-.7-.127 1.5 1.5 0 01-.546-.377 1.7 1.7 0 01-.353-.607 2.5 2.5 0 01-.124-.819v-.265q0-.46.116-.818a1.7 1.7 0 01.336-.607q.22-.248.527-.378.309-.13.689-.13.51 0 .838.169.33.168.508.463.175.293.22.673h-.739q-.03-.21-.121-.367a.63.63 0 00-.26-.248.9.9 0 00-.43-.091q-.223 0-.394.088a.8.8 0 00-.287.257q-.116.167-.176.416a2.5 2.5 0 00-.058.568v.27q0 .322.066.574.067.248.19.419a.84.84 0 00.312.256q.188.086.425.086.215 0 .356-.036a1 1 0 00.228-.091.7.7 0 00.133-.102v-.753h-.797V8.16z"/></g><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/><defs><clipPath id="svgID0"><path fill="#fff" d="M3 6h12v4.941H3z"/></clipPath></defs></g>'
  },
  e57: {
    body: '<g fill="none"><path fill="#74B7FF" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#74B7FF" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#74B7FF" d="M8 12.353V13H4.666v-.647zM4.835 7v6H4V7zm2.724 2.58v.647H4.666V9.58zM7.957 7v.651H4.666V7zm2.009 4.163L9.29 11l.26-2.352h2.563v.701H10.25l-.121 1.088q.099-.06.288-.122a1.4 1.4 0 01.432-.064q.332 0 .595.11.262.105.444.306.186.202.279.493.096.288.096.653 0 .32-.096.601a1.4 1.4 0 01-.285.496 1.35 1.35 0 01-.483.34 1.8 1.8 0 01-.685.121q-.297 0-.572-.086a1.6 1.6 0 01-.49-.26 1.3 1.3 0 01-.349-.422 1.4 1.4 0 01-.14-.573h.835a.9.9 0 00.115.365.63.63 0 00.243.23q.153.08.355.08a.7.7 0 00.314-.067.6.6 0 00.22-.195.9.9 0 00.128-.294q.042-.17.042-.371 0-.195-.048-.356a.8.8 0 00-.147-.281.65.65 0 00-.25-.182.9.9 0 00-.345-.064q-.266 0-.41.08a1.2 1.2 0 00-.25.188M16 8.648v.461l-1.83 4.198h-.893l1.83-3.993H12.74v-.666z"/></g>'
  },
  "e57-link": {
    body: '<g fill="none"><path fill="#74B7FF" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#74B7FF" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#74B7FF" d="M6.767 11.041v.61h-3.14v-.61zM3.786 6v5.65H3V6zm2.566 2.43v.609H3.627v-.61zM6.726 6v.613H3.627V6zm1.892 3.92-.636-.153.244-2.215h2.414v.66H8.886l-.114 1.025q.093-.057.271-.115.18-.06.407-.06.314 0 .56.103.247.099.42.289.174.19.261.464.09.27.09.615 0 .301-.09.566-.087.262-.268.467-.18.202-.455.32a1.7 1.7 0 01-.645.114q-.28 0-.54-.081a1.5 1.5 0 01-.46-.244 1.2 1.2 0 01-.329-.398 1.3 1.3 0 01-.132-.54h.786q.02.203.109.344a.6.6 0 00.229.217q.145.075.334.075a.64.64 0 00.296-.063.6.6 0 00.208-.184.8.8 0 00.12-.277q.04-.16.04-.35a1.2 1.2 0 00-.046-.334.7.7 0 00-.139-.265.6.6 0 00-.235-.172.8.8 0 00-.325-.06.8.8 0 00-.386.075q-.132.075-.235.178m5.683-2.368v.434l-1.723 3.954h-.841l1.723-3.76h-2.23v-.628z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "e57-sync": {
    body: '<g fill="none"><path fill="#74B7FF" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#74B7FF" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#74B7FF" d="M6.767 11.041v.61h-3.14v-.61zM3.786 6v5.65H3V6zm2.566 2.43v.609H3.627v-.61zM6.726 6v.613H3.627V6zm1.892 3.92-.636-.153.244-2.215h2.414v.66H8.886l-.114 1.025q.093-.057.271-.115.18-.06.407-.06.314 0 .56.103.247.099.42.289.174.19.261.464.09.27.09.615 0 .301-.09.566-.087.262-.268.467-.18.202-.455.32a1.7 1.7 0 01-.645.114q-.28 0-.54-.081a1.5 1.5 0 01-.46-.244 1.2 1.2 0 01-.329-.398 1.3 1.3 0 01-.132-.54h.786q.02.203.109.344a.6.6 0 00.229.217q.145.075.334.075a.64.64 0 00.296-.063.6.6 0 00.208-.184.8.8 0 00.12-.277q.04-.16.04-.35a1.2 1.2 0 00-.046-.334.7.7 0 00-.139-.265.6.6 0 00-.235-.172.8.8 0 00-.325-.06.8.8 0 00-.386.075q-.132.075-.235.178m5.683-2.368v.434l-1.723 3.954h-.841l1.723-3.76h-2.23v-.628z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  file: {
    body: '<g fill="none"><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/></g>'
  },
  "file-link": {
    body: '<g fill="none"><g clip-path="url(#svgID1)"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M20 0H0v20h20z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="m19.636 10.315-5.574-.55a.349.349 0 00-.317.553l.889 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.13a.348.348 0 00.626-.263l-.04-.243a4.28 4.28 0 011.715-4.185l.403-.293 1.162 1.6a.35.35 0 00.623-.13l1.199-5.471a.35.35 0 00-.306-.423"/><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M18 8V2.088c0-.484-.547-.967-1.094-.967H6.239L2 4.624v13.53c0 .605.547.967 1.094.967H11"/></g></g><defs><clipPath id="svgID1"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></g>'
  },
  "file-lock": {
    body: '<g fill="none"><g clip-path="url(#svgID0)"><g clip-path="url(#svgID1)"><path fill="currentColor" d="M18.5 13.5v-1c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v1c-.85 0-1.5.65-1.5 1.5v3.5c0 .85.65 1.5 1.5 1.5h5c.85 0 1.5-.65 1.5-1.5V15c0-.85-.65-1.5-1.5-1.5m-4-1c0-.85.65-1.5 1.5-1.5s1.5.65 1.5 1.5v1h-3zm2.05 4.25-.05.05v.7c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-.7c-.3-.3-.35-.75-.05-1.05s.75-.35 1.05-.05c.3.25.35.75.05 1.05"/></g><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10 19.121H3.094c-.547 0-1.094-.362-1.094-.966V4.625L6.24 1.12h10.666c.547 0 1.094.483 1.094.967V8.5"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath><clipPath id="svgID1"><path fill="#fff" d="M12 10h8v10h-8z"/></clipPath></defs></g>'
  },
  "file-sync": {
    body: '<g fill="none"><path fill="currentColor" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M18 8.5V2.088c0-.483-.547-.967-1.094-.967H6.239L2 4.625v13.53c0 .604.547.966 1.094.966H8"/></g>'
  },
  folder: {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M1 6.511V3.457c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.64.41.406.642.958.643 1.534v8.6a2.75 2.75 0 01-.812 1.945 2.8 2.8 0 01-1.956.81H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.463z"/>'
  },
  "folder-link": {
    body: '<g fill="none"><g clip-path="url(#svgID1)"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M20 0H0v20h20z"/></mask><g mask="url(#svgID0)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M11.752 18.216H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.46V3.456c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.64.41.406.642.958.643 1.534V9"/><path fill="currentColor" d="m19.636 10.315-5.574-.55a.348.348 0 00-.317.553l.889 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.605-.073.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.715-4.185l.403-.293 1.162 1.6a.348.348 0 00.623-.13l1.199-5.471a.35.35 0 00-.306-.423"/></g></g><defs><clipPath id="svgID1"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></g>'
  },
  "folder-lock": {
    body: '<g fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10.467 18.216H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.46V3.456c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.639S19 6.285 19 6.86V9.5"/><g clip-path="url(#svgID0)"><path fill="currentColor" d="M18.5 13.5v-1c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v1c-.85 0-1.5.65-1.5 1.5v3.5c0 .85.65 1.5 1.5 1.5h5c.85 0 1.5-.65 1.5-1.5V15c0-.85-.65-1.5-1.5-1.5m-4-1c0-.85.65-1.5 1.5-1.5s1.5.65 1.5 1.5v1h-3zm2.05 4.25-.05.05v.7c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-.7c-.3-.3-.35-.75-.05-1.05s.75-.35 1.05-.05c.3.25.35.75.05 1.05"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M12 10h8v10h-8z"/></clipPath></defs></g>'
  },
  "folder-sync": {
    body: '<g fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.5 18.216H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.46V3.456c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.64.41.406.642.958.643 1.534V9"/><path fill="currentColor" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  fxl: {
    body: '<g fill="none"><path fill="#000" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><circle cx="9" cy="10.5" r="3.6" stroke="#000" stroke-width=".8"/><path stroke="#000" stroke-linecap="round" stroke-width=".8" d="M14.5 10.5 6.5 6v9z"/></g>'
  },
  "fxl-link": {
    body: '<g fill="none"><path fill="#000" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><circle cx="8" cy="9.5" r="3.6" stroke="#000" stroke-width=".8"/><path stroke="#000" stroke-linecap="round" stroke-width=".8" d="M13.5 9.5 5.5 5v9z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "fxl-sync": {
    body: '<g fill="none"><path fill="#000" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><circle cx="8" cy="9.5" r="3.6" stroke="#000" stroke-width=".8"/><path stroke="#000" stroke-linecap="round" stroke-width=".8" d="M13.5 9.5 5.5 5v9z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  image: {
    body: '<g fill="none"><path fill="#28AFEA" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path stroke="#28AFEA" d="M14.658 5.04c0 .854-.688 1.541-1.53 1.541s-1.53-.687-1.53-1.54c0-.854.687-1.541 1.53-1.541.842 0 1.53.687 1.53 1.54Z"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="m2 12.19 4.226-5.11L18 17.933m-6.496-6.363 2.436-2.04L18 13.203"/></g>'
  },
  "image-link": {
    body: '<g fill="none"><path fill="#28AFEA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="#28AFEA" d="M13.658 5.04c0 .854-.688 1.541-1.53 1.541s-1.53-.687-1.53-1.54c0-.854.687-1.541 1.53-1.541.842 0 1.53.687 1.53 1.54Z"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="m1 12.19 4.226-5.11L14 15m-3.496-3.43 2.436-2.04L17 13.203"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "image-sync": {
    body: '<g fill="none"><path fill="#28AFEA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="#28AFEA" d="M13.658 5.04c0 .854-.688 1.541-1.53 1.541s-1.53-.687-1.53-1.54c0-.854.687-1.541 1.53-1.541.842 0 1.53.687 1.53 1.54Z"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="m1 12.19 4.226-5.11L11.5 13m-.996-1.43 2.436-2.04L14.5 11"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  liscad: {
    body: '<g fill="none"><path fill="#B13132" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#B13132" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#B13132" d="M10.275 5h-2.8L4.5 15.5h9.45l.7-2.275H8z"/><path fill="#B13132" fill-rule="evenodd" d="M12.025 8.15a.18.18 0 01.175.185v2.78a.18.18 0 01-.175.185.18.18 0 01-.175-.185v-2.78a.18.18 0 01.175-.185" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M13.894 11.795a.175.175 0 01-.222.109l-1.656-.566a.175.175 0 01.113-.331l1.656.565c.091.032.14.131.109.223" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M10.316 11.998a.175.175 0 01.084-.232l1.586-.742a.175.175 0 01.148.317l-1.585.742a.175.175 0 01-.233-.085" clip-rule="evenodd"/><path fill="#B13132" d="m12.025 6.4.455 2.1h-.91zm3.695 5.952-2.135-.248.294-.861zm-7.148.461 1.71-1.301.385.824z"/></g>'
  },
  "liscad-link": {
    body: '<g fill="none"><path fill="#B13132" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#B13132" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#B13132" d="M9.275 4h-2.8L3.5 14.5h9.45l.7-2.275H7z"/><path fill="#B13132" fill-rule="evenodd" d="M11.025 7.15a.18.18 0 01.175.185v2.78a.18.18 0 01-.175.185.18.18 0 01-.175-.185v-2.78a.18.18 0 01.175-.185" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M12.894 10.795a.175.175 0 01-.222.109l-1.656-.566a.175.175 0 01.113-.331l1.656.565c.091.032.14.131.109.223" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M9.316 10.998a.175.175 0 01.084-.232l1.586-.742a.175.175 0 01.148.317l-1.585.742a.175.175 0 01-.233-.085" clip-rule="evenodd"/><path fill="#B13132" d="m11.025 5.4.455 2.1h-.91zm3.695 5.952-2.135-.248.294-.861zm-7.148.461 1.71-1.301.385.824z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "liscad-sync": {
    body: '<g fill="none"><path fill="#B13132" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#B13132" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#B13132" d="M9.275 4h-2.8L3.5 14.5H11l1-2.275H7z"/><path fill="#B13132" fill-rule="evenodd" d="M11.025 7.15a.18.18 0 01.175.185v2.78a.18.18 0 01-.175.185.18.18 0 01-.175-.185v-2.78a.18.18 0 01.175-.185" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M12.894 10.795a.175.175 0 01-.222.109l-1.656-.566a.175.175 0 01.113-.331l1.656.565c.091.032.14.131.109.223" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M9.316 10.998a.175.175 0 01.084-.232l1.586-.742a.175.175 0 01.148.317l-1.585.742a.175.175 0 01-.233-.085" clip-rule="evenodd"/><path fill="#B13132" d="m11.025 5.4.455 2.1h-.91zm3.695 5.952-2.135-.248.294-.861zm-7.148.461 1.71-1.301.385.824z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  mjf: {
    body: '<g fill="none"><path fill="#26C6DA" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#26C6DA" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#26C6DA" d="M4.372 8h.737l1.233 3.234L7.572 8h.74l-1.675 4.297h-.592zM4 8h.722l.13 2.972v1.325H4zm3.96 0h.725v4.297h-.852v-1.325zm3.433 2.992V8h.852v2.992q0 .428-.195.735-.195.304-.533.466-.339.162-.762.162-.438 0-.775-.138a1.16 1.16 0 01-.53-.431q-.189-.29-.189-.735h.855a.84.84 0 00.078.39.46.46 0 00.22.212.8.8 0 00.34.065.65.65 0 00.332-.082.6.6 0 00.226-.248.9.9 0 00.08-.396M13.943 8v4.297h-.852V8zm1.818 1.856v.64H13.72v-.64zM16 8v.64h-2.28V8z"/></g>'
  },
  "mjf-link": {
    body: '<g fill="none"><path fill="#26C6DA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#26C6DA" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#26C6DA" d="M3.372 6h.737l1.233 3.234L6.572 6h.74l-1.675 4.296h-.592zM3 6h.722l.13 2.971v1.325H3zm3.96 0h.725v4.296h-.852V8.971zm3.433 2.992V6h.852v2.992q0 .427-.195.735-.195.304-.533.466-.339.162-.763.162-.436 0-.774-.138a1.16 1.16 0 01-.53-.431q-.189-.29-.189-.735h.855a.84.84 0 00.078.39.46.46 0 00.22.212.8.8 0 00.34.065.65.65 0 00.332-.083.6.6 0 00.226-.247.9.9 0 00.08-.396M12.943 6v4.296h-.852V6zm1.818 1.856v.64H12.72v-.64zM15 6v.64h-2.28V6z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "mjf-sync": {
    body: '<g fill="none"><path fill="#26C6DA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#26C6DA" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#26C6DA" d="M3.372 6h.737l1.233 3.234L6.572 6h.74l-1.675 4.296h-.592zM3 6h.722l.13 2.971v1.325H3zm3.96 0h.725v4.296h-.852V8.971zm3.433 2.992V6h.852v2.992q0 .427-.195.735-.195.304-.533.466-.339.162-.763.162-.436 0-.774-.138a1.16 1.16 0 01-.53-.431q-.189-.29-.189-.735h.855a.84.84 0 00.078.39.46.46 0 00.22.212.8.8 0 00.34.065.65.65 0 00.332-.083.6.6 0 00.226-.247.9.9 0 00.08-.396M12.943 6v4.296h-.852V6zm1.818 1.856v.64H12.72v-.64zM15 6v.64h-2.28V6z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  pdf: {
    body: '<g fill="none"><path fill="#FF2116" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#FF2116" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#FF2116" d="M5.873 11.223H4.62v-.752h1.254q.309 0 .499-.105a.67.67 0 00.284-.293 1 1 0 00.09-.428q0-.234-.09-.436a.75.75 0 00-.284-.327.9.9 0 00-.499-.126H4.92v4.318H4V8h1.874q.568 0 .97.212.405.21.615.582.214.37.214.844 0 .491-.214.847a1.4 1.4 0 01-.615.547q-.402.19-.97.191m3.978 1.85h-1.05l.006-.752h1.044q.425 0 .713-.195.287-.2.435-.568a2.4 2.4 0 00.147-.892v-.262q0-.4-.084-.707a1.4 1.4 0 00-.247-.516 1.04 1.04 0 00-.398-.317 1.3 1.3 0 00-.546-.108h-1.09V8h1.09q.489 0 .89.17.405.171.7.492.298.317.454.76.16.443.16.99v.254q0 .543-.16.99a2.1 2.1 0 01-.455.76q-.294.316-.702.487t-.907.17M9.316 8v5.074h-.92V8zm4.463 0v5.074h-.92V8zm1.963 2.192v.756h-2.204v-.756zM16 8v.756h-2.462V8z"/></g>'
  },
  "pdf-link": {
    body: '<g fill="none"><path fill="#FF2116" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#FF2116" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#FF2116" d="M4.873 9.223H3.62v-.752h1.254q.309 0 .499-.105a.67.67 0 00.284-.293 1 1 0 00.09-.428q0-.234-.09-.436a.75.75 0 00-.284-.327.9.9 0 00-.499-.126H3.92v4.318H3V6h1.873q.57 0 .97.213.406.208.616.582.214.369.214.843 0 .491-.214.847a1.4 1.4 0 01-.615.547q-.402.192-.97.191m3.978 1.85h-1.05l.006-.752h1.044q.424 0 .713-.195.287-.198.435-.568.147-.373.147-.892v-.261q0-.401-.084-.708a1.4 1.4 0 00-.247-.516 1.04 1.04 0 00-.399-.317 1.3 1.3 0 00-.545-.108h-1.09V6h1.09q.488 0 .89.17.405.172.7.492.297.318.454.76.16.443.16.99v.254q0 .543-.16.99a2.1 2.1 0 01-.455.76q-.294.316-.702.487t-.907.17M8.316 6v5.074h-.92V6zm4.463 0v5.074h-.92V6zm1.963 2.192v.756h-2.204v-.756zM15 6v.756h-2.462V6z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "pdf-sync": {
    body: '<g fill="none"><path fill="#FF2116" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#FF2116" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#FF2116" d="M4.873 9.223H3.62v-.752h1.254q.309 0 .499-.105a.67.67 0 00.284-.293 1 1 0 00.09-.428q0-.234-.09-.436a.75.75 0 00-.284-.327.9.9 0 00-.499-.126H3.92v4.318H3V6h1.873q.57 0 .97.213.406.208.616.582.214.369.214.843 0 .491-.214.847a1.4 1.4 0 01-.615.547q-.402.192-.97.191m3.978 1.85h-1.05l.006-.752h1.044q.424 0 .713-.195.287-.198.435-.568.147-.373.147-.892v-.261q0-.401-.084-.708a1.4 1.4 0 00-.247-.516 1.04 1.04 0 00-.399-.317 1.3 1.3 0 00-.545-.108h-1.09V6h1.09q.488 0 .89.17.405.172.7.492.297.318.454.76.16.443.16.99v.254q0 .543-.16.99a2.1 2.1 0 01-.455.76q-.294.316-.702.487t-.907.17M8.316 6v5.074h-.92V6zm4.463 0v5.074h-.92V6zm1.963 2.192v.756h-2.204v-.756zM15 6v.756h-2.462V6z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  png: {
    body: '<g fill="none"><path fill="#A066AA" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#A066AA" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#A066AA" d="M5.723 10.772H4.57v-.633h1.154q.284 0 .459-.088a.6.6 0 00.261-.246.76.76 0 00.083-.36.8.8 0 00-.083-.367.65.65 0 00-.261-.275.9.9 0 00-.459-.106h-.877v3.631H4V8.062h1.723q.523 0 .892.178.373.176.567.49.195.31.196.709 0 .413-.196.712-.194.3-.567.46a2.2 2.2 0 01-.892.161m5.92-2.71v4.266h-.85L8.89 9.368v2.96h-.846V8.062h.846l1.911 2.962V8.062zM16 10.122v1.661q-.1.12-.31.261t-.548.243a3 3 0 01-.831.1q-.428 0-.782-.135a1.69 1.69 0 01-1.003-1.046 2.5 2.5 0 01-.138-.87v-.282q0-.489.129-.87.132-.381.375-.645.247-.264.588-.401.345-.138.77-.138.568 0 .935.179.368.178.566.492.197.311.246.715h-.825a1.1 1.1 0 00-.135-.39.7.7 0 00-.29-.263 1 1 0 00-.48-.097 1 1 0 00-.44.094.86.86 0 00-.32.272 1.3 1.3 0 00-.196.443 2.6 2.6 0 00-.065.603v.288q0 .342.074.61.075.262.212.444.142.18.348.273.21.09.474.09.24 0 .397-.037.16-.041.255-.097a.7.7 0 00.148-.108v-.8h-.89v-.59z"/></g>'
  },
  "png-link": {
    body: '<g fill="none"><path fill="#A066AA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#A066AA" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#A066AA" d="M4.723 8.772H3.57V8.14h1.154q.284 0 .459-.088a.6.6 0 00.261-.246.76.76 0 00.083-.36.8.8 0 00-.083-.367.65.65 0 00-.261-.275.9.9 0 00-.459-.106h-.877v3.631H3V6.062h1.723q.523 0 .892.178.373.176.567.49.195.31.196.709 0 .413-.196.712-.194.3-.567.46a2.2 2.2 0 01-.892.161m5.92-2.71v4.266h-.85L7.89 7.368v2.96h-.846V6.062h.846L9.8 9.024V6.062zM15 8.122v1.661q-.1.12-.31.261t-.548.243a3 3 0 01-.831.1q-.428 0-.782-.135a1.69 1.69 0 01-1.003-1.046 2.5 2.5 0 01-.138-.87v-.282q0-.489.129-.87.132-.381.375-.645.247-.264.588-.401.345-.138.77-.138.568 0 .935.179.368.178.566.492.197.31.246.715h-.825a1.1 1.1 0 00-.135-.39.7.7 0 00-.29-.263 1 1 0 00-.48-.097 1 1 0 00-.44.094.86.86 0 00-.32.272 1.3 1.3 0 00-.196.443 2.6 2.6 0 00-.065.603v.288q0 .342.074.61.075.263.212.444.142.18.348.273.21.09.474.09.24 0 .397-.037.16-.042.255-.097a.7.7 0 00.148-.108v-.8h-.89v-.59z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "png-sync": {
    body: '<g fill="none"><path fill="#A066AA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#A066AA" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#A066AA" d="M4.723 8.772H3.57V8.14h1.154q.284 0 .459-.088a.6.6 0 00.261-.246.76.76 0 00.083-.36.8.8 0 00-.083-.367.65.65 0 00-.261-.275.9.9 0 00-.459-.106h-.877v3.631H3V6.062h1.723q.523 0 .892.178.373.176.567.49.195.31.196.709 0 .413-.196.712-.194.3-.567.46a2.2 2.2 0 01-.892.161m5.92-2.71v4.266h-.85L7.89 7.368v2.96h-.846V6.062h.846L9.8 9.024V6.062zM15 8.122v1.661q-.1.12-.31.261t-.548.243a3 3 0 01-.831.1q-.428 0-.782-.135a1.69 1.69 0 01-1.003-1.046 2.5 2.5 0 01-.138-.87v-.282q0-.489.129-.87.132-.381.375-.645.247-.264.588-.401.345-.138.77-.138.568 0 .935.179.368.178.566.492.197.31.246.715h-.825a1.1 1.1 0 00-.135-.39.7.7 0 00-.29-.263 1 1 0 00-.48-.097 1 1 0 00-.44.094.86.86 0 00-.32.272 1.3 1.3 0 00-.196.443 2.6 2.6 0 00-.065.603v.288q0 .342.074.61.075.263.212.444.142.18.348.273.21.09.474.09.24 0 .397-.037.16-.042.255-.097a.7.7 0 00.148-.108v-.8h-.89v-.59z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  pptx: {
    body: '<g fill="none"><path fill="#CE4525" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#CE4525" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#CE4525" d="M10.734 11.517h-1.83v-1.055h1.83q.45 0 .728-.147a.95.95 0 00.415-.41q.132-.263.132-.6a1.4 1.4 0 00-.132-.61 1.06 1.06 0 00-.415-.46q-.279-.175-.728-.175H9.343v6.05H8V7h2.734q.831 0 1.416.298.591.293.899.815.312.518.312 1.182 0 .688-.312 1.186a2 2 0 01-.899.767q-.585.27-1.416.269"/></g>'
  },
  "pptx-link": {
    body: '<g fill="none"><path fill="#CE4525" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#CE4525" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#CE4525" d="M9.734 9.517h-1.83V8.462h1.83q.45 0 .728-.147a.95.95 0 00.415-.41q.132-.264.132-.6a1.4 1.4 0 00-.132-.61 1.06 1.06 0 00-.415-.46q-.279-.175-.728-.175H8.343v6.05H7V5h2.734q.831 0 1.416.298.591.293.899.815.312.518.312 1.182 0 .688-.312 1.186a2 2 0 01-.899.767q-.585.27-1.416.269"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "pptx-sync": {
    body: '<g fill="none"><path fill="#CE4525" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#CE4525" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#CE4525" d="M9.734 9.517h-1.83V8.462h1.83q.45 0 .728-.147a.95.95 0 00.415-.41q.132-.264.132-.6a1.4 1.4 0 00-.132-.61 1.06 1.06 0 00-.415-.46q-.279-.175-.728-.175H8.343v6.05H7V5h2.734q.831 0 1.416.298.591.293.899.815.312.518.312 1.182 0 .688-.312 1.186a2 2 0 01-.899.767q-.585.27-1.416.269"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  rcp: {
    body: '<g fill="none"><path fill="#58368A" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#58368A" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#58368A" d="M4 8.07h1.697q.532 0 .915.165.381.165.587.49t.205.797q0 .374-.128.649a1.25 1.25 0 01-.363.46 1.8 1.8 0 01-.545.29l-.276.146H4.594l-.007-.718h1.12a.9.9 0 00.452-.099.65.65 0 00.27-.275.84.84 0 00.093-.4q0-.242-.09-.417a.6.6 0 00-.273-.275 1 1 0 00-.462-.096h-.815v4.1H4zm2.637 4.817-1.08-2.157.933-.004 1.094 2.115v.046zm4.274-1.585h.883a1.9 1.9 0 01-.26.857q-.225.37-.626.582-.4.213-.972.212a1.9 1.9 0 01-.793-.159 1.7 1.7 0 01-.6-.46q-.246-.3-.378-.72a3.2 3.2 0 01-.132-.95v-.368q0-.525.135-.95.135-.423.385-.72.253-.302.606-.464Q9.516 8 9.955 8q.57 0 .966.218.394.215.613.593.218.376.263.867h-.883a1.5 1.5 0 00-.128-.517.7.7 0 00-.301-.32q-.2-.113-.53-.113a1 1 0 00-.452.1.84.84 0 00-.321.297q-.129.195-.193.49a3 3 0 00-.064.675v.374q0 .367.058.658.057.292.18.493a.84.84 0 00.314.308.94.94 0 00.459.106q.324 0 .526-.106a.7.7 0 00.311-.311q.11-.206.138-.51m3.363-.172H13.07v-.715h1.203a1 1 0 00.478-.099.64.64 0 00.273-.278.9.9 0 00.086-.407 1 1 0 00-.086-.413.7.7 0 00-.273-.311.86.86 0 00-.478-.12h-.915v4.1h-.882V8.069h1.797q.546 0 .93.202.39.2.59.553.206.35.206.8 0 .468-.205.805a1.3 1.3 0 01-.59.52q-.386.18-.931.181"/></g>'
  },
  "rcp-link": {
    body: '<g fill="none"><path fill="#58368A" fill-rule="evenodd" d="M7.241 2v3.12c0 .6-.485.96-.97.96H3z" clip-rule="evenodd"/><path stroke="#58368A" stroke-linecap="round" stroke-linejoin="round" d="M13.5 20.121H4.094c-.547 0-1.094-.362-1.094-.966V5.625L7.24 2.12h10.666c.547 0 1.094.484 1.094.967V10"/><path fill="#58368A" d="M5 7.07h1.697q.532 0 .915.165.381.165.587.49t.205.797q0 .374-.128.649a1.25 1.25 0 01-.363.46 1.8 1.8 0 01-.545.29l-.276.146H5.594l-.007-.718h1.12a.9.9 0 00.452-.099.65.65 0 00.27-.275.84.84 0 00.093-.4q0-.242-.09-.417a.6.6 0 00-.273-.275 1 1 0 00-.462-.096h-.815v4.1H5zm2.637 4.817L6.557 9.73l.933-.004 1.094 2.115v.046zm4.274-1.585h.883a1.9 1.9 0 01-.26.857q-.225.37-.626.582-.4.213-.972.212a1.9 1.9 0 01-.793-.159 1.7 1.7 0 01-.6-.46q-.246-.3-.378-.72a3.2 3.2 0 01-.132-.95v-.368q0-.525.135-.95.135-.423.385-.72.253-.302.606-.464A1.9 1.9 0 0110.955 7q.57 0 .966.218.394.215.613.593.218.377.263.867h-.883a1.5 1.5 0 00-.128-.517.7.7 0 00-.301-.32q-.2-.114-.53-.113a1 1 0 00-.452.1.84.84 0 00-.321.297q-.129.195-.193.49a3 3 0 00-.064.675v.374q0 .367.058.658.057.292.18.493a.84.84 0 00.314.308.94.94 0 00.459.106q.324 0 .526-.106a.7.7 0 00.311-.311q.11-.206.138-.51m3.363-.172H14.07v-.715h1.203a1 1 0 00.478-.099.64.64 0 00.273-.278.9.9 0 00.086-.407 1 1 0 00-.086-.413.7.7 0 00-.273-.311.86.86 0 00-.478-.12h-.915v4.1h-.882V7.069h1.797q.546 0 .93.202.39.2.59.553.206.35.206.8 0 .468-.205.805a1.3 1.3 0 01-.59.52q-.385.18-.931.181"/><path fill="#726F74" d="m20.955 11.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>',
    width: 22,
    height: 21
  },
  "rcp-sync": {
    body: '<g fill="none"><path fill="#58368A" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#58368A" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#58368A" d="M3 6.07h1.697q.532 0 .915.165.381.165.587.49t.205.797q0 .374-.128.649a1.25 1.25 0 01-.363.46 1.8 1.8 0 01-.545.29l-.276.146H3.594l-.007-.718h1.12a.9.9 0 00.452-.099.65.65 0 00.27-.275.84.84 0 00.093-.4q0-.241-.09-.417a.6.6 0 00-.273-.275 1 1 0 00-.462-.096h-.815v4.1H3zm2.637 4.817L4.557 8.73l.933-.004 1.094 2.115v.046zm4.274-1.585h.883a1.9 1.9 0 01-.26.857q-.225.37-.626.582-.4.213-.972.212a1.9 1.9 0 01-.793-.159 1.7 1.7 0 01-.6-.46q-.246-.3-.378-.72a3.2 3.2 0 01-.132-.95v-.368q0-.525.135-.95.135-.423.385-.72.253-.302.606-.464Q8.516 6 8.955 6q.57 0 .966.218.394.215.613.593.218.376.263.867h-.883a1.5 1.5 0 00-.128-.517.7.7 0 00-.302-.32q-.198-.114-.529-.113a1 1 0 00-.452.1.84.84 0 00-.321.297q-.129.195-.193.49a3 3 0 00-.064.675v.374q0 .367.058.658.057.292.18.493a.84.84 0 00.314.308.94.94 0 00.459.106q.324 0 .526-.106a.7.7 0 00.311-.311q.11-.206.138-.51m3.363-.172H12.07v-.715h1.203a1 1 0 00.478-.099.64.64 0 00.273-.278.9.9 0 00.086-.407 1 1 0 00-.086-.413.7.7 0 00-.273-.311.86.86 0 00-.478-.12h-.915v4.1h-.882V6.069h1.797q.546 0 .93.202.39.2.59.553.206.35.206.8 0 .468-.205.805a1.3 1.3 0 01-.59.52q-.386.18-.931.181"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  rvt: {
    body: '<g fill="none"><path fill="#004576" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#004576" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#004576" d="M4 7.5h1.72q.54 0 .928.176.387.177.595.523t.208.851q0 .399-.13.693t-.367.49a1.8 1.8 0 01-.553.311l-.28.156H4.6l-.006-.767H5.73a.9.9 0 00.458-.106.67.67 0 00.273-.293.94.94 0 00.095-.427q0-.258-.091-.445a.65.65 0 00-.277-.293.96.96 0 00-.468-.103h-.826v4.377H4zm2.674 5.143L5.578 10.34l.946-.004 1.11 2.257v.05zm3.162-1.007 1.18-4.136h.993l-1.672 5.143h-.66zM8.746 7.5l1.174 4.136.17 1.007h-.667L7.757 7.5zm5.784 0v5.143h-.892V7.5zm1.47 0v.766h-3.816V7.5z"/></g>'
  },
  "rvt-link": {
    body: '<g fill="none"><path fill="#004576" fill-rule="evenodd" d="M7.241 2v3.12c0 .6-.485.96-.97.96H3z" clip-rule="evenodd"/><path stroke="#004576" stroke-linecap="round" stroke-linejoin="round" d="M13.5 20.121H4.094c-.547 0-1.094-.362-1.094-.966V5.625L7.24 2.12h10.666c.547 0 1.094.483 1.094.967V10"/><path fill="#004576" d="M5 7h1.72q.54 0 .928.176.387.177.595.523t.208.851q0 .399-.13.693t-.367.49q-.234.199-.553.311l-.28.156H5.6l-.006-.767H6.73a.9.9 0 00.458-.106.67.67 0 00.273-.293.94.94 0 00.095-.427q0-.258-.091-.445a.65.65 0 00-.277-.293.96.96 0 00-.468-.103h-.826v4.377H5zm2.674 5.143L6.578 9.84l.946-.004 1.11 2.257v.05zm3.162-1.007L12.016 7h.993l-1.672 5.143h-.66zM9.746 7l1.174 4.136.17 1.007h-.667L8.757 7zm5.784 0v5.143h-.892V7zM17 7v.766h-3.816V7z"/><path fill="#726F74" d="m20.955 11.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.131l1.2-5.47a.35.35 0 00-.307-.423"/></g>',
    width: 22,
    height: 21
  },
  "rvt-sync": {
    body: '<g fill="none"><path fill="#004576" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#004576" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path fill="#004576" d="M3 6h1.72q.54 0 .928.176.387.177.595.523t.208.851q0 .399-.13.693t-.367.49q-.234.199-.553.311l-.28.156H3.6l-.006-.767H4.73a.9.9 0 00.458-.106.67.67 0 00.273-.293.94.94 0 00.095-.427q0-.258-.091-.445a.65.65 0 00-.277-.293.96.96 0 00-.468-.103h-.826v4.377H3zm2.674 5.143L4.578 8.84l.946-.004 1.11 2.257v.05zm3.162-1.007L10.016 6h.993l-1.672 5.143h-.66zM7.746 6l1.174 4.136.17 1.007h-.667L6.757 6zm5.784 0v5.143h-.892V6zM15 6v.766h-3.816V6z"/><path fill="#726F74" d="M17.14 12.467a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.623l.703-.703a.473.473 0 01.807.334v2.639a.47.47 0 01-.473.473h-2.639a.472.472 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.806l-.822.823a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.135.232.28a4.88 4.88 0 01-8.17 2.623l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  videos: {
    body: '<g fill="none"><path fill="red" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path stroke="red" stroke-width="1.25" d="m13.312 10.32-5.113 3.194a.375.375 0 01-.574-.318V6.805c0-.295.324-.474.574-.318l5.113 3.197a.375.375 0 010 .636Z"/></g>'
  },
  "videos-link": {
    body: '<g fill="none"><path fill="red" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="red" stroke-width="1.25" d="m12.312 9.32-5.113 3.194a.375.375 0 01-.574-.318V5.805c0-.295.324-.474.574-.318l5.113 3.197a.375.375 0 010 .636Z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "videos-sync": {
    body: '<g fill="none"><path fill="red" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="red" stroke-width="1.25" d="m12.312 9.32-5.113 3.194a.375.375 0 01-.574-.318V5.805c0-.295.324-.474.574-.318l5.113 3.197a.375.375 0 010 .636Z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  xlsx: {
    body: '<g fill="none"><path fill="#107C41" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#107C41" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#107C41" d="m7.922 6 1.705 3.04L11.337 6h1.853l-2.532 4.23 2.596 4.301h-1.87l-1.757-3.1-1.752 3.1H6l2.596-4.3L6.064 6z"/></g>'
  },
  "xlsx-link": {
    body: '<g fill="none"><path fill="#107C41" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#107C41" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path fill="#107C41" d="m7.422 5 1.705 3.04L10.837 5h1.853l-2.532 4.23 2.596 4.301h-1.87l-1.757-3.1-1.752 3.1H5.5l2.596-4.3L5.564 5z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.131l1.2-5.47a.35.35 0 00-.307-.423"/></g>'
  },
  "xlsx-sync": {
    body: '<g fill="none"><path fill="#107C41" fill-rule="evenodd" d="M6.241 2v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#107C41" stroke-linecap="round" stroke-linejoin="round" d="M9.5 20.121H3.094c-.547 0-1.094-.362-1.094-.966V5.625L6.24 2.12h10.666c.547 0 1.094.483 1.094.967V10"/><path fill="#107C41" d="m8.422 6 1.705 3.04L11.837 6h1.853l-2.532 4.23L13 13l-1.115 1.531-1.758-3.1-1.752 3.1H6.5l2.596-4.3L6.564 6z"/><path fill="#726F74" d="M18.14 13.467a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.623l.703-.703a.473.473 0 01.807.334v2.639a.47.47 0 01-.473.473h-2.639a.472.472 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.806l-.822.823a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.135.232.28a4.88 4.88 0 01-8.17 2.623l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>',
    width: 21,
    height: 21
  },
  zip: {
    body: '<g fill="none"><path fill="#E9B233" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#E9B233" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/><g clip-path="url(#svgID0)"><path stroke="#E9B233" stroke-dasharray="1 1" stroke-width="1.3" d="M-5 10.017h18.667"/><path fill="#E9B233" d="m11 9.333 3.393-.848a1.562 1.562 0 110 3.03L11 10.667z"/><circle cx="13.667" cy="10" r=".667" fill="#fff"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M2 8h15v4H2z"/></clipPath></defs></g>'
  },
  "zip-link": {
    body: '<g fill="none"><path fill="#E9B233" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E9B233" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.484 1.094.967v6.912"/><g clip-path="url(#svgID0)"><path stroke="#E9B233" stroke-dasharray="1 1" stroke-width="1.3" d="M-6 8.016h18.667"/><path fill="#E9B233" d="m10 7.332 3.393-.848a1.562 1.562 0 110 3.03L10 8.666z"/><circle cx="12.667" cy="7.999" r=".667" fill="#fff"/></g><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.262l-.04-.243a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.35.35 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/><defs><clipPath id="svgID0"><path fill="#fff" d="M1 5.999h15v4H1z"/></clipPath></defs></g>'
  },
  "zip-sync": {
    body: '<g fill="none"><path fill="#E9B233" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E9B233" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><g clip-path="url(#svgID0)"><path stroke="#E9B233" stroke-dasharray="1 1" stroke-width="1.3" d="M-6 8.017h18.667"/><path fill="#E9B233" d="m10 7.333 3.393-.848a1.562 1.562 0 110 3.03L10 8.667z"/><circle cx="12.667" cy="8" r=".667" fill="#fff"/></g><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/><defs><clipPath id="svgID0"><path fill="#fff" d="M1 6h15v4H1z"/></clipPath></defs></g>'
  }
}, bI = {
  folderlink: {
    parent: "folder-link"
  }
}, yI = 20, wI = 20, xI = {
  prefix: mI,
  lastModified: gI,
  icons: vI,
  aliases: bI,
  width: yI,
  height: wI
}, CI = "#fff", SI = "#F5F3F6", EI = "#D8D6D9", kI = "#BCB9BE", MI = "#8A858E", _I = "#726F74", PI = "#4C494E", OI = "#333234", TI = "#E5ECFF", AI = "#B2C6FF", $I = "#809FFF", RI = "#0040FF", DI = "#002699", NI = "#E5F1ED", LI = "#E5F1ED", jI = "#4CB176", HI = "#0B883D", FI = "#F6E3EB", BI = "#EBB4C4", zI = "#D04A6B", II = "#A60C31", WI = "#FBEEEA", VI = "#FAD5C1", YI = "#F69C64", qI = "#F47C31", UI = "#E3ECFB", GI = "#B0CEF4", XI = "#3F8AE2", ZI = "#015BC5", KI = "#FEF6F0", QI = "#FCD7C0", JI = "#F9B890", eW = "#F47C31", tW = "#CB550B", nW = "400 56px/64px Raleway", rW = "400 40px/48px Raleway", oW = "600 28px/32px Raleway", aW = "600 20px/24px Raleway", xd = "400 20px/24px 'Roboto Flex'", Cd = "400 16px/20px 'Roboto Flex'", Sd = "600 16px/20px 'Roboto Flex'", Ed = "400 12px/20px 'Roboto Flex'", kd = "600 12px/20px 'Roboto Flex'", iW = "400 10px/14px 'Roboto Flex'", sW = "600 10px/14px 'Roboto Flex'", lW = "600 10px/14px 'Roboto Flex'", cW = "400 8px/12px 'Roboto Flex'", uW = "600 8px/12px 'Roboto Flex'", Md = "600 16px/20px 'Roboto Flex'", _d = "600 12px/16px 'Roboto Flex'", dW = "600 10px/14px 'Roboto Flex'", fW = "600 8px/12px 'Roboto Flex'", hW = "4px", pW = "8px", mW = "12px", gW = "16px", vW = "20px", bW = "24px", yW = "28px", wW = "32px", xW = "4px", CW = "8px", SW = "12px", EW = "16px";
function kW(e) {
  return e != null && typeof e == "object" && e["@@functional/placeholder"] === !0;
}
var eu = kW, MW = eu;
function _W(e) {
  return function t(n) {
    return arguments.length === 0 || MW(n) ? t : e.apply(this, arguments);
  };
}
var F3 = _W, Ms = F3, bo = eu;
function PW(e) {
  return function t(n, r) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return bo(n) ? t : Ms(function(o) {
          return e(n, o);
        });
      default:
        return bo(n) && bo(r) ? t : bo(n) ? Ms(function(o) {
          return e(o, r);
        }) : bo(r) ? Ms(function(o) {
          return e(n, o);
        }) : e(n, r);
    }
  };
}
var B3 = PW, xa = F3, ir = B3, it = eu;
function OW(e) {
  return function t(n, r, o) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return it(n) ? t : ir(function(a, i) {
          return e(n, a, i);
        });
      case 2:
        return it(n) && it(r) ? t : it(n) ? ir(function(a, i) {
          return e(a, r, i);
        }) : it(r) ? ir(function(a, i) {
          return e(n, a, i);
        }) : xa(function(a) {
          return e(n, r, a);
        });
      default:
        return it(n) && it(r) && it(o) ? t : it(n) && it(r) ? ir(function(a, i) {
          return e(a, i, o);
        }) : it(n) && it(o) ? ir(function(a, i) {
          return e(a, r, i);
        }) : it(r) && it(o) ? ir(function(a, i) {
          return e(n, a, i);
        }) : it(n) ? xa(function(a) {
          return e(a, r, o);
        }) : it(r) ? xa(function(a) {
          return e(n, a, o);
        }) : it(o) ? xa(function(a) {
          return e(n, r, a);
        }) : e(n, r, o);
    }
  };
}
var z3 = OW;
function TW(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
var AW = TW;
function $W(e, t) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var RW = $W, DW = z3, Ca = RW, NW = /* @__PURE__ */ DW(function(t, n, r) {
  var o = {}, a;
  n = n || {}, r = r || {};
  for (a in n)
    Ca(a, n) && (o[a] = Ca(a, r) ? t(a, n[a], r[a]) : n[a]);
  for (a in r)
    Ca(a, r) && !Ca(a, o) && (o[a] = r[a]);
  return o;
}), LW = NW, jW = z3, Pd = AW, HW = LW, FW = /* @__PURE__ */ jW(function e(t, n, r) {
  return HW(function(o, a, i) {
    return Pd(a) && Pd(i) ? e(t, a, i) : t(o, a, i);
  }, n, r);
}), BW = FW, zW = B3, IW = BW, WW = /* @__PURE__ */ zW(function(t, n) {
  return IW(function(r, o, a) {
    return o;
  }, t, n);
}), VW = WW;
const YW = /* @__PURE__ */ yl(VW), Od = {
  colors: {
    alert: {
      100: FI,
      200: BI,
      300: zI,
      400: II
    },
    info: {
      100: UI,
      200: GI,
      300: XI,
      400: ZI
    },
    neutral: {
      100: CI,
      200: SI,
      300: EI,
      400: kI,
      500: MI,
      600: _I,
      700: PI,
      800: OI
    },
    primary: {
      100: TI,
      200: AI,
      300: $I,
      400: RI,
      500: DI
    },
    skandI: {
      100: KI,
      200: QI,
      300: JI,
      400: eW,
      500: tW
    },
    success: {
      100: NI,
      200: LI,
      300: jI,
      400: HI
    },
    warning: {
      100: WI,
      200: VI,
      300: YI,
      400: qI
    }
  },
  spacing: {
    1: hW,
    2: pW,
    3: mW,
    4: gW,
    5: vW,
    6: bW,
    7: yW,
    8: wW
  },
  borderRadius: {
    1: xW,
    2: CW,
    3: SW,
    4: EW
  }
}, OV = ({ includeReset: e, themeOverrides: t } = {}) => {
  const n = t ? YW(t, Od) : Od;
  return {
    name: "presetSkand",
    preflights: [
      {
        getCSS: () => e ? "*, *:before, *:after { box-sizing: border-box; margin: 0; padding: 0; }" : void 0
      }
    ],
    presets: [
      J3({
        collections: {
          skand: pI,
          fs: () => xI
        }
      })
    ],
    theme: n,
    rules: [
      ["typo-button-xs", { font: lW }],
      ["typo-heading-1", { font: nW }],
      ["typo-heading-2", { font: rW }],
      ["typo-heading-3", { font: oW }],
      ["typo-heading-4", { font: aW }],
      ["typo-link-m", { font: Md }],
      ["typo-link-s", { font: _d }],
      ["typo-link-xs", { font: dW }],
      ["typo-link-xxs", { font: fW }],
      ["typo-text-l", { font: xd }],
      ["typo-text-m-em", { font: Sd }],
      ["typo-text-m", { font: Cd }],
      ["typo-text-s-em", { font: kd }],
      ["typo-text-s", { font: Ed }],
      ["typo-text-xs-em", { font: sW }],
      ["typo-text-xs", { font: iW }],
      ["typo-text-xxs-em", { font: uW }],
      ["typo-text-xxs", { font: cW }],
      ["typo-link-medium", { font: Md }],
      ["typo-link-small", { font: _d }],
      ["typo-text-large", { font: xd }],
      ["typo-text-medium-em", { font: Sd }],
      ["typo-text-medium", { font: Cd }],
      ["typo-text-small-em", { font: kd }],
      ["typo-text-small", { font: Ed }],
      ["inborder-transparent", { "--skand-inborder-color": "transparent" }],
      [
        /^inborder-(\d+)$/,
        (r) => {
          const [, o] = r;
          return {
            "--skand-inborder-width": `${o}px`
          };
        }
      ],
      [
        /^inborder-([A-Za-z]+)-(\d+)$/,
        (r) => {
          const [, o, a] = r;
          return {
            "--skand-inborder-color": n.colors[o][a]
          };
        }
      ],
      ["outborder-transparent", { "--skand-outborder-color": "transparent" }],
      [
        /^outborder-(\d+)$/,
        (r) => {
          const [, o] = r;
          return {
            "--skand-outborder-width": `${o}px`
          };
        }
      ],
      [
        /^outborder-([A-Za-z]+)-(\d+)$/,
        (r) => {
          const [, o, a] = r;
          return {
            "--skand-outborder-color": n.colors[o][a]
          };
        }
      ],
      [
        "dual-border",
        {
          "box-shadow": "inset 0 0 0 var(--skand-inborder-width) var(--skand-inborder-color), 0 0 0 var(--skand-outborder-width) var(--skand-outborder-color)"
        }
      ]
    ]
  };
};
export {
  xl as Button,
  vf as Calendar,
  O8 as CheckBox,
  JW as ColorPicker,
  eV as ColorSelect,
  tV as DatePicker,
  ih as Dropdown,
  nV as DropdownItem,
  sV as EmptyDesc,
  jN as EmptyRoot,
  iV as EmptyTitle,
  aV as EmptyToast,
  uV as ImagePreview,
  dV as Input,
  hF as Menu,
  pF as MenuItem,
  $h as Modal,
  fV as Pagination,
  bp as PaginationContent,
  ul as PaginationEllipsis,
  Or as PaginationLink,
  wp as PaginationNext,
  yp as PaginationPrevious,
  vp as PaginationRoot,
  Fh as Progress,
  bF as QuickList,
  gV as ResizeHandle,
  mV as ResizePanel,
  pV as ResizePanelGroup,
  _$ as Rnd,
  RR as Select,
  vV as Skeleton,
  np as Slider,
  bV as Spinner,
  eB as Switch,
  xV as Tabs,
  EB as TabsContent,
  CB as TabsList,
  SB as TabsTrigger,
  sh as Toast,
  oV as ToastRoot,
  kV as Tooltip,
  dz as TooltipContent,
  EV as TooltipProvider,
  MV as TooltipTrigger,
  _V as Tree,
  PV as VideoPreview,
  XW as chip,
  QW as chipClose,
  ZW as chipIcon,
  KW as chipProbe,
  z as cn,
  LN as dismiss,
  OV as presetSkand,
  Od as theme,
  rV as toast,
  gF as usePagination,
  _c as useToast
};
//# sourceMappingURL=index.es.js.map
